(function($){
/**
 * @ngdoc overview
 * @name qstrap:qstrap.qstrapTranslate
 *
 * @description
 * <h1>Overview</h1>
 *
 * Gives the host application a chance to translate strings used within qstrap.
 *
 * Expects the app to provide a `translate` filter. If it does, then qstrap will request translation
 * using the app's filter. Qstrap will only use the translation if the app was able to provide it,
 * otherwise will fallback to english. Note that the `translate` filter should support variable
 * replacement as an object of keys to translated values passed as the second argument to the filter.
 *
 * - **NOTE: the `qstrapTranslate` filter should NOT be used outside of qstrap**
 * - TODO: use this instead of localizedText option on qstrap.menu
 *
 * <h1>Required Strings</h1>
 *
 * Your app is expected to be able to translate the following strings:
 *
 *  | Translation Key | Fallback | Usage |
	|---|---|---|
	| CLOSE  | Close | qstap.modal default button  |
	| SEARCH_ELLIPSIS |  Search... | qstrap.menu searchable placeholder |
	| RANGE_TEXT | {min} to {max} | qstrap.range-slider |
	| CURRENT_PAGE | &lt;b&gt;Page <span ng-non-bindable>{{current}}</span>&lt;/b&gt; of &lt;b&gt;<span ng-non-bindable>{{total}}</span>&lt;/b&gt; | qstrap.pagination |
	| PAGE_N | Page <span ng-non-bindable>{{page}}</span> | qstrap.pagination |
	| JUMP_TO | Jump to... | qstrap.pagination |
	| ENTER_PAGE | Go to page &lt;span qstrap.page-input&gt;&lt;/span&gt; of <span ng-non-bindable>{{total}}</span> | qstrap.pagination
	| FIRST_PAGE | First Page | qstrap.pagination
	| LAST_PAGE | Last Page | qstrap.pagination
	| NO_ITEMS_TO_DISPLAY | No items to display | qstrap.menu with no items
	| ON | On | qstrap.switch on state
	| OFF | Off | qstrap.switch off state
	| SUN_ABBR | S | qstrap.weekday Sunday label
	| MON_ABBR | M | qstrap.weekday Monday label
	| TUE_ABBR | T | qstrap.weekday Tuesday label
	| WED_ABBR | W | qstrap.weekday Wednesday label
	| THU_ABBR | T | qstrap.weekday Thursday label
	| FRI_ABBR | F | qstrap.weekday Friday label
	| SAT_ABBR | S | qstrap.weekday Saturday label
 *
 * <h1>Translation Prefix</h1>
 *
 * You can use `qstrapTranslateFilterProvider` to specify a prefix for translation strings passed to your
 * app's `translate` filter. For example, if you set the prefix to `"QStrap."`, then your app's translate
 * filter would be called with the string `"QStrap.CLOSE"` for the CLOSE translation.
 *
 * Here is an example of how to specify the prefix with `qstrapTranslateFilterProvider`:
 *
 * <pre>
 * angular.module('myApp', ['qstrap'])
 *     .config(function(qstrapTranslateFilterProvider) {
 *         qstrapTranslateFilterProvider.setPrefix('ABC.');
 *     });
 * </pre>
 *
 * <h1>Translation Filter</h1>
 *
 * You can also use `qstrapTranslateFilterProvider` to specify a custom translation filter name.
 * For example, If your app uses a translation filter called `qtranslate`, you can specify that as follows:
 *
 * <pre>
 * angular.module('myApp', ['qstrap'])
 *     .config(function(qstrapTranslateFilterProvider) {
 *         qstrapTranslateFilterProvider.setFilterName('qtranslate');
 *     });
 * </pre>
 */
(function(module) {
	'use strict';

	module.constant('fallbacks', {
		SEARCH_ELLIPSIS: 'Search...',
		CLOSE: 'Close',
		CURRENT_PAGE: '<b>Page {{current}}</b> of <b>{{total}}</b>',
		RANGE_TEXT: '{min} to {max}',
		PAGE_N: 'Page {{page}}',
		JUMP_TO: 'Jump to...',
		ENTER_PAGE: 'Go to page <span qstrap.page-input></span> of {{total}}',
		FIRST_PAGE: 'First Page',
		LAST_PAGE: 'Last Page',
		NO_ITEMS_TO_DISPLAY: 'No items to display',
		ON: 'On',
		OFF: 'Off',
		SUN_ABBR: 'S',
		MON_ABBR: 'M',
		TUE_ABBR: 'T',
		WED_ABBR: 'W',
		THU_ABBR: 'T',
		FRI_ABBR: 'F',
		SAT_ABBR: 'S'
	})
	.provider('qstrapTranslateFilter', [
		function() {

			this.prefix = '';

			this.setPrefix = function(prefix) {
				this.prefix = prefix;
			};

			this.setFilterName = function(filter) {
				this.customFilterName = filter;
			};

			var that = this;
			this.$get = [
				'$injector',
				'$filter',
				'fallbacks',
				function($injector, $filter, fallbacks) {

					return new QStrapTranslate(
						$injector,
						$filter,
						fallbacks,
						{
							prefix: that.prefix,
							customFilterName: that.customFilterName
						}
					);
				}
			];
		}
	]);

	function QStrapTranslate($injector, $filter, fallbacks, options) {
		var hasFilter = $injector.has('translateFilter') || options.customFilterName;

		function wrap(key) {
			return '{{' + key + '}}';
		}

		function translateValues(translateKey, values) {

			// Retrieve fallback string, return key if not found
			var translated = fallbacks[translateKey];
			if (!translated) {
				return translateKey;
			}

			// Insert values into translation key
			for (var valueKey in values) {
				if (!values.hasOwnProperty(valueKey)) {
					continue;
				}
				translated = translated.replace(new RegExp(wrap(valueKey)), values[valueKey]);
			}

			// Remove any unspecified values
			translated = translated.replace(/{{.*?}}/g, '');

			return translated;
		}

		return function (input, values) {
			if (hasFilter) {
				var filterName = options.customFilterName || 'translate';
				var translation = $filter(filterName)(options.prefix + input, values);
				if (translation && translation !== input) {
					return translation;
				}
			}
			return translateValues(input, values);
		};
	}

})(angular.module('qstrap.translate', []));

(function (module) {
	'use strict';

	module.factory('qstrap.util', [
		'$timeout',
		'$q',
		function($timeout, $q) {
			// Throttles calls to a function. The first happens immediately. If
			// called again within the given interval, the wrapped function will
			// be called once the interval expires.
			function throttle(func, interval) {
				var nextCallTimeout = null;
				var nextCallArgs = null;

				return function() {
					var that = this;

					if (nextCallTimeout) {
						nextCallArgs = arguments;
					}
					else {
						nextCallTimeout = $timeout(interval)
							.finally(function() {
								nextCallTimeout = null;

								if (nextCallArgs) {
									var args = nextCallArgs;
									nextCallArgs = null;
									func.apply(that, args);
								}
							});

						func.apply(that, arguments);
					}
				};
			}

			// Decorates a function so that all calls to the function resolve
			// with the value of the most recent call that's already resolved.
			function ignoreStaleResponses(func) {
				var mostRecentRequestIndex = 0;
				var mostCurrentResponse = null;
				var mostCurrentResponseIndex = -1;
				return function() {
					var requestIndex = ++mostRecentRequestIndex;
					return $q.when(func.apply(null, arguments))
						.then(function(response) {
							if (requestIndex > mostCurrentResponseIndex) {
								mostCurrentResponse = response;
								mostCurrentResponseIndex = requestIndex;
							}

							return mostCurrentResponse;
						});
				};
			}

			// A convenient place to keep a mapping from keyCode to key name
			var keys = {
				TAB: 9,
				ENTER: 13,
				ESCAPE: 27,
				SPACE: 32,
				LEFT_ARROW: 37,
				UP_ARROW: 38,
				RIGHT_ARROW: 39,
				DOWN_ARROW: 40
			};

			// A list of keyboard focuable elements
			var candidateSelectors = [
				'input:not([disabled])',
				'select:not([disabled])',
				'textarea:not([disabled])',
				'a[href]',
				'button:not([disabled])',
				'[tabindex]',
				'audio[controls]',
				'video[controls]',
				'[contenteditable]:not([contenteditable="false"])',
				'details>summary:first-of-type',
				'details'
			];
			var focusableSelector = candidateSelectors.join(',');

			/**
			 * Set the default value to a given argument.
			 * Taken from https://stackoverflow.com/a/894877.
			 *
			 * @param {any} arg Argument to set the default `val` for.
			 * @param {any} val Default value to assign to `arg`.
			 */
			function defaultFor(arg, val) {
				return arg !== undefined ? arg : val;
			}

			return {
				throttle: throttle,
				ignoreStaleResponses: ignoreStaleResponses,
				keys: keys,
				focusableSelector: focusableSelector,
				defaultFor: defaultFor
			};
		}
	]);
})(angular.module('qstrap.util', []));

/**
 * @ngdoc directive
 * @name qstrap:qstrap.auto-complete
 *
 * @restrict A
 * @element input
 * @description
 * A very basic auto-complete/typeahead free-text input that provides suggestions as the user types. This directive is very
 * basic in scope, allowing only text suggestions, suggestions must begin with the search string, and it does not perform
 * any validation. If you require more features or more advanced searches, take a look at
 * <a href='#/api/qstrap:qstrap.quick-search'>qstrap.quick-search</a>, which provides similar but increased functionality in
 * a slightly different format.
 *
 * @param {expression} value The name of the scope variable to which the input value is bound
 * @param {expression} items Array of possible string values. May be wrapped in a promise.
 * @param {expression=} search Optional search function for a custom search. Must return an array of strings or menu items (as defined
 * 								in the qmenu documentation), optionally wrapped in a promise. `$searchTerm` is available as an
 * 								expression variable. All items returned by the custom search __must have a label that starts
 * 								with the search term__.
 *
 * 								If your search function returns a promise (eg makes an ajax call to perform a search), it is recommended
 * 								that you implement a debounce in your search function or set a searchInterval. Otherwise, your search
 * 								function will be called with every change in the input.
 * @param {expression=} onChange Callback when the input is changed. `$value` is available as an expression variable
 * @param {string=} searchInterval If specified, throttles invocations of the search function to once in that many milliseconds.
 *								Also makes more recent searches take precedence over older ones, even if the promises resolve out of order.
 * @param {string=} startChars The minimum number of characters required before auto-complete is shown. Default is 2
 * @param {string=} placeholder Placeholder text for the input
 *
 * @example
	<example module="qstrap">
		<file name="autoComplete.html">

			<div id="autoCompleteDemo" ng-controller="autoCompleteDemoCtrl">
				<h1>Array of Items Example</h1>
				<p>Enter your home state:</p>
				<span qstrap.auto-complete items="autoCompleteItems" value="state" placeholder="State Name..." on-change="change($value)" ></span>
				<p>State: {{state}}</p>

				<h1>Custom Search Example</h1>
				<p><em>This example shows how a custom search can be used in place of the default search. It simulates
				an ajax call with a 1.5-second timer before resolving the promise. Note that any custom search functions
				<b>must</b> return only items whose labels begin with the search term (ie no fuzzy searches, etc.)</em></p>
				<p>Enter your favorite actor:</p>
				<span qstrap.auto-complete items="autoCompleteItems" search="customSearch($searchTerm)" value="actor" placeholder="Actor Name..." ></span>
				<p>Actor: {{actor}}</p>
			</div>
		</file>
		<file name="autoComplete.js">
			angular.module('qstrap.autoComplete').controller('autoCompleteDemoCtrl', function($scope, $timeout, $q) {
				// Basic autoComplete items - state names
				$scope.autoCompleteItems = ['Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virgin Island','Virginia','Washington','West Virginia','Wisconsin','Wyoming'];

				$scope.customSearchItems = [
					{label: 'Jason Bourne', value: 'Jaybourne'},
					{label: 'Jack Black', value: 'JBLck'},
					{label: 'Jack Sparrow', value: 'sparrow'},
					{label: 'JayZ', value: 'JayZ'},
					{label: 'Jack Bauer', value: 'JBauer'}
				];

				$scope.change = function(value) {
					console.log('Changed!' + value);
				};

				// Custom search function
				$scope.customSearch = function(searchTerm) {
					var filtered = [];

					// Filter based on "startsWith"
					angular.forEach($scope.customSearchItems, function(item) {
						if (item.label.toLowerCase().indexOf(searchTerm) === 0) {
							filtered.push(item);
						}
					});

					var deferred = $q.defer();

					$timeout(function() {
						deferred.resolve(filtered);
					}, 1500);

					return deferred.promise;
				};

			});
		</file>
	</example>
 */

(function (module) {
	'use strict';

	module.factory('qstrap.$autoComplete', [
		'$q',
		'$timeout',
		'qstrap.$menu',
		'qstrap.util',
		function($q, $timeout, QMenu, util) {

			var DEFAULT_MIN_CHARS = 2;

			function AutoComplete(element, values, options) {

				var that = this;

				this._element = element;
				this._valuesPromise = $q.when(values);
				this._options = options;
				this._items = [];
				this._selectedIndex = -1;
				this._searchTerm = '';

				this._searchFn = options.searchFn;
				if (options.searchFn && options.searchInterval) {
					this._searchFn = util.ignoreStaleResponses(options.searchFn);
					this.updateMenuItems = util.throttle(this.updateMenuItems, options.searchInterval);
				}

				var menuOpts = {
					items: this._valuesPromise,
					action: function(val, item) {
						that.useSuggestion(item);
					},
					// Non-empty string to prevent the default QMenu show event
					showEvent: ' ',
					shouldSetFocusOnFirstItem: false
				};

				this._menu = new QMenu(element, menuOpts);

				element.data('q.qmenu', this._menu);
				element.on('blur', this.hideMenu.bind(this));
				element.on('keyup', this.handleInput.bind(this));
				element.on('keydown', this.handleKeydown.bind(this));
			}

			function filterStartsWith(filterText, values) {
				var filtered = [];

				// Filter based on "startsWith"
				angular.forEach(values, function(value) {
					// Sort alphabetically by string or by object label
					var text = typeof value === 'string' ? value : value.label;
					if (!text) {
						return;
					}
					if (text.toLowerCase().indexOf(filterText) === 0) {
						filtered.push(text);
					}
				});

				return filtered;
			}

			AutoComplete.prototype = {

				filterItems: function(filterText) {
					// Create items promise that will resolve with filtered array
					filterText = filterText.toLowerCase();

					if (!this._searchFn) {
						return this._valuesPromise.then(function(values) {
							var filtered = filterStartsWith(filterText, values);
							return filtered;
						});
					} else {
						return $q.when(this._searchFn({$searchTerm: filterText}));
					}
				},

				formatMenuItems: function(items) {
					if (!items || !items.length) {
						return [];
					}
					var newItems = [];
					for (var i = 0; i < items.length; i++) {
						var value = items[i];
						if (typeof value === 'string') {
							// Convert string to menu item object
							newItems.push({
								label: value,
								value: value,
								className: this._selectedIndex === i ? 'autocomplete-selected' : ''
							});
						} else if (typeof value === 'object') {
							// Add classname to existing menu item object
							value.className = this._selectedIndex === i ? 'autocomplete-selected' : '';
							newItems.push(value);
						}
					}
					return newItems;
				},

				updateMenuItems: function() {

					this._items = [];
					this._selectedIndex = -1;

					var that = this;
					var newItems = this.filterItems(this._searchTerm)
						.then(this.formatMenuItems.bind(this))
						.then(function(items) {that._items = items; return items;});

					if (!this.menuVisible()) {
						// Update items in definition and show menu
						this._menu._menuDef.items = newItems;
						this._element[0].showMenu();
						// Bind events for menu itself
						this.bindMenuDOMEvents();
					} else {
						// Update qstrap menu items for menu already shown
						this._menu.updateMenuItems(newItems);
					}

					// Bind events for menu items
					$timeout(function() {
						that.bindMenuItemDOMEvents();
					});
				},

				hideMenu: function(e) {
					var that = this;

					// Timeout to avoid interrupting default action
					// (ie when menu item is selected)
					$timeout(function() {
						that.closeMenu();
						that.clearSuggestion();
						that._selectedIndex = -1;
					}, 250);
				},

				closeMenu: function() {
					this._element[0].closeMenu();
				},

				handleInput: function(e) {

					// Get input value
					var value = this._element[0].value;

					// Check if search has changed
					if (value === this._searchTerm) {
						return;
					}

					// Update search term, reset selection index
					this._searchTerm = value;
					this._selectedIndex = -1;
					this.clearSuggestion();

					// Check input length to update/hide menu
					var min = this._options.minChars || DEFAULT_MIN_CHARS;
					if (!!value && value.length >= min) {
						this.updateMenuItems();
					} else {
						this.closeMenu();
					}
				},

				menuVisible: function() {
					return !!this._menu._menuDom;
				},

				handleKeydown: function(e) {

					var code = e.keyCode;
					switch(code) {
						// UP
						case 38:
							this.handleChangeIndex(e, this.indexUp.bind(this));
							break;
						// DOWN
						case 40:
							this.handleChangeIndex(e, this.indexDown.bind(this));
							break;
						// RETURN
						case 13:
							this.handleReturnKey(e);
							break;
						// ESCAPE
						case 27:
							this.handleEscapeKey(e);
							break;
						// TAB
						case 9:
							this.handleTabKey(e);
							break;
					}
				},

				handleChangeIndex: function(e, indexUpdateFn) {
					e.preventDefault();
					e.stopPropagation();

					// Move index if menu is visible
					if (this.menuVisible()) {

						// Do nothing if mouse is hovering (would display multiple selections)
						if (this._menu._menuDom && this._menu._menuDom._isMouseOver) {
							return;
						}

						indexUpdateFn();

						// Render update with new selection
						this.setSuggestion(this._selectedIndex);
					}
					this.updateSelectedMenuItem();
					this.scrollToSelected();
				},

				indexUp: function() {
					this.changeIndexBy(-1);
				},

				indexDown: function() {
					this.changeIndexBy(1);
				},

				changeIndexBy: function(delta) {
					var len = this._items.length;
					var i = 0;

					// Go up or down one index, then keep doing it until we find
					// a non-header item, wrapping around the edges if needed.
					do {
						++i;
						this._selectedIndex = this._selectedIndex + delta;

						if (this._selectedIndex >= len) {
							this._selectedIndex = 0;
						}
						if (this._selectedIndex < 0) {
							this._selectedIndex = len - 1;
						}
					} while (i <= len && this._items[this._selectedIndex].header);

					// If we didn't find any non-header items in the whole menu,
					// don't select anything.
					if (i > len) {
						this._selectedIndex = -1;
					}
				},

				updateSelectedMenuItem: function() {
					if (!this.menuVisible()) {
						// If no menu, then use updateMenuItems to render menu
						this.updateMenuItems();
					} else {
						// If menu visible, only update selected element to avoid re-rendering
						$(this._menu._menuDom).find('.autocomplete-selected').removeClass('autocomplete-selected');
						if (this._selectedIndex > -1) {
							var that = this;
							var children = $(this._menu._menuDom).find('ul').children('li');
							var selected = children.get(that._selectedIndex);
							$(selected).addClass('autocomplete-selected');
						}
					}
				},

				scrollToSelected: function() {
					var that = this;
					$timeout(function() {
						var container = $(that._menu._menuDom).find('ul');
						var selected = $(container).find('.autocomplete-selected');

						// No selection, return
						if (!selected.length) {
							return;
						}

						var scrollTop = container.scrollTop(),
							containerHeight = container.innerHeight(),
							selectedTop = selected.position().top,
							selectedHeight = selected.outerHeight();

						if (selectedTop < 0) {
							// Scroll up to make item visible at top of visible list
							container.scrollTop(scrollTop + selectedTop);
						} else if (selectedTop + selectedHeight > containerHeight) {
							// Scroll down to make item visible at bottom of visible list
							container.scrollTop((scrollTop + selectedTop + selectedHeight) - containerHeight);
						}
					});
				},

				handleReturnKey: function(e) {
					// Do nothing if there isn't a selected item
					if (!this.menuVisible() || this._selectedIndex === -1) {
						return;
					}
					// Use the selected item as the new value
					e.preventDefault();
					this.useSuggestion(this._items[this._selectedIndex]);
					this.closeMenu();
				},

				handleEscapeKey: function(e) {
					e.preventDefault();
					this.closeMenu();
					this._selectedIndex = -1;
					this.clearSuggestion();
				},

				handleTabKey: function(e) {
					// Do nothing if there isn't a selected item
					if (!this.menuVisible() || this._selectedIndex === -1) {
						return;
					}

					// Use the selected item and close menu
					this.useSuggestion(this._items[this._selectedIndex]);
					this.closeMenu();
				},

				bindMenuDOMEvents: function() {
					var that = this;
					this._menu._menuDom.on('mouseleave', function() {
						that.clearSuggestion();
						that._menu._menuDom._isMouseOver = false;
					});
					this._menu._menuDom.on('mouseenter', function() {
						that.setSelectedIndex(-1);
						that._menu._menuDom._isMouseOver = true;
					});
				},

				bindMenuItemDOMEvents: function() {
					var that = this;
					this._menu._menuDom.find('ul').first().children().each(function(i) {
						$(this).find('a').first().on('mouseenter', function() {
							that.setSuggestion(i);
						});
					});
				},

				setSelectedIndex: function(i) {
					if (this._selectedIndex !== i) {
						this._selectedIndex = i;
						// this.updateMenuItems();
						this.updateSelectedMenuItem();
					}
				},

				setSuggestion: function(index) {
					var item = this._items[index] || {};
					var suggestedText = item.label;
					if (!suggestedText || typeof suggestedText !== 'string') {
						return;
					}

					var suggestString = this._searchTerm + suggestedText.substring(this._searchTerm.length);

					this._options.setSuggestion(suggestString);
				},

				clearSuggestion: function() {
					this._options.setSuggestion('');
				},

				useSuggestion: function(item) {
					this.clearSuggestion();
					this._searchTerm = this._options.setValue(item);
				}
			};

			return AutoComplete;
		}
	]);

	module.directive('qstrap.autoComplete', [
		'$q',
		'$timeout',
		'$templateCache',
		'$compile',
		'qstrap.$autoComplete',
		function($q, $timeout, $templateCache, $compile, AutoComplete)
		{
			var DEFAULT_MIN_CHARS = 2;

			$templateCache.put('qstrap.autoComplete.html', '' +
				'<div class="autocomplete-container">' +
					'<input class="form-control" type="text" ng-model="value" ng-attr-placeholder="{{placeholder}}" />' +
					'<input class="form-control" type="text" ng-model="suggestion" disabled="true" />' +
				'</div>'
			);

			return {
				scope:
				{
					value: '=',
					items: '=',
					search: '&?',
					searchInterval: '@?',
					startChars: '@?',
					placeholder: '@?',
					onChange: '&?'
				},
				replace: true,
				templateUrl: 'qstrap.autoComplete.html',
				link: function($scope, el, attrs)
				{
					$scope.setSuggestion = function(suggestion) {
						$scope.$apply(function() {
							$scope.suggestion = suggestion;
						});
					};

					$scope.setValue = function(item) {
						$scope.$apply(function() {
							$scope.value = item.label;
							if ($scope.onChange) {
								$scope.onChange({$value: item.label});
							}
						});
						return item.label;
					};
					var input = angular.element($(el).find('input:not([disabled])')[0]);

					input.on('input', function(e) {
						if ($scope.onChange) {
							$scope.onChange({$value: $scope.value});
						}
					});

					var searchFn = !!attrs.search ? $scope.search : null;

					new AutoComplete(input, $scope.items, {
						setSuggestion: $scope.setSuggestion,
						minChars: parseInt($scope.startChars, 10),
						setValue: $scope.setValue,
						searchFn: searchFn,
						searchInterval: parseInt($scope.searchInterval, 10)
					});

				}
			};
		}
	]);
})(angular.module('qstrap.autoComplete', ['qstrap.menu', 'qstrap.util']));

/**
 * @ngdoc directive
 * @name qstrap:qstrap.quick-search
 *
 * @restrict A
 * @element input
 * @description
 * Provides quick search functionality via an input with automatic suggestions. Similar to qstrap.autoComplete, the quickSearch directive 
 * will display a list of suggestions as the user starts typing in the input, or hits the up/down arrow key. However, the quickSearch has 
 * a few key differences:
  								<ul>
  								<li>Searches are not required to only return terms beginning with the search term</li>
  								<li>Selected values can be more than simple strings</li>
  								<li>Menu items are fully customizable, including content and styling</li>
  								<li>Auto Complete "hint" (gray text suggestion) is not shown</li>
  								</ul>
 * In essence, the quickSearch should be preferred over the autoComplete directive if you need a more powerful search beyond "starts with", 
 * or the value being selected is more than a simple string
 *
 * @param {expression} search Search function to be called when input changes. Must return an array of strings or menu items as
 * 								defined in the qmenu documentation), optionally wrapped in a promise. `$searchTerm` is available as
 * 								an expression variable to be passed into the function.
 *
 * 								If your search function returns a promise (eg makes an ajax call to perform a search), it is recommended
 * 								that you implement a debounce in your search function or set a searchInterval. Otherwise, your search
 * 								function will be called with every change in the input.
 * @param {expression=} onSelect Callback function for when a user selects a search item. `$item` is available as an expression
 * 								variable to be passed into the function.
 *
 * 								By default, the search input will clear the search term after a search is complete. However, you can optionally
 * 								return a string from the `onSelect` method. If a string is returned, then this value is displayed in the input.
 * 								This string should be a string that makes up part of the search - ie, if the user typed in this string, they
 * 								would get the same search result as the one just selected.
 * @param {string=} searchInterval If specified, throttles invocations of the search function to once in that many milliseconds.
 *								Also makes more recent searches take precedence over older ones, even if the promises resolve out of order.
 * @param {string=} startChars The minimum number of characters required before auto-complete is shown. Default is 2
 * @param {string=} placeholder Placeholder text for the input
 *
 * @example
	<example module="qstrap">
		<file name="quickSearch.html">

			<div id="quickSearchDemo" ng-controller="quickSearchDemoCtrl">
				<h1>Recipient Search Example</h1>
				<p><em>This example demonstrates a search that simulates an ajax call which searches for email recipients
				based on the search term. It features custom-formatted menu items and compiles a list of recipients each
				time a recipient is selected.</em></p>
				<p>Select Recipients:</p>
				<span qstrap.quick-search placeholder="Select Recipients..." search="searchRecipients($searchTerm)" on-select="addRecipient($item)" start-chars="3"></span>
				<div ng-if="recipients.length">
					<p>Recipients:</p>
					<ul class="recipient-list">
						<li ng-repeat="recipient in recipients">
						{{recipient.firstName}} {{recipient.lastName}} ({{recipient.email}})
						</li>
					</ul>
				</div>

				<h1>Survey Selector Example</h1>
				<p><em>This is a basic example to show how you might use the quickSearch as a simple way to search for and
				select a survey in the product.</p></em>
				<p>Search for Survey</p>
				<span ng-show="!survey" qstrap.quick-search placeholder="Survey ID or name..." search="searchSurveys($searchTerm)" on-select="selectSurvey($item)" start-chars="2"></span>
				<span class="selected-survey" ng-show="survey">{{survey.name}} ({{survey.id}})<span class="icon icon-x-sm" ng-click="survey = null"></span></span>

				<h1>Throttled Search Example</h1>
				<p><em>This example uses the search-interval attribute to limit the frequency at which the search function is called.</em></p>
				<p>Throttled Search</p>
				<span qstrap.quick-search search="echo($searchTerm)" search-interval=500></span>
			</div>
		</file>
		<file name="quickSearch.js">
			angular.module('qstrap.autoComplete').controller('quickSearchDemoCtrl', function($scope, $timeout, $q) {

				$scope.recipients = [];

				var allRecipients = [
					{firstName: "Michael", lastName: "Scott", email: "theboss@dundermifflin.com"},
					{firstName: "Dwight", lastName: "Schrute", email: "dschrute@dundermifflin.com"},
					{firstName: "Jim", lastName: "Halpert", email: "jim@dundermifflin.com"},
					{firstName: "Pam", lastName: "Beesly", email: "reception@dundermifflin.com"},
					{firstName: "Oscar", lastName: "Martinez", email: "accounting@dundermifflin.com"},
					{firstName: "Andy", lastName: "Bernard", email: "andybernard98@cornell.edu"},
					{firstName: "Angela", lastName: "Martin", email: "angela@cats.com"},
					{firstName: "Creed", lastName: "Bratton", email: "creed@nsa.gov"}
				];

				function generateDom(recipient) {
					var container = angular.element('<div class="recipient-item"></div>'),
						name = angular.element('<span class="recipient-name"><span>').text(recipient.firstName + " " + recipient.lastName),
						email = angular.element('<span class="recipient-email"></span>').text(recipient.email);

					container.append(name);
					container.append(email);

					return container;
				}

				function contains(haystack, needle) {
					return haystack.toLowerCase().indexOf(needle.toLowerCase()) > -1;
				}

				// Custom search function
				$scope.searchRecipients = function(searchTerm) {

					var filtered = [];

					// Filter based on "startsWith"
					angular.forEach(allRecipients, function(recipient) {
						var include = contains(recipient.firstName, searchTerm) ||
							contains(recipient.lastName, searchTerm) ||
							contains(recipient.email, searchTerm);
						if (include) {
							filtered.push({
								value: recipient.email,
								recipient: recipient,
								label: generateDom(recipient)
							});
						}
					});

					var deferred = $q.defer();

					$timeout(function() {
						deferred.resolve(filtered);
					}, 1500);

					return deferred.promise;
				};

				$scope.addRecipient = function(item) {
					$scope.recipients.push(item.recipient);
				};

				var allSurveys = [
					{surveyId: 'SV_123', description: 'Employee Satisfaction'},
					{surveyId: 'SV_456', description: 'Customer Satisfaction'},
					{surveyId: 'SV_789', description: 'Customer Satisfaction Follow-up'},
					{surveyId: 'SV_012', description: 'Incentives Study'},
					{surveyId: 'SV_345', description: 'Post-Graduation Survey'},
					{surveyId: 'SV_678', description: 'New Student Orientation Survey'},
					{surveyId: 'SV_901', description: 'Midterm Satisfaction Survey'}
				];

				$scope.searchSurveys = function(searchTerm) {
					var filtered = [];

					angular.forEach(allSurveys, function(survey) {
						if (contains(survey.description, searchTerm) || contains(survey.surveyId, searchTerm)) {
							filtered.push({
								label: survey.description,
								value: survey.surveyId
							});
						}
					});

					return filtered;
				};

				$scope.selectSurvey = function(item) {
					$scope.survey = {
						name: item.label,
						id: item.value
					};
				};

				$scope.searchCount = 0;

				$scope.echo = function(searchTerm) {
					$scope.searchCount++;
					return [{
						header: true,
						domNode:
							'<div>' +
								'<p>Search was called with "' + searchTerm + '"</p>' +
								'<p>Called ' + $scope.searchCount + ' times in total</p>' +
							'</div>'
					}];
				};

			});
		</file>
		<file name="quickSearch.css">
			.recipient-item {
				width: 300px;
				padding: 5px;
			}

			.recipient-name {
				font-weight: bold;
				display: block;
			}

			.recipient-email {
				color: #aaa;
				display: block;
			}

			ul.recipient-list {
				list-style-type: none;
				border: 1px solid #aaa;
				padding: 10px;
			}

			ul.recipient-list > li {
				border: 1px solid #aaa;
				border-radius: 3px;
				padding: 2px 5px;
				margin: 5px;
				display: inline-block;
			}

			li.autocomplete-selected .recipient-item .recipient-name {
				color: #fff;
			}

			li.autocomplete-selected .recipient-item .recipient-name {
				color: #fff;
			}

			.selected-survey {
				border: 1px solid #aaa;
				padding: 5px 10px;
				border-radius: 5px;
			}

			.selected-survey .icon {
				vertical-align: middle;
				cursor: pointer;
			}
		</file>
	</example>
 */
(function(module) {
	'use strict';
	module.directive('qstrap.quickSearch', [
		'$templateCache',
		'qstrap.$autoComplete',
		function($templateCache, AutoComplete)
		{

			$templateCache.put('qstrap.quickSearch.html', '' +
				'<input class="form-control" type="text" ng-model="value" ng-attr-placeholder="{{placeholder}}" />'
			);

			return {
				scope:
				{
					search: '&',
					searchInterval: '@?',
					startChars: '@?',
					placeholder: '@?',
					onSelect: '&?'
				},
				replace: true,
				templateUrl: 'qstrap.quickSearch.html',
				link: function($scope, el, attrs)
				{
					$scope.setSuggestion = angular.noop;

					$scope.setValue = function(value) {
						$scope.value = (!!attrs.onSelect && $scope.onSelect({$item: value})) || '';
						$scope.$apply();
						return $scope.value;
					};
					var input = angular.element($(el));

					var searchFn = !!attrs.search ? $scope.search : null;

					var autoComplete = new AutoComplete(input, $scope.items, {
						setSuggestion: $scope.setSuggestion,
						minChars: parseInt($scope.startChars, 10),
						setValue: $scope.setValue,
						searchFn: searchFn,
						searchInterval: parseInt($scope.searchInterval, 10)
					});

				}
			};
		}
	]);
})(angular.module('qstrap.autoComplete'));

/**
 * @ngdoc directive
 * @name qstrap:qstrap.button-groups
 *
 * @restrict C
 * @description
 * Ways to group buttons together
 *
 * @param {string} .btn-group Button group container class
 * @param {string} .btn-group-sm Small buttons
 *
 * @example
<example module="qstrap">
  <file name="button-group.html">
    <style>
      .qstrap-qstrap-button-groups-page .btn-group {
        margin: 0 8px 8px 0;
      }
    </style>
    <div ng-controller="buttonGroupDemoCtrl">
      <h1>Basic Example</h1>
      <div class="btn-group" role="group">
        <div class="btn">Left</div>
        <div class="btn">Middle</div>
        <div class="btn">Right</div>
      </div>
      <h1>Button-Dropdown Combo</h1>
      <div class="btn-group" role="group">
        <div class="btn">Button</div>
        <div class="btn" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <div class="btn-group" role="group">
        <div class="btn btn-info">Info</div>
        <div class="btn btn-info" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <div class="btn-group" role="group">
        <div class="btn btn-default">Default</div>
        <div class="btn btn-default" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <div class="btn-group" role="group">
        <div class="btn btn-primary">Primary</div>
        <div class="btn btn-primary" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <div class="btn-group" role="group">
        <div class="btn btn-success">Success</div>
        <div class="btn btn-success" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <div class="btn-group" role="group">
        <div class="btn btn-warning">Warning</div>
        <div class="btn btn-warning" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <div class="btn-group" role="group">
        <div class="btn btn-danger">Danger</div>
        <div class="btn btn-danger" qstrap.menu items="items">
          <span class="icon icon-angle-down-sm"></span>
        </div>
      </div>
      <h1>Button Group Sizes</h1>
      <p>Default</p>
      <div class="btn-group" role="group">
        <div class="btn">1</div>
        <div class="btn">2</div>
        <div class="btn">3</div>
        <div class="btn">4</div>
        <div class="btn">5</div>
        <div class="btn">6</div>
        <div class="btn">7</div>
      </div>
      <br />
      <p>Small (.btn-group-sm)</p>
      <div class="btn-group btn-group-sm" role="group">
        <div class="btn">1</div>
        <div class="btn">2</div>
        <div class="btn">3</div>
        <div class="btn">4</div>
        <div class="btn">5</div>
        <div class="btn">6</div>
        <div class="btn">7</div>
      </div>
    </div>
  </file>
  <file name="button-group.js">
    angular.module('qstrap.selectMenu').controller('buttonGroupDemoCtrl', function($scope) {
      $scope.items = [{
          label: 'Option 1'
        },{
          label: 'Option 2'
        },{
          label: 'Option 3'
        }
      ];
    });
  </file>
</example>
*/

/**
 * @ngdoc directive
 * @name qstrap:qstrap.button
 *
 * @restrict C
 * @description
 * A set of CSS classes that you can add to make buttons
 *
 * @param {string} .btn Base button class, white button with gray text
 * @param {string=} .btn-sm Small button
 * @param {string=} .btn-full Displays the button as a block element and takes up the width of its container
 * @param {string=} .btn-default Gray button
 * @param {string=} .btn-primary Blue button
 * @param {string=} .btn-success Green button
 * @param {string=} .btn-info White button with blue text
 * @param {string=} .btn-warning Yellow button
 * @param {string=} .btn-danger Red button
 * @param {string=} .btn-inverted White border with white text
 * @param {string=} .btn-hover Text only; displays button border on hover
 *
 * @example
<example module="qstrap">
  <file name="data-button.html">
    <style>
      .qstrap-qstrap-button-page .btn {
        margin: 0 8px 8px 0;
      }
      .qstrap-qstrap-button-page .dark-backdrop {
        background-color: #37546C;
        border-radius: 5px;
        height: 60px;
        padding: 12px 0 0 12px;
      }
    </style>
    <h1>class="btn"</h1>
      <div class="btn">Button</div>
      <div class="btn btn-info">Info Button</div>
      <div class="btn btn-default">Default Button</div>
      <div class="btn btn-primary">Primary Button</div>
      <div class="btn btn-success">Success Button</div>
      <div class="btn btn-warning">Warning Button</div>
      <div class="btn btn-danger">Danger Button</div>
      <div class="btn disabled">Disabled Button</div>
      <div class="btn btn-hover">Hover Button</div>
      <div class="btn btn-hover btn-info">Hover Info Button</div>

      <h1>class="btn btn-sm"</h1>
      <div class="btn btn-sm">Button</div>
      <div class="btn btn-sm btn-info">Info Button</div>
      <div class="btn btn-sm btn-default">Default Button</div>
      <div class="btn btn-sm btn-primary">Primary Button</div>
      <div class="btn btn-sm btn-success">Success Button</div>
      <div class="btn btn-sm btn-warning">Warning Button</div>
      <div class="btn btn-sm btn-danger">Danger Button</div>
      <div class="btn btn-sm disabled">Disabled Button</div>
      <div class="btn btn-sm btn-hover">Hover Button</div>
      <div class="btn btn-sm btn-hover btn-info">Hover Info Button</div>

      <h1>inverted buttons</h1>
      <div class="dark-backdrop">
        <div class="btn btn-inverted">Inverted Button</div>
        <div class="btn btn-hover btn-inverted">Inverted Hover Button</div>
      </div>

      <h1>menu buttons</h1>
      <div class="btn btn-select">
        btn-select
        <span class="caret"></span>
      </div>
      <div class="btn btn-select" style='max-width: 150px;'>
        This Dropdown Has extra long text so we can test the overflow properties of select buttons.
        <span class="caret"></span>
      </div>
      <div class="btn btn-sm btn-select">
        btn-sm btn-select
        <span class="caret"></span>
      </div>
      <div class="btn btn-sm btn-select" style='max-width: 150px;'>
        This Dropdown Has extra long text so we can test the overflow properties of select buttons.
        <span class="caret"></span>
      </div>
      <div class="btn btn-full btn-select">
        btn-full btn-select
        <span class="caret"></span>
      </div>

      <h1>buttons with icons</h1>
      <div class="btn">
      	<span class="icon btn-icon-check"></span>
      	<span>btn-icon-check</span>
      </div>
      <div class="btn">
      	<span class="icon btn-icon-search"></span>
      	<span>btn-icon-search</span>
      </div>
      <div class="btn">
      	<span class="icon btn-icon-gear"></span>
      	<span>btn-icon-gear</span>
      </div>
      <div class="btn">
      	<span>btn-icon-plus</span>
      	<span class="icon btn-icon-plus"></span>
      </div>
      <div class="btn">
      	<span>btn-icon-x</span>
      	<span class="icon btn-icon-x"></span>
      </div>
      <div class="btn">
      	<span class="icon btn-icon-angle-down"></span>
      </div>
      <div class="btn">
      	<span class="icon btn-icon-angle-left"></span>
      </div>
      <div class="btn">
      	<span class="icon btn-icon-angle-right"></span>
      </div>
      <div class="btn">
      	<span class="icon btn-icon-angle-up"></span>
      </div>
      <div class="btn btn-full btn-success">
        <span class="icon btn-icon-plus"></span>
        <span>btn-full btn-success</span>
      </div>
      <br>
      <div class="btn btn-sm">
      	<span class="icon btn-icon-check"></span>
      	<span>btn-icon-check</span>
      </div>
      <div class="btn btn-sm">
      	<span class="icon btn-icon-search"></span>
      	<span>btn-icon-search</span>
      </div>
      <div class="btn btn-sm">
      	<span class="icon btn-icon-gear"></span>
      	<span>btn-icon-gear</span>
      </div>
      <div class="btn btn-sm">
      	<span>btn-icon-plus</span>
      	<span class="icon btn-icon-plus"></span>
      </div>
      <div class="btn btn-sm">
      	<span>btn-icon-x</span>
      	<span class="icon btn-icon-x"></span>
      </div>
      <div class="btn btn-sm">
      	<span class="icon btn-icon-angle-down"></span>
      </div>
      <div class="btn btn-sm">
      	<span class="icon btn-icon-angle-left"></span>
      </div>
      <div class="btn btn-sm">
        <span class="icon btn-icon-angle-right"></span>
      </div>
      <div class="btn btn-sm">
        <span class="icon btn-icon-angle-up"></span>
      </div>
      <div class="btn btn-sm btn-full btn-danger">
        <span class="icon btn-icon-x"></span>
        <span>btn-sm btn-full btn-danger</span>
      </div>
  </file>
</example>
*/

/*
 * Originally written by (c) 2012 Stefan Petre
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0.txt
 *
 */

(function(factory) {
        "use strict";
        if (typeof define === 'function' && define.amd) {
            define(['jquery'], factory);
        } else if (window.jQuery && !window.jQuery.fn.colorpicker) {
            factory(window.jQuery);
        }
    }
    (function($) {
        'use strict';

        // Color object
        var Color = function(val) {
            this.value = {
                h: 0,
                s: 0,
                b: 0,
                a: 1
            };
            this.origFormat = null; // original string format
            if (val) {
                if (val.toLowerCase !== undefined) {
                    this.setColor(val);
                } else if (val.h !== undefined) {
                    this.value = val;
                }
            }
        };

        Color.prototype = {
            constructor: Color,
            // 140 predefined colors from the HTML Colors spec
            colors: {
                "aliceblue": "#f0f8ff",
                "antiquewhite": "#faebd7",
                "aqua": "#00ffff",
                "aquamarine": "#7fffd4",
                "azure": "#f0ffff",
                "beige": "#f5f5dc",
                "bisque": "#ffe4c4",
                "black": "#000000",
                "blanchedalmond": "#ffebcd",
                "blue": "#0000ff",
                "blueviolet": "#8a2be2",
                "brown": "#a52a2a",
                "burlywood": "#deb887",
                "cadetblue": "#5f9ea0",
                "chartreuse": "#7fff00",
                "chocolate": "#d2691e",
                "coral": "#ff7f50",
                "cornflowerblue": "#6495ed",
                "cornsilk": "#fff8dc",
                "crimson": "#dc143c",
                "cyan": "#00ffff",
                "darkblue": "#00008b",
                "darkcyan": "#008b8b",
                "darkgoldenrod": "#b8860b",
                "darkgray": "#a9a9a9",
                "darkgreen": "#006400",
                "darkkhaki": "#bdb76b",
                "darkmagenta": "#8b008b",
                "darkolivegreen": "#556b2f",
                "darkorange": "#ff8c00",
                "darkorchid": "#9932cc",
                "darkred": "#8b0000",
                "darksalmon": "#e9967a",
                "darkseagreen": "#8fbc8f",
                "darkslateblue": "#483d8b",
                "darkslategray": "#2f4f4f",
                "darkturquoise": "#00ced1",
                "darkviolet": "#9400d3",
                "deeppink": "#ff1493",
                "deepskyblue": "#00bfff",
                "dimgray": "#696969",
                "dodgerblue": "#1e90ff",
                "firebrick": "#b22222",
                "floralwhite": "#fffaf0",
                "forestgreen": "#228b22",
                "fuchsia": "#ff00ff",
                "gainsboro": "#dcdcdc",
                "ghostwhite": "#f8f8ff",
                "gold": "#ffd700",
                "goldenrod": "#daa520",
                "gray": "#808080",
                "green": "#008000",
                "greenyellow": "#adff2f",
                "honeydew": "#f0fff0",
                "hotpink": "#ff69b4",
                "indianred ": "#cd5c5c",
                "indigo ": "#4b0082",
                "ivory": "#fffff0",
                "khaki": "#f0e68c",
                "lavender": "#e6e6fa",
                "lavenderblush": "#fff0f5",
                "lawngreen": "#7cfc00",
                "lemonchiffon": "#fffacd",
                "lightblue": "#add8e6",
                "lightcoral": "#f08080",
                "lightcyan": "#e0ffff",
                "lightgoldenrodyellow": "#fafad2",
                "lightgrey": "#d3d3d3",
                "lightgreen": "#90ee90",
                "lightpink": "#ffb6c1",
                "lightsalmon": "#ffa07a",
                "lightseagreen": "#20b2aa",
                "lightskyblue": "#87cefa",
                "lightslategray": "#778899",
                "lightsteelblue": "#b0c4de",
                "lightyellow": "#ffffe0",
                "lime": "#00ff00",
                "limegreen": "#32cd32",
                "linen": "#faf0e6",
                "magenta": "#ff00ff",
                "maroon": "#800000",
                "mediumaquamarine": "#66cdaa",
                "mediumblue": "#0000cd",
                "mediumorchid": "#ba55d3",
                "mediumpurple": "#9370d8",
                "mediumseagreen": "#3cb371",
                "mediumslateblue": "#7b68ee",
                "mediumspringgreen": "#00fa9a",
                "mediumturquoise": "#48d1cc",
                "mediumvioletred": "#c71585",
                "midnightblue": "#191970",
                "mintcream": "#f5fffa",
                "mistyrose": "#ffe4e1",
                "moccasin": "#ffe4b5",
                "navajowhite": "#ffdead",
                "navy": "#000080",
                "oldlace": "#fdf5e6",
                "olive": "#808000",
                "olivedrab": "#6b8e23",
                "orange": "#ffa500",
                "orangered": "#ff4500",
                "orchid": "#da70d6",
                "palegoldenrod": "#eee8aa",
                "palegreen": "#98fb98",
                "paleturquoise": "#afeeee",
                "palevioletred": "#d87093",
                "papayawhip": "#ffefd5",
                "peachpuff": "#ffdab9",
                "peru": "#cd853f",
                "pink": "#ffc0cb",
                "plum": "#dda0dd",
                "powderblue": "#b0e0e6",
                "purple": "#800080",
                "red": "#ff0000",
                "rosybrown": "#bc8f8f",
                "royalblue": "#4169e1",
                "saddlebrown": "#8b4513",
                "salmon": "#fa8072",
                "sandybrown": "#f4a460",
                "seagreen": "#2e8b57",
                "seashell": "#fff5ee",
                "sienna": "#a0522d",
                "silver": "#c0c0c0",
                "skyblue": "#87ceeb",
                "slateblue": "#6a5acd",
                "slategray": "#708090",
                "snow": "#fffafa",
                "springgreen": "#00ff7f",
                "steelblue": "#4682b4",
                "tan": "#d2b48c",
                "teal": "#008080",
                "thistle": "#d8bfd8",
                "tomato": "#ff6347",
                "turquoise": "#40e0d0",
                "violet": "#ee82ee",
                "wheat": "#f5deb3",
                "white": "#ffffff",
                "whitesmoke": "#f5f5f5",
                "yellow": "#ffff00",
                "yellowgreen": "#9acd32"
            },
            _sanitizeNumber: function(val) {
                if (typeof val === 'number') {
                    return val;
                }
                if (isNaN(val) || (val === null) || (val === '') || (val === undefined)) {
                    return 1;
                }
                if (val.toLowerCase !== undefined) {
                    return parseFloat(val);
                }
                return 1;
            },
            //parse a string to HSB
            setColor: function(strVal) {
                strVal = strVal.toLowerCase();
                if (strVal.charAt(0) !== '#') {
                    strVal = '#' + strVal;
                }
                this.value = this.stringToHSB(strVal) || {
                    h: 0,
                    s: 0,
                    b: 0,
                    a: 1
                };
            },
            stringToHSB: function(strVal) {
                strVal = strVal.toLowerCase();
                var that = this,
                    result = false;
                $.each(this.stringParsers, function(i, parser) {
                    var match = parser.re.exec(strVal),
                        values = match && parser.parse.apply(that, [match]),
                        format = parser.format || 'rgba';
                    if (values) {
                        if (format.match(/hsla?/)) {
                            result = that.RGBtoHSB.apply(that, that.HSLtoRGB.apply(that, values));
                        } else {
                            result = that.RGBtoHSB.apply(that, values);
                        }
                        that.origFormat = format;
                        return false;
                    }
                    return true;
                });
                return result;
            },
            setHue: function(h) {
                this.value.h = 1 - h;
            },
            setSaturation: function(s) {
                this.value.s = s;
            },
            setBrightness: function(b) {
                this.value.b = 1 - b;
            },
            setAlpha: function(a) {
                this.value.a = parseInt((1 - a) * 100, 10) / 100;
            },
            toRGB: function(h, s, b, a) {
                if (!h) {
                    h = this.value.h;
                    s = this.value.s;
                    b = this.value.b;
                }
                h *= 360;
                var R, G, B, X, C;
                h = (h % 360) / 60;
                C = b * s;
                X = C * (1 - Math.abs(h % 2 - 1));
                R = G = B = b - C;

                h = ~~h;
                R += [C, X, 0, 0, X, C][h];
                G += [X, C, C, X, 0, 0][h];
                B += [0, 0, X, C, C, X][h];
                return {
                    r: Math.round(R * 255),
                    g: Math.round(G * 255),
                    b: Math.round(B * 255),
                    a: a || this.value.a
                };
            },
            toHex: function(h, s, b, a) {
                var rgb = this.toRGB(h, s, b, a);
                return '#' + ((1 << 24) | (parseInt(rgb.r) << 16) | (parseInt(rgb.g) << 8) | parseInt(rgb.b)).toString(16).substr(1);
            },
            toHSL: function(h, s, b, a) {
                h = h || this.value.h;
                s = s || this.value.s;
                b = b || this.value.b;
                a = a || this.value.a;

                var H = h,
                    L = (2 - s) * b,
                    S = s * b;
                if (L > 0 && L <= 1) {
                    S /= L;
                } else {
                    S /= 2 - L;
                }
                L /= 2;
                if (S > 1) {
                    S = 1;
                }
                return {
                    h: isNaN(H) ? 0 : H,
                    s: isNaN(S) ? 0 : S,
                    l: isNaN(L) ? 0 : L,
                    a: isNaN(a) ? 0 : a,
                };
            },
            toAlias: function(r, g, b, a) {
                var rgb = this.toHex(r, g, b, a);
                for (var alias in this.colors) {
                    if (this.colors[alias] == rgb) {
                        return alias;
                    }
                }
                return false;
            },
            RGBtoHSB: function(r, g, b, a) {
                r /= 255;
                g /= 255;
                b /= 255;

                var H, S, V, C;
                V = Math.max(r, g, b);
                C = V - Math.min(r, g, b);
                H = (C === 0 ? null :
                    V === r ? (g - b) / C :
                    V === g ? (b - r) / C + 2 :
                    (r - g) / C + 4
                );
                H = ((H + 360) % 6) * 60 / 360;
                S = C === 0 ? 0 : C / V;
                return {
                    h: this._sanitizeNumber(H),
                    s: S,
                    b: V,
                    a: this._sanitizeNumber(a)
                };
            },
            HueToRGB: function(p, q, h) {
                if (h < 0) {
                    h += 1;
                } else if (h > 1) {
                    h -= 1;
                }
                if ((h * 6) < 1) {
                    return p + (q - p) * h * 6;
                } else if ((h * 2) < 1) {
                    return q;
                } else if ((h * 3) < 2) {
                    return p + (q - p) * ((2 / 3) - h) * 6;
                } else {
                    return p;
                }
            },
            HSLtoRGB: function(h, s, l, a) {
                if (s < 0) {
                    s = 0;
                }
                var q;
                if (l <= 0.5) {
                    q = l * (1 + s);
                } else {
                    q = l + s - (l * s);
                }

                var p = 2 * l - q;

                var tr = h + (1 / 3);
                var tg = h;
                var tb = h - (1 / 3);

                var r = Math.round(this.HueToRGB(p, q, tr) * 255);
                var g = Math.round(this.HueToRGB(p, q, tg) * 255);
                var b = Math.round(this.HueToRGB(p, q, tb) * 255);
                return [r, g, b, this._sanitizeNumber(a)];
            },
            toString: function(format) {
                format = format || 'rgba';
				var rgb, hsl;
                switch (format) {
                    case 'rgb':
                        {
                            rgb = this.toRGB();
                            return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
                        }
                        break;
                    case 'rgba':
                        {
                            rgb = this.toRGB();
                            return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
                        }
                        break;
                    case 'hsl':
                        {
                            hsl = this.toHSL();
                            return 'hsl(' + Math.round(hsl.h * 360) + ',' + Math.round(hsl.s * 100) + '%,' + Math.round(hsl.l * 100) + '%)';
                        }
                        break;
                    case 'hsla':
                        {
                            hsl = this.toHSL();
                            return 'hsla(' + Math.round(hsl.h * 360) + ',' + Math.round(hsl.s * 100) + '%,' + Math.round(hsl.l * 100) + '%,' + hsl.a + ')';
                        }
                        break;
                    case 'hex':
                        {
                            return this.toHex();
                        }
                        break;
                    case 'alias':
                        return this.toAlias() || this.toHex();
                    default:
                        {
                            return false;
                        }
                        break;
                }
            },
            // a set of RE's that can match strings and generate color tuples.
            // from John Resig color plugin
            // https://github.com/jquery/jquery-color/
            stringParsers: [{
                re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
                format: 'hex',
                parse: function(execResult) {
                    return [
                        parseInt(execResult[1], 16),
                        parseInt(execResult[2], 16),
                        parseInt(execResult[3], 16),
                        1
                    ];
                }
            }, {
                re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
                format: 'hex',
                parse: function(execResult) {
                    return [
                        parseInt(execResult[1] + execResult[1], 16),
                        parseInt(execResult[2] + execResult[2], 16),
                        parseInt(execResult[3] + execResult[3], 16),
                        1
                    ];
                }
            }, {
                re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
                format: 'rgb',
                parse: function(execResult) {
                    return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        1
                    ];
                }
            }, {
                re: /rgb\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*?\)/,
                format: 'rgb',
                parse: function(execResult) {
                    return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        1
                    ];
                }
            }, {
                re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                format: 'rgba',
                parse: function(execResult) {
                    return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        execResult[4]
                    ];
                }
            }, {
                re: /rgba\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                format: 'rgba',
                parse: function(execResult) {
                    return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        execResult[4]
                    ];
                }
            }, {
                re: /hsl\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*?\)/,
                format: 'hsl',
                parse: function(execResult) {
                    return [
                        execResult[1] / 360,
                        execResult[2] / 100,
                        execResult[3] / 100,
                        execResult[4]
                    ];
                }
            }, {
                re: /hsla\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                format: 'hsla',
                parse: function(execResult) {
                    return [
                        execResult[1] / 360,
                        execResult[2] / 100,
                        execResult[3] / 100,
                        execResult[4]
                    ];
                }
            }, {
                //predefined color name
                re: /^([a-z]{3,})$/,
                format: 'alias',
                parse: function(execResult) {
                    var hexval = this.colorNameToHex(execResult[0]) || '#000000';
                    var match = this.stringParsers[0].re.exec(hexval),
                        values = match && this.stringParsers[0].parse.apply(this, [match]);
                    return values;
                }
            }],
            colorNameToHex: function(name) {
                if (typeof this.colors[name.toLowerCase()] !== 'undefined') {
                    return this.colors[name.toLowerCase()];
                }
                return false;
            }
        };


        var defaults = {
            inline: false, //forces to show the colorpicker as an inline element
            color: false, //forces a color
            format: false, //forces a format
            input: 'input', // children input selector
            container: false, // container selector
            component: '.add-on, .input-group-addon', // children component selector
            sliders: {
                saturation: {
                    maxLeft: 100,
                    maxTop: 100,
                    callLeft: 'setSaturation',
                    callTop: 'setBrightness'
                },
                hue: {
                    maxLeft: 0,
                    maxTop: 100,
                    callLeft: false,
                    callTop: 'setHue'
                },
                alpha: {
                    maxLeft: 0,
                    maxTop: 100,
                    callLeft: false,
                    callTop: 'setAlpha'
                }
            },
            slidersHorz: {
                saturation: {
                    maxLeft: 100,
                    maxTop: 100,
                    callLeft: 'setSaturation',
                    callTop: 'setBrightness'
                },
                hue: {
                    maxLeft: 100,
                    maxTop: 0,
                    callLeft: 'setHue',
                    callTop: false
                },
                alpha: {
                    maxLeft: 100,
                    maxTop: 0,
                    callLeft: 'setAlpha',
                    callTop: false
                }
            },
            template: '<div class="colorpicker qmenu dropdown-menu">' +
						'<div class="colorpicker-saturation"><i><b></b></i></div>' +
						'<div class="colorpicker-hue"><i></i></div>' +
						'<div class="colorpicker-alpha"><i></i></div>' +
						'<div class="colorpicker-color"><div /></div>' +
					  '</div>'
        };

        var Colorpicker = function(element, options) {
            this.element = $(element).addClass('colorpicker-element');
            this.options = $.extend({}, defaults, this.element.data(), options);
            this.component = this.options.component;
            this.component = (this.component !== false) ? this.element.find(this.component) : false;
            if (this.component && (this.component.length === 0)) {
                this.component = false;
            }
            this.container = (this.options.container === true) ? this.element : this.options.container;
            this.container = (this.container !== false) ? $(this.container) : false;

			this.picker = $(this.options.template);

			// Is the element an input? Should we search inside for any input?
            this.input = this.element.is('input') ? this.element : (this.options.input ?
                this.element.find(this.options.input) : false);
            if (this.input && (this.input.length === 0)) {
                this.input = false;
            }
            // Set HSB color
            this.color = new Color(this.options.color !== false ? this.options.color : this.getValue());
            this.format = this.options.format !== false ? this.options.format : this.color.origFormat;
			this.inputFormat = this.options.inputFormat || this.format;

			var insetInput = false;
			if (this.input === false && this.options.showInput)
			{
				insetInput = true;
				this.picker.find('.colorpicker-color div').append(this.input = $('<input>'));
				this.updateInput();
			}

			var grayscale = ['#272727','#404040','#777777','#CCCCCC','#DDDDDD','#F7F7F7','#FFFFFF'];
			var swatches = grayscale.concat(this.options.swatches || []);
			var div = $('<div class="colorpicker-swatches"></div>');
			var that = this;
			$.each(swatches, function(index, color) {
				div.append($('<span style="background:' + color + '"></span>').on('mouseup', $.proxy(that.setValue, that, color)));
			});
			this.picker.find('.colorpicker-color').before(div);

            // Setup picker
            if (this.options.inline) {
                this.picker
					.addClass('colorpicker-inline colorpicker-visible')
					.removeClass('qmenu dropdown-menu');
            } else {
                this.picker.addClass('colorpicker-hidden');
            }
            if (this.format === 'rgba' || this.format === 'hsla') {
                this.picker.addClass('colorpicker-with-alpha');
            }
            this.picker.on('mousedown.colorpicker', $.proxy(this.mousedown, this));
            this.picker.appendTo(this.container ? this.container : $('body'));

            // Bind events
            if (this.input !== false) {
                this.input.on({
                    'keyup.colorpicker': $.proxy(this.keyup, this)
                });
                if (this.component === false) {
                    this.element.on({
                        'focus.colorpicker': $.proxy(this.show, this)
                    });
                }
                if (this.options.inline === false && !insetInput) {
                    this.element.on({
                        'focusout.colorpicker': $.proxy(this.hide, this)
                    });
                }
            }

            if (this.component !== false) {
                this.component.on({
                    'click.colorpicker': $.proxy(this.show, this)
                });
            }

            if ((this.input === false || insetInput) && (this.component === false)) {
                this.element.on({
                    'click.colorpicker': $.proxy(this.show, this)
                });
            }
            this.update();

            $($.proxy(function() {
                this.element.trigger('create');
            }, this));
        };

        Colorpicker.version = '2.0.0-beta';

        Colorpicker.Color = Color;

        Colorpicker.prototype = {
            constructor: Colorpicker,
            destroy: function() {
                this.picker.remove();
                this.element.removeData('colorpicker').off('.colorpicker');
                if (this.input !== false) {
                    this.input.off('.colorpicker');
                }
                if (this.component !== false) {
                    this.component.off('.colorpicker');
                }
                this.element.removeClass('colorpicker-element');
                this.element.trigger({
                    type: 'destroy'
                });
            },
            reposition: function() {
                if (this.options.inline !== false) {
                    return false;
                }
                var type = this.container && this.container[0] !== document.body ? 'position' : 'offset',
                    el = this.component || this.element,
                    elOffset = el[type](),
                    elHeight = el.outerHeight(),
                    elWidth = el.outerWidth(),
                    winWidth = $(window).width(),
                    winHeight = $(window).height(),
                    scrollTop = $(document).scrollTop(),
                    scrollLeft = $(document).scrollLeft(),
                    pickerHeight = this.picker.outerHeight(),
                    pickerWidth = this.picker.outerWidth();


                var pickerTop = elOffset.top + elHeight;
                //if the picker is off the screen, swap the position to be above the picker
                if (pickerTop + pickerHeight > winHeight + scrollTop) {
                    pickerTop = elOffset.top - pickerHeight;
                }

                var pickerLeft = elOffset.left;
                //if the picker is off the screen to the right, swap the position of the picker to be right-aligned
                if (pickerLeft + pickerWidth > winWidth + scrollLeft) {
                    pickerLeft = elOffset.left + elWidth - pickerWidth;
                }

                this.picker.css({
                    top: pickerTop,
                    left: pickerLeft
                });
            },
            show: function(e) {
                if (this.isDisabled()) {
                    return false;
                }
                this.picker.addClass('colorpicker-visible').removeClass('colorpicker-hidden');
                this.reposition();
                $(window).on('resize.colorpicker', $.proxy(this.reposition, this));
                if (!this.hasInput() && e) {
                    if (e.stopPropagation && e.preventDefault) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
                if (this.options.inline === false) {
                    $(window.document).on({
                        'mousedown.colorpicker': $.proxy(this.hide, this)
                    });
                }
				this.element.addClass('active');
                this.element.trigger({
                    type: 'showPicker',
                    color: this.color
                });
            },
            hide: function() {
                this.picker.addClass('colorpicker-hidden').removeClass('colorpicker-visible');
                $(window).off('resize.colorpicker', this.reposition);
                $(document).off({
                    'mousedown.colorpicker': this.hide
                });
                this.update();
				this.element.removeClass('active');
                this.element.trigger({
                    type: 'hidePicker',
                    color: this.color
                });
            },
            updateData: function(val) {
                val = val || this.color.toString(this.format);
                this.element.data('color', val);
                return val;
            },
            updateInput: function() {
                var val = this.color.toString(this.inputFormat || this.format);
                if (this.input !== false) {
                    this.input.prop('value', val);
                }
                return val;
            },
            updatePicker: function(val) {
                if (val !== undefined) {
                    this.color = new Color(val);
                }
                var sl = this.options.sliders;
                var icns = this.picker.find('i');
                if (icns.length === 0) {
                    return;
                }

				icns.eq(1).css('top', sl.hue.maxTop * (1 - this.color.value.h)).end()
					.eq(2).css('top', sl.alpha.maxTop * (1 - this.color.value.a));

                icns.eq(0).css({
                    'top': sl.saturation.maxTop - this.color.value.b * sl.saturation.maxTop,
                    'left': this.color.value.s * sl.saturation.maxLeft
                });
                this.picker.find('.colorpicker-saturation').css('backgroundColor', this.color.toHex(this.color.value.h, 1, 1, 1));
                this.picker.find('.colorpicker-alpha').css('backgroundColor', this.color.toHex());
                this.picker.find('.colorpicker-color, .colorpicker-color div').css('backgroundColor', this.color.toString(this.format));
                return val;
            },
            updateComponent: function(val) {
                val = val || this.color.toString(this.format);
                if (this.component !== false) {
                    var icn = this.component.find('i').eq(0);
                    if (icn.length > 0) {
                        icn.css({
                            'backgroundColor': val
                        });
                    } else {
                        this.component.css({
                            'backgroundColor': val
                        });
                    }
                }
                return val;
            },
            update: function(force) {
                var val = this.updateComponent();
                if ((this.getValue(false) !== false) || (force === true)) {
                    // Update input/data only if the current value is not blank
                    this.updateInput(val);
                    this.updateData(val);
                }
                this.updatePicker();
                return val;

            },
            setValue: function(val) { // set color manually
                this.color = new Color(val);
                this.update();
                this.element.trigger({
                    type: 'changeColor',
                    color: this.color,
                    value: val
                });
            },
            getValue: function(defaultValue) {
                defaultValue = (defaultValue === undefined) ? '#000000' : defaultValue;
                var val;
                if (this.hasInput()) {
                    val = this.input.val();
                } else {
                    val = this.element.data('color');
                }
                if ((val === undefined) || (val === '') || (val === null)) {
                    // if not defined or empty, return default
                    val = defaultValue;
                }
                return val;
            },
            hasInput: function() {
                return (this.input !== false);
            },
            isDisabled: function() {
                if (this.hasInput()) {
                    return (this.input.prop('disabled') === true);
                }
                return false;
            },
            disable: function() {
                if (this.hasInput()) {
                    this.input.prop('disabled', true);
                    return true;
                }
                return false;
            },
            enable: function() {
                if (this.hasInput()) {
                    this.input.prop('disabled', false);
                    return true;
                }
                return false;
            },
            currentSlider: null,
            mousePointer: {
                left: 0,
                top: 0
            },
            mousedown: function(e) {
                e.stopPropagation();
				if (e.target == this.input[0])
					return;

                e.preventDefault();

                var target = $(e.target);

                //detect the slider and set the limits and callbacks
                var zone = target.closest('div');
                var sl = this.options.sliders;
                if (!zone.is('.colorpicker')) {
                    if (zone.is('.colorpicker-saturation')) {
                        this.currentSlider = $.extend({}, sl.saturation);
                    } else if (zone.is('.colorpicker-hue')) {
                        this.currentSlider = $.extend({}, sl.hue);
                    } else if (zone.is('.colorpicker-alpha')) {
                        this.currentSlider = $.extend({}, sl.alpha);
                    } else {
                        return false;
                    }
                    var offset = zone.offset();
                    //reference to guide's style
                    this.currentSlider.guide = zone.find('i')[0].style;
                    this.currentSlider.left = e.pageX - offset.left;
                    this.currentSlider.top = e.pageY - offset.top;
                    this.mousePointer = {
                        left: e.pageX,
                        top: e.pageY
                    };
                    //trigger mousemove to move the guide to the current position
                    $(document).on({
                        'mousemove.colorpicker': $.proxy(this.mousemove, this),
                        'mouseup.colorpicker': $.proxy(this.mouseup, this)
                    }).trigger('mousemove');
                }
                return false;
            },
            mousemove: function(e) {
                e.stopPropagation();
                e.preventDefault();
                var left = Math.max(
                    0,
                    Math.min(
                        this.currentSlider.maxLeft,
                        this.currentSlider.left + ((e.pageX || this.mousePointer.left) - this.mousePointer.left)
                    )
                );
                var top = Math.max(
                    0,
                    Math.min(
                        this.currentSlider.maxTop,
                        this.currentSlider.top + ((e.pageY || this.mousePointer.top) - this.mousePointer.top)
                    )
                );
                this.currentSlider.guide.left = left + 'px';
                this.currentSlider.guide.top = top + 'px';
                if (this.currentSlider.callLeft) {
                    this.color[this.currentSlider.callLeft].call(this.color, left / 100);
                }
                if (this.currentSlider.callTop) {
                    this.color[this.currentSlider.callTop].call(this.color, top / 100);
                }
                this.update(true);

                this.element.trigger({
                    type: 'changeColor',
                    color: this.color
                });
                return false;
            },
            mouseup: function(e) {
                e.stopPropagation();
                e.preventDefault();
                $(document).off({
                    'mousemove.colorpicker': this.mousemove,
                    'mouseup.colorpicker': this.mouseup
                });
                return false;
            },
            keyup: function(e) {
				var val;
                if ((e.keyCode === 38)) {
                    if (this.color.value.a < 1) {
                        this.color.value.a = Math.round((this.color.value.a + 0.01) * 100) / 100;
                    }
                    this.update(true);
                } else if ((e.keyCode === 40)) {
                    if (this.color.value.a > 0) {
                        this.color.value.a = Math.round((this.color.value.a - 0.01) * 100) / 100;
                    }
                    this.update(true);
                } else {
                    val = this.input.val();
                    this.color = new Color(val);
                    if (this.getValue(false) !== false) {
                        this.updateData();
                        this.updateComponent();
                        this.updatePicker();
                    }
                }
                this.element.trigger({
                    type: 'changeColor',
                    color: this.color,
                    value: val
                });
            }
        };

        $.colorpicker = Colorpicker;

        $.fn.colorpicker = function(option) {
            var pickerArgs = arguments;

            return this.each(function() {
                var $this = $(this),
                    inst = $this.data('colorpicker'),
                    options = ((typeof option === 'object') ? option : {});

                if ((!inst) && (typeof option !== 'string'))
				{
                    $this.data('colorpicker', new Colorpicker(this, options));
                }
				else if(inst && typeof option === 'string')
				{
					inst[option].apply(inst, Array.prototype.slice.call(pickerArgs, 1));
                }
            });
        };

        $.fn.colorpicker.constructor = Colorpicker;

    }));

/**
 * @ngdoc directive
 * @name qstrap:qstrap.color-picker
 *
 * @restrict A
 * @element ANY
 * @description
 * A specialized menu for selecting a color
 *
 * @param {string} color Assignable angular object to data-bind to.
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The color value is available as $value)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The color value is available as $value)
 * @param {expression=} onOpen Angular expression to be executed after the picker is open
 * @param {string=} defaultColor the default color for the color picker
 * @param {string=} format the format of the color string. Either "hex", "rgb" or "rgba"
 * @param {string=} transparentColor Is the default transparent color for the picker if the alpha gets too trasparent. Note: this automatically sets the format to "rgba".
 * @param {array=} swatches an array of colors that will be used in the picker
 *
 * @example
	<example module="qstrap">
		<file name="colorpicker.html">
			<style>
				.qstrap-qstrap-color-picker-page div {
					overflow: hidden;
				}
				.qstrap-qstrap-color-picker-page .picker {
					float: left;
					margin-right: 12px;
				}
			</style>
			<div ng-controller="colorpickerDemoCtrl">
				<div class="picker">
					<p>Default</p>
					<button class="btn btn-select" qstrap.color-picker color="hexColor">
						<span class='icon icon-square' ng-style='{color: hexColor}'></span>
						<span class=caret></span>
					</button>
				</div>
				<div class="picker">
					<p>transparent</p>
					<button class="btn btn-select" qstrap.color-picker color="rgbaColor" format="rgba">
						<span class='icon icon-square' ng-style='{color: rgbaColor}'></span>
						<span class=caret></span>
					</button>
				</div>
				<div class="picker">
					<p>Default Value</p>
					<button class="btn btn-select" qstrap.color-picker color="defaultColor" default-color="#00ACF0">
						<span class='icon icon-square' ng-style='{color: defaultColor}'></span>
						<span class=caret></span>
					</button>
				</div>
			</div>
		</file>
		<file name="colorpicker.js">
			angular.module('qstrap.colorpicker').controller('colorpickerDemoCtrl', function($scope) {
				angular.extend($scope, {
					defaultColor: '#00ACF0',
					hexColor: '#000000',
					rgbaColor: 'rgba(0,0,0,1)'
				});
			});
		</file>
	</example>
 */
angular.module('qstrap.colorpicker', [])
	.directive('qstrap.colorPicker', [
		'qstrap.swatchService',
		function(swatchService) {
			'use strict';
			var recentlyUsedSwatchService = {
				getLocalStorage: function()
				{
					return 'localStorage' in window && window.localStorage;
				},
				getRecentSwatches: function()
				{
					var ret = [],
						locStor = this.getLocalStorage();
					if (locStor && typeof locStor.getItem === 'function')
					{
						ret = angular.fromJson(locStor.getItem('qstrap.recentSwatches') || '[]');
					}
					return ret;
				},
				setRecentSwatches: function(recent)
				{
					var locStor = this.getLocalStorage();

					if (locStor && typeof locStor.setItem === 'function')
					{
						locStor.setItem('qstrap.recentSwatches', angular.toJson(recent));
					}
				},
				addRecentSwatch: function(color)
				{
					if (!color || typeof color != 'string')
						return;

					color = color.toUpperCase();

					var recent = this.getRecentSwatches();

					if (recent.indexOf(color) >= 0)
						return;

					recent.push(color);

					//only allow them to have the latest 20 colors
					while (recent.length > 20)
						recent.shift();

					this.setRecentSwatches(recent);
				},
				getGraphSwatches: function(opt_swatches)
				{
					var swatches = angular.copy(opt_swatches || swatchService.get());
					var recentyUsed = this.getRecentSwatches();
					// put recently used items that are not already on swatches
					for (var i = 0; i < recentyUsed.length && swatches.length < 35; i++) {
						if (swatches.indexOf(recentyUsed[i]) === -1) {
							swatches.push(recentyUsed[i]);
						}
					}
					// truncate to 35 colors
					if (swatches.length > 35) {
						swatches.length = 35;
					}
					return swatches;
				}
			};

			var LEFT_MOUSE = 1;
			return {
				scope: {
					color: '=',
					onChange: '&?',
					afterChange: '&?',
					onOpen: '&?',
					swatches: '=?',
					defaultColor: '@',
					format: '@',
					transparentColor: '@'
				},
				link: function($scope, element, attrs)
				{
					var changeTimeout,
						setTransparent = attrs.hasOwnProperty('transparentColor');

					element.on('mousedown', function(e) {
						// only activate on let mouse down
						if (e.which !== LEFT_MOUSE) {
							return;
						}
						element.colorpicker({
							defaultColor: $scope.defaultColor,
							format: $scope.format || 'hex',
							inputFormat: 'hex',
							color: $scope.color || $scope.defaultColor || '#000000',
							showInput: true,
							swatches: recentlyUsedSwatchService.getGraphSwatches($scope.swatches)
						})
						.on('changeColor', function (evt) {
							if (changeTimeout)
								clearTimeout(changeTimeout);

							changeTimeout = setTimeout(function() {
								if ($scope.format == 'rgb' || $scope.format == 'rgba') {
									var c = evt.color.toRGB();
									if (c.a < 0.05 && setTransparent)
										$scope.color = $scope.transparentColor;
									else
										$scope.color = 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + c.a + ')';
								} else {
									$scope.color = evt.color.toHex();
								}
								if ($scope.onChange)
									$scope.onChange({$value: $scope.color});
								$scope.$apply();
								if ($scope.afterChange)
									$scope.afterChange({$value: $scope.color});
							}, 100);
						})
						.on('hidePicker', function(evt) {
							var c = evt.color.toHex();
							recentlyUsedSwatchService.addRecentSwatch(c);
							element.colorpicker('destroy');
						});

						if ($scope.onOpen) {
							var picker = element.data('colorpicker').picker;
							$scope.onOpen({});
						}
					});
				}
			};
		}
	]);

/**
 * @ngdoc service
 * @name qstrap:qstrap.swatchService
 * @description
 * A service for setting a custom list of swatches, will show as swatches in colorpicker
 *
 * # set(swatches)
 * sets an array of custom colors, will be used in colorpicker
 * ```
 * swatchService.set(['#00FF00', '#FF0000']);
 * swatchService.set(null); // to unset and return to default
 * ```
 *
 * # get()
 * returns the current swatches or the default if none has been set
 */
angular.module('qstrap.colorpicker')
	.factory('qstrap.swatchService', [
		function () {
			'use strict';
			var customSwatches;
			// THESE ARE THE GRAPH COLORS: don't change them
			var DEFAULT_SWATCHES = ['#1E88E5','#00ACC1','#43A047','#C0CA33','#FB8C00','#E53935','#8E24AA','#3949AB','#039BE5','#00897B','#7CB342','#FDD835','#FFB300','#F4511E','#5E35B1'];

			function set (colors) {
				colors = angular.copy(colors);
				if (colors && colors.length) {
					// standardize hex values
					for (var i = 0; i < colors.length; i++) {
						colors[i] = colors[i].toUpperCase();
					}
				}
				customSwatches = colors;
			}

			function get () {
				return angular.copy(customSwatches || DEFAULT_SWATCHES);
			}

			return {
				set: set,
				get: get
			};
		}
	]);

/**
 * @ngdoc overview
 * @name qstrap:qstrap.colors
 *
 * @description
 * Below are the UX approved colors that can be used throughout the product. Elements within the product interface should use one of these color values except where a user can customize a color to their own liking (i.e. Vocalize widgets).
 *
 * If after checking the references in this page, you are still unsure what color a certain element should be, work with a UX Designer to determine the best solution. Pleae seek the advice of a UX Designer if using a color outside of the recommended usage.
 *
 * @example
<example module="qstrap">
	<file name="data-colors.html">
		<style>
			.qstrap-qstrap-colors-page ~ #example,
			.qstrap-qstrap-colors-page #example_demo,
			.qstrap-qstrap-colors-page #example_source,
			.qstrap-qstrap-colors-page .tabbable {
				display: none;
			}
			#color-docs {
				margin: -19px;
			}
			#color-docs .section {
				margin-bottom: 10px;
				clear: both;
				overflow: auto;
			}
			#color-docs .header {
				font-size: 20px !important;
				font-weight: 200;
				margin: 20px 0 !important;
			}
			#color-docs .col {
				width: 50%;
				float: left;
				padding-right: 10px;
			}
			#color-docs .col .swatch {
				font-size: 12px;
				text-align: center;
				width: 100px;
				color: #222;
				padding: 2px 0;
			}
			#color-docs .swatch.quarter { height: 30px; }
			#color-docs .swatch.half { height: 60px; }
			#color-docs .swatch.three-quarters { height: 90px; }
			#color-docs .swatch.full { height: 120px; }

			#color-docs .swatch.border { border: 1px solid #D7D7D7; }

			#color-docs .col .swatch.light {
				color: #FFF;
			}
			#color-docs .col .swatch-info {
				padding: 3px 0 3px 10px;
				font-size: 12px;
				color: #222;
				vertical-align: top;
			}
			#color-docs table {
				margin-bottom: 20px;
			}
			#color-docs .info-text {
				font-size: 12px;
				color: #222;
				margin-bottom: 20px;
				clear: both;
			}
		</style>
		<div id='color-docs'>
			<div class='section'>
				<h2 class='header'>To Use in Project</h2>
				<div class='info-text'>
					<p>qstrap ships with <i>dist/less/q-colors.less</i> which defines variables for all of the colors mentioned here.
					It is easy to include it in your project so you can use colors names like <b>@q-blue</b> instead of hex values like #0B6ED0.
					<p>Simply add the path to qstap`s less directory into you less build script.
					Then in a file use <b>@import (reference) "q-colors"</b> to get access to all the color variables in that file
					<pre>
		In Gulp file:
			return gulp.src(SRC_LESS)
				.pipe(plugins.less({
					<b>paths: ['bower_components/qstrap/dist/less']</b>
				}))
				.pipe(plugins.concat('pr.css'))
				.pipe(gulp.dest('dist/css'));

		or In Grunt file:
			less: {
				files: {
					src: [SRC_LESS],
					<b>options: {
						paths: ['bower_components/qstrap/dist/less']
					},</b>
					dest: 'dist/pr.css'
				}
			}

		In LESS file:
			<b>@import (reference) "q-colors";</b>

			body {
				color: @q-primary-text;
			}

			.sidebar {
				background: @q-light-blue;
			}
					</pre>
				</div>
			</div>
			<div class='section'>
				<h2 class='header'>Main Interface Colors</h2>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch light half' style="background: #0B6ED0">0B6ED0</td>
							<td class='swatch-info'><b>@q-blue</b><br/>Base brand, selected states, link text, active input field highlight.</td>
						</tr>
						<tr>
							<td class='swatch light quarter' style="background: #085CAF">085CAF</td>
							<td class='swatch-info'><b>@q-blue-hover</b></td>
						</tr>
						<tr>
							<td class='swatch quarter' style="background: #CCE4F2">CCE4F2</td>
							<td class='swatch-info'><b>@q-blue-accent</b></td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch light half' style="background: #009451">009451</td>
							<td class='swatch-info'><b>@q-green</b><br/>Confirmation, success notifications.</td>
						</tr>
						<tr>
							<td class='swatch light quarter' style="background: #008448">008448</td>
							<td class='swatch-info'><b>@q-green-hover</b></td>
						</tr>
						<tr>
							<td class='swatch quarter' style="background: #CCE9DC">CCE9DC</td>
							<td class='swatch-info'><b>@q-green-accent</b</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch light half' style="background: #D13A34">D13A34</td>
							<td class='swatch-info'><b>@q-red</b><br/>Error and delete states.</td>
						</tr>
						<tr>
							<td class='swatch light quarter' style="background: #BB342E">BB342E</td>
							<td class='swatch-info'><b>@q-red-hover</b></td>
						</tr>
						<tr>
							<td class='swatch quarter' style="background: #F5D7D6">F5D7D6</td>
							<td class='swatch-info'><b>@q-red-accent</b</td>
						</tr>
					</table>
				</div>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch half' style="background: #F3E350">F3E350</td>
							<td class='swatch-info'><b>@q-yellow</b><br/>Warnings.</td>
						</tr>
						<tr>
							<td class='swatch quarter' style="background: #ECD746">ECD746</td>
							<td class='swatch-info'><b>@q-yellow-hover</b></td>
						</tr>
						<tr>
							<td class='swatch quarter' style="background: #FCF9DB">FCF9DB</td>
							<td class='swatch-info'><b>@q-yellow-accent</b</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch half' style="background: #F2F4F8">F2F4F8</td>
							<td class='swatch-info'><b>@q-light-blue</b><br/>Dense interface hover, configuration section background.</td>
						</tr>
						<tr>
							<td class='swatch half' style="background: #D1E1ED">D1E1ED</td>
							<td class='swatch-info'><b>@q-alt-blue</b><br/>Dense interface selected, subtle attention grabber.</td>
						</tr>
					</table>
				</div>
				<div class='info-text'>Usage of accent colors should still fit the recommended use of the base color. Accent colors are seldom used and only when there is @off-black text on it. Seek the advice of a UX Designer when considering using an accent color.</div>
			</div>
			<div class='section'>
				<h2 class='header'>Text Colors</h2>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch light half' style="background: #222222">222222</td>
							<td class='swatch-info'><b>@q-primary-text</b></td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch light half' style="background: #737373">737373</td>
							<td class='swatch-info'><b>@q-secondary-text</b></td>
						</tr>
					</table>
				</div>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch half' style="background: #A4A4A4">A4A4A4</td>
							<td class='swatch-info'><b>@q-placeholder-text</b></td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch half border' style="background: #FFFFFF">FFFFFF</td>
							<td class='swatch-info'><b>@q-inverted-text</b></td>
						</tr>
					</table>
				</div>
			</div>
			<div class='section'>
				<h2 class='header'>Interface Grays</h2>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch light full' style="background: #222222">222222</td>
							<td class='swatch-info'><b>@q-off-black</b><br/>Primary text, user generated content, modal titles, radio button and checkbox copy.</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch light full' style="background: #737373">737373</td>
							<td class='swatch-info'><b>@q-darkest-gray</b><br/>Secondary text, sub-navigation text, input field labels, section titles, helper text.</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full' style="background: #A4A4A4">A4A4A4</td>
							<td class='swatch-info'><b>@q-dark-gray</b><br/>Placeholder text, disabled state copy, secondary button border.</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full' style="background: #C6C6C6">C6C6C6</td>
							<td class='swatch-info'><b>@q-gray</b><br/>Selection control and input field borders.</td>
						</tr>
					</table>
				</div>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch full' style="background: #D7D7D7">D7D7D7</td>
							<td class='swatch-info'><b>@q-light-gray</b><br/>Container and table borders.</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full' style="background: #E8E8E8">E8E8E8</td>
							<td class='swatch-info'><b>@q-lightest-gray</b><br/>Line separators, page breaks, disabled background color.</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full' style="background: #F9F9F9">F9F9F9</td>
							<td class='swatch-info'><b>@q-off-white</b><br/>Section backgrounds.</td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full border' style="background: #FFFFFF">FFFFFF</td>
							<td class='swatch-info'><b>@q-true-white</b><br/>Default background, inverted text.</td>
						</tr>
					</table>
				</div>
			</div>
			<div class='section'>
				<h2 class='header'>Product Colors</h2>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch full light' style="background: #464E7E">464E7E</td>
							<td class='swatch-info'><b>@q-brand-experience</b></td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full' style="background: #97D700">97D700</td>
							<td class='swatch-info'><b>@q-customer-experience</b></td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full' style="background: #2DCCD3">2DCCD3</td>
							<td class='swatch-info'><b>@q-product-experience</b></td>
						</tr>
					</table>
				</div>
				<div class='col'>
					<table>
						<tr>
							<td class='swatch full light' style="background: #147BD1">147BD1</td>
							<td class='swatch-info'><b>@q-employee-experience</b></td>
						</tr>
					</table>
					<table>
						<tr>
							<td class='swatch full light' style="background: #2E393F">2E393F</td>
							<td class='swatch-info'><b>@q-research-core</b></td>
						</tr>
					</table>
				</div>
			</div>
			<div class='section'>
                <h2 class='header'>Accent Colors</h2>
                <div class='col'>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #E0E1F0">E0E1F0</td>
                            <td class='swatch-info'><b>@q-accent-purple</b><br/></td>
                        </tr>
                        <tr>
                            <td class='swatch half' style="background: #D4D5E3">D4D5E3</td>
                            <td class='swatch-info'><b>@q-accent-purple-hover</b></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #E1F2C2">E1F2C2</td>
                            <td class='swatch-info'><b>@q-accent-green</b><br/></td>
                        </tr>
                        <tr>
                            <td class='swatch half' style="background: #D5E5B8">D5E5B8</td>
                            <td class='swatch-info'><b>@q-accent-green-hover</b></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #D3EDEB">D3EDEB</td>
                            <td class='swatch-info'><b>@q-accent-teal</b><br/></td>
                        </tr>
                        <tr>
                            <td class='swatch half' style="background: #C8E0DF">C8E0DF</td>
                            <td class='swatch-info'><b>@q-accent-teal-hover</b></td>
                        </tr>
                    </table>
                </div>
                <div class='col'>
                   <table>
                        <tr>
                            <td class='swatch half' style="background: #FFE3B9">FFE3B9</td>
                            <td class='swatch-info'><b>@q-accent-orange</b><br/></td>
                        </tr>
                        <tr>
                            <td class='swatch half' style="background: #F2D7AF">F2D7AF</td>
                            <td class='swatch-info'><b>@q-accent-orange-hover</b></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #F5D9E3">F5D9E3</td>
                            <td class='swatch-info'><b>@q-accent-magenta</b><br/></td>
                        </tr>
                        <tr>
                            <td class='swatch half' style="background: #E8CDD7">E8CDD7</td>
                            <td class='swatch-info'><b>@q-accent-magenta-hover</b></td>
                        </tr>
                    </table>
                </div>
                <div class='info-text'>Accent colors are used sparingly to create subtle attention, not be the dominant color and have a small footprint.</div>
            </div>
			<div class='section'>
                <h2 class='header'>Primary Categorical Visualization</h2>
                <div class='col'>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #1E88E5">1E88E5</td>
                            <td class='swatch-info'><b>@q-vis-1</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #00ACC1">00ACC1</td>
                            <td class='swatch-info'><b>@q-vis-2</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #43A047">43A047</td>
                            <td class='swatch-info'><b>@q-vis-3</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #C0CA33">C0CA33</td>
                            <td class='swatch-info'><b>@q-vis-4</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #FB9C00">FB9C00</td>
                            <td class='swatch-info'><b>@q-vis-5</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch light half' style="background: #E53935">E53935</td>
                            <td class='swatch-info'><b>@q-vis-6</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch light half' style="background: #8E24AA">8E24AA</td>
                            <td class='swatch-info'><b>@q-vis-7</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch light half' style="background: #3949AB">3949AB</td>
                            <td class='swatch-info'><b>@q-vis-8</b><br/></td>
                        </tr>
                    </table>
                </div>
                <div class='col'>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #039BE5">039BE5</td>
                            <td class='swatch-info'><b>@q-vis-9</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch light half' style="background: #00897B">00897B</td>
                            <td class='swatch-info'><b>@q-vis-10</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #7CB342">7CB342</td>
                            <td class='swatch-info'><b>@q-vis-11</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #FDD835">FDD835</td>
                            <td class='swatch-info'><b>@q-vis-12</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #FFB300">FFB300</td>
                            <td class='swatch-info'><b>@q-vis-13</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch half' style="background: #F4511E">F4511E</td>
                            <td class='swatch-info'><b>@q-vis-14</b><br/></td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class='swatch light half' style="background: #5E35B1">5E35B1</td>
                            <td class='swatch-info'><b>@q-vis-15</b><br/></td>
                        </tr>
                    </table>
                </div>
                <div class='info-text'>Please note that these colors should only be used for general visualization purposes. When the visualization requires multiple colors and carries no strong connotations (i.e. success, failure, increase, decrease), the colors should be used in the order they are provided.</div>
            </div>
		</div>
	</file>
</example>
*/

/**
 * @ngdoc interface
 * @name qstrap:qstrap.icon-font
 *
 * @restrict C
 * @description
 * A set of CSS classes you can use to add icons.
 *
 * The font files can be found in the dist/fonts directory. The file names change automatically when the fonts are updated, so it's safe (and recommended) for your server to serve them with a long max-age in the Cache-Control header.
 * @param {string} .icon Base icon class
 * @param {string} .icon-[glyphname]-[style]-[size] See icon list below
 *
 * @example
<example module="qstrap">
  <file name="icon-font.html">
    <style>
      .qstrap-qstrap-icon-font-page #example_source,
      .qstrap-qstrap-icon-font-page .tabbable {
        display: none;
      }
      .qstrap-qstrap-icon-font-page .column {
        display: inline-block;
        vertical-align: top;
      }
      .qstrap-qstrap-icon-font-page .column + .column {
        margin-left: 120px;
      }
      .qstrap-qstrap-icon-font-page .group {
        clear: both;
        margin: 0;
      }
      .qstrap-qstrap-icon-font-page .group + .group{
        margin: 30px 0 0;
      }
      .qstrap-qstrap-icon-font-page .section:after,
      .qstrap-qstrap-icon-font-page .column:after,
      .qstrap-qstrap-icon-font-page .group:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
      }
      .qstrap-qstrap-icon-font-page .icon {
        clear: both;
        float: left;
        height: 36px;
        text-align: left;
        width: 26px;
      }
      .qstrap-qstrap-icon-font-page .icon.long:before {
        position: absolute;
        top: -15px;
      }
      .qstrap-qstrap-icon-font-page .icon.xl {
        height: 48px;
        width: 50px;
      }
      .qstrap-qstrap-icon-font-page .lb.xl {
        line-height: 48px;
      }
      .qstrap-qstrap-icon-font-page .lb {
        float: left;
        line-height: 20pt;
        margin-left: 12px;
      }
      .qstrap-qstrap-icon-font-page .btn {
        clear: both;
        float: left;
      }
      .qstrap-qstrap-icon-font-page .separator {
        border-top: 1px solid #ccc;
        margin: 32px 0;
      }
      .qstrap-qstrap-icon-font-page .doc-example-live h4 {
        color: #2E72A5;
      }
      .qstrap-qstrap-icon-font-page .doc-example-live h5 {
        color: #999;
        font-size: 13px;
        font-weight: 300;
        letter-spacing: 0.2px;
        margin: 0 0 22px;
      }
      .qstrap-qstrap-icon-font-page .doc-example-live p {
        margin: 0 0 10px;
      }
      .qstrap-qstrap-icon-font-page .buttons {
        padding-bottom: 12px;
      }
      .qstrap-qstrap-icon-font-page .buttons .btn,
      .qstrap-qstrap-icon-font-page .buttons .lb {
        margin-top: 4px;
      }
      .qstrap-qstrap-icon-font-page .buttons .lb {
        line-height: 36px;
      }
      .qstrap-qstrap-icon-font-page .buttons .lb-sm {
        font-size: 13px;
        line-height: 26px;
      }
      .qstrap-qstrap-icon-font-page .doc-example-live .description {
        color: #595959;
        font-size: 13px;
        margin: 14px 0 24px;
      }
      .qstrap-qstrap-icon-font-page .doc-example-live .description + .description {
        margin-top: -18px;
      }
      .qstrap-qstrap-icon-font-page .doc-example-live .buttons .description {
        margin: 24px 0 14px;
      }
    </style>
    <div class="section">
        <h2>XM Icon Set</h2>
        <div class="column">
          <div class="group">
            <h3>System Icons</h3>
            <span class="icon icon-xm-caret-left-large"></span>
            <span class="lb">.icon-xm-caret-left-large</span>
            <span class="icon icon-xm-caret-right-large"></span>
            <span class="lb">.icon-xm-caret-right-large</span>
            <span class="icon icon-xm-caret-up-large"></span>
            <span class="lb">.icon-xm-caret-up-large</span>
            <span class="icon icon-xm-caret-down-large"></span>
            <span class="lb">.icon-xm-caret-down-large</span>
            <span class="icon icon-xm-caret-left-small"></span>
            <span class="lb">.icon-xm-caret-left-small</span>
            <span class="icon icon-xm-caret-right-small"></span>
            <span class="lb">.icon-xm-caret-right-small</span>
            <span class="icon icon-xm-caret-up-small"></span>
            <span class="lb">.icon-xm-caret-up-small</span>
            <span class="icon icon-xm-caret-down-small"></span>
            <span class="lb">.icon-xm-caret-down-small</span>
            <span class="icon icon-xm-add-large"></span>
            <span class="lb">.icon-xm-add-large</span>
            <span class="icon icon-xm-remove-large"></span>
            <span class="lb">.icon-xm-remove-large</span>
            <span class="icon icon-xm-add-small"></span>
            <span class="lb">.icon-xm-add-small</span>
            <span class="icon icon-xm-remove-small"></span>
            <span class="lb">.icon-xm-remove-small</span>
            <span class="icon icon-xm-close-large"></span>
            <span class="lb">.icon-xm-close-large</span>
            <span class="icon icon-xm-close-small"></span>
            <span class="lb">.icon-xm-close-small</span>
            <span class="icon icon-xm-settings"></span>
            <span class="lb">.icon-xm-settings</span>
            <span class="icon icon-xm-check"></span>
            <span class="lb">.icon-xm-check</span>
            <span class="icon icon-xm-radio-selected"></span>
            <span class="lb">.icon-xm-radio-selected</span>
            <span class="icon icon-xm-radio-unselected"></span>
            <span class="lb">.icon-xm-radio-unselected</span>
            <span class="icon icon-xm-checkbox-selected"></span>
            <span class="lb">.icon-xm-checkbox-selected</span>
            <span class="icon icon-xm-checkbox-unselected"></span>
            <span class="lb">.icon-xm-checkbox-unselected</span>
            <span class="icon icon-xm-download-large"></span>
            <span class="lb">.icon-xm-download-large</span>
            <span class="icon icon-xm-upload-large"></span>
            <span class="lb">.icon-xm-upload-large</span>
            <span class="icon icon-xm-download-small"></span>
            <span class="lb">.icon-xm-download-small</span>
            <span class="icon icon-xm-upload-small"></span>
            <span class="lb">.icon-xm-upload-small</span>
            <span class="icon icon-xm-chevron-up-large"></span>
            <span class="lb">.icon-xm-chevron-up-large</span>
            <span class="icon icon-xm-chevron-down-large"></span>
            <span class="lb">.icon-xm-chevron-down-larg</span>
            <span class="icon icon-xm-chevron-up-small"></span>
            <span class="lb">.icon-xm-chevron-up-small</span>
            <span class="icon icon-xm-chevron-down-small"></span>
            <span class="lb">.icon-xm-chevron-down-small</span>
            <span class="icon icon-xm-back-large"></span>
            <span class="lb">.icon-xm-back-large</span>
            <span class="icon icon-xm-forward-large"></span>
            <span class="lb">.icon-xm-forward-large</span>
            <span class="icon icon-xm-edit"></span>
            <span class="lb">.icon-xm-edit</span>
            <span class="icon icon-xm-look-and-feel"></span>
            <span class="lb">.icon-xm-look-and-feel</span>
            <span class="icon icon-xm-account"></span>
            <span class="lb">.icon-xm-account</span>
            <span class="icon icon-xm-notification"></span>
            <span class="lb">.icon-xm-notification</span>
            <span class="icon icon-xm-filter-large"></span>
            <span class="lb">.icon-xm-filter-large</span>
            <span class="icon icon-xm-visibility-on"></span>
            <span class="lb">.icon-xm-visibility-on</span>
            <span class="icon icon-xm-export"></span>
            <span class="lb">.icon-xm-export</span>
            <span class="icon icon-xm-kiosk-mode"></span>
            <span class="lb">.icon-xm-kiosk-mode</span>
            <span class="icon icon-xm-search"></span>
            <span class="lb">.icon-xm-search</span>
            <span class="icon icon-xm-info-filled"></span>
            <span class="lb">.icon-xm-info-filled</span>
            <span class="icon icon-xm-share-arrow"></span>
            <span class="lb">.icon-xm-share-arrow</span>
            <span class="icon icon-xm-folder"></span>
            <span class="lb">.icon-xm-folder</span>
            <span class="icon icon-xm-warning"></span>
            <span class="lb">.icon-xm-warning</span>
            <span class="icon icon-xm-calendar"></span>
            <span class="lb">.icon-xm-calendar</span>
            <span class="icon icon-xm-phone-portrait"></span>
            <span class="lb">.icon-xm-phone-portrait</span>
            <span class="icon icon-xm-phone-landscape"></span>
            <span class="lb">.icon-xm-phone-landscape</span>
            <span class="icon icon-xm-tablet"></span>
            <span class="lb">.icon-xm-tablet</span>
            <span class="icon icon-xm-desktop"></span>
            <span class="lb">.icon-xm-desktop</span>
            <span class="icon icon-xm-employment"></span>
            <span class="lb">.icon-xm-employment</span>
            <span class="icon icon-xm-household"></span>
            <span class="lb">.icon-xm-household</span>
            <span class="icon icon-xm-heart"></span>
            <span class="lb">.icon-xm-heart</span>
            <span class="icon icon-xm-lock"></span>
            <span class="lb">.icon-xm-lock</span>
            <span class="icon icon-xm-actions"></span>
            <span class="lb">.icon-xm-actions</span>
            <span class="icon icon-xm-unlock"></span>
            <span class="lb">.icon-xm-unlock</span>
            <span class="icon icon-xm-share"></span>
            <span class="lb">.icon-xm-share</span>
            <span class="icon icon-xm-help"></span>
            <span class="lb">.icon-xm-help</span>
            <span class="icon icon-xm-external-link"></span>
            <span class="lb">.icon-xm-external-link</span>
            <span class="icon icon-xm-datasource"></span>
            <span class="lb">.icon-xm-datasource</span>
            <span class="icon icon-xm-remap"></span>
            <span class="lb">.icon-xm-remap</span>
            <span class="icon icon-xm-skipped"></span>
            <span class="lb">.icon-xm-skipped</span>
            <span class="icon icon-xm-sort-descending"></span>
            <span class="lb">.icon-xm-sort-descending</span>
            <span class="icon icon-xm-sort-ascending"></span>
            <span class="lb">.icon-xm-sort-ascending</span>
            <span class="icon icon-xm-concatenate"></span>
            <span class="lb">.icon-xm-concatenate</span>
            <span class="icon icon-xm-split"></span>
            <span class="lb">.icon-xm-split</span>
            <span class="icon icon-xm-merge"></span>
            <span class="lb">.icon-xm-merge</span>
            <span class="icon icon-xm-transform-normal"></span>
            <span class="lb">.icon-xm-transform-normal</span>
            <span class="icon icon-xm-transform-uppercase"></span>
            <span class="lb">.icon-xm-transform-uppercase</span>
            <span class="icon icon-xm-transform-lowercase"></span>
            <span class="lb">.icon-xm-transform-lowercase</span>
            <span class="icon icon-xm-two-way-sms"></span>
            <span class="lb">.icon-xm-two-way-sms</span>
            <span class="icon icon-xm-sms-access-code"></span>
            <span class="lb">.icon-xm-sms-access-code</span>
            <span class="icon icon-xm-qr-code"></span>
            <span class="lb">.icon-xm-qr-code</span>
            <span class="icon icon-xm-customer-xm"></span>
            <span class="lb">.icon-xm-customer-xm</span>
            <span class="icon icon-xm-employee-xm"></span>
            <span class="lb">.icon-xm-employee-xm</span>
            <span class="icon icon-xm-brand-xm"></span>
            <span class="lb">.icon-xm-brand-xm</span>
            <span class="icon icon-xm-product-xm"></span>
            <span class="lb">.icon-xm-product-xm</span>
            <span class="icon icon-xm-research-core"></span>
            <span class="lb">.icon-xm-research-core</span>
            <span class="icon icon-xm-chevron-right-small"></span>
            <span class="lb">.icon-xm-chevron-right-small</span>
            <span class="icon icon-xm-chevron-left-small"></span>
            <span class="lb">.icon-xm-chevron-left-small</span>
            <span class="icon icon-xm-nested-arrow"></span>
            <span class="lb">.icon-xm-nested-arrow</span>
          </div>
        </div>
        <div class="column">
          <div class="group">
            <h3>Visualization Icons</h3>
            <span class="icon icon-xm-gauge-chart"></span>
            <span class="lb">.icon-xm-gauge-chart</span>
            <span class="icon icon-xm-simple-chart"></span>
            <span class="lb">.icon-xm-simple-chart</span>
            <span class="icon icon-xm-line-chart"></span>
            <span class="lb">.icon-xm-line-chart</span>
            <span class="icon icon-xm-area-chart"></span>
            <span class="lb">.icon-xm-area-chart</span>
            <span class="icon icon-xm-pie-chart"></span>
            <span class="lb">.icon-xm-pie-chart</span>
            <span class="icon icon-xm-scatter-plot"></span>
            <span class="lb">.icon-xm-scatter-plot</span>
            <span class="icon icon-xm-key-driver-plot"></span>
            <span class="lb">.icon-xm-key-driver-plot</span>
            <span class="icon icon-xm-bubble-plot"></span>
            <span class="lb">.icon-xm-bubble-plot</span>
            <span class="icon icon-xm-heat-map"></span>
            <span class="lb">.icon-xm-heat-map</span>
            <span class="icon icon-xm-breakdown-bar"></span>
            <span class="lb">.icon-xm-breakdown-bar</span>
            <span class="icon icon-xm-number-chart"></span>
            <span class="lb">.icon-xm-number-chart</span>
            <span class="icon icon-xm-text"></span>
            <span class="lb">.icon-xm-text</span>
            <span class="icon icon-xm-word-cloud"></span>
            <span class="lb">.icon-xm-word-cloud</span>
            <span class="icon icon-xm-simple-tab"></span>
            <span class="lb">.icon-xm-simple-tab</span>
            <span class="icon icon-xm-record-grid"></span>
            <span class="lb">.icon-xm-record-grid</span>
            <span class="icon icon-xm-pivot-table"></span>
            <span class="lb">.icon-xm-pivot-table</span>
            <span class="icon icon-xm-breakdown-table"></span>
            <span class="lb">.icon-xm-breakdown-table</span>
            <span class="icon icon-xm-action-plan-editor"></span>
            <span class="lb">.icon-xm-action-plan-editor</span>
            <span class="icon icon-xm-action-plan-summary"></span>
            <span class="lb">.icon-xm-action-plan-summary</span>
            <span class="icon icon-xm-image-carousel"></span>
            <span class="lb">.icon-xm-image-carousel</span>
            <span class="icon icon-xm-text-responses"></span>
            <span class="lb">.icon-xm-text-responses</span>
            <span class="icon icon-xm-engagement-summary"></span>
            <span class="lb">.icon-xm-engagement-summary</span>
            <span class="icon icon-xm-participation-summary"></span>
            <span class="lb">.icon-xm-participation-summary</span>
            <span class="icon icon-xm-key-drivers"></span>
            <span class="lb">.icon-xm-key-drivers</span>
            <span class="icon icon-xm-themes"></span>
            <span class="lb">.icon-xm-themes</span>
            <span class="icon icon-xm-high-low"></span>
            <span class="lb">.icon-xm-high-low</span>
            <span class="icon icon-xm-comparison"></span>
            <span class="lb">.icon-xm-comparison</span>
            <span class="icon icon-xm-response-rates"></span>
            <span class="lb">.icon-xm-response-rates</span>
            <span class="icon icon-xm-demographic-breakout"></span>
            <span class="lb">.icon-xm-demographic-breakout</span>
            <span class="icon icon-xm-rating"></span>
            <span class="lb">.icon-xm-rating</span>
            <span class="icon icon-xm-map"></span>
            <span class="lb">.icon-xm-map</span>
            <span class="icon icon-xm-distributions"></span>
            <span class="lb">.icon-xm-distributions</span>
            <span class="icon icon-xm-boxplot"></span>
            <span class="lb">.icon-xm-boxplot</span>
            <span class="icon icon-xm-radar-chart"></span>
            <span class="lb">.icon-xm-radar-chart</span>
            <span class="icon icon-xm-report-summary"></span>
            <span class="lb">.icon-xm-report-summary</span>
            <span class="icon icon-xm-gap-chart"></span>
            <span class="lb">.icon-xm-gap-chart</span>
            <span class="icon icon-xm-scoring-overview"></span>
            <span class="lb">.icon-xm-scoring-overview</span>
            <span class="icon icon-xm-gap-table"></span>
            <span class="lb">.icon-xm-gap-table</span>
            <span class="icon icon-xm-agreement-chart"></span>
            <span class="lb">.icon-xm-agreement-chart</span>
            <span class="icon icon-xm-high-low-table"></span>
            <span class="lb">.icon-xm-high-low-table</span>
            <span class="icon icon-xm-journeys"></span>
            <span class="lb">.icon-xm-journeys</span>
            <span class="icon icon-xm-delete"></span>
            <span class="lb">.icon-xm-delete</span>
            <span class="icon icon-xm-downvote"></span>
            <span class="lb">.icon-xm-downvote</span>
            <span class="icon icon-xm-upvote"></span>
            <span class="lb">.icon-xm-upvote</span>
            <span class="icon icon-xm-duplicate"></span>
            <span class="lb">.icon-xm-duplicate</span>
            <span class="icon icon-xm-union"></span>
            <span class="lb">.icon-xm-union</span>
            <span class="icon icon-xm-accounts-table"></span>
            <span class="lb">.icon-xm-accounts-table</span>
            <span class="icon icon-xm-agent-performance"></span>
            <span class="lb">.icon-xm-agent-performance</span>
            <span class="icon icon-xm-coaching-priorities"></span>
            <span class="lb">.icon-xm-coaching-priorities</span>
            <span class="icon icon-xm-project"></span>
            <span class="lb">.icon-xm-project</span>
          </div>
          <div class="group">
            <h3>iQ Directory Event Types</h3>
            <span class="icon icon-xm-thank-you"></span>
            <span class="lb">.icon-xm-thank-you</span>
            <span class="icon icon-xm-reminder"></span>
            <span class="lb">.icon-xm-reminder</span>
            <span class="icon icon-xm-interaction"></span>
            <span class="lb">.icon-xm-interaction</span>
            <span class="icon icon-xm-contact"></span>
            <span class="lb">.icon-xm-contact</span>
            <span class="icon icon-xm-basic-message"></span>
            <span class="lb">.icon-xm-basic-message</span>
            <span class="icon icon-xm-survey-invite"></span>
            <span class="lb">.icon-xm-survey-invite</span>
            <span class="icon icon-xm-personal-links"></span>
            <span class="lb">.icon-xm-personal-links</span>
            <span class="icon icon-xm-open-message"></span>
            <span class="lb">.icon-xm-open-message</span>
            <span class="icon icon-xm-expired-survey"></span>
            <span class="lb">.icon-xm-expired-survey</span>
            <span class="icon icon-xm-tickets"></span>
            <span class="lb">.icon-xm-tickets</span>
          </div>
          <div class="group">
            <h3>Third Party Icons</h3>
            <span class="icon icon-xm-twitter"></span>
            <span class="lb">.icon-xm-twitter</span>
            <span class="icon icon-xm-tango-card"></span>
            <span class="lb">.icon-xm-tango-card</span>
          </div>
        </div>
    </div>
    <div class="section buttons">
        <h2>Button Icons</h2>
        <div class="column">
          <div class="btn"><span class="icon btn-icon-check"></span></div>
          <span class="lb">.btn .btn-icon-check</span>
          <div class="btn"><span class="icon btn-icon-gear"></span></div>
          <span class="lb">.btn .btn-icon-gear</span>
          <div class="btn"><span class="icon btn-icon-plus"></span></div>
          <span class="lb">.btn .btn-icon-plus</span>
          <div class="btn"><span class="icon btn-icon-search"></span></div>
          <span class="lb">.btn .btn-icon-search</span>
          <div class="btn"><span class="icon btn-icon-x"></span></div>
          <span class="lb">.btn .btn-icon-x</span>
        </div>
        <div class="column">
          <div class="btn"><span class="icon btn-icon-angle-down"></span></div>
          <span class="lb">.btn .btn-icon-angle-down</span>
          <div class="btn"><span class="icon btn-icon-angle-left"></span></div>
          <span class="lb">.btn .btn-icon-angle-left</span>
          <div class="btn"><span class="icon btn-icon-angle-right"></span></div>
          <span class="lb">.btn .btn-icon-angle-right</span>
          <div class="btn"><span class="icon btn-icon-angle-up"></span></div>
          <span class="lb">.btn .btn-icon-angle-up</span>
        </div>
        <p class="description">Button icons will adapt to the button size:</p>
        <div class="btn btn-sm">
          <span class="icon btn-icon-check"></span>
          <span>Small Button</span>
        </div>
        <span class="lb lb-sm">.btn.btn-sm .btn-icon-check</span>
        <div class="btn">
          <span class="icon btn-icon-check"></span>
          <span>Default Button</span>
        </div>
        <span class="lb">.btn .btn-icon-check</span>
    </div>
    <div class="section">
        <h2>Main Navigation Icons</h2>
        <div class="column">
          <span class="icon nav-icon-airplane"></span>
          <span class="lb">.nav-icon-airplane</span>
          <span class="icon nav-icon-airplane-alt"></span>
          <span class="lb">.nav-icon-airplane-alt</span>
          <span class="icon nav-icon-bargraph"></span>
          <span class="lb">.nav-icon-bargraph</span>
          <span class="icon nav-icon-bargraph-alt"></span>
          <span class="lb">.nav-icon-bargraph-alt</span>
          <span class="icon nav-icon-building"></span>
          <span class="lb">.nav-icon-building</span>
          <span class="icon nav-icon-building-alt"></span>
          <span class="lb">.nav-icon-building-alt</span>
          <span class="icon nav-icon-bulletlist"></span>
          <span class="lb">.nav-icon-bulletlist</span>
          <span class="icon nav-icon-bulletlist-alt"></span>
          <span class="lb">.nav-icon-bulletlist-alt</span>
          <span class="icon nav-icon-text"></span>
          <span class="lb">.nav-icon-text</span>
          <span class="icon nav-icon-text-alt"></span>
          <span class="lb">.nav-icon-text-alt</span>
          <span class="icon nav-icon-comment"></span>
          <span class="lb">.nav-icon-comment</span>
          <span class="icon nav-icon-comment-alt"></span>
          <span class="lb">.nav-icon-comment-alt</span>
          <span class="icon nav-icon-coupon"></span>
          <span class="lb">.nav-icon-coupon</span>
          <span class="icon nav-icon-coupon-alt"></span>
          <span class="lb">.nav-icon-coupon-alt</span>
          <span class="icon nav-icon-envelope"></span>
          <span class="lb">.nav-icon-envelope</span>
          <span class="icon nav-icon-envelope-alt"></span>
          <span class="lb">.nav-icon-envelope-alt</span>
          <span class="icon nav-icon-gear"></span>
          <span class="lb">.nav-icon-gear</span>
          <span class="icon nav-icon-gear-alt"></span>
          <span class="lb">.nav-icon-gear-alt</span>
          <span class="icon nav-icon-globe"></span>
          <span class="lb">.nav-icon-globe</span>
          <span class="icon nav-icon-globe-alt"></span>
          <span class="lb">.nav-icon-globe-alt</span>
          <span class="icon nav-icon-actions"></span>
          <span class="lb">.nav-icon-actions</span>
          <span class="icon nav-icon-actions-alt"></span>
          <span class="lb">.nav-icon-actions-alt</span>

        </div>
        <div class="column">
          <span class="icon nav-icon-image"></span>
          <span class="lb">.nav-icon-image</span>
          <span class="icon nav-icon-image-alt"></span>
          <span class="lb">.nav-icon-image-alt</span>
          <span class="icon nav-icon-linegraph"></span>
          <span class="lb">.nav-icon-linegraph</span>
          <span class="icon nav-icon-linegraph-alt"></span>
          <span class="lb">.nav-icon-linegraph-alt</span>
          <span class="icon nav-icon-list"></span>
          <span class="lb">.nav-icon-list</span>
          <span class="icon nav-icon-list-alt"></span>
          <span class="lb">.nav-icon-list-alt</span>
          <span class="icon nav-icon-pencil"></span>
          <span class="lb">.nav-icon-pencil</span>
          <span class="icon nav-icon-pencil-alt"></span>
          <span class="lb">.nav-icon-pencil-alt</span>
          <span class="icon nav-icon-survey"></span>
          <span class="lb">.nav-icon-survey</span>
          <span class="icon nav-icon-survey-alt"></span>
          <span class="lb">.nav-icon-survey-alt</span>
          <span class="icon nav-icon-ticket"></span>
          <span class="lb">.nav-icon-ticket</span>
          <span class="icon nav-icon-ticket-alt"></span>
          <span class="lb">.nav-icon-ticket-alt</span>
          <span class="icon nav-icon-user"></span>
          <span class="lb">.nav-icon-user</span>
          <span class="icon nav-icon-user-alt"></span>
          <span class="lb">.nav-icon-user-alt</span>
          <span class="icon nav-icon-usergroup"></span>
          <span class="lb">.nav-icon-usergroup</span>
          <span class="icon nav-icon-usergroup-alt"></span>
          <span class="lb">.nav-icon-usergroup-alt</span>
          <span class="icon nav-icon-verticalsliders"></span>
          <span class="lb">.nav-icon-verticalsliders</span>
          <span class="icon nav-icon-verticalsliders-alt"></span>
          <span class="lb">.nav-icon-verticalsliders-alt</span>
          <span class="icon nav-icon-bargraph-unboxed"></span>
          <span class="lb">.nav-icon-bargraph-unboxed</span>
          <span class="icon nav-icon-bargraph-unboxed-alt"></span>
          <span class="lb">.nav-icon-bargraph-unboxed-alt</span>
        </div>
    </div>
    <div class="section">
      <h2>Sub Section Navigation Icons</h2>
      <h3>Sub Sections don't have alternates, since they only show up on an active (alt) section</h3>
      <div class="column">
        <span class="icon subnav-icon-conversation"></span>
        <span class="lb">.subnav-icon-conversation</span>
        <span class="icon subnav-icon-speeder"></span>
        <span class="lb">.subnav-icon-speeder</span>
        <span class="icon subnav-icon-bargraph-unboxed"></span>
        <span class="lb">.subnav-icon-bargraph-unboxed</span>
        <span class="icon subnav-icon-table"></span>
        <span class="lb">.subnav-icon-table</span>
      </div>
      <div class="column">
        <span class="icon subnav-icon-comment"></span>
        <span class="lb">.subnav-icon-comment</span>
        <span class="icon subnav-icon-reportfile"></span>
        <span class="lb">.subnav-icon-reportfile</span>
        <span class="icon subnav-icon-reportfile-alt"></span>
        <span class="lb">.subnav-icon-reportfile-alt</span>
      </div>
    </div>
    <div class="section">
        <h2>Toolbar Icons</h2>
        <div class="column">
          <span class="icon toolbar-icon-branch"></span>
          <span class="lb">.toolbar-icon-branch</span>
          <span class="icon toolbar-icon-collaborate"></span>
          <span class="lb">.toolbar-icon-collaborate</span>
          <span class="icon toolbar-icon-comment"></span>
          <span class="lb">.toolbar-icon-comment</span>
          <span class="icon toolbar-icon-download"></span>
          <span class="lb">.toolbar-icon-download</span>
          <span class="icon toolbar-icon-droplet"></span>
          <span class="lb">.toolbar-icon-droplet</span>
          <span class="icon toolbar-icon-gear"></span>
          <span class="lb">.toolbar-icon-gear</span>
          <span class="icon toolbar-icon-lock"></span>
          <span class="lb">.toolbar-icon-lock</span>
          <span class="icon toolbar-icon-open"></span>
          <span class="lb">.toolbar-icon-open</span>
        </div>
        <div class="column">
          <span class="icon toolbar-icon-page"></span>
          <span class="lb">.toolbar-icon-page</span>
          <span class="icon toolbar-icon-paintbrush"></span>
          <span class="lb">.toolbar-icon-paintbrush</span>
          <span class="icon toolbar-icon-prohibited"></span>
          <span class="lb">.toolbar-icon-prohibited</span>
          <span class="icon toolbar-icon-search"></span>
          <span class="lb">.toolbar-icon-search</span>
          <span class="icon toolbar-icon-split"></span>
          <span class="lb">.toolbar-icon-split</span>
          <span class="icon toolbar-icon-translate"></span>
          <span class="lb">.toolbar-icon-translate</span>
          <span class="icon toolbar-icon-upload"></span>
          <span class="lb">.toolbar-icon-upload</span>
          <span class="icon toolbar-icon-wrench"></span>
          <span class="lb">.toolbar-icon-wrench</span>
        </div>
    </div>
    <div class="section">
        <h2>Sidebar Icons</h2>
        <p class="description" style="width:450px;">These classes may also be used in section titles so the title icon matches its corresponding sidebar icon.</p>
        <div class="column">
          <span class="icon sidebar-icon-addperson"></span>
          <span class="lb">.sidebar-icon-addperson</span>
          <span class="icon sidebar-icon-addressbook"></span>
          <span class="lb">.sidebar-icon-addressbook</span>
          <span class="icon sidebar-icon-airplane"></span>
          <span class="lb">.sidebar-icon-airplane</span>
          <span class="icon sidebar-icon-bargraph"></span>
          <span class="lb">.sidebar-icon-bargraph</span>
          <span class="icon sidebar-icon-block"></span>
          <span class="lb">.sidebar-icon-block</span>
          <span class="icon sidebar-icon-bulletlist"></span>
          <span class="lb">.sidebar-icon-bulletlist</span>
          <span class="icon sidebar-icon-caution"></span>
          <span class="lb">.sidebar-icon-caution</span>
          <span class="icon sidebar-icon-collaborate"></span>
          <span class="lb">.sidebar-icon-collaborate</span>
          <span class="icon sidebar-icon-comment"></span>
          <span class="lb">.sidebar-icon-comment</span>
          <span class="icon sidebar-icon-envelope"></span>
          <span class="lb">.sidebar-icon-envelope</span>
          <span class="icon sidebar-icon-fingerprint"></span>
          <span class="lb">.sidebar-icon-fingerprint</span>
          <span class="icon sidebar-icon-folder"></span>
          <span class="lb">.sidebar-icon-folder</span>
          <span class="icon sidebar-icon-ghostblock"></span>
          <span class="lb">.sidebar-icon-ghostblock</span>
          <span class="icon sidebar-icon-image"></span>
          <span class="lb">.sidebar-icon-image</span>
        </div>
        <div class="column">
          <span class="icon sidebar-icon-link"></span>
          <span class="lb">.sidebar-icon-link</span>
          <span class="icon sidebar-icon-list"></span>
          <span class="lb">.sidebar-icon-list</span>
          <span class="icon sidebar-icon-mobiledevice"></span>
          <span class="lb">.sidebar-icon-mobiledevice</span>
          <span class="icon sidebar-icon-outcomes"></span>
          <span class="lb">.sidebar-icon-outcomes</span>
          <span class="icon sidebar-icon-paintbrush"></span>
          <span class="lb">.sidebar-icon-paintbrush</span>
          <span class="icon sidebar-icon-paperstack"></span>
          <span class="lb">.sidebar-icon-paperstack</span>
          <span class="icon sidebar-icon-pencil"></span>
          <span class="lb">.sidebar-icon-pencil</span>
          <span class="icon sidebar-icon-qrcode"></span>
          <span class="lb">.sidebar-icon-qrcode</span>
          <span class="icon sidebar-icon-radiogroup"></span>
          <span class="lb">.sidebar-icon-radiogroup</span>
          <span class="icon sidebar-icon-search"></span>
          <span class="lb">.sidebar-icon-search</span>
          <span class="icon sidebar-icon-siteintercept"></span>
          <span class="lb">.sidebar-icon-siteintercept</span>
          <span class="icon sidebar-icon-survey"></span>
          <span class="lb">.sidebar-icon-survey</span>
          <span class="icon sidebar-icon-thumbnails"></span>
          <span class="lb">.sidebar-icon-thumbnails</span>
          <span class="icon sidebar-icon-verticalsliders"></span>
          <span class="lb">.sidebar-icon-verticalsliders</span>
        </div>
    </div>
    <div class="separator"></div>
    <div class="section everything">
      <h2>Everything</h2>
      <p class="description">This is the complete list of all the glyphs in our icon font.</p>
      <p class="description">Many icons have more than one classname if they are used in multiple contexts (e.g. .icon-check and .btn-icon-check, .nav-icon-airplane and .icon-airplane-wire). <strong>Please be judicious when choosing which class to use</strong>&mdash;don't use a .toolbar-icon class in a table, do use a .btn-icon class in a button, etc.</p>
      <div class="column">
        <div class="group">
          <h3>General Interface Controls</h3>
          <span class="icon icon-hamburger"></span>
          <span class="lb">.icon-hamburger</span>
          <span class="icon icon-ellipsis"></span>
          <span class="lb">.icon-ellipsis</span>
          <span class="icon icon-verticalellipsis"></span>
          <span class="lb">.icon-verticalellipsis</span>
          <span class="icon icon-info-filled-sm"></span>
          <span class="lb">.icon-info-filled-sm</span>
          <span class="icon icon-question-filled-sm"></span>
          <span class="lb">.icon-question-filled-sm</span>
          <span class="icon icon-maximize-framed"></span>
          <span class="lb">.icon-maximize-framed</span>
          <span class="icon icon-minimize-framed"></span>
          <span class="lb">.icon-minimize-framed</span>
          <span class="icon icon-object-resize-handle"></span>
          <span class="lb">.icon-object-resize-handle</span>
          <span class="icon icon-text-resize-handle"></span>
          <span class="lb">.icon-text-resize-handle</span>
        </div>
        <div class="group">
          <h3>Date and Time</h3>
          <span class="icon icon-calendar-wire-sm"></span>
          <span class="lb">.icon-calendar-wire-sm</span>
          <span class="icon icon-clock"></span>
          <span class="lb">.icon-clock</span>
          <span class="icon icon-stopwatchalert"></span>
          <span class="lb">.icon-stopwatchalert</span>
        </div>
        <div class="group">
          <h3>Settings and Configuration</h3>
          <span class="icon icon-gear-sm"></span>
          <span class="lb">.icon-gear-sm</span>
          <span class="icon icon-gear"></span>
          <span class="lb">.icon-gear</span>
          <span class="icon icon-gears"></span>
          <span class="lb">.icon-gears</span>
          <span class="icon icon-gear-lg"></span>
          <span class="lb">.icon-gear-lg</span>
          <span class="icon icon-wrench"></span>
          <span class="lb">.icon-wrench</span>
          <span class="icon icon-wrench-lg"></span>
          <span class="lb">.icon-wrench-lg</span>
          <span class="icon icon-droplet-lg"></span>
          <span class="lb">.icon-droplet-lg</span>
          <span class="icon icon-paintbrush"></span>
          <span class="lb">.icon-paintbrush</span>
          <span class="icon icon-paintbrush-framed-lg"></span>
          <span class="lb">.icon-paintbrush-framed-lg</span>
        </div>
        <div class="group">
          <h3>Editing</h3>
          <span class="icon icon-pencil"></span>
          <span class="lb">.icon-pencil</span>
          <span class="icon icon-pencil-wire"></span>
          <span class="lb">.icon-pencil-wire</span>
          <span class="icon icon-pencil-filled"></span>
          <span class="lb">.icon-pencil-filled</span>
          <span class="icon icon-pencil-framed"></span>
          <span class="lb">.icon-pencil-framed</span>
          <span class="icon icon-pencil-filled-lg"></span>
          <span class="lb">.icon-pencil-filled-lg</span>
          <span class="icon icon-pencil-framed-lg"></span>
          <span class="lb">.icon-pencil-framed-lg</span>
          <span class="icon icon-save-framed"></span>
          <span class="lb">.icon-save-framed</span>
          <span class="icon icon-floppy-disk"></span>
          <span class="lb">.icon-floppy-disk</span>
          <span class="icon icon-undo"></span>
          <span class="lb">.icon-undo</span>
          <span class="icon icon-redo"></span>
          <span class="lb">.icon-redo</span>
          <span class="icon icon-trash-bin"></span>
          <span class="lb">.icon-trash-bin</span>
        </div>
        <div class="group">
          <h3>Locks and Keys</h3>
          <span class="icon icon-key"></span>
          <span class="lb">.icon-key</span>
          <span class="icon icon-lock"></span>
          <span class="lb">.icon-lock</span>
          <span class="icon icon-lock-sm"></span>
          <span class="lb">.icon-lock-sm</span>
          <span class="icon icon-lock-lines-filled"></span>
          <span class="lb">.icon-lock-lines-filled</span>
          <span class="icon icon-lock-lines"></span>
          <span class="lb">.icon-lock-lines</span>
          <span class="icon icon-unlock"></span>
          <span class="lb">.icon-unlock</span>
        </div>
        <div class="group">
          <h3>Viewing and Previewing</h3>
          <span class="icon icon-eye"></span>
          <span class="lb">.icon-eye</span>
          <span class="icon icon-eye-hidden"></span>
          <span class="lb">.icon-eye-hidden</span>
          <span class="icon icon-open"></span>
          <span class="lb">.icon-open</span>
          <span class="icon icon-open-lg"></span>
          <span class="lb">.icon-open-lg</span>
        </div>
        <div class="group">
          <h3>Layout</h3>
          <span class="icon icon-list"></span>
          <span class="lb">.icon-list</span>
          <span class="icon icon-list-filled"></span>
          <span class="lb">.icon-list-filled</span>
          <span class="icon icon-list-framed"></span>
          <span class="lb">.icon-list-framed</span>
          <span class="icon icon-list-filled-lg"></span>
          <span class="lb">.icon-list-filled-lg</span>
          <span class="icon icon-list-framed-lg"></span>
          <span class="lb">.icon-list-framed-lg</span>
          <span class="icon icon-bulletlist"></span>
          <span class="lb">.icon-bulletlist</span>
          <span class="icon icon-bulletlist-filled"></span>
          <span class="lb">.icon-bulletlist-filled</span>
          <span class="icon icon-bulletlist-framed"></span>
          <span class="lb">.icon-bulletlist-framed</span>
          <span class="icon icon-bulletlist-filled-lg"></span>
          <span class="lb">.icon-bulletlist-filled-lg</span>
          <span class="icon icon-bulletlist-framed-lg"></span>
          <span class="lb">.icon-bulletlist-framed-lg</span>
          <span class="icon icon-thumbnails"></span>
          <span class="lb">.icon-thumbnails</span>
          <span class="icon icon-thumbnails-filled-lg"></span>
          <span class="lb">.icon-thumbnails-filled-lg</span>
          <span class="icon icon-thumbnails-framed-lg"></span>
          <span class="lb">.icon-thumbnails-framed-lg</span>
          <span class="icon icon-projectbar"></span>
          <span class="lb">.icon-projectbar</span>
          <span class="icon icon-projectbar-framed-lg"></span>
          <span class="lb">.icon-projectbar-framed-lg</span>
          <span class="icon icon-projectbar-filled-lg"></span>
          <span class="lb">.icon-projectbar-filled-lg</span>
          <span class="icon icon-compacttable"></span>
          <span class="lb">.icon-compacttable</span>
          <span class="icon icon-compacttable-framed-lg"></span>
          <span class="lb">.icon-compacttable-framed-lg</span>
          <span class="icon icon-compacttable-filled-lg"></span>
          <span class="lb">.icon-compacttable-filled-lg</span>
        </div>
        <div class="group">
          <h3>Users</h3>
          <span class="icon icon-building"></span>
          <span class="lb">.icon-building</span>
          <span class="icon icon-peopleinbuilding"></span>
          <span class="lb">.icon-peopleinbuilding</span>
          <span class="icon icon-peoplewithgrid"></span>
          <span class="lb">.icon-peoplewithgrid</span>
          <span class="icon icon-user"></span>
          <span class="lb">.icon-user</span>
          <span class="icon icon-user-framed"></span>
          <span class="lb">.icon-user-framed</span>
          <span class="icon icon-user-wire-framed"></span>
          <span class="lb">.icon-user-wire-framed</span>
          <span class="icon icon-user-framed-lg"></span>
          <span class="lb">.icon-user-framed-lg</span>
          <span class="icon icon-usergroup"></span>
          <span class="lb">.icon-usergroup</span>
          <span class="icon icon-usergroup-wire"></span>
          <span class="lb">.icon-usergroup-wire</span>
          <span class="icon icon-user-menu"></span>
          <span class="lb">.icon-user-menu</span>
        </div>
        <div class="group">
          <h3>Collaboration and Communication</h3>
          <span class="icon icon-collaborate-lg"></span>
          <span class="lb">.icon-collaborate-lg</span>
          <span class="icon icon-collaborate-filled-lg"></span>
          <span class="lb">.icon-collaborate-filled-lg</span>
          <span class="icon icon-collaborate-framed-lg"></span>
          <span class="lb">.icon-collaborate-framed-lg</span>
          <span class="icon icon-comment"></span>
          <span class="lb">.icon-comment</span>
          <span class="icon icon-comment-wire"></span>
          <span class="lb">.icon-comment-wire</span>
          <span class="icon icon-emptycomment-lg"></span>
          <span class="lb">.icon-emptycomment-lg</span>
          <span class="icon icon-comment-percent"></span>
          <span class="lb">.icon-comment-percent</span>
          <span class="icon icon-emptycomment-wire-lg"></span>
          <span class="lb">.icon-emptycomment-wire-lg</span>
          <span class="icon icon-conversation"></span>
          <span class="lb">.icon-conversation</span>
          <span class="icon icon-conversation-wire"></span>
          <span class="lb">.icon-conversation-wire</span>
          <span class="icon icon-xm-shared"></span>
          <span class="lb">.icon-xm-shared</span>
        </div>
        <div class="group">
          <h3>Adding and Removing</h3>
          <span class="icon icon-plus-framed-sm"></span>
          <span class="lb">.icon-plus-framed-sm</span>
          <span class="icon icon-minus-framed-sm"></span>
          <span class="lb">.icon-minus-framed-sm</span>
          <span class="icon icon-plus-filled-sm"></span>
          <span class="lb">.icon-plus-filled-sm</span>
          <span class="icon icon-minus-filled-sm"></span>
          <span class="lb">.icon-minus-filled-sm</span>
          <span class="icon icon-plus-filled"></span>
          <span class="lb">.icon-plus-filled</span>
          <span class="icon icon-minus-filled"></span>
          <span class="lb">.icon-minus-filled</span>
          <span class="icon icon-plus-framed"></span>
          <span class="lb">.icon-plus-framed</span>
          <span class="icon icon-minus-framed"></span>
          <span class="lb">.icon-minus-framed</span>
          <span class="icon icon-plus-sm"></span>
          <span class="lb">.icon-plus-sm</span>
          <span class="icon icon-plus-xs"></span>
          <span class="lb">.icon-plus-xs</span>
          <span class="icon icon-plus"></span>
          <span class="lb">.icon-plus</span>
          <span class="icon icon-plus-filled-lg"></span>
          <span class="lb">.icon-plus-filled-lg</span>
        </div>
        <div class="group">
          <h3>Checks and Xs</h3>
          <span class="icon icon-check-filled-sm"></span>
          <span class="lb">.icon-check-filled-sm</span>
          <span class="icon icon-x-filled-sm"></span>
          <span class="lb">.icon-x-filled-sm</span>
          <span class="icon icon-check-sm"></span>
          <span class="lb">.icon-check-sm</span>
          <span class="icon icon-x-sm"></span>
          <span class="lb">.icon-x-sm</span>
          <span class="icon icon-check"></span>
          <span class="lb">.icon-check</span>
          <span class="icon icon-x"></span>
          <span class="lb">.icon-x</span>
          <span class="icon icon-check-filled"></span>
          <span class="lb">.icon-check-filled</span>
          <span class="icon icon-x-filled"></span>
          <span class="lb">.icon-x-filled</span>
          <span class="icon icon-check-framed-lg"></span>
          <span class="lb">.icon-check-framed-lg</span>
          <span class="icon icon-checkandx"></span>
          <span class="lb">.icon-checkandx</span>
        </div>
        <div class="group">
          <h3>Warnings</h3>
          <span class="icon icon-caution"></span>
          <span class="lb">.icon-caution</span>
          <span class="icon icon-caution-lg"></span>
          <span class="lb">.icon-caution-lg</span>
          <span class="icon icon-caution-framed-lg"></span>
          <span class="lb">.icon-caution-framed-lg</span>
          <span class="icon icon-prohibited"></span>
          <span class="lb">.icon-prohibited</span>
          <span class="icon icon-skull-lg"></span>
          <span class="lb">.icon-skull-lg</span>
          <span class="icon icon-skull-inverted-lg"></span>
          <span class="lb">.icon-skull-inverted-lg</span>
        </div>
        <div class="group">
          <h3>Carets</h3>
          <span class="icon icon-angle-down-sm"></span>
          <span class="lb">.icon-angle-down-sm</span>
          <span class="icon icon-angle-left-sm"></span>
          <span class="lb">.icon-angle-left-sm</span>
          <span class="icon icon-angle-right-sm"></span>
          <span class="lb">.icon-angle-right-sm</span>
          <span class="icon icon-angle-up-sm"></span>
          <span class="lb">.icon-angle-up-sm</span>
          <span class="icon icon-double-angle-down-sm"></span>
          <span class="lb">.icon-double-angle-down-sm</span>
          <span class="icon icon-double-angle-up-sm"></span>
          <span class="lb">.icon-double-angle-up-sm</span>
          <span class="icon icon-triple-angle-down-sm"></span>
          <span class="lb">.icon-triple-angle-down-sm</span>
          <span class="icon icon-triple-angle-up-sm"></span>
          <span class="lb">.icon-triple-angle-up-sm</span>
          <span class="icon icon-angle-down"></span>
          <span class="lb">.icon-angle-down</span>
          <span class="icon icon-angle-left"></span>
          <span class="lb">.icon-angle-left</span>
          <span class="icon icon-angle-right"></span>
          <span class="lb">.icon-angle-right</span>
          <span class="icon icon-angle-up"></span>
          <span class="lb">.icon-angle-up</span>
          <span class="icon icon-angle-down-lg"></span>
          <span class="lb">.icon-angle-down-lg</span>
          <span class="icon icon-angle-left-lg"></span>
          <span class="lb">.icon-angle-left-lg</span>
          <span class="icon icon-angle-right-lg"></span>
          <span class="lb">.icon-angle-right-lg</span>
          <span class="icon icon-angle-up-lg"></span>
          <span class="lb">.icon-angle-up-lg</span>
          <span class="icon icon-caret-down-sm"></span>
          <span class="lb">.icon-caret-down-sm</span>
          <span class="icon icon-caret-left-sm"></span>
          <span class="lb">.icon-caret-left-sm</span>
          <span class="icon icon-caret-right-sm"></span>
          <span class="lb">.icon-caret-right-sm</span>
          <span class="icon icon-caret-up-sm"></span>
          <span class="lb">.icon-caret-up-sm</span>
          <span class="icon icon-caret-down"></span>
          <span class="lb">.icon-caret-down</span>
          <span class="icon icon-caret-up"></span>
          <span class="lb">.icon-caret-up</span>
          <span class="icon icon-caret-updown"></span>
          <span class="lb">.icon-caret-updown</span>
          <span class="icon icon-angle-right-circled"></span>
          <span class="lb">.icon-angle-right-circled</span>
        </div>
        <div class="group">
          <h3>Arrows</h3>
          <span class="icon icon-arrow-left"></span>
          <span class="lb">.icon-arrow-left</span>
          <span class="icon icon-arrow-right"></span>
          <span class="lb">.icon-arrow-right</span>
          <span class="icon icon-arrow-left-shorttail"></span>
          <span class="lb">.icon-arrow-left-shorttail</span>
          <span class="icon icon-arrow-right-shorttail"></span>
          <span class="lb">.icon-arrow-right-shorttail</span>
          <span class="icon icon-arrow-up-shorttail"></span>
          <span class="lb">.icon-arrow-up-shorttail</span>
          <span class="icon icon-arrow-down-shorttail"></span>
          <span class="lb">.icon-arrow-down-shorttail</span>
          <span class="icon icon-exchange-arrow"></span>
          <span class="lb">.icon-exchange-arrow</span>
          <span class="icon icon-arrow-leftright"></span>
          <span class="lb">.icon-arrow-leftright</span>
          <span class="icon icon-arrow-updown"></span>
          <span class="lb">.icon-arrow-updown</span>
          <span class="icon icon-arrow-circle"></span>
          <span class="lb">.icon-arrow-circle</span>
          <span class="icon icon-arrow-counterclockwise"></span>
          <span class="lb">.icon-arrow-counterclockwise</span>
          <span class="icon icon-arrow-downright"></span>
          <span class="lb">.icon-arrow-downright</span>
          <span class="icon icon-arrow-leftdown"></span>
          <span class="lb">.icon-arrow-leftdown</span>
          <span class="icon icon-curvedarrow-downright"></span>
          <span class="lb">.icon-curvedarrow-downright</span>
          <span class="icon icon-curvedarrow-leftdown"></span>
          <span class="lb">.icon-curvedarrow-leftdown</span>
          <span class="icon long icon-curvedarrow-downright-long"></span>
          <span class="lb long">.icon-curvedarrow-downright-long</span>
          <span class="icon long icon-curvedtriplearrow-downright-long"></span>
          <span class="lb long">.icon-curvedtriplearrow-downright-long</span>
          <span class="icon long icon-curvedtriplearrow-rightsplit-long"></span>
          <span class="lb long">.icon-curvedtriplearrow-rightsplit-long</span>
          <span class="icon icon-curveddoublearrow-downright-framed"></span>
          <span class="lb">.icon-curveddoublearrow-<br />downright-framed</span>
          <span class="icon icon-arrow-down-strikeout"></span>
          <span class="lb">.icon-arrow-down-strikeout</span>
          <span class="icon icon-arrow-swivel-right"></span>
          <span class="lb">.icon-arrow-swivel-right</span>
          <span class="icon icon-arrow-swivel-right-filled"></span>
          <span class="lb">.icon-arrow-swivel-right-filled</span>
          <span class="icon icon-arrows-merge"></span>
          <span class="lb">.icon-arrows-merge</span>
        </div>
        <div class="group">
          <h3>Logic and Workflow</h3>
          <span class="icon icon-branch-lg"></span>
          <span class="lb">.icon-branch-lg</span>
          <span class="icon icon-merge-lg"></span>
          <span class="lb">.icon-merge-lg</span>
          <span class="icon icon-split-lg"></span>
          <span class="lb">.icon-split-lg</span>
          <span class="icon icon-restart"></span>
          <span class="lb">.icon-restart</span>
          <span class="icon icon-arrow-branchright"></span>
          <span class="lb">.icon-arrow-branchright</span>
          <span class="icon icon-branchrightpercent-lg"></span>
          <span class="lb">.icon-branchrightpercent-lg</span>
          <span class="icon icon-calculator"></span>
          <span class="lb">.icon-calculator</span>
        </div>
        <div class="group">
          <h3>Upload and Download</h3>
          <span class="icon icon-download-lg"></span>
          <span class="lb">.icon-download-lg</span>
          <span class="icon icon-download-sm"></span>
          <span class="lb">.icon-download-sm</span>
          <span class="icon icon-download-wire-lg"></span>
          <span class="lb">.icon-download-wire-lg</span>
          <span class="icon icon-upload-lg"></span>
          <span class="lb">.icon-upload-lg</span>
          <span class="icon icon-upload-wire-lg"></span>
          <span class="lb">.icon-upload-wire-lg</span>
          <span class="icon icon-upload-filled-lg"></span>
          <span class="lb">.icon-upload-filled-lg</span>
        </div>
        <div class="group">
          <h3>Text Formatting</h3>
          <span class="icon icon-bold"></span>
          <span class="lb">.icon-bold</span>
          <span class="icon icon-italic"></span>
          <span class="lb">.icon-italic</span>
          <span class="icon icon-underline"></span>
          <span class="lb">.icon-underline</span>
          <span class="icon icon-strikethrough"></span>
          <span class="lb">.icon-strikethrough</span>
          <span class="icon icon-superscript"></span>
          <span class="lb">.icon-superscript</span>
          <span class="icon icon-subscript"></span>
          <span class="lb">.icon-subscript</span>
          <span class="icon icon-cleartextformatting"></span>
          <span class="lb">.icon-cleartextformatting</span>
          <span class="icon icon-textcolor"></span>
          <span class="lb">.icon-textcolor</span>
          <span class="icon icon-backgroundcolor"></span>
          <span class="lb">.icon-backgroundcolor</span>
          <span class="icon icon-insertnumberedlist"></span>
          <span class="lb">.icon-insertnumberedlist</span>
          <span class="icon icon-insertbulletedlist"></span>
          <span class="lb">.icon-insertbulletedlist</span>
          <span class="icon icon-alignleft"></span>
          <span class="lb">.icon-alignleft</span>
          <span class="icon icon-center"></span>
          <span class="lb">.icon-center</span>
          <span class="icon icon-alignright"></span>
          <span class="lb">.icon-alignright</span>
          <span class="icon icon-justify"></span>
          <span class="lb">.icon-justify</span>
          <span class="icon icon-link"></span>
          <span class="lb">.icon-link</span>
          <span class="icon icon-numbers"></span>
          <span class="lb">.icon-numbers</span>
          <span class="icon icon-specialcharacters"></span>
          <span class="lb">.icon-specialcharacters</span>
          <span class="icon icon-pagebreak"></span>
          <span class="lb">.icon-pagebreak</span>
          <span class="icon icon-printer"></span>
          <span class="lb">.icon-printer</span>
        </div>
        <div class="group">
          <h3>Shortcut Keys</h3>
          <span class="icon icon-shiftkey"></span>
          <span class="lb">.icon-shiftkey</span>
          <span class="icon icon-commandkey"></span>
          <span class="lb">.icon-commandkey</span>
          <span class="icon icon-optionkey"></span>
          <span class="lb">.icon-optionkey</span>
          <span class="icon icon-controlkey"></span>
          <span class="lb">.icon-controlkey</span>
        </div>
        <div class="group">
          <h3>Alignment</h3>
          <span class="icon icon-alignvertical-left"></span>
          <span class="lb">.icon-alignvertical-left</span>
          <span class="icon icon-alignvertical-center"></span>
          <span class="lb">.icon-alignvertical-center</span>
          <span class="icon icon-alignvertical-right"></span>
          <span class="lb">.icon-alignvertical-right</span>
          <span class="icon icon-alignhorizontal-top"></span>
          <span class="lb">.icon-alignhorizontal-top</span>
          <span class="icon icon-alignhorizontal-center"></span>
          <span class="lb">.icon-alignhorizontal-center</span>
          <span class="icon icon-alignhorizontal-bottom"></span>
          <span class="lb">.icon-alignhorizontal-bottom</span>
          <span class="icon icon-distributehorizontal-left"></span>
          <span class="lb">.icon-distributehorizontal-left</span>
          <span class="icon icon-distributehorizontal-center"></span>
          <span class="lb">.icon-distributehorizontal-center</span>
          <span class="icon icon-distributehorizontal-right"></span>
          <span class="lb">.icon-distributehorizontal-right</span>
          <span class="icon icon-distributevertical-top"></span>
          <span class="lb">.icon-distributevertical-top</span>
          <span class="icon icon-distributevertical-center"></span>
          <span class="lb">.icon-distributevertical-center</span>
          <span class="icon icon-distributevertical-bottom"></span>
          <span class="lb">.icon-distributevertical-bottom</span>
        </div>
        <div class="group">
          <h3>Files</h3>
          <span class="icon icon-blankfile2"></span>
          <span class="lb">.icon-blankfile2</span>
          <span class="icon icon-twofiles2"></span>
          <span class="lb">.icon-twofiles2</span>
          <span class="icon icon-downloadblank"></span>
          <span class="lb">.icon-downloadblank</span>
          <span class="icon icon-downloadcsv"></span>
          <span class="lb">.icon-downloadcsv</span>
          <span class="icon icon-uploadcsv"></span>
          <span class="lb">.icon-uploadcsv</span>
          <span class="icon icon-downloadhtml"></span>
          <span class="lb">.icon-downloadhtml</span>
          <span class="icon icon-downloadjson"></span>
          <span class="lb">.icon-downloadjson</span>
          <span class="icon icon-uploadqsf"></span>
          <span class="lb">.icon-uploadqsf</span>
          <span class="icon icon-downloadspss"></span>
          <span class="lb">.icon-downloadspss</span>
          <span class="icon icon-downloadtsv"></span>
          <span class="lb">.icon-downloadtsv</span>
          <span class="icon icon-downloadtxt"></span>
          <span class="lb">.icon-downloadtxt</span>
          <span class="icon icon-downloadxml"></span>
          <span class="lb">.icon-downloadxml</span>
          <span class="icon icon-reportfile-sm"></span>
          <span class="lb">.icon-reportfile-sm</span>
          <span class="icon icon-reportfile-filled-sm"></span>
          <span class="lb">.icon-reportfile-filled-sm</span>
          <span class="icon icon-page-wire"></span>
          <span class="lb">.icon-page-wire</span>
          <span class="icon icon-page-wire-sm"></span>
          <span class="lb">.icon-page-wire-sm</span>
          <span class="icon icon-page"></span>
          <span class="lb">.icon-page</span>
          <span class="icon icon-blankfile"></span>
          <span class="lb">.icon-blankfile</span>
          <span class="icon icon-blankfile-lg"></span>
          <span class="lb">.icon-blankfile-lg</span>
          <span class="icon icon-twofiles"></span>
          <span class="lb">.icon-twofiles</span>
          <span class="icon icon-audiofile-lg"></span>
          <span class="lb">.icon-audiofile-lg</span>
          <span class="icon icon-excelfile-lg"></span>
          <span class="lb">.icon-excelfile-lg</span>
          <span class="icon icon-imagefile-lg"></span>
          <span class="lb">.icon-imagefile-lg</span>
          <span class="icon icon-pdffile-lg"></span>
          <span class="lb">.icon-pdffile-lg</span>
          <span class="icon icon-textfile-lg"></span>
          <span class="lb">.icon-textfile-lg</span>
          <span class="icon icon-videofile-lg"></span>
          <span class="lb">.icon-videofile-lg</span>
          <span class="icon icon-wordfile-lg"></span>
          <span class="lb">.icon-wordfile-lg</span>
          <span class="icon icon-uploadcsv-lg"></span>
          <span class="lb">.icon-uploadcsv-lg</span>
        </div>
        <div class="group">
          <h3>Contacts</h3>
          <span class="icon icon-addperson"></span>
          <span class="lb">.icon-addperson</span>
          <span class="icon icon-addperson-framed-lg"></span>
          <span class="lb">.icon-addperson-framed-lg</span>
          <span class="icon icon-addressbook-lg"></span>
          <span class="lb">.icon-addressbook-lg</span>
          <span class="icon icon-contactgroup-lg"></span>
          <span class="lb">.icon-contactgroup-lg</span>
          <span class="icon icon-sample-lg"></span>
          <span class="lb">.icon-sample-lg</span>
          <span class="icon icon-individual-selected"></span>
          <span class="lb">.icon-individual-selected</span>
        </div>
        <div class="group">
          <h3>Money and Rewards</h3>
          <span class="icon icon-coupon"></span>
          <span class="lb">.icon-coupon</span>
          <span class="icon icon-dollarsign-filled"></span>
          <span class="lb">.icon-dollarsign-filled</span>
          <span class="icon icon-present"></span>
          <span class="lb">.icon-present</span>
          <span class="icon icon-prizeribbon"></span>
          <span class="lb">.icon-prizeribbon</span>
        </div>
        <div class="group">
          <h3>Tickets and Outcomes</h3>
          <span class="icon icon-actions"></span>
          <span class="lb">.icon-actions</span>
          <span class="icon icon-actions-wire"></span>
          <span class="lb">.icon-actions-wire</span>
          <span class="icon icon-outcomes-wire-lg"></span>
          <span class="lb">.icon-outcomes-wire-lg</span>
          <span class="icon icon-ticket-lg"></span>
          <span class="lb">.icon-ticket-lg</span>
          <span class="icon icon-ticket-alt"></span>
          <span class="lb">.icon-ticket-alt</span>
          <span class="icon icon-xm-tickets-app"></span>
          <span class="lb">.icon-xm-tickets-app</span>
        </div>
        <div class="group">
          <h3>Miscellaneous</h3>
          <span class="icon icon-books"></span>
          <span class="lb">.icon-books</span>
          <span class="icon icon-books-lg"></span>
          <span class="lb">.icon-books-lg</span>
          <span class="icon icon-briefcase"></span>
          <span class="lb">.icon-briefcase</span>
          <span class="icon icon-broom"></span>
          <span class="lb">.icon-broom</span>
          <span class="icon icon-bucket"></span>
          <span class="lb">.icon-bucket</span>
          <span class="icon icon-bucket-wire-lg"></span>
          <span class="lb">.icon-bucket-wire-lg</span>
          <span class="icon icon-emoji"></span>
          <span class="lb">.icon-emoji</span>
          <span class="icon icon-lightbulb"></span>
          <span class="lb">.icon-lightbulb</span>
          <span class="icon icon-megaphone"></span>
          <span class="lb">.icon-megaphone</span>
          <span class="icon icon-progressbar"></span>
          <span class="lb">.icon-progressbar</span>
          <span class="icon icon-pulse"></span>
          <span class="lb">.icon-pulse</span>
          <span class="icon icon-translate"></span>
          <span class="lb">.icon-translate</span>
          <span class="icon icon-unbalancedscales-lg"></span>
          <span class="lb">.icon-unbalancedscales-lg</span>
          <span class="icon icon-xm-dot-grid"></span>
          <span class="lb">.icon-xm-dot-grid</span>
        </div>
      </div>
      <div class="column">
        <div class="group">
          <h3>Organization</h3>
          <span class="icon icon-folder"></span>
          <span class="lb">.icon-folder</span>
          <span class="icon icon-folder-wire"></span>
          <span class="lb">.icon-folder-wire</span>
          <span class="icon icon-folder-lg"></span>
          <span class="lb">.icon-folder-lg</span>
          <span class="icon icon-folder-wire-lg"></span>
          <span class="lb">.icon-folder-wire-lg</span>
          <span class="icon icon-emptyfolder-lg"></span>
          <span class="lb">.icon-emptyfolder-lg</span>
          <span class="icon icon-paperstack-wire"></span>
          <span class="lb">.icon-paperstack-wire</span>
          <span class="icon icon-paperstack-filled-lg"></span>
          <span class="lb">.icon-paperstack-filled-lg</span>
          <span class="icon icon-paperstack-framed-lg"></span>
          <span class="lb">.icon-paperstack-framed-lg</span>
          <span class="icon icon-emptybox-lg"></span>
          <span class="lb">.icon-emptybox-lg</span>
          <span class="icon icon-tag"></span>
          <span class="lb">.icon-tag</span>
          <span class="icon icon-tag-lg"></span>
          <span class="lb">.icon-tag-lg</span>
          <span class="icon icon-tag-wire-lg"></span>
          <span class="lb">.icon-tag-wire-lg</span>
          <span class="icon icon-tags-lg"></span>
          <span class="lb">.icon-tags-lg</span>
          <span class="icon icon-tags-wire-lg"></span>
          <span class="lb">.icon-tags-wire-lg</span>
          <span class="icon icon-ribbon-wire-lg"></span>
          <span class="lb">.icon-ribbon-wire-lg</span>
          <span class="icon icon-star-sm"></span>
          <span class="lb">.icon-star-sm</span>
        </div>
        <div class="group">
          <h3>Searching and Filtering</h3>
          <span class="icon icon-search-sm"></span>
          <span class="lb">.icon-search-sm</span>
          <span class="icon icon-search"></span>
          <span class="lb">.icon-search</span>
          <span class="icon icon-search-lg"></span>
          <span class="lb">.icon-search-lg</span>
          <span class="icon icon-search-filled-lg"></span>
          <span class="lb">.icon-search-filled-lg</span>
          <span class="icon icon-search-framed-lg"></span>
          <span class="lb">.icon-search-framed-lg</span>
          <span class="icon icon-search-wire-lg"></span>
          <span class="lb">.icon-search-wire-lg</span>
          <span class="icon icon-filter"></span>
          <span class="lb">.icon-filter</span>
          <span class="icon icon-sort-asc"></span>
          <span class="lb">.icon-sort-asc</span>
          <span class="icon icon-sort-desc"></span>
          <span class="lb">.icon-sort-desc</span>
          <span class="icon icon-sort-alphabetic-asc"></span>
          <span class="lb">.icon-sort-alphabetic-asc</span>
          <span class="icon icon-sort-alphabetic-desc"></span>
          <span class="lb">.icon-sort-alphabetic-desc</span>
          <span class="icon icon-sort-numeric-asc"></span>
          <span class="lb">.icon-sort-numeric-asc</span>
          <span class="icon icon-sort-numeric-desc"></span>
          <span class="lb">.icon-sort-numeric-desc</span>
        </div>
        <div class="group">
          <h3>Jump-Start Projects</h3>
          <span class="icon icon-rocket-wire"></span>
          <span class="lb">.icon-rocket-wire</span>
          <span class="icon xl icon-customerrelationship-xl"></span>
          <span class="lb xl">.icon-customerrelationship-xl</span>
          <span class="icon xl icon-customersupport-xl"></span>
          <span class="lb xl">.icon-customersupport-xl</span>
          <span class="icon xl icon-thumbsupanddown-xl"></span>
          <span class="lb xl">.icon-thumbsupanddown-xl</span>
          <span class="icon xl icon-governmentbuilding-xl"></span>
          <span class="lb xl">.icon-governmentbuilding-xl</span>
          <span class="icon xl icon-bank-xl"></span>
          <span class="lb xl">.icon-bank-xl</span>
          <span class="icon xl icon-appleonbook-xl"></span>
          <span class="lb xl">.icon-appleonbook-xl</span>
          <span class="icon xl icon-websiteads-xl"></span>
          <span class="lb xl">.icon-websiteads-xl</span>
          <span class="icon icon-customerrelationship"></span>
          <span class="lb">.icon-customerrelationship</span>
          <span class="icon icon-customersupport"></span>
          <span class="lb">.icon-customersupport</span>
          <span class="icon icon-thumbsupanddown"></span>
          <span class="lb">.icon-thumbsupanddown</span>
          <span class="icon icon-governmentbuilding"></span>
          <span class="lb">.icon-governmentbuilding</span>
          <span class="icon icon-bank"></span>
          <span class="lb">.icon-bank</span>
          <span class="icon icon-appleonbook"></span>
          <span class="lb">.icon-appleonbook</span>
          <span class="icon icon-websiteads"></span>
          <span class="lb">.icon-websiteads</span>
        </div>
        <div class="group">
          <h3>Surveys</h3>
          <span class="icon icon-survey"></span>
          <span class="lb">.icon-survey</span>
          <span class="icon icon-survey-wire"></span>
          <span class="lb">.icon-survey-wire</span>
          <span class="icon icon-survey-wire-2"></span>
          <span class="lb">.icon-survey-wire-2</span>
          <span class="icon icon-survey-lg"></span>
          <span class="lb">.icon-survey-lg</span>
          <span class="icon icon-survey-filled-lg"></span>
          <span class="lb">.icon-survey-filled-lg</span>
          <span class="icon icon-survey-framed-lg"></span>
          <span class="lb">.icon-survey-framed-lg</span>
          <span class="icon icon-ghostsurvey"></span>
          <span class="lb">.icon-ghostsurvey</span>
          <span class="icon icon-ghostsurvey-filled"></span>
          <span class="lb">.icon-ghostsurvey-filled</span>
          <span class="icon icon-ghostsurvey-framed"></span>
          <span class="lb">.icon-ghostsurvey-framed</span>
          <span class="icon icon-block-wire-sm"></span>
          <span class="lb">.icon-block-sm</span>
          <span class="icon icon-block-filled-lg"></span>
          <span class="lb">.icon-block-filled-lg</span>
          <span class="icon icon-block-framed-lg"></span>
          <span class="lb">.icon-block-framed-lg</span>
          <span class="icon icon-ghostblock-wire-sm"></span>
          <span class="lb">.icon-ghostblock-wire-sm</span>
          <span class="icon icon-ghostblock-filled-lg"></span>
          <span class="lb">.icon-ghostblock-filled-lg</span>
          <span class="icon icon-ghostblock-framed-lg"></span>
          <span class="lb">.icon-ghostblock-framed-lg</span>
          <span class="icon icon-inactive"></span>
          <span class="lb">.icon-inactive</span>
          <span class="icon icon-inactive-framed-lg"></span>
          <span class="lb">.icon-inactive-framed-lg</span>
          <span class="icon icon-pipedtext"></span>
          <span class="lb">.icon-pipedtext</span>
        </div>
        <div class="group">
          <h3>Question Types</h3>
          <span class="icon icon-text"></span>
          <span class="lb">.icon-text</span>
          <span class="icon icon-graphic"></span>
          <span class="lb">.icon-graphic</span>
          <span class="icon icon-multiplechoice"></span>
          <span class="lb">.icon-multiplechoice</span>
          <span class="icon icon-multiplechoice-sm"></span>
          <span class="lb">.icon-multiplechoice-sm</span>
          <span class="icon icon-matrix"></span>
          <span class="lb">.icon-matrix</span>
          <span class="icon icon-matrix-sm"></span>
          <span class="lb">.icon-matrix-sm</span>
          <span class="icon icon-textentry"></span>
          <span class="lb">.icon-textentry</span>
          <span class="icon icon-textentry-sm"></span>
          <span class="lb">.icon-textentry-sm</span>
          <span class="icon icon-slider"></span>
          <span class="lb">.icon-slider</span>
          <span class="icon icon-slider-sm"></span>
          <span class="lb">.icon-slider-sm</span>
          <span class="icon icon-rankorder"></span>
          <span class="lb">.icon-rankorder</span>
          <span class="icon icon-rankorder-sm"></span>
          <span class="lb">.icon-rankorder-sm</span>
          <span class="icon icon-sidebyside"></span>
          <span class="lb">.icon-sidebyside</span>
          <span class="icon icon-sidebyside-sm"></span>
          <span class="lb">.icon-sidebyside-sm</span>
          <span class="icon icon-constantsum"></span>
          <span class="lb">.icon-constantsum</span>
          <span class="icon icon-constantsum-sm"></span>
          <span class="lb">.icon-constantsum-sm</span>
          <span class="icon icon-groupandrank"></span>
          <span class="lb">.icon-groupandrank</span>
          <span class="icon icon-groupandrank-sm"></span>
          <span class="lb">.icon-groupandrank-sm</span>
          <span class="icon icon-hotspot"></span>
          <span class="lb">.icon-hotspot</span>
          <span class="icon icon-hotspot-sm"></span>
          <span class="lb">.icon-hotspot-sm</span>
          <span class="icon icon-heatmap"></span>
          <span class="lb">.icon-heatmap</span>
          <span class="icon icon-heatmap-sm"></span>
          <span class="lb">.icon-heatmap-sm</span>
          <span class="icon icon-graphicslider"></span>
          <span class="lb">.icon-graphicslider</span>
          <span class="icon icon-graphicslider-sm"></span>
          <span class="lb">.icon-graphicslider-sm</span>
          <span class="icon icon-gapanalysis"></span>
          <span class="lb">.icon-gapanalysis</span>
          <span class="icon icon-gapanalysis-sm"></span>
          <span class="lb">.icon-gapanalysis-sm</span>
          <span class="icon icon-drilldown"></span>
          <span class="lb">.icon-drilldown</span>
          <span class="icon icon-drilldown-sm"></span>
          <span class="lb">.icon-drilldown-sm</span>
          <span class="icon icon-nps"></span>
          <span class="lb">.icon-nps</span>
          <span class="icon icon-nps-sm"></span>
          <span class="lb">.icon-nps-sm</span>
          <span class="icon icon-highlighter-framed-lg"></span>
          <span class="lb">.icon-highlighter-framed-lg</span>
          <span class="icon icon-highlighter-framed-sm"></span>
          <span class="lb">.icon-highlighter-framed-sm</span>
          <span class="icon icon-pen-framed-lg"></span>
          <span class="lb">.icon-pen-framed-lg</span>
          <span class="icon icon-pen-framed-sm"></span>
          <span class="lb">.icon-pen-framed-sm</span>
          <span class="icon icon-screen-capture"></span>
          <span class="lb">.icon-screen-capture</span>
          <span class="icon icon-screen-capture-sm"></span>
          <span class="lb">.icon-screen-capture-sm</span>
          <span class="icon icon-timer"></span>
          <span class="lb">.icon-timer</span>
          <span class="icon icon-timer-sm"></span>
          <span class="lb">.icon-timer-sm</span>
          <span class="icon icon-metadata"></span>
          <span class="lb">.icon-metadata</span>
          <span class="icon icon-metadata-sm"></span>
          <span class="lb">.icon-metadata-sm</span>
          <span class="icon icon-page-wire"></span>
          <span class="lb">.icon-page-wire</span>
          <span class="icon icon-page-wire-sm"></span>
          <span class="lb">.icon-page-wire-sm</span>
          <span class="icon icon-fingerprint-lg"></span>
          <span class="lb">.icon-fingerprint-lg</span>
          <span class="icon icon-fingerprint-sm"></span>
          <span class="lb">.icon-fingerprint-sm</span>
        </div>
        <div class="group">
          <h3>Survey Editor</h3>
          <span class="icon icon-asterisk-filled-lg"></s"></span>
          <span class="lb">.icon-asterisk-filled-lg</span>
          <span class="icon icon-asterisk"></span>
          <span class="lb">.icon-asterisk</span>
          <span class="icon icon-js-filled-lg"></span>
          <span class="lb">.icon-js-filled-lg</span>
          <span class="icon icon-js-framed"></span>
          <span class="lb">.icon-js-framed</span>
          <span class="icon icon-mobiledevice-filled-lg"></span>
          <span class="lb">.icon-mobiledevice-filled-lg</span>
          <span class="icon icon-selectedoption-filled-lg"></span>
          <span class="lb">.icon-selectedoption-filled-lg</span>
          <span class="icon icon-selectedoption-framed"></span>
          <span class="lb">.icon-selectedoption-framed</span>
          <span class="icon icon-variable-filled-lg"></span>
          <span class="lb">.icon-variable-filled-lg</span>
          <span class="icon icon-variable-wire-lg"></span>
          <span class="lb">.icon-variable-wire-lg</span>
          <span class="icon icon-vitruvianman-filled-lg"></span>
          <span class="lb">.icon-vitruvianman-filled-lg</span>
          <span class="icon icon-squarestack"></span>
          <span class="lb">.icon-squarestack</span>
          <span class="icon icon-questiongroup"></span>
          <span class="lb">.icon-questiongroup</span>
          <span class="icon icon-stickynote-left"></span>
          <span class="lb">.icon-stickynote-left</span>
          <span class="icon icon-stickynotebg-left"></span>
          <span class="lb">.icon-stickynotebg-left</span>
          <span class="icon icon-stickynote-right"></span>
          <span class="lb">.icon-stickynote-right</span>
          <span class="icon icon-stickynotebg-right"></span>
          <span class="lb">.icon-stickynotebg-right</span>
        </div>
        <div class="group">
          <h3>Email and Messages</h3>
          <span class="icon icon-airplane"></span>
          <span class="lb">.icon-airplane</span>
          <span class="icon icon-airplane-wire"></span>
          <span class="lb">.icon-airplane-wire</span>
          <span class="icon icon-airplane-wire-lg"></span>
          <span class="lb">.icon-airplane-wire-lg</span>
          <span class="icon icon-airplane-filled-lg"></span>
          <span class="lb">.icon-airplane-filled-lg</span>
          <span class="icon icon-airplane-framed-lg"></span>
          <span class="lb">.icon-airplane-framed-lg</span>
          <span class="icon icon-envelope"></span>
          <span class="lb">.icon-envelope</span>
          <span class="icon icon-envelope-wire"></span>
          <span class="lb">.icon-envelope-wire</span>
          <span class="icon icon-envelope-lg"></span>
          <span class="lb">.icon-envelope-lg</span>
          <span class="icon icon-envelope-wire-lg"></span>
          <span class="lb">.icon-envelope-wire-lg</span>
          <span class="icon icon-envelope-wire-alt-lg"></span>
          <span class="lb">.icon-envelope-wire-alt-lg</span>
          <span class="icon icon-emailsubject"></span>
          <span class="lb">.icon-emailsubject</span>
          <span class="icon icon-emailsubject-framed-lg"></span>
          <span class="lb">.icon-emailsubject-framed-lg</span>
          <span class="icon icon-bell"></span>
          <span class="lb">.icon-bell</span>
          <span class="icon icon-bell-sm"></span>
          <span class="lb">.icon-bell-sm</span>
          <span class="icon icon-bell-framed-lg"></span>
          <span class="lb">.icon-bell-framed-lg</span>
          <span class="icon icon-smile"></span>
          <span class="lb">.icon-smile</span>
          <span class="icon icon-smile-framed-lg"></span>
          <span class="lb">.icon-smile-framed-lg</span>
          <span class="icon icon-fingerprint-lg"></span>
          <span class="lb">.icon-fingerprint-lg</span>
        </div>
        <div class="group">
          <h3>Web and Mobile</h3>
          <span class="icon icon-globe"></span>
          <span class="lb">.icon-globe</span>
          <span class="icon icon-globe-inverted"></span>
          <span class="lb">.icon-globe-inverted</span>
          <span class="icon icon-globe-lg"></span>
          <span class="lb">.icon-globe-lg</span>
          <span class="icon icon-globe-inverted-lg"></span>
          <span class="lb">.icon-globe-inverted-lg</span>
          <span class="icon icon-network-lg"></span>
          <span class="lb">.icon-network-lg</span>
          <span class="icon icon-database"></span>
          <span class="lb">.icon-database</span>
          <span class="icon icon-database-sm"></span>
          <span class="lb">.icon-database-sm</span>
          <span class="icon icon-websitepopup"></span>
          <span class="lb">.icon-websitepopup</span>
          <span class="icon icon-webbrowser-wire-lg"></span>
          <span class="lb">.icon-webbrowser-wire-lg</span>
          <span class="icon icon-iphone"></span>
          <span class="lb">.icon-iphone</span>
          <span class="icon icon-mobiledevice-lg"></span>
          <span class="lb">.icon-mobiledevice-lg</span>
          <span class="icon icon-qrcode-lg"></span>
          <span class="lb">.icon-qrcode-lg</span>
          <span class="icon icon-viewqrcode-lg"></span>
          <span class="lb">.icon-viewqrcode-lg</span>
          <span class="icon icon-selectedqrcode"></span>
          <span class="lb">.icon-selectedqrcode</span>
          <span class="icon icon-link"></span>
          <span class="lb">.icon-link</span>
          <span class="icon icon-link-lg"></span>
          <span class="lb">.icon-link-lg</span>
        </div>
        <div class="group">
          <h3>Reporting</h3>
          <span class="icon icon-bargraph-filled"></span>
          <span class="lb">.icon-bargraph-filled</span>
          <span class="icon icon-bargraph-framed"></span>
          <span class="lb">.icon-bargraph-framed</span>
          <span class="icon icon-bargraph"></span>
          <span class="lb">.icon-bargraph</span>
          <span class="icon icon-bargraph-wire"></span>
          <span class="lb">.icon-bargraph-wire</span>
          <span class="icon icon-bargraph-filled-lg"></span>
          <span class="lb">.icon-bargraph-filled-lg</span>
          <span class="icon icon-bargraph-framed-lg"></span>
          <span class="lb">.icon-bargraph-framed-lg</span>
          <span class="icon icon-verticalsliders"></span>
          <span class="lb">.icon-verticalsliders</span>
          <span class="icon icon-verticalsliders-filled"></span>
          <span class="lb">.icon-verticalsliders-filled</span>
          <span class="icon icon-verticalsliders-framed"></span>
          <span class="lb">.icon-verticalsliders-framed</span>
          <span class="icon icon-verticalsliders-filled-lg"></span>
          <span class="lb">.icon-verticalsliders-filled-lg</span>
          <span class="icon icon-verticalsliders-framed-lg"></span>
          <span class="lb">.icon-verticalsliders-framed-lg</span>
          <span class="icon icon-radiogroup-framed-lg"></span>
          <span class="lb">.icon-radiogroup-framed-lg</span>
          <span class="icon icon-simplelinegraph"></span>
          <span class="lb">.icon-simplelinegraph</span>
          <span class="icon icon-linegraph-filled"></span>
          <span class="lb">.icon-linegraph-filled</span>
          <span class="icon icon-linegraph"></span>
          <span class="lb">.icon-linegraph</span>
          <span class="icon icon-dottedlinegraph-filled"></span>
          <span class="lb">.icon-dottedlinegraph-filled</span>
          <span class="icon icon-trianglelines-lg"></span>
          <span class="lb">.icon-trianglelines-lg</span>
          <span class="icon icon-trianglelineswithpencil-lg"></span>
          <span class="lb">.icon-trianglelineswithpencil-lg</span>
          <span class="icon icon-barsandtwowayarrow-lg"></span>
          <span class="lb">.icon-barsandtwowayarrow-lg</span>
          <span class="icon icon-blockgrid-lg"></span>
          <span class="lb">.icon-blockgrid-lg</span>
          <span class="icon icon-quadrant-1"></span>
          <span class="lb">.icon-quadrant-1</span>
          <span class="icon icon-quadrant-2"></span>
          <span class="lb">.icon-quadrant-2</span>
          <span class="icon icon-quadrant-3"></span>
          <span class="lb">.icon-quadrant-3</span>
          <span class="icon icon-quadrant-4"></span>
          <span class="lb">.icon-quadrant-4</span>
        </div>
        <div class="group">
          <h3>Charts and Visualizations</h3>
          <span class="icon icon-bargraph"></span>
          <span class="lb">.icon-bargraph</span>
          <span class="icon icon-addchart"></span>
          <span class="lb">.icon-addchart</span>
          <span class="icon icon-4columnbargraph"></span>
          <span class="lb">.icon-4columnbargraph</span>
          <span class="icon icon-4columnbargraph-sm"></span>
          <span class="lb">.icon-4columnbargraph-sm</span>
          <span class="icon icon-areachart"></span>
          <span class="lb">.icon-areachart</span>
          <span class="icon icon-linechart"></span>
          <span class="lb">.icon-linechart</span>
          <span class="icon icon-breakdownbar"></span>
          <span class="lb">.icon-breakdownbar</span>
          <span class="icon icon-halfgauge"></span>
          <span class="lb">.icon-halfgauge</span>
          <span class="icon icon-heatmap"></span>
          <span class="lb">.icon-heatmap</span>
          <span class="icon icon-piechart"></span>
          <span class="lb">.icon-piechart</span>
          <span class="icon icon-hierarchychart"></span>
          <span class="lb">.icon-hierarchychart</span>
          <span class="icon icon-map"></span>
          <span class="lb">.icon-map</span>
          <span class="icon icon-wordcloud"></span>
          <span class="lb">.icon-wordcloud</span>
          <span class="icon icon-number"></span>
          <span class="lb">.icon-number</span>
          <span class="icon icon-scatterplot"></span>
          <span class="lb">.icon-scatterplot</span>
          <span class="icon icon-bubblechart"></span>
          <span class="lb">.icon-bubblechart</span>
          <span class="icon icon-bar-chart"></span>
          <span class="lb">.icon-bar-chart</span>
          <span class="icon icon-line-chart"></span>
          <span class="lb">.icon-line-chart</span>
          <span class="icon icon-donut-chart"></span>
          <span class="lb">.icon-donut-chart</span>
          <span class="icon icon-breakdown-bar"></span>
          <span class="lb">.icon-breakdown-bar</span>
          <span class="icon icon-gauge-chart"></span>
          <span class="lb">.icon-gauge-chart</span>
          <span class="icon icon-word-cloud"></span>
          <span class="lb">.icon-word-cloud</span>
          <span class="icon icon-heat-map"></span>
          <span class="lb">.icon-heat-map</span>
          <span class="icon icon-xm-demographic-breakout"></span>
          <span class="lb">.icon-xm-demographic-breakout</span>
        </div>
        <div class="group">
          <h3>Tables</h3>
          <span class="icon icon-table"></span>
          <span class="lb">.icon-table</span>
          <span class="icon icon-crosstab-lg"></span>
          <span class="lb">.icon-crosstab-lg</span>
          <span class="icon icon-pivottable-lg"></span>
          <span class="lb">.icon-pivottable-lg</span>
          <span class="icon icon-table-inverted"></span>
          <span class="lb">.icon-table-inverted</span>
          <span class="icon icon-multiplesourcetable"></span>
          <span class="lb">.icon-multiplesourcetable</span>
          <span class="icon icon-breakdowntable"></span>
          <span class="lb">.icon-breakdowntable</span>
          <span class="icon icon-grid"></span>
          <span class="lb">.icon-grid</span>
          <span class="icon icon-table-sm"></span>
          <span class="lb">.icon-table-sm</span>
          <span class="icon icon-addtable-sm"></span>
          <span class="lb">.icon-addtable-sm</span>
          <span class="icon icon-simple-table"></span>
          <span class="lb">.icon-simple-table</span>
          <span class="icon icon-stats-table"></span>
          <span class="lb">.icon-stats-table</span>
          <span class="icon icon-list-table"></span>
          <span class="lb">.icon-list-table</span>
        </div>
        <div class="group">
          <h3>Text</h3>
          <span class="icon icon-text-framed"></span>
          <span class="lb">.icon-text-framed</span>
          <span class="icon icon-text-sm"></span>
          <span class="lb">.icon-text-sm</span>
          <span class="icon icon-addtext-sm"></span>
          <span class="lb">.icon-addtext-sm</span>
          <span class="icon icon-addtext-xs"></span>
          <span class="lb">.icon-addtext-xs</span>
          <span class="icon icon-grade-framed"></span>
          <span class="lb">.icon-grade-framed</span>
          <span class="icon icon-percent-framed"></span>
          <span class="lb">.icon-percent-framed</span>
          <span class="icon icon-text-box"></span>
          <span class="lb">.icon-text-box</span>
        </div>
        <div class="group">
          <h3>Images</h3>
          <span class="icon icon-image"></span>
          <span class="lb">.icon-image</span>
          <span class="icon icon-image-2"></span>
          <span class="lb">.icon-image-2</span>
          <span class="icon icon-image-filled"></span>
          <span class="lb">.icon-image-filled</span>
          <span class="icon icon-image-lg"></span>
          <span class="lb">.icon-image-lg</span>
          <span class="icon icon-slideshow"></span>
          <span class="lb">.icon-slideshow</span>
          <span class="icon icon-image-sm"></span>
          <span class="lb">.icon-image-sm</span>
          <span class="icon icon-addimage-sm"></span>
          <span class="lb">.icon-addimage-sm</span>
        </div>
        <div class="group">
          <h3>Shapes</h3>
          <span class="icon icon-shapes-wire-sm"></span>
          <span class="lb">.icon-shapes-wire-sm</span>
          <span class="icon icon-addshapes-wire-sm"></span>
          <span class="lb">.icon-addshapes-wire-sm</span>
          <span class="icon icon-triangle-wire"></span>
          <span class="lb">.icon-triangle-wire</span>
          <span class="icon icon-rdrectangle-wire"></span>
          <span class="lb">.icon-rdrectangle-wire</span>
          <span class="icon icon-line-wire"></span>
          <span class="lb">.icon-line-wire</span>
        </div>
        <div class="group">
          <h3>Stars</h3>
          <span class="icon icon-star-sm"></span>
          <span class="lb">.icon-star-sm</span>
          <span class="icon icon-star-filled-sm"></span>
          <span class="lb">.icon-star-filled-sm</span>
          <span class="icon icon-star-wire-sm"></span>
          <span class="lb">.icon-star-wire-sm</span>
          <span class="icon icon-star-half-filled-sm"></span>
          <span class="lb">.icon-star-half-filled-sm</span>
        </div>
        <div class="group">
          <h3>Checkboxes and Radio Buttons</h3>
          <span class="icon icon-check-sm"></span>
          <span class="lb">.icon-check-sm</span>
          <span class="icon icon-square-wire"></span>
          <span class="lb">.icon-square-wire</span>
          <span class="icon icon-square"></span>
          <span class="lb">.icon-square</span>
          <span class="icon icon-square" style="color: #fff;">
            <span class="icon icon-square-wire" style="color: #808080;">
              <span class="icon icon-check-sm" style="color: #333;"></span>
            </span>
          </span>
          <span class="lb">assembed checkbox</span>
          <span class="icon icon-checkedbox-sm"></span>
          <span class="lb">.icon-checkedbox-sm</span>
          <span class="icon icon-circle-sm"></span>
          <span class="lb">.icon-circle-sm</span>
          <span class="icon icon-circle-wire"></span>
          <span class="lb">.icon-circle-wire</span>
          <span class="icon icon-circle"></span>
          <span class="lb">.icon-circle</span>
          <span class="icon icon-circle" style="color: #fff;">
            <span class="icon icon-circle-wire" style="color: #808080;">
              <span class="icon icon-circle-sm" style="color: #333;"></span>
            </span>
          </span>
          <span class="lb">assembled radio button</span>
        </div>
        <div class="group">
          <h3>Qualtrics Logos</h3>
          <span class="icon icon-360"></span>
          <span class="lb">.icon-360</span>
          <span class="icon icon-employeeengagement"></span>
          <span class="lb">.icon-employeeengagement</span>
          <span class="icon icon-employeepulse"></span>
          <span class="lb">.icon-employeepulse</span>
          <span class="icon icon-siteintercept-lg"></span>
          <span class="lb">.icon-siteintercept-lg</span>
          <span class="icon icon-vocalize"></span>
          <span class="lb">.icon-vocalize</span>
          <span class="icon icon-xm-crosstabs-iq"></span>
          <span class="lb">.icon-xm-crosstabs-iq</span>
          <span class="icon icon-xm-predict-iq"></span>
          <span class="lb">.icon-xm-predict-iq</span>
          <span class="icon icon-xm-iq"></span>
          <span class="lb">.icon-xm-iq</span>
        </div>
        <div class="group">
          <h3>Qualtrics Product Categories</h3>
          <span class="icon icon-customerexperience-lg"></span>
          <span class="lb">.icon-customerexperience-lg</span>
          <span class="icon icon-researchandpredict-lg"></span>
          <span class="lb">.icon-researchandpredict-lg</span>
          <span class="icon icon-employeeexperience"></span>
          <span class="lb">.icon-employeeexperience</span>
          <span class="icon icon-employeeexperience-lg"></span>
          <span class="lb">.icon-employeeexperience-lg</span>
          <span class="icon icon-research-core"></span>
          <span class="lb">.icon-research-core</span>
          <span class="icon icon-brand-experience"></span>
          <span class="lb">.icon-brand-experience</span>
          <span class="icon icon-customer-experience"></span>
          <span class="lb">.icon-customer-experience</span>
          <span class="icon icon-product-experience"></span>
          <span class="lb">.icon-product-experience</span>
          <span class="icon icon-employee-experience"></span>
          <span class="lb">.icon-employee-experience</span>
        </div>
        <div class="group">
          <h3>Third-Party Logos</h3>
          <span class="icon icon-dynamics"></span>
          <span class="lb">.icon-dynamics</span>
          <span class="icon icon-jira"></span>
          <span class="lb">.icon-jira</span>
          <span class="icon icon-marketo"></span>
          <span class="lb">.icon-marketo</span>
          <span class="icon icon-salesforce-lg"></span>
          <span class="lb">.icon-salesforce-lg</span>
          <span class="icon icon-slack"></span>
          <span class="lb">.icon-slack</span>
          <span class="icon icon-statwing"></span>
          <span class="lb">.icon-statwing</span>
          <span class="icon icon-twitter"></span>
          <span class="lb">.icon-twitter</span>
        </div>
      </div>
    </div>
  </file>
</example>
*/

/**
 * @ngdoc directive
 * @name qstrap:qstrap.inlineInput
 *
 * @restrict A
 * @description
 * Directive that overlays an input over an element when the element is clicked, or receives tab focus.
 *
 * @param {string} ngModel Assignable angular expression to data-bind the text to.
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The text value is available as $value)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The text value is available as $value)
 * @param {expresion=} validate Angular expression that takes $value as a parameter, executes before the ngModel is assigned, and returns a boolean of whether the value is valid.
 * @param {string=} inputType Non-bound string value that defaults to "text". Current options are "text" and "number"
 * @param {string=} defaultValue String value that will be set on the ngModel if the element is blurred and the text is empty.
 *
 * @example
   <example module="qstrap">
     <file name="inlineInput.html">
       <style>
         div.inline-input-demo em,
         div.inline-input-demo span,
         div.inline-input-demo strong {
           color: #006DAC;
           cursor: pointer;
         }
       </style>
       <div ng-controller="InlineInputDemoCtrl" class='inline-input-demo'>
         My name is <span qstrap.inline-input ng-model='name'>{{name}}</span>.
         I am <strong qstrap.inline-input ng-model='age' input-type='number' validate='$value > 0 && $value < 100'>{{age}}</strong> years old,
         and I say "<em qstrap.inline-input ng-model='answer' default-value='{{defaultValue}}'>{{answer}}</em>"
       </div>
     </file>
     <file name="inlineInput.js">
       angular.module('qstrap.inlineInput').controller('InlineInputDemoCtrl', function($scope) {
         $scope.name = "Bill S. Preston Esq.";
         $scope.age = "15";
         $scope.answer = "Party on dudes!";
         $scope.defaultValue = "default";
       });
     </file>
   </example>
 */
angular.module('qstrap.inlineInput', ['qstrap.util']).directive('qstrap.inlineInput', [
	'$document',
	'$window',
	'qstrap.util',
	function($document, $window, util)
	{
		"use strict";
		return {
			restrict: 'A',
			scope: {
				validate: '&',
				onChange: '&',
				afterChange: '&',
				defaultValue: '@'
			},
			require:'?ngModel',
			link: function($scope, $element, attrs, ngModel)
			{
				if (!ngModel)
				{
					return;
				}

				$element.addClass('q-inline-input');
				$element.attr('contenteditable', true);
				$element.attr('tabindex', 0);

				ngModel.$render = function()
				{
					$element.text(ngModel.$viewValue);
				};

				$element.on('keydown', function(evt)
				{
					if (evt.which === util.keys.ENTER || evt.which === util.keys.ESCAPE) {
						evt.stopPropagation();
						evt.preventDefault();
						if ($element.hasClass('editMode')) {
							$element.toggleClass('editMode');
							$element.attr('contenteditable', false);
						}
					}
				});

				$element.on('focus', function ()
				{
					$element.toggleClass('editMode');
					$element.attr('contenteditable', true);
					$scope.$evalAsync(select);
				});

				$element.on('keyup change', function()
				{
					return $scope.$evalAsync(read);
				});

				$element.on('focusout', function ()
				{
					if ($element.hasClass('editMode')) {
						$element.toggleClass('editMode');
						$element.attr('contenteditable', false);
						$window.getSelection().removeAllRanges();
					}
					return $scope.$evalAsync(finish);
				});

				// Cleanup to prevent memory leaks
				$scope.$on('$destroy', function() {
					// clean up event listeners and the element
					if ($element) {
						$element.off();
						$element.remove();
						$element = null;
					}
				});

				function select()
				{
					var range = $document[0].createRange();
					range.selectNodeContents($element[0]);
					var sel = $window.getSelection();
					sel.removeAllRanges();
					sel.addRange(range);
				}

				function update(text)
				{
					// force it to be either a number or zero
					if (attrs.inputType === 'number')
					{
						text = parseFloat(text) || 0;
					}

					//using != instead of !== so we don't change if ngModel.$viewValue is a number
					if (ngModel.$viewValue != text)
					{
						if (attrs.hasOwnProperty('onChange'))
						{
							$scope.onChange({$value:text});
						}

						ngModel.$setViewValue(text);

						if (attrs.hasOwnProperty('afterChange'))
						{
							$scope.afterChange({$value:text});
						}
					}
				}

				function read()
				{
					var text = getText();
					update(text);
				}

				function finish()
				{
					var text = getText();
					if (text === '')
					{
						if (attrs.hasOwnProperty('defaultValue') && angular.isDefined(attrs.defaultValue))
						{
							text = attrs.defaultValue;
						}
						else if (attrs.inputType === 'number')
						{
							text = '0';
						}
						$element.text(text);
					}
					update(text);
				}

				function getText() {
					var text = $element.text();

					//this makes it so it doesn't duplicate the text
					if (text === '<br>')
					{
						text = '';
					}

					return text;
				}
			}
		};
	}
]);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.input-groups
 *
 * @restrict C
 * @description
 * Ways to group inputs and buttons together
 *
 * @param {string} .input-group Input group container class
 * @param {string} .input-group-sm Small inputs and addons
 * @param {string} .input-group-full Makes the input group full-width
 * @param {string} .input-group-addon Add descriptive text
 * @param {string} .input-group-btn Add a button container (you'll still need to add the actual button inside .input-group-btn)
 *
 * @example
<example module="qstrap">
  <file name="input-groups.html">
    <style>
      .qstrap-qstrap-input-groups-page .input-group {
        margin-bottom: 10px;
      }
    </style>
    <div ng-controller="inputGroupDemoController">
      <h1>Text Add-ons</h1>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="username" />
        <span class="input-group-addon">@qualtrics.com</span>
      </div>
      <div class="input-group">
        <span class="input-group-addon">$</span>
        <input type="text" class="form-control" />
        <span class="input-group-addon">.00</span>
      </div>

      <h1>Button Add-ons</h1>
      <div class="input-group">
        <span class="input-group-btn">
          <div class="btn">Go</div>
        </span>
        <input type="text" class="form-control" placeholder="Search for..." />
      </div>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Search for..." />
        <span class="input-group-btn">
          <div class="btn">Go</div>
        </span>
      </div>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Default button" />
        <span class="input-group-btn">
          <div class="btn btn-default">Go</div>
        </span>
      </div>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Primary button" />
        <span class="input-group-btn">
          <div class="btn btn-primary">Go</div>
        </span>
      </div>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Success button" />
        <span class="input-group-btn">
          <div class="btn btn-success">Go</div>
        </span>
      </div>

      <h1>Menu Button Add-ons</h1>
      <div class="input-group">
        <span class="input-group-btn">
          <div class="btn btn-select" qstrap.menu items="items">
            <span>Load</span>
            <span class="caret"></span>
          </div>
        </span>
        <input type="text" class="form-control" placeholder="Email subject" />
      </div>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Email subject" />
        <span class="input-group-btn">
          <div class="btn btn-select" qstrap.menu items="items">
            <span>Load</span>
            <span class="caret"></span>
          </div>
        </span>
      </div>
      <div class="input-group">
        <span class="input-group-addon">Subject</span>
        <input type="text" class="form-control" placeholder="Email subject" />
        <span class="input-group-btn">
          <div class="btn" qstrap.menu items="items">
            <span class="icon icon-angle-down-sm"></span>
          </div>
        </span>
      </div>

      <h1>Input Group Sizes</h1>
      <div class="input-group">
        <span class="input-group-addon">@</span>
        <input type="text" class="form-control" placeholder="Default size" />
      </div>
      <div class="input-group input-group-sm">
        <span class="input-group-addon">@</span>
        <input type="text" class="form-control" placeholder=".input-group-sm" />
      </div>

      <h1>Full Width</h1>
      <div class="input-group input-group-full">
        <span class="input-group-addon">$</span>
        <input type="text" class="form-control" />
        <span class="input-group-addon">.00</span>
      </div>
      <div class="input-group input-group-full">
        <input type="text" class="form-control" placeholder="Search for..." />
        <span class="input-group-btn">
          <div class="btn">Go</div>
        </span>
      </div>
      <div class="input-group input-group-full">
        <input type="text" class="form-control" placeholder="Primary button" />
        <span class="input-group-btn">
          <div class="btn btn-primary">Go</div>
        </span>
      </div>
      <div class="input-group input-group-full">
        <span class="input-group-addon">Subject</span>
        <input type="text" class="form-control" placeholder="Email subject" />
        <span class="input-group-btn">
          <div class="btn" qstrap.menu items="items">
            <span class="icon icon-angle-down-sm"></span>
          </div>
        </span>
      </div>
    </div>
  </file>

  <file name="input-group.js">
    angular.module('qstrap.selectMenu').controller('inputGroupDemoController', function($scope) {
      $scope.items = [{
          label: 'Option 1'
        },{
          label: 'Option 2'
        },{
          label: 'Option 3'
        },{
          divider: true
        },{
          label: 'Option 4'
        }
      ];
    });
  </file>
</example>
*/

/**
 * @ngdoc directive
 * @name qstrap:qstrap.inputs
 *
 * @restrict C
 * @description
 * Styles for text inputs, password inputs, and textareas
 *
 * @param {class} .form-control Base class
 * @param {class} .form-control-full Full-width inputs
 * @param {class} .form-control-sm Small text inputs
 * @param {class} .ng-invalid added dynamically when using angular forms, or it can be added manually for invalid styles
 *
 * @param {string} placeholder Adds placeholder text to your input. There is a shim for IE that will also add the placeholder text. NOTE: The IE shim will NOT work without the "ng-model" attribute.
 * @param {string} ng-disabled Dynamically disables the input @see angularjs documentation for more info
 *
 * @example
<example module="qstrap">
	<file name="textInputs.html">
		<style>
			.form-group > label {
				display: block;
			}
		</style>
		<h1>Text Inputs</h1>
		<div class='form-group'>
			<label>Basic Input</label>
			<input type="text" class="form-control" />
		</div>
		<div class='form-group'>
			<label>Basic Input w/ placeholder</label>
			<input type="text" class="form-control" placeholder="name"/>
		</div>
		<div class='form-group'>
			<label>Full Input</label>
			<input type="text" class="form-control form-control-full" />
		</div>
		<div class='form-group'>
			<label>Small Input</label>
			<input type="text" class="form-control form-control-sm" />
		</div>
		<div class='form-group'>
			<label>Invalid Input using ng-invalid</label>
			<input type="text" class="ng-invalid form-control" />
		</div>
		<div class='form-group'>
			<label>Disabled</label>
			<input type="text" class="form-control" value="disabled" disabled="disable dynamically with ng-disabled"/>
		</div>

		<h1>Password Inputs</h1>
		<div class='form-group'>
			<label>Default Password w/ placeholder</label>
			<input type="password" class="form-control" placeholder="type a password" />
		</div>
		<div class='form-group'>
			<label>Full Width</label>
			<input type="password" class="form-control form-control-full" value="floop"/>
		</div>
		<div class='form-group'>
			<label>Small</label>
			<input type="password" class="form-control form-control-sm" value="dwerp"/>
		</div>
	</file>
</example>
*/
/**
 * @ngdoc directive
 * @name qstrap:qstrap.radio
 *
 * @restrict A
 * @description
 * Wraps an HTML `<input type='radio'>` with qstrap styles, and provides onChange and afterChange callbacks.
 * To disable a radio, use the `disabled` attribute, or use `ng-disabled` to set the disabled attribute dynamically.
 *
 * @param {boolean} ngModel scope variable you want to bind to the radio
 * @param {string} value the value you are assiging to the radio button
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The radio value is available as `$value`)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The radio value is available as $value)
 *
 * @example
	<example module="qstrap">
		<file name="radioDemo.html">
			<h1>Radio Buttons</h1>
			<div ng-controller="radioDemoController">
				<h3>Angular way</h3>
				<div class='form-group'>
					<label>No default</label>
					<div>
						<input type="radio" qstrap.radio ng-model="radioValue1" value="1" />
						<input type="radio" qstrap.radio ng-model="radioValue1" value="2" />
						<input type="radio" qstrap.radio ng-model="radioValue1" value="3" />
					</div>
					<div>{{radioValue1}}</div>
				</div>
				<div class='form-group'>
					<label>Default selected</label>
					<div>
						<input type="radio" qstrap.radio ng-model="radioValue2" value="A" />
						<input type="radio" qstrap.radio ng-model="radioValue2" value="B" />
						<input type="radio" qstrap.radio ng-model="radioValue2" value="C" />
					</div>
					<div>{{radioValue2}}</div>
				</div>
				<div class="form-group">
					<label>With labels</label>
					<label><input type="radio" qstrap.radio ng-model="radioValue3" value="apple" />Apple</label>
					<label><input type="radio" qstrap.radio ng-model="radioValue3" value="banana" />Banana</label>
					<label><input type="radio" qstrap.radio ng-model="radioValue3" value="orange" />Orange</label>
					<div>{{radioValue3}}</div>
				</div>
				<div class="form-group">
					<label>onChange event</label>
					<label><input type="radio" qstrap.radio ng-model="radioValue4" value="red" on-change="doOnChange($value)" />Red</label>
					<label><input type="radio" qstrap.radio ng-model="radioValue4" value="green" on-change="doOnChange($value)" />Green</label>
					<label><input type="radio" qstrap.radio ng-model="radioValue4" value="blue" on-change="doOnChange($value)" />Blue</label>
					<div ng-class="radioOnChangeColor" class="value" style="color: #fff;">{{radioOnChangeMessage}}</div>
				</div>
				<div class="form-group">
					<label>Disabled <button class='btn btn-sm btn-default' ng-click='radioDisabled = !radioDisabled'>{{radioDisabled ? "Enable" : "Disable"}}</button></label>
					<label><input type="radio" ng-disabled="radioDisabled" qstrap.radio ng-model="radioValue5" value="{{'Dog'}}"/>Dog</label>
					<label><input type="radio" ng-disabled="radioDisabled" qstrap.radio ng-model="radioValue5" ng-value="'Cat'"/>Cat</label>
					<div>{{radioValue5}}</div>
				</div>
			</div>
			<h3>HTML only (not recommended)</h3>
			<div class="form-group">
				<label>Basic example:</label>
				<div>
					<label class="qradio"><input type="radio" name="demo-qradio" value="x" /><i><i><i></i></i></i></label>
					<label class="qradio"><input type="radio" name="demo-qradio" value="y" /><i><i><i></i></i></i></label>
					<label class="qradio"><input type="radio" name="demo-qradio" value="z" /><i><i><i></i></i></i></label>
				</div>
			</div>
			<div class="form-group">
				<label>With labels:</label>
				<label>
					<label class="qradio"><input type="radio" name="demo-qradio-labels" value="apple" checked="checked" /><i><i><i></i></i></i></label>
					Apple
				</label>
				<label>
					<label class="qradio"><input type="radio" name="demo-qradio-labels" value="banana" /><i><i><i></i></i></i></label>
					Banana
				</label>
				<label>
					<label class="qradio"><input type="radio" name="demo-qradio-labels" value="orange" /><i><i><i></i></i></i></label>
					Orange
				</label>
			</div>
		</file>
		<file name="radioDemo.js">
			angular.module('qstrap.inputs')
				.controller('radioDemoController', function($scope) {
					$scope.radioValue2 = 'B';
					$scope.radioValue3 = 'apple';

					$scope.radioOnChangeMessage = '';
					$scope.radioOnChangeColor = '';
					$scope.doOnChange = function($value) {
						switch($value) {
							case 'red':
								$scope.radioOnChangeMessage = 'Changed to RED';
								$scope.radioOnChangeColor = 'red';
								break;
							case 'green':
								$scope.radioOnChangeMessage = 'Changed to GREEN';
								$scope.radioOnChangeColor = 'green';
								break;
							case 'blue':
								$scope.radioOnChangeMessage = 'Changed to BLUE';
								$scope.radioOnChangeColor = 'blue';
								break;
							default:
								$scope.radioOnChangeMessage = '';
								break;
						}
					};
				});
		</file>
	</example>
 */

/**
 * @ngdoc directive
 * @name qstrap:qstrap.checkbox
 *
 * @restrict A
 * @description
 * Wraps an HTML `<input type='checkbox'>` with qstrap styles, and provides onChange and afterChange callbacks.
 * To disable a checkbox, use the `disabled` attribute, or use `ng-disabled` to set the disabled attribute dynamically.
 *
 * @param {boolean} ngModel scope variable you want to bind to the checkbox
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The checkbox value is available as `$value`)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The checkbox value is available as $value)
 * @param {expression=} ngChange Angular expression to be executed when input changes due to user interaction with the input element (i.e. doesn't trigger on model update from JS)
 *
 * @example
	<example module="qstrap">
		<file name="checkbox.html">
			<h1>Checkboxes</h1>
			<em>To vertically align a checkbox or input to match your text size, just increase/decrease the height on the .qcheckbox or .qradio with CSS</em>
			<div ng-controller="checkboxDemoController">
				<div class="form-group">
					<label>Basic example:</label>
					<label><input type="checkbox" qstrap.checkbox ng-model="value1" ng-change="m('ngChange')" on-change="m('onChange')" after-change="m('afterChange')" />{{value1}}</label>
				</div>

				<div class="form-group">
					<label>onChange event:</label>
					<div>
						<input type="checkbox" qstrap.checkbox ng-model="value2" on-change="doOnChange($value)" />
						<span>true: {{onChangeTrueCounter}}</span>
						<span>false: {{onChangeFalseCounter}}</span>
					</div>
				</div>

				<div class="form-group">
					<label>With label:</label>
					<label><input type="checkbox" qstrap.checkbox ng-model="value3" />I love Angular!</label>
					<div>{{value3}}</div>
				</div>
				<div class="form-group">
					<label>Disabled:</label>
					<label><input type="checkbox" disabled="disabled" qstrap.checkbox ng-model="checkBoxValue4" />Clicking on this input will do nothing</label>
				</div>
			</div>
		</file>
		<file name="checkboxDemo.js">
			angular.module('qstrap.inputs').controller('checkboxDemoController', function($scope) {
				angular.extend($scope, {
					value1: false,
					value2: false,
					value3: true,
					onChangeTrueCounter: 0,
					onChangeFalseCounter: 0,
					doOnChange: function($value) {
						$scope.onChangeTrueCounter += $value;
						$scope.onChangeFalseCounter += !$value;
					},
					m: function(message) {
						console.log(message);
					}
				});
			});
		</file>
	</example>
 */
(function (module) {
	'use strict';

	// IE 8 doesn't get cool inputs. Sorry :(
	var isIE8 = (window.navigator.userAgent.indexOf('MSIE 8') > 0);

	function getInputDirective(className) {
		return [
			'$timeout',
			'$parse',
			function ($timeout, $parse) {

				return {
					link: function (scope, el, attrs) {

						if (!isIE8) {
							el.wrap('<label class="' + className + '"></label>');
							el.after('<i><i><i></i></i></i>');
						}

						if (attrs.ngModel && (attrs.onChange || attrs.afterChange)) {
							var onChange, afterChange;
							scope.$watch(attrs.ngModel, function (val, oldVal) {

								if (oldVal === val) {
									return;
								}
								if (attrs.onChange) {
									if (!onChange) {
										onChange = $parse(attrs.onChange);
									}
									onChange(scope, {$value:val});
								}

								//put the afterChange in a timeout to occor after the digest cycle
								if (attrs.afterChange) {
									if (!afterChange) {
										afterChange = $parse(attrs.afterChange);
									}
									$timeout(function () {
										afterChange(scope, {$value:val});
									});
								}
							});
						}
					}
				};
			}
		];
	}

	module.directive('qstrap.checkbox', getInputDirective('qcheckbox'));
	module.directive('qstrap.radio', getInputDirective('qradio'));

})(angular.module('qstrap.inputs', []));

angular.module('qstrap.placeholder', []).directive('placeholder', ['$document', function($document)
{
	'use strict';
	// Check for placeholder support, if it has it, return empty directive as fix isn't needed
	if ('placeholder' in $document[0].createElement('input')) {
		return {};
	}
	// Returned on browsers without placeholder support
	// Note: this will not work properly without the ng-model attribute
	return {
		restrict: 'A',
		require: '?ngModel',
		link: function($scope, element, attrs, ngModel) {
			var value = '',
				password = attrs.type === 'password';

			function placehold() {
				if (attrs.placeholder) {
					element.val(attrs.placeholder);
					element.addClass('placeholder');

					//NOTE: This is only a fix for IE9, since older versions don't respect type changes on inputs
					if (password) {
						element.attr('type', 'text');
					}
				}
			}

			function unplacehold() {
				element.val('');
				element.removeClass('placeholder');
				if (password) {
					element.attr('type', 'password');
				}
			}

			var placeholderObserverDeregister;
			function observePlaceholder() {
				if (!placeholderObserverDeregister && angular.isDefined(attrs.placeholder)) {
					placeholderObserverDeregister = attrs.$observe('placeholder', function () {
						if (value === '') {
							placehold();
						}
					});
				}
			}

			element.on('focus', function() {
				if (value === '') {
					unplacehold();
				}
			});

			element.on('blur', function() {
				if (element.val() === '') {
					placehold();
				}
			});

			// get the initial value, and set up the formatters
			if (attrs.ngModel && ngModel) {

				ngModel.$formatters.unshift(function (val) {
					if (!val) {
						placehold();
						value = '';
						return attrs.placeholder;
					}
					return val;
				});

				$scope.$watch(attrs.ngModel, function(val) {
					// If the ngModel is triggered from the placehold function we need to clear it.
					// NOTE: this only happens when tabbing out of an empty (no text), dirty (it has been changed) input.
					if (!val || (value === '' && val === attrs.placeholder)) {
						val = '';
					}
					value = val;
					observePlaceholder();
				});
			}
			else {
				value = element.val();
				observePlaceholder();
			}
		}
	};
}]);
/**
 * @ngdoc directive
 * @name qstrap:qstrap.menu
 *
 * @restrict A
 * @element ANY
 * @description
 * Menu
 *
 * @param {expression} items an expression that returns a menu items object. This can be an `Object` an `Array` or a `function` that returns either an `Object` or an `Array` or a `promise` that resolves to an `Object` or an `Array`
 * @param {expression=} action global callback when a menu item is selected. Optional expression variables are `$value`, `$item`, and `$event`
 * @param {string=} selectMenu Makes the menu a select menu. This will add checkmarks to the 'selected' items.
 * @param {string=} multiSelectMenu Makes the menu a multi select menu. This will add checkmarks to all 'selected' items in a menu
 * @param {string=} searchable Adds a search box to the top of the menu that will search the menu as you type
 * @param {string=} preferredDirection overrides the default positioning direction ex. `left`, `right`
 * @param {number=} maxHeight sets the maximum height a menu will expand to before scrolling. The menu may be less than max height depending on the size of the items in the menu.
 * @param {string=} filterable Like searchable, but will not re-evaluate the menu items
 * @param {expression=} searchCallback An `expression` that returns a `promise` of matching menu items. `$search` is provided as an expression variable. When used with `pagination`, the `searchCallback` must return an object `{items: ..., total: 107}`
 * @param {expression=} localizedText Supplies translated strings for keys emptyText, searchText, and paginationText. Pagination text has place holders available for currentPageNum (%1) and totalPages (%2)
 * @param {object=} pagination An object that specifies a limit. Ex: `{limit: 10}`
 * @param {expression=} afterChange called after the digest cycle with `$value`, `$item`, and `$event` as expression variables
 * @param {string=} showEvent The event that triggers the menu. By default this is `mousedown`.
 * @param {expression=} ngDisabled can be used to disable the menu
 *
 * @param {string=} item If the item is a string, it will use the Array index, or Object Key as the `$value` and the item string as the `$item`
 * @param {object=} item If items is an object, or an array of objects, each item can have the properties listed under item.property.
 * @param {string=} item.label The label of the item. It can be a domNode or plain text (HTML will be escaped)
 * @param {multi=} item.value The value of the item. This can be whatever you want
 * @param {string=} item.icon any qstrap.icon name. These will automatically be included with the `.icon` class so you only need to provide `icon-check`
 * @param {string=} item.replaceCheck Replaces the checkmark space with the icon you are passing in. By default if you pass an icon, it will NOT fill the checkmark space.
 * @param {boolean=} item.divider Makes the item a dividing line in the menu
 * @param {boolean=} item.selected If the menu is a select or multi-select menu, then this will add a checkmark to the item
 * @param {boolean=} item.notSelectable If the menu is a select or multi-select menu, then this will make the item not-selectable. This will allow you to add custom action items to select menus
 * @param {boolean=} item.disabled Will render the item as disabled and you will not be able to click on it
 * @param {boolean=} item.header Will render the item.label as header text and will not preform the menu action when the item is clicked
 * @param {string=} item.header Will use this as the item text and render the item as a header
 * @param {boolean=} item.domNode Will render item.label as a simple domNode. You will need to provide your own styles to make it look the way you wish. It will not look like a menu item
 * @param {string=} item.domNode Will use this as the item text and render the item as a domNode
 * @param {object=} item.submenu Is a menu definition with items, an action, and all other menu options. This actions will inherit from parent menus and parent menu items.
 *
 * @example
	<example module="qstrap">
		<file name="qmenu.html">
			<div ng-controller="qmenuDemoCtrl" style="min-height: 200px;">
				<p>Use the btn and btn-select classes and a span with class caret for great styles</p>
				<button class="btn btn-select" qstrap.menu items="arrayItems" action="alert('value:' + $value + ' label:' + $item)">
					Array Items
					<span class="caret"></span>
				</button>
				<button class="btn btn-select" qstrap.menu items="objectItems">
					Object Items
					<span class="caret"></span>
				</button>
				<button class="btn btn-success btn-select" qstrap.menu preferred-direction="right" items="searchMenu">
					Searchable Menu
					<span class="caret"></span>
				</button>
				<button class="btn btn-select" qstrap.menu items="manyItems(100)" searchable="true" preferred-direction="right" max-height="200">
					Scrollable menu
					<span class="caret"></span>
				</button>

				<h1>Disabled</h1>
				<button class="btn btn-select" qstrap.menu ng-disabled="toggleDisabled" items="arrayItems" action="alert('value:' + $value + ' label:' + $item)">
					Disabled
					<span class="caret"></span>
				</button>
				<label><input type='checkbox' ng-model="toggleDisabled">Toggle Disabled</label>

				<h1>Preferred Direction</h1>
				<button class="btn btn-select" qstrap.menu preferred-direction="{{direction}}" items="arrayItems">
					Showing {{direction}}
					<span class="caret"></span>
				</button>
				<p>
					<button class="btn-group">
						<button class="btn" ng-click="direction='left'" ng-class="{'btn-primary': direction=='left'}">Left</button>
						<button class="btn" ng-click="direction='right'" ng-class="{'btn-primary': direction=='right'}">Right</button>
					</button>
				</p>

 				<h1>Pagination</h1>
				<button class="btn btn-select" qstrap.menu searchable="true" search-callback="paginatedSearch($search, $limit, $offset)" pagination="pagination">
					Paginated Search
					<span class="caret"></span>
				</button>

				<h1>Localization</h1>
				<button class="btn btn-select" qstrap.menu searchable="true" search-callback="paginatedSearch($search, $limit, $offset)" pagination="pagination" localized-text="localizedText">
					Paginated Search
					<span class="caret"></span>
				</button>
				<button class="btn btn-select" qstrap.menu items="subMenuCustomSearch" searchable="true">
					Custom Search
					<span class="caret"></span>
				</button>
			</div>
		</file>
		<file name="qmenu.js">
			angular.module('qstrap.menu').controller('qmenuDemoCtrl', [
				'$scope',
				'$timeout',
				function($scope, $timeout)
				{
					angular.extend($scope, {
							toggleDisabled: true,
							manyItems: function (val) {
								var ret = [{
									label: 'With a submenu',
									submenu: {
										searchable: true,
										items: []
									}
								}];
								for (var i = 0; i < val; ++i) {
									ret.push(i);
								}
								return ret;
							},
							arrayItems: ['one', '<b>two</b>', $('<b>three</b>')],
							direction: 'right',
							objectItems: [{
									label: 'Copy to Report',
									action: function() {
										alert("Copied to Report");
									}
								}, {
									label: 'Save Page',
									action: function() {
										alert("Saved Page");
									},
									submenu: {
											items: [
											{
													disabled: true,
													label: 'PDF - disabled',
													icon: 'icon-pdffile-lg',
													action: function() {
												alert("Exported");
													}
											}, {
													label: 'Word Doc',
													icon: 'icon-wordfile-lg',
													action: function() {
												alert("Exported");
													}
											}, {
													label: 'Image',
													icon: 'icon-imagefile-lg',
													action: function() {
												alert("Exported");
													}
											}]
									}
								}, {
									label: 'Print Sheet',
									action: function() {
										alert("Printed");
									}

								}, {
									label: 'Duplicate Page',
									action: function() {
										alert("Duplicated");
									}
								}, {
									label: 'Delete Page',
									action: function() {
										alert("Deleted Page");
									}
								}, {
									label: 'Rename Page',
									action: function() {
										alert("Renamed");
									}
								}, {
									divider: true
								}, {
									header: true,
									label: 'Header'
								}, {
									domNode: $('<button class="btn">Click me!</button>').click(function () { alert('Why did you do that?'); })
								}

							],
							searchMenu: [{
								label: "Sub Menu",
								submenu: {
									searchable: true,
									items: ['Dog', $('<span>My jQuery Object</span>'), 'Buffalo']
								}
							}, "apple", "banana", "carrot"],
							paginatedSearch: function(value, limit, offset) {
							  value = (value || '').toLowerCase();
							  var items = [{
									label: "Sub Menu",
									submenu: {
										searchable: true,
										items: ['Dog', 'Cat', 'Buffalo']
									}
								}, "Apple", "Lettuce", "Tomato", "Potatoes", "Banana", "Cabbage", "Pork Chops", "Milk"];

								for (var i = items.length; i--;) {
									var item = items[i];
									if ((item.label || item).toLowerCase().indexOf(value.toLowerCase()) === -1) {
										items.splice(i, 1);
									}
								}

								return $.when({
									items: items.slice(offset, offset + limit),
									total: items.length
								});
							},
							pagination: {limit: 3},
							alert: function(value) {
									alert(value);
							},
							subMenuCustomSearch: [{
								label: "Sub Menu",
								submenu: {
									searchable: true,
									searchCallback: function(search) {
										return $timeout(function() {
											return {items: ["Dog", "Cat", "Buffalo"]}
										}, 1000);
									},
									localizedText: {
										emptyText: "Empty Submenu",
										searchText: "Submenu Search"
									},
									pagination: {limit: 2}
								}
							}, "apple", "banana", "carrot"],
							localizedText: {
								emptyText: "emptyText message",
								searchText: "really supermegalong searchText here",
								paginationText: "paginationText: %1 / %2"
							}
					});
				}
			]);
		</file>
	</example>
 */

(function(module, $) {
	'use strict';

	// keep a global regitry of menus outside of Angular, so JQuery and Angular menus can co-exist
	var MENU_REGISTRY = [];
	var DIRECTION_LEFT = 'left';
	var DIRECTION_RIGHT = 'right';
	module.factory('qstrap.$menu', [
		'$q',
		'$rootScope',
		'$timeout',
		'$filter',
		'qstrap.util',
		function(
			$q,
			$rootScope,
			$timeout,
			$filter,
			util
		) {

			var removeEventHandlers;
			/**
			 * This function sets the focus on the first item of a menu.
			 *
			 * @param {DOM element} menuElement - The menu element (typically, this._menuDom)
			 * @param {function} closeMenu - A function which is executed when the user presses the
			 * 	Escape", "Tab", or "Shift" + "Tab" keys.
			 * @param {boolean} shouldSetFocusOnFirstItem - Determines if focus should set on the
			 * first menu item if focusable. Defaults to true.
			 * @returns {function} A function for removing all event handlers setup on the menu.
			 */
			function setupMenuFocus(menuElement, closeMenu, shouldSetFocusOnFirstItem) {
				var currentFocusIndex;
				var allFocusableElements = $(menuElement).find(util.focusableSelector);
				var firstFocusableElement = allFocusableElements.get(0);
				var lastFocusableElement = allFocusableElements.get(allFocusableElements.length - 1);

				shouldSetFocusOnFirstItem = util.defaultFor(shouldSetFocusOnFirstItem, true);

				// Upon entering the menu, focus on the first item.
				if (firstFocusableElement && shouldSetFocusOnFirstItem) {
					firstFocusableElement.focus();
				}

				function handleMenuItemKeyDown(event) {
					if (event.keyCode === util.keys.DOWN_ARROW) {
						event.preventDefault();
						currentFocusIndex = allFocusableElements.index(document.activeElement);
						allFocusableElements.get(++currentFocusIndex).focus();
					} else if (event.keyCode === util.keys.UP_ARROW) {
						event.preventDefault();
						currentFocusIndex = allFocusableElements.index(document.activeElement);
						allFocusableElements.get(--currentFocusIndex).focus();
					} else if (event.keyCode === util.keys.ESCAPE || event.keyCode === util.keys.TAB) {
						closeMenu();
					}
				}

				/**
				 * Moves focus back to the last focusable element in the event of a up or left arrow.
				 * In effect causing the focus to wrap, resulting in the focus being locked in the menu.
				 */
				function handleFirstFocusableElementKeyDown(event) {
					if (event.keyCode === util.keys.UP_ARROW) {
						event.stopPropagation();
						event.preventDefault();
						lastFocusableElement.focus();
					}
				}

				/**
				 * Moves focus to the first focusable element in the event of a down or right arrow event.
				 * In effect causing the focus to wrap, resulting in the focus being locked in the menu.
				 */
				function handleLastFocusableElementKeyDown(event) {
					if (event.keyCode === util.keys.DOWN_ARROW) {
						event.stopPropagation();
						event.preventDefault();
						firstFocusableElement.focus();
					}
				}

				menuElement.addEventListener('keydown', handleMenuItemKeyDown);
				if (firstFocusableElement) {
					firstFocusableElement.addEventListener('keydown', handleFirstFocusableElementKeyDown);
				}
				if (lastFocusableElement) {
					lastFocusableElement.addEventListener('keydown', handleLastFocusableElementKeyDown);
				}

				function removeEventHandlers() {
					menuElement.removeEventListener('keydown', handleMenuItemKeyDown);
					if (firstFocusableElement) {
						firstFocusableElement.removeEventListener('keydown', handleFirstFocusableElementKeyDown);
					}
					if (lastFocusableElement) {
						lastFocusableElement.removeEventListener('keydown', handleLastFocusableElementKeyDown);
					}
				}

				return removeEventHandlers;
			}

			/*
			 * Used when a submenu is opened. It monitors the mouse position and determines
			 * if it is still traveling to the submenu. If it is, the submenu will remain open
			 * even when hovering over other menu itesm
			 * @type Object
			 */
			var SubmenuHelper = {
				/*
				 * Called when a submenu is opened and will close the submenu if the mouse
				 * strays from the triangle defined by the current mouse position, and the top and bottom of the menu
				 * @param {Object} menu
				 * @param {Event} evt
				 */
				watchMouseTravel: function(menu, mouseX, mouseY)
				{

					if (!mouseX || !mouseY)
						return;

					var doc = $(document),
						offset = menu.getMenuOffset(),
						clientX = mouseX + doc.scrollLeft(),
						clientY = mouseY + doc.scrollTop();


					SubmenuHelper.watching = {
						menu: menu,
						v1: {x: clientX, y: clientY}
					};
					//update the watching info with the menu coordinates.
					SubmenuHelper.updateWatcherMenuInfo(menu);
				},
				/*
				* Adds the menu coordinates to the watching info
				* The size of the menu is updated asynchronously so any time it changes
				* we need to tell the watcher about the new size
				* @param {Object} menu
				*/
				updateWatcherMenuInfo:function(menu)
				{

					if(SubmenuHelper.watching && menu)
					{
						var offset = menu.getMenuOffset(),
						x = menu.getIsFlyingLeft() ?  offset.left + offset.width : offset.left,
						y = offset.top,
						b = offset.top + offset.height;
						SubmenuHelper.watching.v2 = {x: x, y: b};
						SubmenuHelper.watching.v3 = {x: x, y: y};
					}
				},
				/*
				 * Will update the triangle to the new mouse position, and return true if the mouse is in the triangle
				 * @param {Event} evt - the JQuery event object
				 * @returns {Boolean} - if the mouse is traveling to the submenu
				 */
				isTravelingToSubmenu: function(mouseX, mouseY)
				{
					if (SubmenuHelper.watchingTimeout) {
						$timeout.cancel(SubmenuHelper.watchingTimeout);
						delete SubmenuHelper.watchingTimeout;
					}
					var w = SubmenuHelper.watching;
					if (w && w.menu && !w.menu.visited && w.menu == QMenuRegistry.reg[QMenuRegistry.reg.length - 1])
					{
						var doc = $(document),
							newPt = {x: mouseX+ doc.scrollLeft(), y: mouseY + doc.scrollTop()};

						//this.debugTriangle(newPt, w.v1, w.v2, w.v3);
						if (SubmenuHelper.isPointInTriangle(newPt, w.v1, w.v2, w.v3))
						{
							SubmenuHelper.watchingTimeout = $timeout(function() {
								//If they gave up in the middle of the travel they might have ended on a menu item.
								//This item will be suppressed from hovering in perpetuity unless we unsupress it.
								var mouseX, mouseY;
								if(SubmenuHelper.watching && SubmenuHelper.watching.v1)
								{
									//v1 contains the current mouse coordinates
									mouseX = SubmenuHelper.watching.v1.x;
									mouseY = SubmenuHelper.watching.v1.y;
								}
								//we have to delete the watcher first or the unspressed item will be suppressed again.
								delete SubmenuHelper.watching;

								//unsuppress will trigger the suppressed hover.
								SubmenuHelper.unsuppressCurrentHover(mouseX, mouseY);
							}, 1000);

							w.v1 = newPt;
							return true;
						}
					}

					delete SubmenuHelper.watching;
					return false;
				},
				// debugTriangle:function(point, t1, t2, t3)
				// {

				// 	var oldDots= document.getElementsByClassName('TestDot');

				// 	for (var i = oldDots.length-1; i > -1; i--) {
				// 		oldDots[i].parentNode.removeChild(oldDots[i]);
				// 	}

				// 	var dot = document.createElement('div');
				// 	dot.className='TestDot';
				// 	dot.style.width = '4px';
				// 	dot.style.height = '4px';
				// 	dot.style.background = 'red';
				// 	dot.style.position = 'absolute';
				// 	dot.style.zIndex = '9999999';
				// 	var pointNode = dot.cloneNode(true);
				// 	var t1Node = dot.cloneNode(true);
				// 	var t2Node = dot.cloneNode(true);
				// 	var t3Node = dot.cloneNode(true);
				// 	pointNode.style.top =  point && point.y+'px';
				// 	pointNode.style.left =  point && point.x+'px';
				// 	pointNode.style.background =  'red';
				// 	pointNode.style.border =  '1px solid white';
				// 	document.body.appendChild(pointNode);

				// 	t1Node.style.top =  t1 && t1.y+'px';
				// 	t1Node.style.left =  t1 && t1.x+'px';
				// 	t2Node.style.top =  t2 && t2.y+'px';
				// 	t2Node.style.left =  t2 && t2.x+'px';
				// 	t2Node.style.background = 'orange';
				// 	t3Node.style.top =  t3 && t3.y+'px';
				// 	t3Node.style.left =  t3 && t3.x+'px';
				// 	document.body.appendChild(t1Node);
				// 	document.body.appendChild(t2Node);
				// 	document.body.appendChild(t3Node);
				// },
				/*
				 * Computes cross product
				 * @param {Object} p1, p2, p3 - point object with an x and a y
				 * @returns {Number} - the cross product
				 */
				cross: function(p1, p2, p3)
				{
					return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
				},
				/*
				 * Determines if a point pt is in a triangle defined by the verteces v1, v2 and v3
				 * @param {Object} pt
				 * @param {Object} v1
				 * @param {Object} v2
				 * @param {Object} v3
				 * @returns {Boolean} - if the point pt is in the triagle
				 */
				isPointInTriangle: function(pt, v1, v2, v3)
				{
					var b1 = SubmenuHelper.cross(pt, v1, v2) < 0,
						b2 = SubmenuHelper.cross(pt, v2, v3) < 0,
						b3 = SubmenuHelper.cross(pt, v3, v1) < 0;
					return ((b1 == b2) && (b2 == b3));
				},
				/*
				* SubmenuHelper.registerSuppressed
				* If we aren't going to hover an item due to a submenu travel.
				* Store it here so we can unsupress it if the travel ends abruptly.
				*/
				registerSuppressed:function(li)
				{
					SubmenuHelper.activeSuppressed = li;
				},
				unregisterSuppressed:function()
				{
					SubmenuHelper.activeSuppressed = null;
				},
				/*
				* SubmenuHelper.unsuppressCurrentHover
				* if they gave up in the middle of the travel they might have ended on a menu item
				* this item will be suppressed from hovering in purpituity unless we unsupress it.
				*/
				unsuppressCurrentHover:function(mouseX, mouseY)
				{
					if(SubmenuHelper.activeSuppressed)
					{
						//we have a suppressed hover and the travel should be interrupted at this point.
						//lets trigger a hover on the suppressed item
						_hoverItemHelper(SubmenuHelper.activeSuppressed, mouseX, mouseY);
						SubmenuHelper.unregisterSuppressed();
					}
				},
				/*
				* Keeps track of what is hovered so we can unhover it.
				*/
				registerHover:function(li)
				{
					QMenuRegistry.activeHover = li;
					if(li)
					{
						//hoverable is only assigned if the hover is not suppressed due to
						//a submenu travel. This is so we dont highlight items during the travel.
						$(li).addClass('hoverable');
					}
				},
				/*
				* Only 1 hoverable at a time.
				*/
				clearExistingHover:function()
				{
					if(QMenuRegistry.activeHover)
					{
						$(QMenuRegistry.activeHover).removeClass('hoverable');
						QMenuRegistry.activeHover = null;
					}
				}
			};

			/*
			 * Keeps track of all of the menu panes on the stack
			 * @type Object
			 */
			var QMenuRegistry = {
				reg: MENU_REGISTRY,
				/*
				 * Pushes a menu on the menu stack
				 * @param {Instance} menu - the menu instance
				 */
				register: function(menu)
				{
					QMenuRegistry.reg.push(menu);
					QMenuRegistry.listen();
				},
				/*
				 * Closes all menus
				 * @param {Instance} to - a optional menu instance which will serve as the stoping point for the menu closing.
				 */
				closeAllMenus: function(opt_to)
				{
					var w = SubmenuHelper.watching && SubmenuHelper.watching.menu;
					while (QMenuRegistry.reg.length)
					{
						var menu = QMenuRegistry.reg.pop();

						if (w == menu)
							delete SubmenuHelper.watching;

						if (menu == opt_to)
						{
							QMenuRegistry.reg.push(menu);
							if (menu._searchInputDom) {
								menu._searchInputDom.focus();
							}
							break;
						}
						menu.close();
					}

					if (!QMenuRegistry.reg.length) {
						QMenuRegistry.stopListening();
						SubmenuHelper.unregisterSuppressed();
					}
				},
				/*
				 * Listen for the mouseup event on the document and close all menus when triggered
				 */
				listen: function()
				{
					if (!QMenuRegistry.listening)
					{
						QMenuRegistry.listening = true;
						$(document).on('mouseup touchend', QMenuRegistry.closeAllMenus);
					}
				},
				/*
				 * Stops listening to the mousedown event on the document
				 */
				stopListening: function()
				{
					QMenuRegistry.listening = false;
					$(document).off('mouseup touchend', QMenuRegistry.closeAllMenus);
				}
			};

			/*
			 *
			 * @param {type} evt
			 */
			var _stopEventPropagation = function(evt)
				{
					evt.preventDefault();
					evt.stopPropagation();
				},
				_hoverItem = function(evt)
				{
					var li = this;
					_hoverItemHelper(li, evt.clientX, evt.clientY);
				},
				_hoverItemHelper = function(li, mouseX, mouseY)
				{
					SubmenuHelper.clearExistingHover();

					//start fresh with the suppressed menu items.
					SubmenuHelper.unregisterSuppressed();
					//if we just opened a submenu, and we are traveling there, don't do anything
					if (SubmenuHelper.isTravelingToSubmenu(mouseX, mouseY))
					{
						SubmenuHelper.registerSuppressed(li);
						return;
					}
					//only add the hoverable class if it isnt suppressed.
					SubmenuHelper.registerHover(li);

					var info = _getItemInfo(li),
						menu = info.menu,
						submenu = info.submenu;

					//register that we have visited this menu
					menu.visited = true;

					//close all child menus
					QMenuRegistry.closeAllMenus(menu);

					if (submenu)
					{
						submenu.show();
						SubmenuHelper.watchMouseTravel(submenu, mouseX, mouseY);
					}
				},
				_selectItem = function(evt, context)
				{
					evt.stopImmediatePropagation();
					evt.preventDefault();

					var li = context,
						info = _getItemInfo(li),
						menu = info.menu,
						itemValue = info.value,
						item = info.item,
						itemAction = item.action,
						label = item.label || item,
						keepMenuOpen = false,
						i;

					if (menu._menuDef.selectMenu && !item.notSelectable)
					{
						$(menu._menuItems).children('li.checked').removeClass('checked');
						for (i = 0; i < menu._allItems.length; ++i) {
							if (menu._allItems[i].selected) {
								menu._allItems[i].selected = false;
							}
						}
						li.className += ' checked';
						item.selected = true;
					}
					else if (menu._menuDef.multiSelectMenu && !item.notSelectable)
					{
						keepMenuOpen = true;

						// uncheck visible exclusive items
						$(menu._menuItems).children('li.checked').each(function () {
							var info = _getItemInfo(this),
								checkedItem = info.item || {};
							if (checkedItem !== item && (checkedItem.exclusive || item.exclusive)) {
								$(this).removeClass('checked');
							}
						});

						$(li).toggleClass('checked');
						item.selected = !item.selected;

						var itemValues = [];
						var items = [];
						var labels = [];
						for (i = 0; i < menu._allItems.length; ++i) {
							var checkedItem = menu._allItems[i];
							if (!checkedItem.selected) {
								continue;
							}
							// if the checked item is exclusive, deselect it
							if (checkedItem !== item && (checkedItem.exclusive || item.exclusive)) {
								checkedItem.selected = false;
							}
							else {
								var value = checkedItem.value === undefined ? i : checkedItem.value;
								itemValues.push(value);
								items.push(checkedItem);
								labels.push(checkedItem.label || checkedItem);
							}
						}

						if  (labels.length > 6) {
							label = labels.length + ' selected';
						}
						else {
							label = labels.join(', ');
						}
						item = items;
						itemValue = itemValues;
					}
					else if(item.hasOwnProperty('selected'))
					{
						item.selected = !item.selected;
						$(li).toggleClass('checked');
					}

					if (menu._menuDef.updateButton)
						_updateButton(menu, label);

					// itemAction is the selected item's action
					(itemAction || menu._menuDef.action || $.noop)(itemValue, item, evt);


					if (!keepMenuOpen) {
						$(li).fadeOut(50).fadeIn(100, QMenuRegistry.closeAllMenus);
						if (typeof removeEventHandlers === 'function') {
							removeEventHandlers();
						}
						menu._element.focus();
					}

				},
				_updateButton = function(menu, text)
				{
					var btn = menu._menuDef.updateButton,
						ntext = $('<span>');

					if (btn === true)
					{
						//get the text content of the button in case they have an icon or a menu button or whatever
						btn = menu._element.contents().filter(function(){
							return this.nodeType == 3;
						});
					}

					ntext.append(_createTextNode(text));

					btn.replaceWith(ntext);
					menu._menuDef.updateButton = ntext;
				},
				_getItemInfo = function (item) {
					return $(item).data('q.qmenu.itemInfo') || {};
				},
				_setItemInfo = function (item, info) {
					$(item).data('q.qmenu.itemInfo', info);
				},
				_filterItems = function (items, searchTerm) {

					if (!searchTerm) {
						return items;
					}
					var isArr = (items instanceof Array),
						newItems = isArr ? [] : {};

					for (var key in items) {
						if (!items.hasOwnProperty(key)) {
							continue;
						}

						var item = items[key],
							label = $('<div>').append(_createTextNode(item.label || item.domNode || item)).text() || '';
						if (label.toLowerCase().indexOf(searchTerm) > -1) {
							if (isArr) {
								newItems.push(item);
							}
							else {
								newItems[key] = item;
							}
						}
					}

					return newItems;
				},
				_limitItems = function (items, page, perPage) {

					var startIndex = (page - 1) * perPage,
						endIndex = startIndex + perPage;

					if (items instanceof Array) {
						return items.slice(startIndex, endIndex);
					}

					var newItems = {};
					var i = 0;
					for (var key in items) {
						if (!items.hasOwnProperty(key)) {
							continue;
						}
						var item = items[key];
						if (i >= startIndex && i < endIndex) {
							newItems[key] = item;
						}
						i++;
					}

					return newItems;
				},
				_size = function (o) {
					if (o instanceof Array) {
						return o.length;
					}

					var size = 0;
					for (var i in o) size += o.hasOwnProperty(i);
					return size;
				},
				_createTextNode = function(text) {
					// Create text node if string, else pass back the dom element
					return typeof text === 'string' ? document.createTextNode(text) : text;
				},
				_debounce = function(func, wait) {
					var timeout;
					return function() {
						var context = this, args = arguments;
						var later = function() {
							timeout = null;
							return func.apply(context, args);
						};
						$timeout.cancel(timeout);
						timeout = $timeout(later, wait);

						return timeout;
					};
				};

			var QMenu = function(element, menuDef, opt_parentMenu, opt_options)
			{
				var self = this;
				//we need to attach this for testing purposes
				this.$rootScope = $rootScope;
				this._element = element;
				this.setMenuDef(menuDef);
				this._parentMenu = opt_parentMenu;
				this.options = opt_options;
				//listen to events on menu buttons
				if (!this._menuDef.isSubmenu)
				{
					var toggle = $.proxy(this.toggle, this);
					this._element[0].showMenu = function() {self.show(); };
					this._element[0].closeMenu = QMenuRegistry.closeAllMenus;
					this._element.on(this._menuDef.showEvent || 'mousedown touchstart', toggle);
					this._element[0].addEventListener('keydown', function(event) {
						// Open the menu when Enter or Space is pressed.
						if (event.keyCode === util.keys.ENTER || event.keyCode === util.keys.SPACE) {
							toggle(event);
						}
					});
				}

				if (this.shouldShowPagination()) {
					this._page = 1;
					this._totalItems = 0;
				}

				//if there is a parent menu use the parents preference.
				//this is because it feels weird if a submenu switches directions for no apparent reason.
				if (this._parentMenu)
				{
					this.preferredDirection = this._parentMenu.getPreferredDirection();
				}
				//if direction is defined then use the menuDef.
				if (this._menuDef.preferredDirection)
				{
					this.preferredDirection = this._menuDef.preferredDirection;
				}
			};

			QMenu.prototype = {
				isFlyingLeft:false,
				toggle: function(evt) {
					var disabled = this._menuDef.disabled;
					// NOTE: ng-disabled can not be a function on the element as that will not
					// work with the styling, this is for select-menu.js
					if (typeof disabled === 'function') {
						disabled = disabled();
					}
					if (disabled) {
						return;
					}
					if (!this._menuDom) {
						this.show(evt);
					}
					else {
						this.close(evt);
					}
				},
				show: function(evt)
				{
					angular.extend(this._menuDef, this.options || {});
					// stop the menu from stealing focus
					if (evt)
						evt.preventDefault();

					//destroy any menus that may be open already
					if (!this._menuDef.isSubmenu)
					{
						QMenuRegistry.closeAllMenus();
						this._element.on('mouseup touchstart touchend', _stopEventPropagation);
					}

					QMenuRegistry.register(this);

					// reset to page one every time the menu is opened
					if (this.shouldShowPagination()) {
						this._page = 1;
					}

					$('body').append(this.buildMenu());
					if (typeof this._menuDef.onOpen === 'function') {
						this._menuDef.onOpen();
					}
					this.positionMenu();
					this._element.addClass('active');

					// If there is a search input, then focus
					if(this._searchInputDom)
						this._searchInputDom.focus();

				},
				setMenuDef: function(def)
				{
					def = def || {};
					if(typeof def.searchCallback === 'function')
					{
						def.searchable = true;
					}
					def.localizedText = def.localizedText || {};

					this._menuDef = def;
				},
				/*
				keyup: function (evt)
				{
					var k = evt.key;
					if (k == 13) //Enter
					{

					}
					else if (k == 27) //escape
					{

					}
					else if (k == 37) //left
					{

					}
					else if (k == 38) //up
					{

					}
					else if (k == 39) //right
					{

					}
					else if (k == 40) //down
					{

					}
				},
				*/
				buildMenu: function()
				{
					this._menuDom = $('<div>', {'class':'qmenu dropdown-menu ' + (this._menuDef.className || '') + (this._menuDef.isSubmenu ? ' qsubmenu' : '' )});

					if (this._menuDef.searchable || this._menuDef.filterable) {
						this._menuDom.append(this.buildSearchBox()).addClass('search-menu');
					}

					this._menuDom.append(this.buildMenuItems());

					if (this.shouldShowPagination()) {
						this._menuDom.append(this.buildPaginationControls());
					}

					this._menuDom.on('mouseup touchend', _stopEventPropagation);
					this._menuDom.on('mousedown touchstart', function(evt) {
						evt.stopPropagation();
					});

					return this._menuDom;
				},
				buildMenuItems: function()
				{
					this._menuItems = $('<ul>', {'class': 'menu-items'});

					this.updateMenuItems(this.getMenuItems());

					return this._menuItems;
				},
				updateMenuItems: function (items, opt_heightOnly) {

					var menuItems = this._menuItems,
						that = this;

					// show a spinner if the promise doesn't resolve immediately
					var timerCancelled = false;
					var spinTimer = $timeout(function () {
						if (timerCancelled) {
							return;
						}
						menuItems.empty();
						menuItems.append($('<li><div class="waiter-spinner-sm"></li>'));
						that.updatePaginationControls(true);
						that.positionMenu(opt_heightOnly);
					}, 10);
					var cancelTimer = function () {
						timerCancelled = true;
						$timeout.cancel(spinTimer);
					};

					return $q.when(items).then(function (items) {
						cancelTimer();
						menuItems.empty();

						for(var i in items)
						{
							if (!items.hasOwnProperty(i))
								continue;

							menuItems.append(that.buildMenuItem(items[i], i));
						}

						// there were no menu items
						if (!i && i !== 0) {
							menuItems.append(that.buildMenuItem({
								header: that._menuDef.localizedText.emptyText || $filter('qstrapTranslate')('NO_ITEMS_TO_DISPLAY')
							}));
						}

						//reposition the menu
						if (that.shouldShowPagination()) {
							that.updatePaginationControls();
						}
						that.positionMenu(opt_heightOnly);
						function closeMenu() {
							QMenuRegistry.closeAllMenus();
							that._element.focus();
						}
						if (typeof removeEventHandlers === 'function') {
							removeEventHandlers();
						}
						if (that._menuDom) {
							removeEventHandlers = setupMenuFocus(
								that._menuDom.get(0),
								closeMenu,
								that._menuDef.shouldSetFocusOnFirstItem
							);
						}

					// if there was an error, show empty items message
					})['catch'](function (error) {
						cancelTimer();
						menuItems.empty();
						menuItems.append(that.buildMenuItem({
							header: that._menuDef.localizedText.emptyText || $filter('qstrapTranslate')('NO_ITEMS_TO_DISPLAY')
						}));
					});
				},
				/*
				 * Returns a promise of menu items
				 */
				getMenuItems: function (searchTerm) {

					var itemFunc = this._menuDef.items,
						searchFunc = this._menuDef.searchCallback,
						pagination = this._menuDef.pagination || {},
						itemsPerPage = pagination.limit,
						page = this._page,
						offset = (this._page - 1) * itemsPerPage,
						// if we have a search term, use the search callback first, and fallback to items
						// if we don't have a search term, use the items clalback first, and fallback to the search
						items = searchTerm && searchFunc || itemFunc || searchFunc;

					if (this._menuDef.filterable && this._allItems) {
						items = this._allItems;
					}
					if (typeof items === 'function' && items === searchFunc) {
						items = items(searchTerm, itemsPerPage, offset);
					} else if(typeof items === 'function') {
					  items = items();
					}

					var that = this;
					return $q.when(items || []).then(function (raw) {
						// make sure we always have a value
						raw = raw || [];
						var items = raw.items || raw;
						that._allItems = items;

						// item search regardless of pagination
						if (searchTerm && !searchFunc) {
							items = _filterItems(items, searchTerm);
						}
						that._totalItems = raw.total || _size(items);

						// pagination that didn't come from the search
						if (page && itemsPerPage && !raw.total) {
							items = _limitItems(items, page, itemsPerPage);
						}
						return items;
					});
				},
				buildMenuItem: function(item, index)
				{
					var li = $('<li>');

					if (item.className)
					{
						li.addClass(item.className);
					}


					if (item.divider)
					{
						li.addClass('divider');
					}
					else if (item.domNode || item.header)
					{
						li.append(_createTextNode(item.label) || item.domNode || item.header);
						li.addClass('dom-node');
						if (item.header)
							li.addClass('dropdown-header');
					}
					else
					{
						var menuText = _createTextNode(item.label || item),
							sub = item.submenu,
							sel = this._menuDef.selectMenu || this._menuDef.multiSelectMenu || item.hasOwnProperty('selected') ? $('<i>',{'class': 'checkmark icon icon-check-sm'}) : '',
							icon = item.icon ? $('<i>',{'class':'icon ' + item.icon}) : '',
							arrow = sub ? $('<b class="icon icon-angle-right-sm">') : '';

						if (item.replaceCheck && item.icon)
						{
							li.addClass('no-check');
							sel = '';
						}

						// anchor tags need to have an href in order to be natively focusable
						var a = $('<a href="javascript:void(0)">');
						a.append(sel, icon, menuText, arrow);
						li.append(a);

						var itemInfo = {
							menu: this,
							item: item,
							value: item.value !== undefined ? item.value : index
						};

						if (sub)
						{
							if (typeof sub == 'function')
								sub = sub(item);

							sub.isSubmenu = true;
							if (!sub.action) {
								sub.action = (item.action || this._menuDef.action);
							}

							// If the submenu definition doesn't explicitly have localized text, use the parent's
							if(sub.localizedText === undefined) {
								sub.localizedText = item.localizedText || this._menuDef.localizedText;
							}
							itemInfo.submenu = new QMenu(li, sub, this);
						}

						_setItemInfo(li, itemInfo);

						if (item.selected)
							li.addClass('checked');

						var disabled = item.disabled;
						if (typeof disabled == 'function')
						{
							disabled = disabled();
						}

						if (disabled)
							li.addClass('disabled');


						li.on('mouseenter touchstart', _hoverItem);

						if (!disabled && (!sub || item.selectable)) {
							li.on('mouseup touchend keydown', function(event) {
								if (event.type === 'mouseup' ||
									event.type === 'touchend' ||
									(event.type === 'keydown' &&
										(event.keyCode === util.keys.ENTER || event.keyCode === util.keys.SPACE))
								) {
									_selectItem(event, $(this));
								}
							});
						}
					}

					return li;
				},
				buildSearchBox: function()
				{
					var searchTranslation = this._menuDef.localizedText.searchText || $filter('qstrapTranslate')('SEARCH_ELLIPSIS');
					this._searchInputDom = $('<input>', {'class': 'form-control input-sm', placeholder:searchTranslation});
					// If we have custom search text that is longer than the default size, fit the input to the length
					if(this._menuDef.localizedText.searchText) {
						this._searchInputDom.attr('size', searchTranslation.length);
					}

					var searchFunc = $.proxy(this.searchMenu, this);

					// we want to debounce the search
					if (this._menuDef.searchCallback) {
						searchFunc = _debounce(searchFunc, 300);
					}

					this._searchInputDom.keyup(searchFunc);
					this.searchBox = $('<div>', {'class': 'search-box'}).append(
						$('<i>', {'class': 'icon icon-search'}),
						this._searchInputDom
					);
					var menu = this;
					this.searchBox.on('mouseenter', function() {
						QMenuRegistry.closeAllMenus(menu);
					});
					return this.searchBox;
				},

				getPreferredDirection:function()
				{
					return this.preferredDirection;
				},
				getPreferredLeft:function()
				{
					return this.preferredDirection === DIRECTION_LEFT;
				},
				positionMenu: function(opt_heightOnly)
				{
					// if we don't have a menu dom to position anymore, we should not try to position anything.
					// this happens in the case that a search promise resolves after the menu dom is destroyed
					if (!this._menuDom) {
						return;
					}

					var md = this._menuDom,
						winWidth = $(window).width(), //viewable area width
						winHeight = $(window).height(), //viewable area height
						sTop = $(document).scrollTop(), //scroll top
						sLeft = $(document).scrollLeft(), //scroll left
						offset = this._element.offset(), //the parent coordinates
						eWidth = this._element.outerWidth(), //the parent width
						eHeight = this._element.outerHeight(), //the parent height
						SHADOW_WIDTH = 5,
						left, //where the left of the menu should be positioned.
						top, //where the top of the menu should be positioned.
						w,
						width,
						originalHeight, //height of the contents of the menu
						h, //what we are going to set the height to be.
						height,
						viewTop = sTop + SHADOW_WIDTH,
						viewHeight = winHeight - (SHADOW_WIDTH * 2),
						viewBottom = sTop + (winHeight - SHADOW_WIDTH),

						rightAligned = false;

					//decide which direction to go fly by default
					//we dont do this until the menu is positioned because the width calc is expensive.
					if (!this.preferredDirection)
					{
						var isParentOnRight = this._element.offset().left > $(window).width() / 2; //if the parent is on right half of the screen
						this.preferredDirection =  isParentOnRight ? DIRECTION_LEFT : DIRECTION_RIGHT;
					}

					//reset all the styles so we can position it correctly
					md.removeClass('positioned scroll-hidden').css({height: ''});

					if (!opt_heightOnly)
						md.css({width:'', top: 0, left: 0});

					//assign originalHeight to the height of the full menu on the inside with no scroll clipping.
					originalHeight = md.height();

					left = offset.left;

					/*
					 * Position both submenus and buttons the to the left or right
					 */

					w = md.outerWidth() + SHADOW_WIDTH;
					left = offset.left + eWidth;
					width = winWidth - (left + sLeft);

					// we don't have enough room to the right of the menu, so switch it to the left
					if (w > width || this.getPreferredLeft())
					{
						var beside = offset.left - sLeft;
						if (beside > w)
						{
							left = offset.left - w;
							this.isFlyingLeft = true;
						}
					}
					//first set the width before setting the height
					if (!opt_heightOnly) {
						md.css({width: w + 'px'});
					}


					var defaultHeight = !!this._menuDef.maxHeight ?
						Math.min(this._menuDef.maxHeight, originalHeight) :
						originalHeight;

					// Start with the default height (maxHeight, or size of content,
					// whichever is smaller).
					// We'll clip it later if it's too big
					h = defaultHeight;

					//set the top to the parent menuitem
					top = offset.top;

					if (top + h > viewBottom)
					{
						//the bottom of the menu is off the bottom of the view.
						//bring it higher by the amount that it is over.
						var bottomDelta = (top + h) - viewBottom;
						top -= bottomDelta;
					}
					if (top < viewTop)
					{
						//the top is higher than the top of the view.
						//move it down
						top = viewTop;
					}
					if (h > viewHeight)
					{
						//the menu is bigger than the view.
						//clip the height so it isn't bigger than the viewable area.
						h = viewHeight;
					}

					/*
					 * if the parent is a button we have the posibility of positioning below
					 */
					else if(!this._menuDef.isSubmenu)
					{
						var positionedVertically = false;

						//check to see if there is room under the button for the entire menu.
						if (defaultHeight < viewHeight - ((offset.top - sTop)+ eHeight))
						{
							//put the menu below the menuButton like a normal UI
							top = offset.top + eHeight;
							positionedVertically = true;
						}
						else if (defaultHeight < offset.top - sTop)
						{
							//maybe there is room above the menu
							top = offset.top - defaultHeight;
							positionedVertically = true;
						}
						if (positionedVertically)
						{
							if (this.getPreferredLeft())
							{
								//align the menu right
								rightAligned = true;
								left = (offset.left + eWidth) - w;
							}
							else
							{
								//align left
								left = offset.left;
							}
						}
						//dont worry, if there was no room to position vertically it is already positioned horizontally.
					}

					var size = {height: h + 'px', maxHeight:'99%'};

					if (!opt_heightOnly)
						$.extend(size, {top: Math.floor(top) + 'px', left: Math.floor(left) + 'px', width: w + 'px'});

					md.addClass('positioned').css(size);
					var mi = this._menuItems[0];

					//check to see if menu has overflow
					if (mi.scrollHeight > mi.offsetHeight)
					{
						//check to see if it has overflow but no scrollbar
						if(mi.clientWidth === mi.offsetWidth)
						{
							md.addClass('scroll-hidden');
							// trigger reflow
							var reflow = md[0].offsetHeight;
						}

						//adjust width and left position based on width of scrollbar
						var scrollbarWidth = $(mi).outerWidth(true) - mi.clientWidth;
						w += scrollbarWidth;
						if(rightAligned) //if menu is right aligned, we need to move it to the left
						{
							left -= scrollbarWidth;
						}
						md.css({left: left + 'px', width: w + 'px'});
					}
					//tell the submenu watcher about the new menu size and position.
					SubmenuHelper.updateWatcherMenuInfo(this);
				},
				close: function()
				{
					this._element.removeClass('active');
					this._element.off('mouseup touchstart', _stopEventPropagation);

					if (this._menuDom)
						this._menuDom.detach();

					delete this._menuDom;
					delete this._pagination;

					this.visited = false;

					if (typeof this._menuDef.onClose === 'function')
					{
						this._menuDef.onClose();
					}
					if (typeof removeEventHandlers === 'function') {
						removeEventHandlers();
					}
				},
				getMenuOffset: function()
				{
					var o = this._menuDom.offset();
					o.height = this._menuDom.outerHeight();
					o.width = this._menuDom.outerWidth();
					return o;
				},
				getIsFlyingLeft:function()
				{
					return this.isFlyingLeft;
				},
				searchMenu: function(evt)
				{
					// reset to page one
					if (this._menuDef.pagination && evt.target.value) {
						this._page = 1;
					}

					var value = (evt.target.value || '').toLowerCase(),
						items = this.getMenuItems(value);

					this.updateMenuItems(items, true);
				},
				buildPaginationControls: function(opt_clear)
				{
					var limit = this._menuDef.pagination.limit,
						total = this._totalItems,
						numPages = Math.floor(total / limit) + (total % limit > 0 ? 1 : 0);

					this._menuDom.removeClass('paginated-menu');

					// there is no need to paginate
					if (!numPages || total <= limit || opt_clear) {
						return (this._pagination = $('<div>'));
					}

					this._menuDom.addClass('paginated-menu');

					var paginationText = this._page + ' of ' + numPages;
					if(this._menuDef.localizedText.paginationText) {
						paginationText = this._menuDef.localizedText.paginationText;
						paginationText = paginationText.replace("%1", this._page).replace("%2", numPages);
					}

					var text = $('<div class="page-text">' + paginationText + '</div>'),
						lButton = $('<button class="btn btn-sm btn-hover left-btn"><span class="icon btn-icon-angle-left"></span></button>"'),
						rButton = $('<button class="btn btn-sm btn-hover right-btn"><span class="icon btn-icon-angle-right"></span></button>"');

					if (this._page > 1) {
						lButton.on('click', $.proxy(this.changePage, this, -1));
					}
					else {
						lButton.attr('disabled', 'disabled');
					}

					if (this._page < numPages) {
						rButton.on('click', $.proxy(this.changePage, this, 1));
					}
					else {
						rButton.attr('disabled', true);
					}

					return (this._pagination = $('<div>', {'class': 'pagination no-select'}).append(text, lButton, rButton));
				},
				updatePaginationControls: function(opt_clear)
				{
					var o = this._pagination;
					return (o && o.replaceWith(this.buildPaginationControls(opt_clear)));
				},
				changePage: function(dir) {

					// close any open submenus
					QMenuRegistry.closeAllMenus(this);

					this._page += dir;
					this.updatePaginationControls();
					var searchText = this._searchInputDom && this._searchInputDom.val().toLowerCase() || null,
						items = this.getMenuItems(searchText);

					this.updateMenuItems(items);

					var qMenuContext = this;
					$timeout(function() {
						function closeMenu() {
							QMenuRegistry.closeAllMenus();
							qMenuContext._element.focus();
						}
						if (typeof removeEventHandlers === 'function') {
							removeEventHandlers();
						}
						removeEventHandlers = setupMenuFocus(
							qMenuContext._menuDom.get(0),
							closeMenu,
							qMenuContext._menuDef.shouldSetFocusOnFirstItem
						);
					});
				},
				shouldShowPagination: function()
				{
					return !!this._menuDef.pagination;
				}
			};

			return QMenu;
		}
	]);

	module.directive('qstrap.menu', [
		'qstrap.$menu',
		function(QMenu) {

			return {
				scope: {
					items: '&?',
					action: '&',
					selectMenu: '@?',
					multiSelectMenu: '@?',
					className: '@?',
					updateButton: '@?',
					searchable: '@?',
					preferredDirection: '@',
					maxHeight: '@?',
					filterable: '@?',
					pagination: '=',
					_searchCallback: '&searchCallback',
					localizedText: '=?',
					onOpen: '&?',
					onClose: '&?',
					afterChange: '&?',
					showEvent: '@?',
					disabled: '=ngDisabled'
				},
				link: function ($scope, element, attrs)
				{
					if (!attrs.items)
						delete $scope.items;
					if(attrs.searchCallback)
					{
						$scope.searchCallback = function(search, limit, offset) {
							return $scope._searchCallback({$search:search,$limit:limit,$offset:offset});
						};
					}
					var action = $scope.action;
					$scope.action = function(value, item, evt) {
						action({$value:value,$item:item,$event:evt});
						$scope.$apply();
						if ($scope.afterChange)
							$scope.afterChange({$value:value,$item:item,$event:evt});
					};
					var menu = new QMenu(element, $scope);
					element.data('q.qmenu', menu);

					$scope.$watch('preferredDirection', function(newVal) {
						if (newVal) {
							menu.preferredDirection = newVal;
						}
					});

					$scope.getMenu = function() {
						return menu;
					};
				}
			};
		}
	]);

	// attach the qmenu object as a jquery extension
	var QMenu = angular.injector(['ng', 'qstrap.menu', 'qstrap.translate']).get('qstrap.$menu');

	var old = $.fn.qmenu;

	$.fn.qmenu = function (options)
	{
		return this.each(function()
		{
			var el = $(this);
			if (!el.data('q.qmenu'))
			{
				el.data('q.qmenu', new QMenu(el, options));
			}
		});
	};

	$.fn.qmenu.Constructor = QMenu;

	$.fn.qmenu.noConflict = function ()
	{
		$.fn.qmenu = old;
		return this;
	};
})(angular.module('qstrap.menu', ['qstrap.util']), jQuery);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.select-menu
 *
 * @restrict A
 * @element ANY
 * @description
 * Simplified version of qstrap.menu that is used for a simple select menu
 *
 * @param {expression} ngModel Assignable angular expression to data-bind to.
 * @param {expression} items Angular expression that returns a menu items object. See <a href='#/api/qstrap:qstrap.menu'>qstrap.menu</a> for more details
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The switch value is available as $value)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The switch value is available as $value)
 * @param {expression=} options options object that has all the menu options like "className" and "searchable". See <a href='#/api/qstrap:qstrap.menu'>qstrap.menu</a> for full list of options
 * @param {expression=} ngDisabled can be used to disable the menu
 *
 * @example
	<example module="qstrap">
		<file name="selectMenu.html">
			<div ng-controller="selectMenuDemoCtrl">
				<p>Use the btn and btn-select classes and a span with class caret for great styles</p>
				<button id='btn0' class="btn btn-select" qstrap.select-menu ng-model="val" items="items" on-change="label = $item.label" after-change="alert($value)">
					{{label}}
					<span class=caret></span>
				</button>

				<p>Use DOM nodes to style labels that you trust (i.e. not user input). Otherwiwse we will escape HTML tags</p>
				<button id='btn0' class="btn btn-select" qstrap.select-menu ng-model="val" items="domItems" on-change="label = $item.label" after-change="alert($value)">
					{{domLabel}}
					<span class=caret></span>
				</button>

				<p>Use .btn-select-secondary to get a menu using @q-seconday-text color</p>
				<button id='btn0' class="btn btn-select btn-select-secondary" qstrap.select-menu ng-model="val" items="items">
					{{val}}
					<span class=caret></span>
				</button>

				<p>Searchable select menu with a custom class name</p>
				<button id='btn0' class='btn btn-select' qstrap.select-menu ng-model="val_1" items="items" options="options">
					{{val_1}}
					<span class=caret></span>
				</button>
				<button id='btn0' class='btn btn-select' qstrap.select-menu ng-model="val_2" items="itemsB" options="options">
					{{val_2}}
					<span class=caret></span>
				</button>

				<p>Disabled</p>
				<button id='btn0' class='btn btn-select' ng-disabled="toggleDisabled" qstrap.select-menu ng-model="val" items="items">
					{{val}}
					<span class=caret></span>
				</button>
				<label><input type='checkbox' ng-model="toggleDisabled">Toggle Disabled</label>
			</div>
		</file>
		<file name="selectMenu.js">
			angular.module('qstrap.selectMenu').controller('selectMenuDemoCtrl', function($scope) {
				$scope.toggleDisabled = true;
				$scope.val = 2;
				$scope.val_1 = 2;
				$scope.val_2 = 2;
				$scope.label = 'two';
				$scope.items = [
					{
						label: 'one',
						value: 1,
					},{
						label: 'two',
						value: 2
					},{
						divider: true
					},{
						label: 'Remove (not selectable)',
						notSelectable: true,
						icon: 'icon-x-sm',
						replaceCheck: true,
						action: function () {
							$('#btn0').fadeOut(300, function () {
								setTimeout(function () {
									$('#btn0').fadeIn(300);
								}, 1000);
							});
						}
					}
				];
				$scope.itemsB = [
					{
						label: 'one',
						value: 1,
					},{
						label: 'two',
						value: 2
					},
				];
				$scope.alert = function(value) { alert('selectMenu value changed to: ' + value); };

				$scope.domLabel = '<b>one</b>';
				$scope.domItems = [
					{
						label: '<b>one</b>',
						value: 1,
					},{
						label: $('<b>two</b>'),
						value: 2
					},{
						divider: true
					},{
						label: 'Remove (not selectable)',
						notSelectable: true,
						icon: 'icon-x-sm',
						replaceCheck: true,
						action: function () {
							$('#btn0').fadeOut(300, function () {
								setTimeout(function () {
									$('#btn0').fadeIn(300);
								}, 1000);
							});
						}
					}
				];

				$scope.options = {
					searchable: true,
					className: 'my-class'
				};
			});
		</file>
		<file name="selectMenu.css">
			.my-class {
				border: 2px solid red !important;
			}
		</file>
	</example>
 */

(function (module) {
	'use strict';
	module.directive('qstrap.selectMenu', [
		'qstrap.$menu',
		function(QMenu)
		{
			return {
				require: 'ngModel', //http://goo.gl/yt0DvG
				scope:
				{
					items: '&',
					onChange: '&',
					afterChange: '&',
					options: '&',
					disabled: '=ngDisabled'
				},
				link: function($scope, element, attrs, ngModel)
				{
					// I use element.attr instead of attrs, so the multi-select can be dynamically added in a pre compile function
					var multiSelect = !!element.attr('multi-select');

					function processMenuItems(items)
					{
						var newItems = [],
							val = ngModel.$modelValue;

						if (multiSelect && !val)
						{
							val = [];
						}

						//prep items and make sure the right one is selected
						for (var i in items)
						{
							if (!items.hasOwnProperty(i))
							{
								continue;
							}

							var item = items[i];
							if (typeof item == 'string')
							{
								item = {
									label: item
								};
							}

							if (!item.hasOwnProperty('value'))
							{
								item.value = i;
							}

							if (multiSelect && isSelectableItem(item) && val.indexOf(item.value) >= 0 || item.value == val)
							{
								item.selected = true;
							}

							if (item.submenu && item.submenu.items) {
								item.submenu.items = wrapItems(item.submenu.items);
							}

							newItems.push(item);
						}

						return newItems;
					}

					function wrapItems (originalItems) {
						return function () {
							// create a local reference so we don't overwrite the original
							var items = originalItems;
							if (typeof items == 'function') {
								items = items();
							}
							//it returned a promise which means it was asynchronous
							if (typeof items.then === 'function') {
								return items.then(processMenuItems);
							}

							return processMenuItems(items);
						};
					}

					function isSelectableItem(item) {
						return !(item.divider || item.header || item.domNode);
					}


					var menuOpts = {
						selectMenu: true,
						items: wrapItems($scope.items),
						action: function(val, item, evt)
						{
							if ($scope.onChange)
							{
								$scope.onChange({
									$value: val,
									$item: item,
									$event: evt
								});
							}

							ngModel.$setViewValue(val);
							$scope.$apply();

							if ($scope.afterChange)
							{
								$scope.afterChange({
									$value: val,
									$item: item,
									$event: evt
								});
							}
						}
					};

					if (multiSelect)
					{
						delete menuOpts.selectMenu;
						menuOpts.multiSelectMenu = true;
					}

					menuOpts.disabled = function () {
						return $scope.disabled;
					};

					element.data('q.qmenu', new QMenu(element, menuOpts, null, $scope.options()));
				}
			};
		}
	]);
})(angular.module('qstrap.selectMenu', ['qstrap.menu']));

/**
 * @ngdoc service
 * @name qstrap:qstrap.modal
 *
 * @restrict C
 * @description
 * A modal factory that when instantiated, will return a modal controller with `show()` and `close()` functions.
 *
 ```
 var modal = modal(options);`
 modal.show();`
 ```
 *
 * Adding a `mobile` class to the `<body>` tag will render the modal in a mobile-mode.
 *
 * @param {object=} scope The modal will compile with a child of this scope. If none is provided, the child scope will be created from `$rootScope`. The child scope will have a `close()` function on the scope which will destroy the dialog
 * @param {string=} controller A controller for the modal scope. This is the name of the controller rather than the controller object.
 * @param {string=} title Text/HTML that will be added as an `<h4 class='modal-title'>` to the modal-header
 * @param {string=} header Text/HTML that will be placed in the modal-header
 * @param {path=} headerTemplate .html file reference that will be used in the modal-header with ng-include
 * @param {string=} content Text/HTML that will be placed as the modal-body
 * @param {path=} contentTemplate `.html` file reference that will be used in the `modal-body` with `ng-include`
 * @param {string=} footer Text/HTML that will be placed as the modal-footer.
 * @param {path=} footerTemplate `.html` file reference that will be used in the `modal-footer` with `ng-include`
 * @param {path=} templateUrl `.html` file reference that will be used in the `modal-content`
 * @param {array=} buttons An array of button HTML elements to be placed in the footer. If you don't provide buttons, footerTemplate, or footer, a default close button will be added
 * @param {string=} className A class that will be added to the modal. This can be used for more fine-tuning of the modal.
 * @param {boolean=} destroyScopeOnClose The $scope of the modal will be destroyed when the modal is closed. Once the modal is closed you will not be able to call .show() on it again.
 *
 * @example
<example module="qstrap">
	<file name="modal.html">
		<div ng-controller='modalDemoCtrl'>
			<button class='btn btn-default' ng-click='showModal("dynamic");'>
				<span>Dynamic Modal</span>
			</button>
			<button class='btn btn-default' ng-click='showModal("templates");'>
				<span>Template Modal</span>
			</button>
			<button class='btn btn-default' ng-click='showModal("buttons");'>
				<span>Scope and Buttons</span>
			</button>
			<button class='btn btn-default' ng-click='showModal("form");'>
				<span>Form</span>
			</button>
			<button class='btn btn-default' ng-click='showModal("controller");'>
				<span>Controller</span>
			</button>
		</div>
	</file>
	<file name="modalController.js">
		angular.module('qstrap.modal').controller('modalDemoCtrl', [
			'$templateCache',
			'$scope',
			'qstrap.modal',
			function($templateCache, $scope, modal)
			{
				$templateCache.put('modal-header.tpl.html', '<h4 class="modal-title">Here is a templated title</h4>');
				$templateCache.put('modal-content.tpl.html', 'Here is templated content');
				$templateCache.put('modal-footer.tpl.html', '<button class="btn btn-hover" ng-click="close()">Templated Close</button>');
				$templateCache.put('modal-form.tpl.html', '' +
					'<form name="myForm" novalidate>' +
						'<div class="modal-header">' +
							'<h4 class="modal-title">{{modalText.title || "Form Title"}}</h4>' +
						'</div>' +
						'<div class="modal-body">' +
							'<div class="form-group">' +
								'<label for="name">Name</label>' +
								'<input type="text" class="form-control form-control-full" ng-model="name" name="name" id="name" placeholder="Name" required>' +
							'</div>' +
							'<div class="form-group">' +
								'<label for="email">Email</label>' +
								'<input type="email" class="form-control form-control-full" ng-model="email" name="email" id="email" placeholder="Email" required>' +
							'</div>' +
						'</div>' +
						'<div class="modal-footer">' +
							'<button class="btn btn-success" ng-class="{disabled: myForm.$invalid}" ng-click="close()">' +
								'<i class="icon btn-icon-check"></i>' +
								'<span>Submit</span>' +
							'</button>' +
							'<button class="btn btn-hover" ng-click="close()">Cancel</button>' +
						'</div>' +
					'</form>'
				);

				var modals = {
					dynamic: modal({
						title: 'Dynamic Modal',
						content: '<div contenteditable>Type something here. Will grow as you type, and shrink as you resize the page!</div>'
					}),
					templates: modal({
						headerTemplate: 'modal-header.tpl.html',
						contentTemplate: 'modal-content.tpl.html',
						footerTemplate: 'modal-footer.tpl.html'
					}),
					buttons: modal({
						scope: $scope,
						controller: 'modalTextCtrl',
						header: '<h4 class="modal-title">{{modalText.title}}</h4>',
						content: '' +
							'<div class="form-group">' +
								'<label>Title</label>' +
								'<input class="form-control form-control-full" type="text" ng-model="modalText.title" />' +
							'</div>' +
							'<div class="form-group">' +
								'<label>Content</label>' +
								'<textarea class="form-control form-control-full" ng-model="modalText.text" />' +
							'</div>',
						buttons: [
							'<button class="btn btn-default left" ng-click="clearText()">Clear Text</button>',
							'<button class="btn btn-success" ng-click="showModal(\'dynamic\')"><i class="icon btn-icon-check"></i><span>Save</span></button>',
							'<button class="btn btn-hover" ng-click="close()">Cancel</button>'
						]
					}),
					form: modal({
						templateUrl: 'modal-form.tpl.html'
					}),
					controller: modal({
						templateUrl: 'modal-form.tpl.html',
						controller: 'modalTextCtrl'
					})
				};

				$scope.showModal = function(type)
				{
					modals[type].show();
				};
			}
		]);

		angular.module('qstrap.modal').controller('modalTextCtrl', [
			'$scope',
			function($scope)
			{
				$scope.modalText = {
					title: 'Modal Title',
					text: 'Modal Text'
				};

				$scope.clearText = function()
				{
					$scope.modalText.text = '';
				}
			}
		]);
	</file>
</example>
*/
(function(module) {
	'use strict';
	module.factory('qstrap.modal', [
		'$templateCache',
		'$compile',
		'$rootScope',
		'$window',
		'$timeout',
		'$q',
		'$http',
		'qstrap.util',
		function($templateCache, $compile, $rootScope, $window, $timeout, $q, $http, util)
		{
			$templateCache.put('qstrap.modal.html', '' +
				'<div class="modal">' +
					'<div class="modal-dialog">' +
						'<div class="modal-content scale">' +
							'<div class="modal-header">' +
								'<h4 class="modal-title"></h4>' +
							'</div>' +
							'<div class="modal-body"></div>' +
							'<div class="modal-footer">' +
								'<button class="btn btn-hover" ng-click="close()">{{"CLOSE" | qstrapTranslate}}</button>' +
							'</div>' +
						'</div>' +
					'</div>' +
					'<div class="modal-backdrop"></div>' +
				'</div>'
			);

			$templateCache.put('qstrap.modal.template', '' +
				'<div class="modal">' +
					'<div class="modal-dialog">' +
						'<div class="modal-content scale">' +
						'</div>' +
					'</div>' +
					'<div class="modal-backdrop"></div>' +
				'</div>'
			);
			var Modal = function(def)
			{
				// def = {
				// 	scope: '',
				// 	title: '',
				// 	header: '',
				// 	headerTemplate: '',
				// 	content: '',
				// 	contentTemplate: '',
				// 	buttons: [],
				// 	footer: '',
				// 	footerTemplate: '',
				// 	templateUrl: '',
				// 	className:'',
				// 	destroyScopeOnClose: false,
				// 	effect: ['scale']
				// };

				this.definition = def;
				this.scope = (this.definition.scope || $rootScope).$new();
				delete this.definition.scope;

				this.scope.close = $.proxy(this.close, this);

				// resize should not be proxied because jQuery treats output functions from the same proxy
				// as being equivalent within its event handling system, thus preventing individual resize events
				// from being deregistered
				var that = this;
				this._resize = function () { that.resize.call(that); };

				if (this.definition.show)
				{
					this.show();
				}
			};

			var focusedElBeforeOpen;
			var containerElement;
			Modal.prototype = {
				show: function()
				{
					var self = this;

					if (self.modalDestroyed) {
						console.error('Attempting to show modal after it was destroyed.');
						return;
					}

					return build(this.definition, this.scope).then(function(modalEl) {
						self.modal = modalEl;
						$('body').append(self.modal).addClass('modal-visible');
						position(self.modal);
						self.modal.addClass('modal-show');
                        self.focusedElBeforeOpen = document.activeElement;
						self.containerElement = self.modal.get(0).firstElementChild;
						self.containerElement.setAttribute('tabindex', 0);
						self.handleFocusTrap(self.containerElement);

						$($window).on('resize', self._resize);
					});
				},
				handleFocusTrap: function(containerElement)
				{
					var modalRef = this;
                    var allFocusableElements = containerElement.querySelectorAll(util.focusableSelector);
					var firstFocusableElement = allFocusableElements[0];
					var lastFocusableElement = allFocusableElements[allFocusableElements.length - 1];
					containerElement.focus();
					containerElement.addEventListener('keydown', handleKeyDown);
					if (firstFocusableElement) {
						firstFocusableElement.addEventListener('keydown', handleFirstFocusableElementKeyDown);
					}

					if (lastFocusableElement) {
						lastFocusableElement.addEventListener('keydown', handleLastFocusableElementKeyDown);
					}

					function handleKeyDown(event){
						if (event.keyCode === util.keys.ESCAPE) {
							modalRef.close();
						}
					}

					function handleFirstFocusableElementKeyDown (event) {
						if (event.keyCode === util.keys.TAB && event.shiftKey) {
							event.stopPropagation();
							event.preventDefault();
							lastFocusableElement.focus();
						}
					}
		
					function handleLastFocusableElementKeyDown (event) {
						if (event.keyCode === util.keys.TAB && !event.shiftKey) {
							event.stopPropagation();
							event.preventDefault();
							firstFocusableElement.focus();
						}
					}

				},
				close: function(opt_force)
				{
					if (this.modal)
					{
						this.modal.removeClass('modal-show');

						var that = this,
							body = $('body');

						return $timeout(function()
						{
							if (that.definition.destroyScopeOnClose) {
								that.modalDestroyed = true;
								that.scope.$destroy();
							}

							that.modal.remove();
							delete that.modal;
							$($window).off('resize', that._resize);

							//if there are no more modals, then remove the modal-visible class from the body
							if (!$('.modal:not(.persistent-modal)').length)
							{
								body.removeClass('modal-visible').css('margin-right', 0);
							}
							that.focusedElBeforeOpen.focus();

						}, 300);
					}
				},
				resize: function()
				{
					if (this.modal)
					{
						position(this.modal);
					}
				}
			};

			function build(def, scope)
			{
				var modal;
				if (def.templateUrl)
				{
					modal = buildContent($templateCache.get('qstrap.modal.template'), def);
				}
				else
				{
					modal = angular.element($templateCache.get('qstrap.modal.html'));
					buildHeader(modal, def);
					buildBody(modal, def);
					buildFooter(modal, def);
				}

				return $q.when(modal).then(function(modal) {
					if (def.controller)
					{
						modal = angular.element(modal).attr('ng-controller', def.controller);
					}
					modal = $compile(modal)(scope);
					if (def.className)
					{
						modal.addClass(def.className);
					}
					return modal;
				});
			}

			function buildContent(modalTemplate, def)
			{
				return fetchTemplate(def.templateUrl).then(function(template) {
					if (angular.isObject(template))
					{
						template = template.data;
					}
					template = String.prototype.trim.apply(template);

					var modalEl = angular.element(modalTemplate);
					modalEl.find('.modal-content').html(template);

					return modalEl[0].outerHTML;
				});
			}

			function buildHeader(modal, def)
			{
				var header = modal.find('.modal-header');

				if (def.headerTemplate)
				{
					header.html('<div ng-include="\'' + def.headerTemplate + '\'"></div>');
				}
				else if (def.header)
				{
					header.html(def.header);
				}
				else if (def.title)
				{
					header.html('<h3 class="modal-title">' + def.title + '</h3>');
				}
			}

			function buildBody(modal, def)
			{
				var body = modal.find('.modal-body');

				if (def.bodyTemplate || def.contentTemplate)
				{
					body.html('<div ng-include="\'' + (def.bodyTemplate || def.contentTemplate) + '\'"></div>');
				}
				else if (def.body || def.content)
				{
					body.html(def.body || def.content);
				}
			}

			function buildFooter(modal, def)
			{
				var footer = modal.find('.modal-footer');
				if (def.footerTemplate)
				{
					footer.html('<div ng-include="\'' + def.footerTemplate + '\'"></div>');
				}
				else if (def.footer)
				{
					footer.html(def.footer);
				}
				//TODO: do something more fancy with buttons
				else if (def.buttons)
				{
					footer.html(def.buttons.join(''));
				}
			}

			function position(modal)
			{
				var modalBody = modal.find(('.modal-body')),
					headerFooterHeight = 140; //not magic

				modalBody.css({
					'max-width': ($window.innerWidth * 0.85) + 'px',
					'max-height': ($window.innerHeight * 0.85 - headerFooterHeight) + 'px'
				});

				//check to see if there is a scrollbar
				var body = $('body');
				if (body[0].scrollHeight > body[0].clientHeight)
				{
					body.css('margin-right', getScrollWidth() + 'px');
				}
			}

			var scrollWidth = null;
			function getScrollWidth()
			{
				if (scrollWidth === null)
				{
					// Create the measurement node
					var scrollDiv = $('<div>').css({width:'100px',height:'100px',overflow:'scroll',position:'absolute',top:'-9999px'});
					$('body').append(scrollDiv);

					// Get the scrollbar width
					scrollWidth = scrollDiv[0].offsetWidth - scrollDiv[0].clientWidth;

					// Delete the DIV
					scrollDiv.remove();
				}
				return scrollWidth;
			}

			var fetchPromises = {};
			function fetchTemplate(template)
			{
				if (fetchPromises[template])
				{
					return fetchPromises[template];
				}
				fetchPromises[template] = $q.when($templateCache.get(template) || $http.get(template));
				return fetchPromises[template].then(function(res)
				{
					if (angular.isObject(res))
					{
						$templateCache.put(template, res.data);
						return res.data;
					}
					return res;
				});
			}

			return function(options)
			{
				return new Modal(options);
			};
		}
	]);
})(angular.module('qstrap.modal',['qstrap.util']));

/**
 * @ngdoc directive
 * @name qstrap:qstrap.paginationControls
 *
 * @restrict A
 * @element div
 * @description
 * __NOTE: This directive is being deprecated, and will likly be removed in the next major version. Please migrate your application
 * to use <a href='#/api/qstrap:qstrap.pagination'>qstrap.pagination</a> instead.__
 *
 * Directive that creates a set of controls to connect to a table source for pagination. Best when paired with search widget to filter results to manageable paging size.
 *
 * @param {string} total The total number of _objects_ to be paginated.
 * @param {string} offset The number of _objects_ skipped (add one to get index of first object).
 * @param {string} limit The number of _objects_ to show on one page.
 * @param {string} msg-template The template to use for the message. The current page and total number of pages can be inserted into the template. Example: "Page 1 of 6" would be "Page ${currentPg} of ${totalPgs}"
 * @param {expression} before-change Angular expression to be executed before the offset value is updated. Return boolean false to prevent navigation. Takes offset, total, and limit as parameters. Parameters must be indicated with the appropriate names in the directive.
 * @param {expression} on-change (deprecated) synonymous with _afterChange_.
 * @param {expression} after-change Angular expression to be executed after the offset value is updated, but before $scope is notified. Takes offset, total, and limit as parameters. Parameters must be indicated with the appropriate names in the directive.
 *
 * @example
<example module="qstrap">
<file name="paginationControls.html">
	<style>
		.demo {
			float: left;
			width:50%;
		}
		.well.doc-example-live:after {
			content: "";
			clear: both;
			display: block;
		}
		.qstrap .special-label {
		    margin-bottom: -20px;
		    display: block;
		}
	</style>
    <div ng-controller="PaginationDemoCtrl" class='demo'>
    	<i>New Style Controller</i>
        <div qstrap.pagination-controls limit="pager.limit" offset="pager.offset" total="pager.total" after-change="pager.afterChange(offset, total, limit)" before-change="pager.beforeChange(offset, total, limit)"></div>
    </div>
    <div ng-controller="PaginationDemoCtrl" class='demo'>
    	<i>Using message template</i>
        <div qstrap.pagination-controls limit="pager.limit" offset="pager.offset" total="pager.total" msg-template="{{pager.newMsgTemplate}}"></div>
    </div>
    <div ng-controller="PaginationDemoCtrl" class='demo'>
    	<i>Before change demo:</i><br>
    	<label class="special-label"><input ng-model="pager.preventNav" type="checkbox"/>Prevent page nav</label>
        <div qstrap.pagination-controls limit="pager.limit" offset="pager.offset" total="pager.total" before-change="pager.conditionalNav()"></div>
    </div>
    <div ng-controller="OldStyleController" class='demo'>
    	<i>Old Style Controller</i>
        <div qstrap.pagination-controls limit="pager.limit" offset="pager.offset" total="pager.total" on-change="pager.onChange(offset, total, limit)"></div>
    </div>
</file>
<file name="paginationControls.js">
	angular.module('qstrap.paginationControls')
	.controller('PaginationDemoCtrl', function($scope){
	    $scope.pager = {
	        afterChange: function(offset, total, limit)
	        {
	            alert('afterChange: On page '+(offset / limit + 1)+'. Showing '+limit+' of '+total+' objects starting at object ' + offset);
	        },
	        beforeChange: function(offset, total, limit)
	        {
	        	// return boolean false to stop nav
	        },
	        conditionalNav: function() {
				return !$scope.pager.preventNav;
	        },
	        total: 30,
	        offset: 0,
	        limit: 10,
	        newMsgTemplate: 'Page ${currentPg} of ${totalPgs}',
	        preventNav: false
	    };
	})
	.controller('OldStyleController', function($scope) {
	    $scope.pager = {
	        onChange: function($offset)
	        {
	            alert('on-change: New offset: ' + $offset);
	        },
	        total: 20,
	        offset: 5,
	        limit: 5
	    };
	});
</file>
</example>
*/
angular.module('qstrap.paginationControls', [])
	.filter('paginationText', function () {
		'use strict';
		return function (template, currentPg, totalPgs) {
			if (!template) {
				template = 'Showing page ${currentPg} of ${totalPgs}'; //TODO translate
			}
			return template.replace('${currentPg}', currentPg).replace('${totalPgs}', totalPgs);
		};
	})
	.directive('qstrap.paginationControls', [function () {
		'use strict';
		return {
			restrict: 'A',
			scope: {
				total: '=',
				offset: '=',
				limit: '=',
				msgTemplate: '@',
				onChange: '&',
				beforeChange: '&',
				afterChange: '&'
			},
			link: function ($scope, $element, $attrs) {
				$scope.offset = parseInt($scope.offset, 10);
				$scope.limit = parseInt($scope.limit, 10);
				$scope.total = parseInt($scope.total, 10);

				if ($scope.offset > $scope.total) {
					throw new Error('paginationControl: Provided offset larger than total');
				}

				var hasBeforeChange = typeof $attrs.beforeChange === 'string';
				var hasOnChange = typeof $attrs.onChange === 'string';
				var hasAfterChange = typeof $attrs.afterChange === 'string';

				//Fires on any change of the numeric directive parameters
				var updateState = function () {
					$scope.currPage = Math.floor($scope.offset / $scope.limit) + 1;
					$scope.totalPages = Math.ceil($scope.total / $scope.limit);

					$scope.enableBack = $scope.offset !== 0;
					$scope.enableForward = ($scope.offset + $scope.limit) < $scope.total;
				};

				$scope.$watch('offset', updateState);
				$scope.$watch('limit', updateState);
				$scope.$watch('total', updateState);

				$scope.pagination = {
					start: function () {
						if ($scope.enableBack && callBeforeChange()) {
							$scope.offset = 0;
							callAfterChange();
						}
					},
					back: function () {
						if ($scope.enableBack && callBeforeChange()) {
							$scope.offset -= $scope.limit;
							callAfterChange();
						}
					},
					forward: function () {
						if ($scope.enableForward && callBeforeChange()) {
							$scope.offset += $scope.limit;
							callAfterChange();
						}
					},
					end: function () {
						if ($scope.enableForward && callBeforeChange()) {
							var multiplier = (Math.ceil($scope.total / $scope.limit)) - 1;
							$scope.offset = (multiplier * $scope.limit);
							callAfterChange();
						}
					}

				};

				// Since logic depends on this function, it
				// returns true if beforeChange is not defined
				function callBeforeChange() {
					if (hasBeforeChange) {
						var rval = $scope.beforeChange({
							offset: $scope.offset,
							total: $scope.total,
							limit: $scope.limit
						});
						return (typeof rval === 'boolean' ? rval : true);
					}
					return true;

				}

				function callAfterChange() {
					if (hasAfterChange) {
						return $scope.afterChange({
							offset: $scope.offset,
							total: $scope.total,
							limit: $scope.limit
						});
					} else if (hasOnChange) {
						return $scope.onChange({
							$offset: $scope.offset,
							$currPage: $scope.currPage
						});
					} else {
						return true;
					}
				}

			},

			/*jshint multistr: true */
			//TODO: How will we translate the message? Will qtranslate work?
			template: '<div class="pagination"> \
				<div class="message" ng-bind="msgTemplate | paginationText : currPage : totalPages"></div>\
				<div class="controls" ng-show="total> limit"> \
					<div ng-class="{disabled: !enableBack}" class="btn btn-default back" ng-click="pagination.back()"> \
						<span class="icon btn-icon-angle-left"> </span>\
					</div>\
					<div ng-class="{disabled: !enableForward}" class="btn btn-default forward" ng-click="pagination.forward()"> \
						<span class="icon btn-icon-angle-right"> </span>\
					</div>\
				</div>\
			</div>'

		};
	}]);
/**
 * @ngdoc directive
 * @name qstrap:qstrap.pagination
 *
 * @restrict A
 * @element ANY
 * @description
 * Directive that displays a generic pagination control for tables, search results, etc. This directive does not handle the displaying of
 * paginated data; rather, it provides the controls and callbacks for when a page is changed, and leaves the implementation of loading and
 * displaying paginated data to the implementing app.
 *
 * @param {object} pagination An object with pagination data to display in the controls
 * @param {number} pagination.page The current page (0-indexed)
 * @param {number} pagination.total The total number of pages
 * @param {expression} setPage Callback for when a user changes page through the controls. The callback function
 * 								should update `pagination.page`, as the pagination directive will not change values
 * 								of the pagination object on its own.
 *
 * @example
	<example module="qstrap">
		<file name="pagination.html">
			<div ng-controller="PaginationDemoController">
				<div class="pageDemo">
					<h1>Page Index: {{paginationObj.page}}</h1>
					<p>{{lorem[paginationObj.page]}}</p>
				</div>
				<div qstrap.pagination pagination="paginationObj" set-page="setPage(page)" ></div>
			</div>
		</file>
		<file name="pagination.js">
			angular.module('qstrap.pagination').controller('PaginationDemoController', function($scope) {

				$scope.paginationObj = {
					page: 1,
					totalPages: 7
				};

				$scope.setPage = function(page) {
					$scope.paginationObj.page = page;
				};

				$scope.lorem = [
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae dignissim lorem. Morbi venenatis, libero in maximus luctus, sem erat efficitur arcu, vitae eleifend turpis massa a nisi. Mauris sollicitudin pellentesque enim eu efficitur. Cras a elit neque. Phasellus volutpat, tortor et ornare auctor, nibh diam mattis mauris, et suscipit metus ipsum sagittis est. Praesent dolor leo, ornare sit amet mauris vitae, tristique ultricies ligula. Proin rutrum mattis eros et rhoncus. Maecenas accumsan molestie pellentesque. Integer in massa et purus facilisis bibendum. Nam ante tortor, blandit quis fringilla in, scelerisque at nulla. Sed a porttitor lacus. Quisque sit amet nunc ac est semper interdum.',
					'Donec consectetur vehicula tortor non feugiat. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nullam cursus lectus quis hendrerit ullamcorper. Maecenas faucibus vel ipsum id dictum. Aliquam non leo turpis. Nunc in dolor arcu. Nulla maximus ipsum sed mauris bibendum feugiat. Cras facilisis nunc id risus aliquet, pharetra tincidunt arcu scelerisque.',
					'Etiam quis ligula sit amet erat porttitor hendrerit fermentum vitae sapien. Donec vitae eros et orci varius tincidunt. Sed ut faucibus mauris. Nam non purus nec arcu dictum dignissim. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam sit amet ipsum accumsan, egestas dolor eget, sodales quam. Suspendisse varius quam id arcu hendrerit ultricies. Aliquam lectus odio, suscipit laoreet ultricies id, sagittis ac nibh.',
					'Nulla eget ultricies tellus. Nunc tristique tortor vel volutpat cursus. Duis ac leo faucibus, ornare ante quis, convallis mauris. Integer convallis justo nec pellentesque finibus. Sed venenatis elit ut magna mollis, sit amet placerat nisi aliquet. Vivamus velit magna, cursus eget nulla id, ullamcorper venenatis arcu. Aliquam neque nibh, lobortis scelerisque sem sed, eleifend eleifend lectus. Mauris sodales, ligula id aliquet molestie, nisi lacus faucibus nibh, volutpat egestas erat lacus et turpis. Maecenas scelerisque nisi ex, nec ornare lectus maximus ac. Praesent facilisis diam et turpis fringilla, sit amet ultrices quam feugiat. Donec imperdiet nibh ut arcu sagittis auctor.',
					'Integer lacinia tincidunt risus volutpat placerat. Maecenas fermentum eu felis eget volutpat. Ut pulvinar dui mauris, vitae mollis ipsum egestas a. In imperdiet ornare nisl eu eleifend. Nullam eu ex risus. Morbi vel quam sagittis, dignissim nunc et, molestie est. Sed bibendum efficitur dui ut vulputate. Phasellus ac nibh vel ex venenatis imperdiet. Nullam aliquam mauris id mi rutrum, eu dictum dui consequat. Proin nibh purus, dictum non laoreet et, cursus in mauris. Vestibulum cursus nisi sed facilisis laoreet. Nullam vestibulum nisi id ex bibendum convallis non non felis.',
					'In nec interdum lacus. Curabitur venenatis neque quis mauris finibus sodales. Aliquam efficitur pulvinar felis ac venenatis. Cras quis luctus nunc, sit amet porta arcu. Sed non auctor libero. Pellentesque non bibendum magna, ut ultrices augue. Aliquam vel viverra mi. Donec dapibus nulla luctus, vulputate ante nec, dictum urna. Pellentesque bibendum, nunc ut varius luctus, purus erat tincidunt nisl, quis vestibulum quam justo auctor neque. Vivamus ut turpis dolor. Sed ac porta libero. Ut at sapien tellus. Donec ligula nunc, auctor at augue in, fermentum viverra mi. In et fringilla nunc. Vestibulum sit amet ante pellentesque, rutrum neque vehicula, scelerisque est.',
					'Nulla aliquam auctor sapien id laoreet. Integer aliquam metus ut sodales eleifend. Vestibulum nec lacus porta, consectetur nisl eget, viverra nibh. Fusce sodales accumsan nulla sed pellentesque. Donec nec tortor a augue pulvinar viverra. Sed ut convallis risus. Nulla lacinia erat augue, non sagittis diam viverra vitae. Donec sit amet ipsum at dui consequat gravida. Etiam consectetur dui et facilisis sagittis. Aliquam erat volutpat. Quisque vulputate sodales ante, ac sodales sem convallis sed. Pellentesque egestas lectus in est consequat, in ornare lacus tincidunt. Praesent scelerisque est vel hendrerit congue. Aliquam dapibus sodales enim, vel dignissim mauris hendrerit efficitur. Integer molestie dui neque, eget gravida enim suscipit non.'
				]
			});
		</file>
		<file name="pagination.css">
			.pageDemo {
				padding: 20px;
				border: 1px solid black;
				margin: 20px 5px;
				height: 350px;
			}
		</file>
	</example>
 */
(function(module) {
	'use strict';
	module.controller('PaginationController', [
		'$scope',
		'$filter',
		'$sce',
		function($scope, $filter, $sce) {

			var translate = $filter('qstrapTranslate');

			var keys = {
				RETURN: 13,
				ESCAPE: 27
			};

			// Changes whether the user can manually
			// input a page number
			$scope.isEditing = false;

			$scope.pageItems = function() {
				var page;
				var currentPage = $scope.pagination.page + 1;
				var lastPage = $scope.pagination.totalPages;
				var count = 0;
				var items = [{
					label: $('<div class="page-item-bold"></div>').html(translate('PAGE_N', {page: currentPage})),
					value: currentPage,
					selected: true
				}];
				// add previous pages except first page
				for (page = currentPage - 1; page > 1 && count < 3; page--) {
					items.unshift({
						label: translate('PAGE_N', {page: page}),
						value: page
					});
					count++;
				}
				// add first page if current page is not
				if(currentPage !== 1) {
					items.unshift({
						divider: true
					});
					items.unshift({
						label: translate('FIRST_PAGE'),
						value: 1
					});
				}
				// add next pages except last page
				count = 0;
				for (page = currentPage + 1; page < lastPage && count < 3; page++) {
					items.push({
						label: translate('PAGE_N', {page: page}),
						value: page
					});
					count++;
				}
				//add last page if current page is not
				if(currentPage !== lastPage) {
					items.push({
						divider: true
					});
					items.push({
						label: translate('LAST_PAGE'),
						value: lastPage
					});
				}
				// add jump to
				items.push({
					divider: true
				});
				items.push({
					label: translate('JUMP_TO'),
					notSelectedable: true,
					action: editPage,
					value: -1
				});
				return items;
			};

			function editPage(value, item, event) {
				event.stopPropagation();
				$scope.editPage = $scope.pagination.page + 1;
				$scope.isEditing = true;
				$scope.$digest();
				$scope.focusInput();
			}

			$scope.goToPage = function(item) {
				$scope.setPage({page: item.value - 1});
			};

			$scope.hasNext = function() {
				return $scope.pagination.page < $scope.pagination.totalPages - 1;
			};

			// Navigates to the next page (right arrow)
			$scope.nextPage = function() {
				$scope.setPage({page: $scope.pagination.page + 1});
			};

			$scope.hasPrev = function() {
				return $scope.pagination.page > 0;
			};

			// Navigates to the previous page (left arrow)
			$scope.prevPage = function() {
				$scope.setPage({page: $scope.pagination.page - 1});
			};

			$scope.currentPageMessage = function() {
				return $sce.trustAsHtml(translate('CURRENT_PAGE', {current: $scope.pagination.page + 1, total: +$scope.pagination.totalPages}));
			};

			$scope.input = function(e) {
				switch (e.keyCode) {
					case keys.RETURN:
						setPageManual($scope.editPage);
						break;
					case keys.ESCAPE:
						// Cancel out of edit mode
						$scope.isEditing = false;
						// Reset the edit page
						$scope.editPage = $scope.pagination.page + 1;
						break;
				}
			};

			$scope.inputBlur = function() {
				$scope.isEditing = false;
				$scope.editPage = $scope.pagination.page + 1;
			};

			function setPageManual(page) {
				if (page > $scope.pagination.totalPages) {
					page = $scope.pagination.totalPages;
				} else if (page < 1) {
					page = 1;
				}
				$scope.setPage({page: page - 1});
				$scope.isEditing = false;
			}
		}
	]);

	module.directive('qstrap.pagination', [
		'$timeout',
		'$filter',
		'$compile',
		'$templateCache',
		function($timeout, $filter, $compile, $templateCache) {

			$templateCache.put('qstrap.pagination.html', '' +
				'<div class="pagination-controls">' +
					'<div ng-show="pagination && pagination.totalPages > 1">' +
						'<div class="btn btn-hover prev-button" ng-class="{disabled: disable || !hasPrev()}" ng-click="prevPage()">' +
							'<span class="icon icon-angle-left-lg" ></span>' +
						'</div>' +
						'<div ng-show="!isEditing" class="btn btn-hover btn-page" qstrap.select-menu ng-model="editPage" items="pageItems()" on-change="goToPage($item)" options="{\'preferredDirection\': \'right\'}" >' +
							'<span ng-bind-html="currentPageMessage()"></span>' +
							'<div class="icon icon-angle-down-sm"></div>' +
						'</div>' +
						'<div class="manual-entry" ng-show="isEditing"></div>' +
						'<div class="btn btn-hover next-button" ng-class="{disabled: disable || !hasNext()}" ng-click="nextPage()">' +
							'<span class="icon icon-angle-right-lg"></span>' +
						'</div>' +
					'</div>' +
				'</div>'
			);

			var translate = $filter('qstrapTranslate');

			return {
				templateUrl: 'qstrap.pagination.html',
				scope: {
					pagination : '=',
					setPage: '&',
					disabled: '=?'
				},
				link: function($scope, el, attrs) {

					// Element that will contain the manual entry message/input
					var manualEntryEl = jQuery(el).find('.manual-entry');

					// Add a function on the scope to set the
					// focus on the input
					$scope.focusInput = function() {
						$timeout(function() {
							var inputEl = jQuery(el).find('input');
							inputEl.focus();
							inputEl.select();
						});
					};

					// Watch for changes to the pagination data,
					// and re-render the custom input
					$scope.$watch('pagination', function(newVal, oldVal) {

						// Get the correct translation string
						var totalPages = $scope.pagination && $scope.pagination.totalPages || 0;
						var message = translate('ENTER_PAGE', {total: +totalPages});

						// Compile the message as a span
						var inputEl = $compile('<span>' + message + '</span>')($scope);

						// Insert compiled element into the DOM
						manualEntryEl.html(inputEl);

						$scope.editPage = $scope.pagination.page + 1;
					}, true);

				},
				controller: 'PaginationController'
			};
		}
	]);

	module.directive('qstrap.pageInput', [
		function() {
			return {
				scope: false,
				restrict: 'A',
				replace: true,
				template: '<input class="form-control form-control-sm" type="number" ng-model="editPage" ng-keydown="$event.stopPropagation()" ng-keyup="input($event)" ng-blur="inputBlur();" maxlength="{{limit}}" />'
			};
		}
	]);
})(angular.module('qstrap.pagination', ['qstrap.selectMenu', 'qstrap.translate']));
/**
 * @ngdoc directive
 * @name qstrap:qstrap.popover
 *
 * @restrict A
 * @description
 * Directive that creates a positioned popover around an element when clicked
 * @Note: The popover creates a child $scope
 *
 *
 * @param {string} position Position of the popover: (top, bottom, left, right)
 * @param {string} content Content of the popover
 * @param {string} className Class Name of the popover
 * @param {boolean} html is content HTML safe (true: will use content directly, fasle: will strip HTML from content)
 * @param {string} template Template URL of the popover. See below for the required html structure. This will overwrite the default template so you can add in your own directives, classes etc.
 * @param {function} onClose callback function that will be called when the popover is hidden
 * @param {function} onOpen callback function that will be called when the popover is shown
 * @example
	<example module="qstrap">
		<file name="popover.html">
			<div ng-controller="DemoController" class='popovers'>
				<button class="btn btn-info" qstrap.popover position="left" content="{{content}}">Left</button>
				<button class="btn btn-info" qstrap.popover position="top" content="{{content}}">Top</button>
				<button class="btn btn-info" qstrap.popover position="bottom" content="{{content}}">Bottom</button>
				<button class="btn btn-info" qstrap.popover position="right" content="{{content}}">Right</button>

				<h1>Popover with HTML</h1>
				<p>
					By default qstrap will sanitize `content` by removing HTML. If you would like to
					display HTML set the html attribute to true.
				</p>
				<button class="btn btn-info" qstrap.popover position="top" html="true" content="{{contentHTML}}">With HTML</button>
				<button class="btn btn-info" qstrap.popover position="top" content="{{contentHTML}}">Strip HTML</button>

				<h1>popover with open and close events</h1>
				<button class="btn btn-info" qstrap.popover position="top" html="true" content="{{contentHTML}}" on-open="onOpenCallback()" on-close="onCloseCallback()">With open close callbacks</button>

				<h1>popover with a template</h1>
				Templates should follow this structure:
				<pre class="prettyprint linenums" ng-set-text="popover.html"><ol class="linenums"><li class="L0"><span class="tag">&lt;div</span><span class="pln"> </span><span class="atn">class</span><span class="pun">=</span><span class="atv">"popover"</span><span class="tag">&gt;</span></li><li class="L1"><span class="pln">	</span><span class="tag">&lt;div</span><span class="pln"> </span><span class="atn">class</span><span class="pun">=</span><span class="atv">"popover-arrow"</span><span class="tag">&gt;&lt;/div&gt;</span></li><li class="L2"><span class="pln">	</span><span class="tag">&lt;div</span><span class="pln"> </span><span class="atn">class</span><span class="pun">=</span><span class="atv">"popover-inner"</span><span class="tag">&gt;</span></li><li class="L3"><span class="pln">		</span><span class="com">&lt;!-- place content here --&gt;</span></li><li class="L4"><span class="pln">	</span><span class="tag">&lt;/div&gt;</span></li><li class="L5"><span class="tag">&lt;/div&gt;</span></li></ol></pre>

				<button class="btn" style="margin-top: 3px;" qstrap.popover template="popover-demo-1.html">Template popover with select menu</button>
				<button class="btn" qstrap.popover template="popover-demo-2.html">Template popover with range slider</button>
				<button class="btn" style="margin-top: 3px;" qstrap.popover template="popover-demo-3.html">Template popover with inline input</button>
				<button class="btn" style="margin-top: 3px;" qstrap.popover template="popover-demo-4.html">Template popover with a button</button>
			</div>
		</file>
		<file name="popover.js">
			angular.module('qstrap.popover').controller('DemoController', [
				'$scope',
				'$templateCache',
				function($scope, $templateCache) {
					$scope.content = 'Hey this is content for the popover';
					$scope.contentHTML = '<h1>h1</h1> <b>bold</b> <u>underline</u>';
					$scope.exampleItems = ['Dog', 'Cat', 'Buffalo'];
					$scope.name = 'Gunther';
					$scope.food = 'yogurt';
					$scope.onOpenCallback = function() {
						alert('On Open');
					};
					$scope.onCloseCallback = function() {
						alert('On Close');
					};
					$templateCache.put('popover-demo-1.html', '' +
						'<div class="popover">' +
							'<div class="arrow"></div>' +
							'<div class="popover-content">' +
								'Here is a templated popover with a menu:' +
								'<br />' +
								'<button class="btn btn-select" qstrap.select-menu items="exampleItems" ng-model="selected">{{exampleItems[selected] || "Click me..."}}<span class="caret"></span></button>' +
								'<div ng-if="selected==2">Adding some height!</div>' +
							'</div>' +
						'</div>'
					);
					$templateCache.put('popover-demo-2.html', '' +
						'<div class="popover">' +
							'<div class="arrow"></div>' +
							'<div class="popover-content">' +
								'Here is a templated popover with a range slider:' +
								'<br />' +
								'<div qstrap.range-slider ' +
									'min-value="0" ' +
									'max-value="10" ' +
									'range-min="0" ' +
									'range-max="10" ' +
									'step="1"> ' +
								'</div>' +
							'</div>' +
						'</div>'
					);
					$templateCache.put('popover-demo-3.html', '' +
						'<div class="popover">' +
							'<div class="arrow"></div>' +
							'<div class="popover-content">' +
								'Here is a templated popover with inline input:' +
								'<br />' +
								'<div>' +
									'Hi, my name is <em qstrap.inline-input ng-model="name">{{name}}</em>' +
									' and I really like <em qstrap.inline-input ng-model="food">{{food}}</em>!' +
								'</div>' +
							'</div>' +
						'</div>'
					);
					$templateCache.put('popover-demo-4.html', '' +
						'<div class="popover">' +
							'<div class="arrow"></div>' +
							'<div class="popover-content">' +
								'Here is a templated popover with a button:' +
								'<br />' +
								'<button class="btn btn-sm btn-default">Default button</button>' +
							'</div>' +
						'</div>'
					);
				}
			]);
		</file>
	</example>
 */
(function(module) {
	'use strict';

	var DEFAULT_TEMPLATE = 'qstrap-popover.tpl.html';

	var removeEventHandlers;

	module.factory('qstrap.$popover', [
		'$document',
		'$templateCache',
		'$timeout',
		'qstrap.$tooltip',
		'qstrap.util',
		function(
			$document,
			$templateCache,
			$timeout,
			$tooltip,
			util
		) {
			
			$templateCache.put(DEFAULT_TEMPLATE, '' +
				'<div class="popover">' +
					'<div class="arrow"></div>' +
					'<div class="popover-content">{{content}}</div>' +
				'</div>'
			);

			/**
			 * This function creates a focus trap (i.e. a container that cannot be escaped with tab/shift+tab)
			 *
			 * @param {DOM element} trapContainerElement - The menu container (typically, tooltip)
			 * @param {function} onEscape - A function which is executed when the user presses the "Escape" key
			 */
			function createFocusTrap(trapContainerElement, onEscape) {
				var allFocusableElements;
				var firstFocusableElement;
				var lastFocusableElement;

				createEventHandlers();

				trapContainerElement.setAttribute('tabindex', -1);
				trapContainerElement.focus();

				function handleTrapContainerKeyDown(event) {
					if (allFocusableElements.length === 0 && event.keyCode === util.keys.TAB) {
						// no where to move focus; keep focus on container
						event.preventDefault();
					} else if (
						event.keyCode === util.keys.TAB &&
						event.shiftKey &&
						document.activeElement === trapContainerElement
					) {
						event.preventDefault();
						if (lastFocusableElement) {
							lastFocusableElement.focus();
						}
					} else if (event.keyCode === util.keys.ESCAPE) {
						onEscape();
					}
				}

				/**
				 * Moves focus back to the last focusable element in the event of a shift+tab.
				 * In effect causing the focus to wrap, resulting in the focus being locked in the popover
				 */
				function handleFirstFocusableElementKeyDown(event) {
					if (event.keyCode === util.keys.TAB && event.shiftKey) {
						event.stopPropagation();
						event.preventDefault();
						trapContainerElement.focus();
					}
				}

				/**
				 * Moves focus to the first focusable element in the event of a tab event.
				 * In effect causing the focus to wrap, resulting in the focus being locked in the popover
				 */
				function handleLastFocusableElementKeyDown(event) {
					if (event.keyCode === util.keys.TAB && !event.shiftKey) {
						event.stopPropagation();
						event.preventDefault();
						trapContainerElement.focus();
					}
				}

				/**
				 * In the event that manipulating an element in the popover causes the number of focusable
				 * elements to change, we need to handle that (i.e. a checkbox makes more buttons appear)
				 */
				function handleDOMChange() {
					$timeout(function() {
						var newFocusableElements = trapContainerElement.querySelectorAll(util.focusableSelector);
						if (newFocusableElements.length !== allFocusableElements.length) {
							removeEventHandlers();
							createEventHandlers();
						}
					});
				}


				function createEventHandlers() {
					allFocusableElements = trapContainerElement.querySelectorAll(util.focusableSelector);
					firstFocusableElement = allFocusableElements[0];
					lastFocusableElement = allFocusableElements[allFocusableElements.length - 1];

					trapContainerElement.addEventListener('keydown', handleTrapContainerKeyDown);
					trapContainerElement.addEventListener('keyup', handleDOMChange);
					if (firstFocusableElement) {
						firstFocusableElement.addEventListener('keydown', handleFirstFocusableElementKeyDown);
					}
					if (lastFocusableElement) {
						lastFocusableElement.addEventListener('keydown', handleLastFocusableElementKeyDown);
					}
				}


				function removeEventHandlers() {
					trapContainerElement.removeEventListener('keydown', handleTrapContainerKeyDown);
					trapContainerElement.removeEventListener('keyup', handleDOMChange);
					if (firstFocusableElement) {
						firstFocusableElement.removeEventListener('keydown', handleFirstFocusableElementKeyDown);
					}
					if (lastFocusableElement) {
						lastFocusableElement.removeEventListener('keydown', handleLastFocusableElementKeyDown);
					}
				}

				return removeEventHandlers;
			}

			// we only ever allow one popover
			var visiblePopover;
			function show(popover) {
				// it's already visible
				if (popover === visiblePopover) {
					return;
				}

				// hide the other one
				hide();

				//show the new one
				if (popover && popover.options && popover.options.onOpen) {
					popover.options.onOpen();
				}
				popover.show().then(function (tooltip) {
					$(tooltip).on('mousedown touchstart', stopPropagation);

					function onEscape() {
						hide();
						popover.options.anchor.focus();
					}

					removeEventHandlers = createFocusTrap(tooltip.get(0), onEscape);
				});

				visiblePopover = popover;
				$(visiblePopover.options.anchor).addClass('active');
				$(visiblePopover.options.anchor).on('mousedown touchstart', stopPropagation);
				// close the popover if a mousedown event occors outside of it
				$($document).on('mousedown touchstart', hide);
			}

			function hide() {
				if (visiblePopover && visiblePopover.tooltip) {
					// call blur handlers for focused element within the tooltip
					// otherwise bs-datepicker in IE9 doesn't get cleaned u
					visiblePopover.tooltip.find(':focus').blur();
					var vis = visiblePopover;
					visiblePopover = null;

					if (vis.options.onClose) {
						vis.options.onClose();
					}

					$timeout(function() {
						vis.hide();
						$(vis.options.anchor).removeClass('active');
						$(vis.options.anchor).focus();
					});
				}

				$($document).off('mousedown touchstart', hide);
				if (typeof removeEventHandlers === 'function') {
					removeEventHandlers();
				}
			}

			function stopPropagation(evt) {
				if (evt && evt.stopImmediatePropagation) {
					evt.stopImmediatePropagation();
				}
			}

			return function(options) {
				if (!options.template) {
					options.template = DEFAULT_TEMPLATE;
				}
				options.adjustHeight = true;
				var popover = $tooltip(options);
				popover.close = hide;

				if (options.anchor) {
					$(options.anchor).on('mousedown keydown', function (event) {
						stopPropagation(event);
						if (
							event.type === 'mousedown' ||
							event.keyCode === util.keys.SPACE ||
							event.keyCode === util.keys.ENTER
						) {
							// toggle functionality
							if (visiblePopover === popover) {
								hide();
							} else {
								show(popover);
							}
						}
					});
				}

				return popover;
			};
		}
	]);

	module.directive('qstrap.popover', [
		'qstrap.$popover',
		'$parse',
		function($popover, $parse) {
			return {
				restrict: 'A',
				link: function ($scope, element, attr) {
					var options = {
						html: attr.html,
						content: attr.content,
						position: attr.position,
						template: attr.template || DEFAULT_TEMPLATE,
						controller: attr.controller,
						anchor: element,
						className: attr.className || '',
						scope: $scope
					};

					options.onClose = function() {
						if(attr.onClose) {
							$parse(attr.onClose)($scope);
						}
					};

					options.onOpen = function() {
						if (attr.onOpen) {
							$parse(attr.onOpen)($scope);
						}
					};

					var popover = $popover(options);
					
					element.data('qstrap.popover', popover);

					var watchers = [
						// position and templates
						$scope.$watch(function () { return attr.position + '' + attr.template; }, function () {
							options.position = attr.position || options.position;
							options.template = attr.template || options.template;
							popover.build();
						}),
						//content
						$scope.$watch(function () { return attr.content; }, function () {
							popover.updateContent(attr.content);
						})
					];

					element.on('$destroy', function() {
						if ($scope) {
							for(var i = watchers.length; i--;) {
								watchers[i]();
							}
							watchers = null;
							$scope.$destroy();
							$scope = null;
							popover.destroy();
						}
					});
				}
			};
		}
	]);
})(angular.module('qstrap.popover', ['qstrap.tooltip', 'qstrap.util']));

/*
 * A positioning service that will place elements intelligently on the page relative to an anchor.
 */
(function(module) {
	'use strict';

	/*
	 * The position class will position elements absolutely on the page.
	 */
	module.factory('qstrap.$position', [
		'$window',
		'$document',
		function ($window, $document) {

			var verticalPositioners = {
				// anchor.top - element.height
				top: function positionTop(elDims, anchorDims, anchorOffset) {
					return anchorOffset.top - elDims.height;
				},
				// anchor.top + anchor.height / 2 - element.height / 2
				center: function positionMiddle(elDims, anchorDims, anchorOffset) {
					return anchorOffset.top + (anchorDims.height / 2) - (elDims.height / 2);
				},
				// anchor.top + anchor.height
				bottom: function positionBottom(elDims, anchorDims, anchorOffset) {
					return anchorOffset.top + anchorDims.height;
				}
			};

			var horizontalPositioners = {
				// anchor.left - element.width
				left: function positionLeft(elDims, anchorDims, anchorOffset) {
					return anchorOffset.left - elDims.width;
				},
				// anchor.left + anchor.width / 2 - element.width / 2
				center: function positionCenter(elDims, anchorDims, anchorOffset) {
					return anchorOffset.left + (anchorDims.width / 2) - (elDims.width / 2);
				},
				// anchor.left + anchor.width
				right: function positionRight(elDims, anchorDims, anchorOffset) {
					return anchorOffset.left + anchorDims.width;
				}
			};

			// returns the dimensions of an element
			function getDimensions(el) {
				return {
					width: el.outerWidth() || +(el.attr('width') || '0'),
					height: el.outerHeight() || +(el.attr('height') || '0')
				};
			}

			function getOffest(el) {
				el.offset();
			}

			// if it is rendering above, but it will be off screen, and there is more room below
			// or if it is rendering below, but it will be off screen, and there is more room above
			function shouldReflectTop(dir, elDims, anchor) {
				// if it is center or something else, then don't even try
				if (dir !== 'top' && dir !== 'bottom') {
					return false;
				}
				var anchorOffset = $(anchor)[0].getBoundingClientRect(),
					spaceAbove = anchorOffset.top,
					spaceBelow = $($window).innerHeight() - anchorOffset.bottom;

				// if we are rendering above, and there is more space below
				return (dir === 'top' && spaceAbove < elDims.height && spaceBelow > spaceAbove) ||
					// we are rendering below, and there is more space above
					(dir === 'bottom' && spaceBelow < elDims.height && spaceAbove > spaceBelow);
			}

			function shouldReflectLeft(dir, elDims, anchor) {
				// if it is center or something else then don't even try
				if (dir !== 'left' && dir !== 'right') {
					return false;
				}

				var anchorOffset = $(anchor)[0].getBoundingClientRect(),
					spaceLeft = anchorOffset.left,
					spaceRight = $($window).innerWidth() - anchorOffset.right;

				// if we are rendering left, and there is more space right
				return (dir === 'left' && spaceLeft < elDims.width && spaceRight > spaceLeft) ||
					// we are rendering right, and there is more space left
					(dir === 'right' && spaceRight < elDims.width && spaceLeft > spaceRight);
			}

			/*
			 * Scoots the element up / down into the viewable area of the page, and returns the difference it moved
			 */
			function adjustTop(el) {
				el = $(el);
				// these are relative to the viewport
				var elOffset = el[0].getBoundingClientRect();

				var topDiff = Math.min(elOffset.top, 0) || Math.max(elOffset.bottom - $($window).innerHeight(), 0);
				if (topDiff) {
					var top = el[0].offsetTop;
					if (top - topDiff < 0) {
						topDiff = topDiff - (0 - (top - topDiff));
					}
					el.css('top', (top - topDiff) + 'px');
				}
				return -topDiff;
			}

			/*
			 * Scoots the elemeent left / right into the viewable area of the page, and returns the difference that it moved
			 */
			function adjustLeft(el) {
				el = $(el);
				// these are relative to the viewport
				var elOffset = el[0].getBoundingClientRect(),
					leftDiff = Math.min(elOffset.left, 0) || Math.max(elOffset.right - $($window).innerWidth(), 0);

				if (leftDiff) {
					var left = el[0].offsetLeft;
					el.css('left', (left - leftDiff) + 'px');
				}
				return -leftDiff;
			}

			// shrink it if it is off the page to the bottom
			function adjustHeight(el, elDims) {
				el = $(el);
				var elOffset = el[0].getBoundingClientRect();
				var diff = Math.max(0, elOffset.bottom - $($window).innerHeight());
				if (diff) {
					el.css("max-height", elDims.height - diff + 'px');
				}
				return diff;
			}

			function callback(func) {
				if (typeof func === 'function') {
					func.apply(null, Array.prototype.slice.call(arguments, 1));
				}
			}

			/*
				var options = {
					element: '', // the element to position. Must be attached to the body, and will assume an absolute position
					position: 'left top', //'left center', 'left bottom', 'right top', 'right center', 'right bottom', 'center top', 'center center', 'center bottom',
					anchor: '', // the element to anchor to. If none is specified, it will position the element relative to the window
					autoMirror: false, // if true, it will reflect the element both horizontally, or vertically if there is more room in the view window on the other side
					autoAdjustHorizontal: false, // if true, it will try to move the element horizontally back into the viewable area
					autoAdjustVertical: false, // if true, it will try to move the element vertically back into the viewable area
					adjustHeight: true // if false, it will not modify the element's max-width and max-height properties
				};
			*/
			function position(options) {
				var el = $(options.element);

				//clear any previous positions to get an unbiased size
				el.css({ top: 0, left: 0, 'max-height': 'none'});

				var anchor = $(options.anchor),
					elDims = getDimensions(el),
					anchorDims = getDimensions(anchor),
					anchorOffset = anchor.offset();

				el.css({
					'min-width': elDims.width + 'px',
					'min-height': elDims.height + 'px'
				});

				var pos = options.position.split(" "),
					vert = pos[0] || 'top',
					horiz = pos[1] || 'center',
					reflectRule = options.autoReflect,
					adjustRule = options.autoAdjust;

				if (reflectRule) {
					// we can reflect left because reflectRule is truthy and not specifically 'top'
					if (reflectRule !== 'top' && shouldReflectLeft(horiz, elDims, anchor)) {
						horiz = horiz === 'left' ?  'right' : 'left';
						callback(options.onReflectLeft, horiz);
					}
					// we can reflect top because reflectRule is truthy and not specifically 'left'
					if (reflectRule !== 'left' && shouldReflectTop(vert, elDims, anchor)) {
						vert = vert === 'top' ?  'bottom' : 'top';

						callback(options.onReflectTop, vert);
					}
				}

				var top = (verticalPositioners[vert] || verticalPositioners.top)(elDims, anchorDims, anchorOffset),
					left = (horizontalPositioners[horiz] || horizontalPositioners.center)(elDims, anchorDims, anchorOffset);

				el.css({
					top: top + 'px',
					left: left + 'px'
				});

				// check the position of the element to make sure it isn't off the screen
				if (adjustRule) {
					// we can adjust left because it is truthy and not specifically "top"
					if (adjustRule !== 'top') {
						var ldiff = adjustLeft(el);
						if (ldiff) {
							callback(options.onAdjustLeft, ldiff);
						}
					}
					// we can adjust top because it is truthy and not specifically "left"
					if (adjustRule !== 'left') {
						var tdiff = adjustTop(el);
						if (tdiff) {
							callback(options.onAdjustTop, tdiff);
						}
					}
				}

				// check the size of the element, if it is bigger than the screen, shrink it down
				if (options.adjustHeight !== false) {
					var diff = adjustHeight(el, elDims);
					if (diff) {
						callback(options.onAdjustHeight, diff);
					}
				}

				el.css({
					'min-width': 0,
					'min-height': 0
				});
			}

			return position;
		}
	]);
})(angular.module('qstrap.position', []));

/**
 * @ngdoc overview
 * @name qstrap
 *
 * @description
 * QStrap is a library of common components used in Qualtrics Products.
 * These components adhere to our styleguide conventions and will facilitate development.
 */
angular.module('qstrap', [
	'qstrap.autoComplete',
	'qstrap.translate',
	'qstrap.colorpicker',
	'qstrap.inputs',
	'qstrap.menu',
	'qstrap.pagination',
	'qstrap.paginationControls',
	'qstrap.rangeSlider',
	'qstrap.slider',
	'qstrap.selectMenu',
	'qstrap.sortable',
	'qstrap.spinner',
	'qstrap.spin',
	'qstrap.switch',
	'qstrap.inlineInput',
	'qstrap.tabs',
	'qstrap.tooltip',
	'qstrap.modal',
	'qstrap.placeholder',
	'qstrap.popover',
	'qstrap.position',
	'qstrap.weekday'
]);

if (typeof window !== 'undefined' && !window.keyboardUserListenersAdded) {
    window.keyboardUserListenersAdded = true;
    document.addEventListener('mousedown', function() {
        document.body.classList.remove('keyboard-user');
    });
    document.addEventListener('keydown', function(e) {
        if (e.keyCode === 9) {
            document.body.classList.add('keyboard-user');
        }
    });
}

/**
 * @ngdoc interface
 * @name qstrap:qstrap.open-sans-fonts
 *
 * @restrict C
 * @description
 * Open Sans font. Note: to override the default Qualtrics Grotesque font you will need to aggresively target each element using `*`
 *
 * @example
<example module="qstrap">
  <file name="open-sans-fonts.html">
    <style>
      .qstrap-qstrap-open-sans-fonts-page,
      .qstrap-qstrap-open-sans-fonts-page * {
        font-family: 'Open Sans';
      }
      .extra-light {
        font-weight: 100;
      }
      .thin {
        font-weight: 200;
      }
      .light {
        font-weight: 300;
      }
      .regular {
        font-weight: 400;
      }
      .semibold {
        font-weight: 500;
      }
      .bold {
        font-weight: 700;
      }
      .extra-bold {
        font-weight: 800;
      }
    </style>
    <h1>Open Sans</h1>
    <code>font-family: 'Open Sans';</code>
    <div>
      <h2>Extra Light</h2>
      <code>font-weight: 100;</code>
      <p class="extra-light">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Thin</h2>
      <code>font-weight: 200;</code>
      <p class="thin">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Light</h2>
      <code>font-weight: 300;</code>
      <p class="light">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Normal</h2>
      <code>font-weight: normal;</code>
      <code>font-weight: 400;</code>
      <p class="normal">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Semibold</h2>
      <code>font-weight: 500;</code>
      <p class="semibold">π π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    <div>
      <h2>Bold</h2>
      <code>font-weight: bold;</code>
      <code>font-weight: 600;</code>
      <code>font-weight: 700;</code>
      <p class="bold">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Extra Bold</h2>
      <code>font-weight: 800;</code>
      <p class="extra-bold">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
  </file>
</example>
*/

/**
 * @ngdoc interface
 * @name qstrap:qstrap.qualtrics-fonts
 *
 * @restrict C
 * @description
 * SAP 72 font.
 *
 * The font files can be found in the dist/fonts directory. The file names change automatically when the fonts are updated, so it's safe (and recommended) for your server to serve them with a long max-age in the Cache-Control header.
 * @example
<example module="qstrap">
  <file name="qualtrics-fonts.html">
    <style>
      .qstrap-qstrap-qualtrics-fonts-page {
        font-family: '72';
      }
      .light {
        font-weight: 300;
      }
      .regular {
        font-weight: 400;
      }
      .bold {
        font-weight: 700;
      }
    </style>
    <h1>72</h1>
    <code>font-family: '72';</code>
    <div>
      <h2>Light</h2>
      <code>font-weight: 300;</code>
      <p class="light">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Normal</h2>
      <code>font-weight: normal;</code>
      <p class="normal">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
    <div>
      <h2>Bold</h2>
      <code>font-weight: bold;</code>
      <code>font-weight: 700;</code>
      <p class="bold">π Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur scelerisque facilisis nisi, ut hendrerit tellus. Suspendisse non nunc velit. Phasellus sit amet vehicula nisi, ultrices auctor leo. Nulla facilisi. Nunc venenatis auctor quam in consectetur. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
    </div>
  </file>
</example>
*/

/**
 * @ngdoc directive
 * @name qstrap:qstrap.simpleTable
 *
 * @restrict C
 * @description
 * A set of CSS classes that you can add to make a very clean and mobile table
 *
 * @param {string} simple-table Base class that creates good spacing and colors that conform to the styleguide.
 * @param {string=} mobile Renders the table in a good format on moble. NOTE: each td must have a data-title attribute for this to work. This can also be added somewhere else up the dom tree
 * @param {string=} th.sorting Adds an arrow implying that you are sorting by that column. The text of the cell must be wrapped in a <span> tag.
 * @param {string=} th.reverse  Reverses the arrow when used in conjunction with the "sorting" class.
 * @param {string=} col-hover Makes the columns highlight when hovering over them
 * @param {string=} row-separators Adds a line between each row
 * @param {string=} col-separators Adds a line between each column
 *
 * @example
   <example module="qstrap">
     <file name="data-table.html">
       <style>
         .simple-table.response-table tbody td span {
           color: #737373;
         }
         .simple-table.response-table tbody td:last-child {
           font-weight: bold;
           font-size: 19px
         }
         .well.doc-example-live {
           background: none !important;
           border: none !important;
         }
       </style>
       <h1>class="simple-table"</h1>
       <table class="simple-table response-table">
         <thead>
           <tr>
             <th>Survey Name</th>
             <th>Status</th>
             <th>Last Modified</th>
             <th>Created</th>
             <th class="sorting reverse"><span>Responses</span></th>
           </tr>
         </thead>
         <tbody>
           <tr>
             <td>Company wide VOC</td>
             <td>Active</td>
             <td>Feb 21 2014 <span>8:41 AM</span></td>
             <td>Feb 21 2014 <span>8:41 AM</span></td>
             <td>27,469</td>
           </tr>
           <tr>
             <td>Two dollar Tuesday</td>
             <td>Active</td>
             <td>28 2014 <span>4:21 PM</span></td>
             <td>28 2014 <span>4:21 PM</span></td>
             <td>8,594</td>
           </tr>
           <tr>
             <td>Employee Satisfaction</td>
             <td>Active</td>
             <td>May 6, 2014 <span>12:34 PM</span></td>
             <td>May 6, 2014 <span>12:34 PM</span></td>
             <td>1,957</td>
           </tr>
           <tr>
             <td>Lunch Feedback</td>
             <td>Inctive</td>
             <td>Jan 8 2014 <span>12:07 PM</span></td>
             <td>Jan 8 2014 <span>12:07 PM</span></td>
             <td>1,200</td>
           </tr>
         </tbody>
       </table>
       <h1>class="simple-table row-separators col-separators col-hover"</h1>
       <table class="simple-table row-separators col-separators col-hover response-table">
         <thead>
           <tr>
             <th>Survey Name</th>
             <th>Status</th>
             <th>Last Modified</th>
             <th>Created</th>
             <th class="sorting reverse"><span>Responses</span></th>
           </tr>
         </thead>
         <tbody>
           <tr>
             <td>Company wide VOC</td>
             <td>Active</td>
             <td>Feb 21 2014 <span>8:41 AM</span></td>
             <td>Feb 21 2014 <span>8:41 AM</span></td>
             <td>27,469</td>
           </tr>
           <tr>
             <td>Two dollar Tuesday</td>
             <td>Active</td>
             <td>28 2014 <span>4:21 PM</span></td>
             <td>28 2014 <span>4:21 PM</span></td>
             <td>8,594</td>
           </tr>
           <tr>
             <td>Employee Satisfaction</td>
             <td>Active</td>
             <td>May 6, 2014 <span>12:34 PM</span></td>
             <td>May 6, 2014 <span>12:34 PM</span></td>
             <td>1,957</td>
           </tr>
           <tr>
             <td>Lunch Feedback</td>
             <td>Inctive</td>
             <td>Jan 8 2014 <span>12:07 PM</span></td>
             <td>Jan 8 2014 <span>12:07 PM</span></td>
             <td>1,200</td>
           </tr>
         </tbody>
       </table>
       <h1>class="simple-table mobile"</h1>
       <table class="simple-table mobile">
         <thead>
           <tr>
             <th>Survey Name</th>
             <th>Status</th>
             <th>Last Modified</th>
             <th>Created</th>
             <th class="sorting reverse"><span>Responses</span></th>
           </tr>
         </thead>
         <tbody>
           <tr>
             <td data-title="Survey Name">Company wide VOC</td>
             <td data-title="Status">Active</td>
             <td data-title="Last Modified">Feb 21 2014 <span>8:41 AM</span></td>
             <td data-title="Created">Feb 21 2014 <span>8:41 AM</span></td>
             <td data-title="Responses">27,469</td>
           </tr>
           <tr>
             <td data-title="Survey Name">Two dollar Tuesday</td>
             <td data-title="Status">Active</td>
             <td data-title="Last Modified">28 2014 <span>4:21 PM</span></td>
             <td data-title="Created">28 2014 <span>4:21 PM</span></td>
             <td data-title="Responses">8,594</td>
           </tr>
           <tr>
             <td data-title="Survey Name">Employee Satisfaction</td>
             <td data-title="Status">Active</td>
             <td data-title="Last Modified">May 6, 2014 <span>12:34 PM</span></td>
             <td data-title="Created">May 6, 2014 <span>12:34 PM</span></td>
             <td data-title="Responses">1,957</td>
           </tr>
           <tr>
             <td data-title="Survey Name">Lunch Feedback</td>
             <td data-title="Status">Inctive</td>
             <td data-title="Last Modified">Jan 8 2014 <span>12:07 PM</span></td>
             <td data-title="Created">Jan 8 2014 <span>12:07 PM</span></td>
             <td data-title="Responses">1,200</td>
           </tr>
         </tbody>
       </table>
       <h1>Single Column Simple Table</h1>
       <table class='simple-table'>
         <thead>
           <tr>
             <th>Survey Name</th>
           </tr>
         </thead>
         <tbody>
           <tr>
             <td data-title="Survey Name">Company wide VOC</td>
           </tr>
           <tr>
             <td data-title="Survey Name">Two dollar Tuesday</td>
           </tr>
           <tr>
             <td data-title="Survey Name">Employee Satisfaction</td>
           </tr>
           <tr>
             <td data-title="Survey Name">Lunch Feedback</td>
           </tr>
         </tbody>
       </table>
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name qstrap:qstrap.rangeSlider
 *
 * @restrict A
 * @description
 * A slider that slects a range
 *
 * @param {number} minValue Assignable angular expression to data-bind the min value to.
 * @param {number} maxValue Assignable angular expression to data-bind the max value to
 * @param {number} rangeMin The maximum value the range will go to (this can be changed with the range inputs)
 * @param {number} rangeMax The minimum value the range will go to (this can be changed with the range inputs)
 * @param {object=} localizedText NOTE: Probably shouldn't be used very often, see qstrap.qstrapTranslate. But if necessary, supplies the translated string for key rangeText. Uses `{min}` and `{max}` as placeholders. Default: `{min} to {max}`
 * @param {number=} step The value the slider increments by
 * @param {expression=} onChange Angular expression called with $min and $max. This is called before the the minValue and maxValue are assigned.
 * @param {expression=} afterChange Angular expression called with $min and $max. This is called after the the minValue and maxValue are assigned.
 * @param {expression=} formatter Angular expression called with $value which will return a string representation of the number to be displayed in the range tooltip.
 *
 * @example
   <example module="qstrap">
     <file name="rangeSlider.html">
       <style>
         .range-slider-demo .qslider {
           width: 200px;
         }
       </style>
       <div ng-controller="RangeSliderDemoCtrl" class='range-slider-demo'>
         <div class='form-group'>
           <label>Slider</label>
           <div qstrap.range-slider min-value='slider.min' max-value='slider.max' range-min='slider.rangeMin' range-max='slider.rangeMax'></div>
         </div>
         <div class='form-group'>
           <label>Formatter</label>
           <div qstrap.range-slider min-value='slider.min' max-value='slider.max' range-min='slider.rangeMin' range-max='slider.rangeMax' formatter='slider.format($value)'></div>
         </div>
         <div class='form-group'>
           <label>onChange: <em id='onChangeVal'></em></label>
           <div qstrap.range-slider min-value='slider.min' max-value='slider.max' range-min='slider.rangeMin' range-max='slider.rangeMax' on-change='slider.onChange("on")'></div>
         </div>
         <div class='form-group'>
           <label>afterChange: <em id='afterChangeVal'></em></label>
           <div qstrap.range-slider min-value='slider.min' max-value='slider.max' range-min='slider.rangeMin' range-max='slider.rangeMax' after-change='slider.onChange("after")'></div>
         </div>
         <div class='form-group'>
           <label>Localized Text</label>
           <div qstrap.range-slider min-value='slider.min' max-value='slider.max' range-min='slider.rangeMin' range-max='slider.rangeMax' localized-text='slider.localizedText'></div>
         </div>
       </div>
     </file>
     <file name="rangeSlider.js">
       angular.module('qstrap.rangeSlider').controller('RangeSliderDemoCtrl', ['$scope', function($scope) {
         $scope.slider = {
           min: 0,
           max: 100,
           rangeMin: 0,
           rangeMax: 100,
           format: function(val)
           {
             return '$' + val;
           },
           onChange: function(when)
           {
           	 $('#' + when + 'ChangeVal').html('min:' + $scope.slider.min + ' max:' + $scope.slider.max).fadeOut(100).fadeIn(100);
           },
           localizedText: {
             rangeText: 'Values between {min} and {max}'
           }
         };
       }]);
     </file>
   </example>
 */

/* global $ */
angular.module('qstrap.rangeSlider', ['qstrap.translate']).directive('qstrap.rangeSlider', ['$compile', '$filter', 'qstrap.util', function($compile, $filter, util)
{
	"use strict";
	return {
		template: "" +
			"<div aria-live='polite' aria-label='{{getSliderRangeAriaLabel()}}'class='qslider'>" +
				"<div class='track'>" +
					"<div class='fill' ng-style='getFillStyles()'></div>" +
					"<button role='slider' aria-valuemin='{{rangeMin}}' aria-valuemax='{{maxValue}}' aria-valuenow='{{minValue}}' aria-valuetext='{{getMinSliderAriaValueText()}}' class='btn round btn-min'><div class='tooltip-container'><div class='tooltip bottom'><div class='tooltip-arrow'></div><div class='tooltip-inner'>{{formatValue(minValue)}}</div></div></div></button>" +
					"<button role='slider' aria-valuemin='{{minValue}}' aria-valuemax='{{rangeMax}}' aria-valuenow='{{maxValue}}' aria-valuetext='{{getMaxSliderAriaValueText()}}' class='btn round btn-max'><div class='tooltip-container'><div class='tooltip bottom'><div class='tooltip-arrow'></div><div class='tooltip-inner'>{{formatValue(maxValue)}}</div></div></div></button>" +
				"</div>" +
				"<span class='description'>" +
				"</span>"+
			'</div>',
		replace: true,
		scope: {
			minValue: '=',
			maxValue: '=',
			rangeMin: '=',
			rangeMax: '=',
			localizedText: '=?',
			step: '@?',
			onChangeCallback: '&onChange',
			afterChangeCallback: '&afterChange',
			formatter: '&'
		},
		link: function($scope, $element, $attrs)
		{
			var minHtml = "<strong qstrap.inline-input ng-model='minValue' input-type='number' validate='validateRange($value, maxValue)' on-change='onChange($value, maxValue)' after-change='afterChange($value, maxValue)'>{{formatValue(minValue)}}</strong>";
			var maxHtml = "<strong qstrap.inline-input ng-model='maxValue' input-type='number' validate='validateRange(minValue, $value)' on-change='onChange(minValue, $value)' after-change='afterChange(minValue, $value)'>{{formatValue(maxValue)}}</strong>";

			var rangeText = ($scope.localizedText || {}).rangeText || $filter('qstrapTranslate')('RANGE_TEXT');
			rangeText = rangeText.replace('{min}', minHtml).replace('{max}', maxHtml);
			$element.find('.description').append($compile('<span>' + rangeText + '</span>')($scope));

			if ($scope.rangeMin === undefined)
				$scope.rangeMin = 0;

			if ($scope.rangeMax === undefined)
				$scope.rangeMax = 100;

			$scope.formatValue = function(val)
			{
				if ('formatter' in $attrs)
					return $scope.formatter({$value: val});

				return val;
			};

			var translateFilter = $filter('qstrapTranslate');
			$scope.getSliderRangeAriaLabel = function() {
				return translateFilter(
					'ACCESSIBLE_FILTER_LABELS.SELECTED_RANGE',
					{
						minValue: ($scope.minValue || $scope.minValue == 0) ? $scope.minValue : '',
						maxValue: ($scope.maxValue || $scope.maxValue == 0) ? $scope.maxValue : ''
					}
				);
			};

			$scope.getMinSliderAriaValueText = function() {
				return translateFilter(
					'ACCESSIBLE_FILTER_LABELS.MIN_RANGE_SLIDER_VAL',
					{
						val: ($scope.minValue || $scope.minValue == 0) ? $scope.minValue : ''
					}
				);
			};

			$scope.getMaxSliderAriaValueText = function() {
				return translateFilter(
					'ACCESSIBLE_FILTER_LABELS.MAX_RANGE_SLIDER_VAL',
					{
						val: ($scope.maxValue || $scope.maxValue == 0) ? $scope.maxValue : ''
					}
				);
			};

			$scope.validateRange = function(min, max)
			{
				//TODO: make an option where they can't modify the range
				updateRangeMin(min);
				updateRangeMax(max);
				return !(min > max || max < min || min < $scope.rangeMin || max > $scope.rangeMax);
			};

			$scope.onChange = function(min, max)
			{
				if ('onChange' in $attrs)
				{
					$scope.onChangeCallback({$min: min, $max: max});
				}
			};

			$scope.afterChange = function(min, max)
			{
				if ('afterChange' in $attrs)
				{
					$scope.afterChangeCallback({$min: min, $max: max});
				}	
			};

			$scope.getFillStyles = function() {
				return {
					left: getPointAtValue($scope.minValue) + 'px',
					right: track.width() - getPointAtValue($scope.maxValue) + 'px'
				};
			};

			var track = $element.find('.track'),
				fill = track.find('.fill'),
				minButton = track.find('.btn-min'),
				maxButton = track.find('.btn-max'),
				minBtnOffset = minButton.width() / 2,
				maxBtnOffset = maxButton.width() / 2,
				movingButton = null,
				updatedButton = false,
				applyTimeout = 0,
				boundApply = function()
				{
					$scope.onChange($scope.minValue, $scope.maxValue);
					$scope.$apply();
					$scope.afterChange($scope.minValue, $scope.maxValue);
				};

			track.mousedown(onTrackMousedown);
			fill.mousedown(onTrackMousedown);
			minButton.mousedown(onButtonMouseDown);
			maxButton.mousedown(onButtonMouseDown);
			$(minButton).bind('keydown',onButtonKeyDown);
			$(maxButton).bind('keydown',onButtonKeyDown);
			var allowedKeyEvents = [
				util.keys.LEFT_ARROW,
				util.keys.UP_ARROW,
				util.keys.RIGHT_ARROW,
				util.keys.DOWN_ARROW
			];

			whenVisible($element, updatePosition);
			$scope.$watch('[minValue, maxValue]', function()
			{
				if (updatedButton)
					updatedButton = false;
				else
					updatePosition();
			}, true);

			function getRangeVal()
			{
				return $scope.rangeMax - $scope.rangeMin;
			}

			function getValueAtPoint (posX)
			{
				var valueOnTrack = (posX / track.width()) * getRangeVal();
				return Math.round($scope.rangeMin + valueOnTrack);
			}

			function getPointAtValue(value)
			{
				var percentOfRange = (value - $scope.rangeMin) / getRangeVal();
				var positionOnTrack = percentOfRange * track.width();
				return positionOnTrack;
			}

			function getDiscreteValue(value)
			{
				var rangeMin = $scope.rangeMin,
					rangeMax = $scope.rangeMax,
					step = parseFloat($scope.step) || 1;

				if (value < rangeMin)
					value = rangeMin;
				else if (value > rangeMax)
					value = rangeMax;

				var mod = (value - rangeMin) % step;
				value += (mod > step / 2) ? (step - mod) : -mod;

				if (value > rangeMax)
					value -= step;

				return value;
			}

			function onTrackMousedown(e)
			{
				e.stopPropagation();
				var pt = e.pageX - track.offset().left,
					val = getValueAtPoint(pt),
					min = Math.abs($scope.minValue - val),
					max = Math.abs($scope.maxValue - val);

				//move whichever button is closer
				movingButton = max < min ? maxButton : minButton;
				updateButtonPos(pt);
				movingButton = null;
			}

			function onButtonKeyDown(event) {
				if (allowedKeyEvents.indexOf(event.keyCode) < 0) {
					return;
				}
				movingButton = $(event.target);
				var minValue = $scope.minValue;
				var maxValue = $scope.maxValue;
				
				if (movingButton.hasClass('btn-min')) {
					minValue = getUpdatedMinMax(event, minValue);
				}

				if (movingButton.hasClass('btn-max')) {
					maxValue = getUpdatedMinMax(event, maxValue);
				}

				if (validateInRange(minValue, maxValue)){
					var isValueUpdated = updateValue(movingButton.hasClass('btn-min') ? minValue : maxValue);
					if (isValueUpdated){
						event.stopPropagation();
						event.preventDefault();
					}
				}
			}

			function getUpdatedMinMax(event, val) {
				if (event.keyCode == util.keys.LEFT_ARROW || event.keyCode == util.keys.DOWN_ARROW){
					event.stopPropagation();
					event.preventDefault();
					return val -= 1;
				}
				else if(event.keyCode == util.keys.RIGHT_ARROW || event.keyCode == util.keys.UP_ARROW){
					event.stopPropagation();
					event.preventDefault();
					return val += 1;
				}
			}

			function validateInRange(minVal, maxVal) {
				var isValid = false;

				if (movingButton.hasClass('btn-min')) {
					isValid = minVal >= $scope.rangeMin && minVal < $scope.maxValue;
				} else {
					isValid = maxVal > $scope.minValue && maxVal <= $scope.rangeMax;
				}

				return isValid;
			}

			function onButtonMouseDown(e)
			{
				e.stopPropagation();
				movingButton = $(e.target);
				$(document).bind('mouseup', onMouseup);
				$(document).bind('mousemove', onMousemove);
			}

			function onMouseup(e)
			{
				$(document).unbind('mouseup', onMouseup);
				$(document).unbind('mousemove', onMousemove);
				movingButton = null;
			}

			function onMousemove(e)
			{
				updateButtonPos(e.pageX - track.offset().left);
			}

			function updateButtonPos(pt)
			{
				if (!movingButton)
					return;

				//the max button can never be biger than the min button
				if (movingButton.hasClass('btn-min'))
					pt = Math.min(pt, parseFloat(maxButton.css('left')) + maxBtnOffset);
				else
					pt = Math.max(pt, parseFloat(minButton.css('left')) + minBtnOffset);

				pt = Math.min(Math.max(0, pt), track.width());

				var val = getValueAtPoint(pt);
				val = getDiscreteValue(val);
				if (updateValue(val))
				{
					pt = getPointAtValue(val);
					movingButton.css('left', pt - movingButton.width() / 2 + 'px');

					updatedButton = true;
				}
			}

			function updateValue(val)
			{
				if (!movingButton)
					return false;

				if (movingButton.hasClass('btn-min'))
				{
					if ($scope.minValue === val)
						return false;

					$scope.minValue = val;
				}
				else
				{
					if ($scope.maxValue === val)
						return false;

					$scope.maxValue = val;
				}

				clearTimeout(applyTimeout);
				applyTimeout = setTimeout(boundApply, 10);

				return true;
			}

			function updatePosition()
			{
				var recalcValMinBtnOffset = minButton.width() / 2;
				var recalcValMaxBtnOffset = maxButton.width() / 2;

				minButton.css({
					left: getPointAtValue(+$scope.minValue) - recalcValMinBtnOffset + 'px',
					top: -1 * recalcValMinBtnOffset + 'px'
				});
				maxButton.css({
					left: getPointAtValue(+$scope.maxValue) - recalcValMaxBtnOffset + 'px',
					top: -1 * recalcValMaxBtnOffset + 'px'
				});
			}

			function whenVisible(el, func)
			{
				if (el.is(':visible'))
				{
					func();
				}
				else
				{
					var watcher = $scope.$watch(function() {
						if (el.is(':visible'))
						{
							func();
							watcher();
						}
					});
				}
			}

			var originalMin = $scope.rangeMin;
			function updateRangeMin(min)
			{
				min = parseFloat(min);

				if (min < originalMin)
					$scope.rangeMin = min;
				else if ($scope.rangeMin !== originalMin)
					$scope.rangeMin = originalMin;
			}
			
			var originalMax = $scope.rangeMax;
			function updateRangeMax(max)
			{
				max = parseFloat(max);

				if (max > originalMax)
					$scope.rangeMax = max;
				else if ($scope.rangeMax !== originalMax)
					$scope.rangeMax = originalMax;
					
			}
		}
	};
}]);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.slider
 *
 * @restrict A
 * @description
 * A slider that selects a single value from within a range
 *
 * @param {number} value Assignable angular expression to data-bind the value to.
 * @param {number=} rangeMin The maximum value the range will go to (this can be changed with the range inputs)
 * @param {number=} rangeMax The minimum value the range will go to (this can be changed with the range inputs)
 * @param {number=} step The value the slider increments by
 * @param {expression=} onChange Angular expression called with $min and $max. This is called before the the value is assigned.
 * @param {expression=} afterChange Angular expression called with $min and $max. This is called after the the value is assigned.
 * @param {expression=} formatter Angular expression called with $value which will return a string representation of the number to be displayed in the range tooltip.
 *
 * @example
    <example module="qstrap">
    <file name="slider.css">
        .slider-demo .qslider {
          width: 200px;
        }
        .displayVal {
		  float: right;
        }
        .label-cont {
		  display: inline-block;
		  min-width: 13.5em;
        }
    </file>
    <file name="slider.html">
        <div ng-controller="SliderDemoCtrl" class="slider-demo">
            <div class="form-group">
            	<span class="label-cont">
	                <label>Slider</label>
	                <em class="displayVal">{{slider.value1}}</em>
                </span>
                <div qstrap.slider value="slider.value1" range-min="slider.bottom" range-max="slider.top"></div>
            </div>
            <div class="form-group">
            	<span class="label-cont">
	                <label>Stepped</label>
	                <em class="displayVal">{{slider.value2}}</em>
                </span>
                <div qstrap.slider value="slider.value2" step=10 range-min="slider.bottom" range-max="slider.top"></div>
            </div>
            <div class="form-group">
            	<span class="label-cont">
	                <label>Formatter</label>
	                <em class="displayVal">{{slider.value3}}</em>
                </span>
                <div qstrap.slider value="slider.value3" range-min="slider.rangeMin" range-max="slider.rangeMax" formatter="slider.format($value)"></div>
            </div>
            <div class="form-group">
                <label>onChange: <em id="onChange"></em></label>
                <div qstrap.slider value="slider.value3" range-min="slider.rangeMin" range-max="slider.rangeMax" on-change="slider.onChange('on')"></div>
            </div>
            <div class="form-group">
                <label>afterChange: <em id="afterChange"></em></label>
                <div qstrap.slider value="slider.value3" range-min="slider.rangeMin" range-max="slider.rangeMax" after-change="slider.onChange('after')"></div>
            </div>
        </div>
    </file>
    <file name="slider.js">
    angular.module('qstrap.slider').controller('SliderDemoCtrl', function($scope)
    {
        $scope.slider = {
            value1: 50,
            value2: 10,
            value3: 32,
            rangeMin: 0,
            rangeMax: 100,
            top: 60,
            botton: 10,
            format: function(val)
            {
                return '$' + val;
            },
            onChange: function(when)
            {
                $('#' + when + 'Change').html('value: '+$scope.slider.value3).fadeOut(100).fadeIn(100);
            }
        };
    });
    </file>
    </example>
 */
angular.module('qstrap.slider', []).directive('qstrap.slider', [function()
{
	"use strict";
	return {
		template: "" +
			"<div class='qslider'>" +
				"<div class='track'>" +
					"<button class='btn round btn-val'>" +
						"<div class='tooltip-container'>" +
							"<div class='tooltip bottom'>" +
								"<div class='tooltip-arrow'></div>" +
								"<div class='tooltip-inner'>{{formatValue(value)}}</div>" +
							"</div>" +
						"</div>" +
					"</button>" +
				"</div>" +
			'</div>',
		replace: true,
		scope:
		{
			value: '=',
			rangeMin: '=?',
			rangeMax: '=?',
			step: '@',
			onChangeCallback: '&onChange',
			afterChangeCallback: '&afterChange',
			formatter: '&'
		},
		link: function($scope, $element, $attrs)
		{
			if ($scope.rangeMin === undefined)
				$scope.rangeMin = 0;

			if ($scope.rangeMax === undefined)
				$scope.rangeMax = 100;

			if ($scope.step !== undefined && $scope.step < 1)
				$scope.step = 1;

			$scope.formatValue = function(val)
			{
				if ('formatter' in $attrs)
					return $scope.formatter(
					{
						$value: val
					});

				return val;
			};

			$scope.onChange = function(value)
			{
				if ('onChange' in $attrs)
				{
					$scope.onChangeCallback(
					{
						$value: value
					});
				}
			};

			$scope.afterChange = function(value)
			{
				if ('afterChange' in $attrs)
				{
					$scope.afterChangeCallback(
					{
						$value: value
					});
				}
			};

			var track = $element.find('.track'),
				valButton = track.find('.btn-val'),
				valBtnOffset = valButton.width() / 2,
				movingButton = null,
				applyTimeout = 0,
				boundApply = function()
				{
					$scope.onChange($scope.value);
					$scope.$apply();
					$scope.afterChange($scope.value);
				};

			track.mousedown(onTrackMousedown);
			valButton.mousedown(onButtonMouseDown);

			whenVisible($element, updatePosition);
			$scope.$watch('value', function()
			{
				var temp = getDiscreteValue($scope.value);
				if (temp != $scope.value)
				{
					$scope.value = temp;
				}
				else
				{
					updatePosition();
				}
			}, true);

			function getRangeVal()
			{
				return $scope.rangeMax - $scope.rangeMin;
			}

			//Returns the value corresponding to the pixel position
			//on the track (float)
			function getValueAtPoint(posX)
			{
				var valueOnTrack = (posX / track.width()) * getRangeVal();
				return Math.round($scope.rangeMin + valueOnTrack);
			}

			//Returns the pixel point corresponding to a value
			//on the track (float), with respect to rangeMin.
			function getPointAtValue(value)
			{
				var percentOfRange = (value - $scope.rangeMin) / getRangeVal();
				var positionOnTrack = percentOfRange * track.width();
				return positionOnTrack;
			}

			//Returns the value (pos on track) modded by the step.
			function getDiscreteValue(value)
			{
				var rangeMin = $scope.rangeMin,
					rangeMax = $scope.rangeMax,
					step = parseFloat($scope.step) || 1;

				if (value < rangeMin)
					value = rangeMin;
				else if (value > rangeMax)
					value = rangeMax;

				var mod = (value - rangeMin) % step;
				value += (mod > step / 2) ? (step - mod) : -mod;

				if (value > rangeMax)
					value -= step;

				return value;
			}

			function onTrackMousedown(e)
			{
				e.stopPropagation();
				var pt = e.pageX - track.offset().left, //pt on track
					val = getValueAtPoint(pt); //the cooresponding value of that point

				movingButton = valButton;
				updateButtonPos(pt);
				movingButton = null;
			}


			function onButtonMouseDown(e)
			{
				e.stopPropagation();
				movingButton = $(e.target);
				$(document).bind('mouseup', onMouseup);
				$(document).bind('mousemove', onMousemove);
			}

			function onMouseup(e)
			{
				$(document).unbind('mouseup', onMouseup);
				$(document).unbind('mousemove', onMousemove);
				movingButton = null;
			}

			function onMousemove(e)
			{
				updateButtonPos(e.pageX - track.offset().left);
			}

			function updateButtonPos(pt)
			{
				if (!movingButton)
					return;

				pt = Math.min(Math.max(0, pt), track.width());

				var val = getValueAtPoint(pt);
				val = getDiscreteValue(val);
				if (updateValue(val))
				{
					pt = getPointAtValue(val);
					movingButton.css('left', pt - movingButton.width() / 2 + 'px');
				}
			}

			function updateValue(val)
			{
				if ($scope.value === val)
				{
					return false;
				}

				$scope.value = val;
				clearTimeout(applyTimeout);
				applyTimeout = setTimeout(boundApply, 10);

				return true;
			}

			function updatePosition()
			{
				var recalcValBtnOffset = valButton.width() / 2;
				valButton.css(
				{
					left: getPointAtValue(+$scope.value) - recalcValBtnOffset + 'px',
					top: -1 * recalcValBtnOffset + 'px'
				});
			}

			function whenVisible(el, func)
			{
				if (el.is(':visible'))
				{
					func();
				}
				else
				{
					var watcher = $scope.$watch(function()
					{
						if (el.is(':visible'))
						{
							func();
							watcher();
						}
					});
				}
			}
		}
	};
}]);
/*
 jQuery UI Sortable plugin wrapper

 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
 */
/*! jQuery UI - v1.12.1 - 2017-12-12
* http://jqueryui.com
* Includes: widget.js, data.js, scroll-parent.js, widgets/sortable.js, widgets/mouse.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

/* jshint ignore:start */
(function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)})(function(t){t.ui=t.ui||{},t.ui.version="1.12.1";var e=0,i=Array.prototype.slice;t.cleanData=function(e){return function(i){var s,n,o;for(o=0;null!=(n=i[o]);o++)try{s=t._data(n,"events"),s&&s.remove&&t(n).triggerHandler("remove")}catch(a){}e(i)}}(t.cleanData),t.widget=function(e,i,s){var n,o,a,r={},l=e.split(".")[0];e=e.split(".")[1];var h=l+"-"+e;return s||(s=i,i=t.Widget),t.isArray(s)&&(s=t.extend.apply(null,[{}].concat(s))),t.expr[":"][h.toLowerCase()]=function(e){return!!t.data(e,h)},t[l]=t[l]||{},n=t[l][e],o=t[l][e]=function(t,e){return this._createWidget?(arguments.length&&this._createWidget(t,e),void 0):new o(t,e)},t.extend(o,n,{version:s.version,_proto:t.extend({},s),_childConstructors:[]}),a=new i,a.options=t.widget.extend({},a.options),t.each(s,function(e,s){return t.isFunction(s)?(r[e]=function(){function t(){return i.prototype[e].apply(this,arguments)}function n(t){return i.prototype[e].apply(this,t)}return function(){var e,i=this._super,o=this._superApply;return this._super=t,this._superApply=n,e=s.apply(this,arguments),this._super=i,this._superApply=o,e}}(),void 0):(r[e]=s,void 0)}),o.prototype=t.widget.extend(a,{widgetEventPrefix:n?a.widgetEventPrefix||e:e},r,{constructor:o,namespace:l,widgetName:e,widgetFullName:h}),n?(t.each(n._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete n._childConstructors):i._childConstructors.push(o),t.widget.bridge(e,o),o},t.widget.extend=function(e){for(var s,n,o=i.call(arguments,1),a=0,r=o.length;r>a;a++)for(s in o[a])n=o[a][s],o[a].hasOwnProperty(s)&&void 0!==n&&(e[s]=t.isPlainObject(n)?t.isPlainObject(e[s])?t.widget.extend({},e[s],n):t.widget.extend({},n):n);return e},t.widget.bridge=function(e,s){var n=s.prototype.widgetFullName||e;t.fn[e]=function(o){var a="string"==typeof o,r=i.call(arguments,1),l=this;return a?this.length||"instance"!==o?this.each(function(){var i,s=t.data(this,n);return"instance"===o?(l=s,!1):s?t.isFunction(s[o])&&"_"!==o.charAt(0)?(i=s[o].apply(s,r),i!==s&&void 0!==i?(l=i&&i.jquery?l.pushStack(i.get()):i,!1):void 0):t.error("no such method '"+o+"' for "+e+" widget instance"):t.error("cannot call methods on "+e+" prior to initialization; "+"attempted to call method '"+o+"'")}):l=void 0:(r.length&&(o=t.widget.extend.apply(null,[o].concat(r))),this.each(function(){var e=t.data(this,n);e?(e.option(o||{}),e._init&&e._init()):t.data(this,n,new s(o,this))})),l}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(i,s){s=t(s||this.defaultElement||this)[0],this.element=t(s),this.uuid=e++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=t(),this.hoverable=t(),this.focusable=t(),this.classesElementLookup={},s!==this&&(t.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===s&&this.destroy()}}),this.document=t(s.style?s.ownerDocument:s.document||s),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this.options=t.widget.extend({},this.options,this._getCreateOptions(),i),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){var e=this;this._destroy(),t.each(this.classesElementLookup,function(t,i){e._removeClass(i,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:t.noop,widget:function(){return this.element},option:function(e,i){var s,n,o,a=e;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof e)if(a={},s=e.split("."),e=s.shift(),s.length){for(n=a[e]=t.widget.extend({},this.options[e]),o=0;s.length-1>o;o++)n[s[o]]=n[s[o]]||{},n=n[s[o]];if(e=s.pop(),1===arguments.length)return void 0===n[e]?null:n[e];n[e]=i}else{if(1===arguments.length)return void 0===this.options[e]?null:this.options[e];a[e]=i}return this._setOptions(a),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(e){var i,s,n;for(i in e)n=this.classesElementLookup[i],e[i]!==this.options.classes[i]&&n&&n.length&&(s=t(n.get()),this._removeClass(n,i),s.addClass(this._classes({element:s,keys:i,classes:e,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(e){function i(i,o){var a,r;for(r=0;i.length>r;r++)a=n.classesElementLookup[i[r]]||t(),a=e.add?t(t.unique(a.get().concat(e.element.get()))):t(a.not(e.element).get()),n.classesElementLookup[i[r]]=a,s.push(i[r]),o&&e.classes[i[r]]&&s.push(e.classes[i[r]])}var s=[],n=this;return e=t.extend({element:this.element,classes:this.options.classes||{}},e),this._on(e.element,{remove:"_untrackClassesElement"}),e.keys&&i(e.keys.match(/\S+/g)||[],!0),e.extra&&i(e.extra.match(/\S+/g)||[]),s.join(" ")},_untrackClassesElement:function(e){var i=this;t.each(i.classesElementLookup,function(s,n){-1!==t.inArray(e.target,n)&&(i.classesElementLookup[s]=t(n.not(e.target).get()))})},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){s="boolean"==typeof s?s:i;var n="string"==typeof t||null===t,o={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s};return o.element.toggleClass(this._classes(o),s),this},_on:function(e,i,s){var n,o=this;"boolean"!=typeof e&&(s=i,i=e,e=!1),s?(i=n=t(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),t.each(s,function(s,a){function r(){return e||o.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof a?o[a]:a).apply(o,arguments):void 0}"string"!=typeof a&&(r.guid=a.guid=a.guid||r.guid||t.guid++);var l=s.match(/^([\w:-]*)\s*(.*)$/),h=l[1]+o.eventNamespace,c=l[2];c?n.on(h,c,r):i.on(h,r)})},_off:function(e,i){i=(i||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.off(i).off(i),this.bindings=t(this.bindings.not(e).get()),this.focusable=t(this.focusable.not(e).get()),this.hoverable=t(this.hoverable.not(e).get())},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){this._addClass(t(e.currentTarget),null,"ui-state-hover")},mouseleave:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){this._addClass(t(e.currentTarget),null,"ui-state-focus")},focusout:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}}),t.widget,t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])}}),t.fn.scrollParent=function(e){var i=this.css("position"),s="absolute"===i,n=e?/(auto|scroll|hidden)/:/(auto|scroll)/,o=this.parents().filter(function(){var e=t(this);return s&&"static"===e.css("position")?!1:n.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==i&&o.length?o:t(this[0].ownerDocument||document)},t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var s=!1;t(document).on("mouseup",function(){s=!1}),t.widget("ui.mouse",{version:"1.12.1",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(e){if(!s){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(e),this._mouseDownEvent=e;var i=this,n=1===e.which,o="string"==typeof this.options.cancel&&e.target.nodeName?t(e.target).closest(this.options.cancel).length:!1;return n&&!o&&this._mouseCapture(e)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(e)!==!1,!this._mouseStarted)?(e.preventDefault(),!0):(!0===t.data(e.target,this.widgetName+".preventClickEvent")&&t.removeData(e.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return i._mouseMove(t)},this._mouseUpDelegate=function(t){return i._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),e.preventDefault(),s=!0,!0)):!0}},_mouseMove:function(e){if(this._mouseMoved){if(t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button)return this._mouseUp(e);if(!e.which)if(e.originalEvent.altKey||e.originalEvent.ctrlKey||e.originalEvent.metaKey||e.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(e)}return(e.which||e.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,s=!1,e.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),t.widget("ui.sortable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return t>=e&&e+i>t},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){var e=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),t.each(this.items,function(){e._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(e,i){var s=null,n=!1,o=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,o.widgetName+"-item")===o?(s=t(this),!1):void 0}),t.data(e.target,o.widgetName+"-item")===o&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,o,a=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,a.cursorAt&&this._adjustOffsetFromHelper(a.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),a.containment&&this._setContainment(),a.cursor&&"auto"!==a.cursor&&(o=this.document.find("body"),this.storedCursor=o.css("cursor"),o.css("cursor",a.cursor),this.storedStylesheet=t("<style>*{ cursor: "+a.cursor+" !important; }</style>").appendTo(o)),a.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",a.opacity)),a.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",a.zIndex)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,o,a=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<a.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+a.scrollSpeed:e.pageY-this.overflowOffset.top<a.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-a.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<a.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+a.scrollSpeed:e.pageX-this.overflowOffset.left<a.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-a.scrollSpeed)):(e.pageY-this.document.scrollTop()<a.scrollSensitivity?r=this.document.scrollTop(this.document.scrollTop()-a.scrollSpeed):this.window.height()-(e.pageY-this.document.scrollTop())<a.scrollSensitivity&&(r=this.document.scrollTop(this.document.scrollTop()+a.scrollSpeed)),e.pageX-this.document.scrollLeft()<a.scrollSensitivity?r=this.document.scrollLeft(this.document.scrollLeft()-a.scrollSpeed):this.window.width()-(e.pageX-this.document.scrollLeft())<a.scrollSensitivity&&(r=this.document.scrollLeft(this.document.scrollLeft()+a.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],o=this._intersectsWithPointer(s),o&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===o?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===o?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),o=this.options.axis,a={};o&&"x"!==o||(a.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),o&&"y"!==o||(a.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(a,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp(new t.Event("mouseup",{target:null})),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+h>r&&l>s+h,d="y"===this.options.axis||e+c>o&&a>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>o&&a>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&l>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var e,i,s="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),n="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width),o=s&&n;return o?(e=this._getDragVerticalDirection(),i=this._getDragHorizontalDirection(),this.floating?"right"===i||"down"===e?2:1:e&&("down"===e?2:1)):!1},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),i=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),s=this._getDragVerticalDirection(),n=this._getDragHorizontalDirection();return this.floating&&n?"right"===n&&i||"left"===n&&!i:s&&("down"===s&&e||"up"===s&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){function i(){r.push(this)}var s,n,o,a,r=[],l=[],h=this._connectWith();if(h&&e)for(s=h.length-1;s>=0;s--)for(o=t(h[s],this.document[0]),n=o.length-1;n>=0;n--)a=t.data(o[n],this.widgetFullName),a&&a!==this&&!a.options.disabled&&l.push([t.isFunction(a.options.items)?a.options.items.call(a.element):t(a.options.items,a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),a]);for(l.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),s=l.length-1;s>=0;s--)l[s][0].each(i);return t(r)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,o,a,r,l,h,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i],this.document[0]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&(u.push([t.isFunction(o.options.items)?o.options.items.call(o.element[0],e,{item:this.currentItem}):t(o.options.items,o.element),o]),this.containers.push(o));for(i=u.length-1;i>=0;i--)for(a=u[i][1],r=u[i][0],s=0,h=r.length;h>s;s++)l=t(r[s]),l.data(this.widgetName+"-item",a),c.push({item:l,instance:a,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.floating=this.items.length?"x"===this.options.axis||this._isFloating(this.items[0].item):!1,this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,o;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),o=n.offset(),s.left=o.left,s.top=o.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)o=this.containers[i].element.offset(),this.containers[i].containerCache.left=o.left,this.containers[i].containerCache.top=o.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]);return e._addClass(n,"ui-sortable-placeholder",i||e.currentItem[0].className)._removeClass(n,"ui-sortable-helper"),"tbody"===s?e._createTrPlaceholder(e.currentItem.find("tr").eq(0),t("<tr>",e.document[0]).appendTo(n)):"tr"===s?e._createTrPlaceholder(e.currentItem,n):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_createTrPlaceholder:function(e,i){var s=this;e.children().each(function(){t("<td>&#160;</td>",s.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(i)})},_contactContainers:function(e){var i,s,n,o,a,r,l,h,c,u,d=null,p=null;for(i=this.containers.length-1;i>=0;i--)if(!t.contains(this.currentItem[0],this.containers[i].element[0]))if(this._intersectsWith(this.containers[i].containerCache)){if(d&&t.contains(this.containers[i].element[0],d.element[0]))continue;d=this.containers[i],p=i}else this.containers[i].containerCache.over&&(this.containers[i]._trigger("out",e,this._uiHash(this)),this.containers[i].containerCache.over=0);if(d)if(1===this.containers.length)this.containers[p].containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1);else{for(n=1e4,o=null,c=d.floating||this._isFloating(this.currentItem),a=c?"left":"top",r=c?"width":"height",u=c?"pageX":"pageY",s=this.items.length-1;s>=0;s--)t.contains(this.containers[p].element[0],this.items[s].item[0])&&this.items[s].item[0]!==this.currentItem[0]&&(l=this.items[s].item.offset()[a],h=!1,e[u]-l>this.items[s][r]/2&&(h=!0),n>Math.abs(e[u]-l)&&(n=Math.abs(e[u]-l),o=this.items[s],this.direction=h?"up":"down"));if(!o&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[p])return this.currentContainer.containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash()),this.currentContainer.containerCache.over=1),void 0;o?this._rearrange(e,o,null,!0):this._rearrange(e,null,this.containers[p].element,!0),this._trigger("change",e,this._uiHash()),this.containers[p]._trigger("change",e,this._uiHash(this)),this.currentContainer=this.containers[p],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===n.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===n.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())*s}
},_generatePosition:function(e){var i,s,n=this.options,o=e.pageX,a=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,l=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(o=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(a=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(o=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(a=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((a-this.originalPageY)/n.grid[1])*n.grid[1],a=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((o-this.originalPageX)/n.grid[0])*n.grid[0],o=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():l?0:r.scrollTop()),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():l?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){function i(t,e,i){return function(s){i._trigger(t,s,e._uiHash(e))}}this.reverting=!1;var s,n=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(s in this._storedCSS)("auto"===this._storedCSS[s]||"static"===this._storedCSS[s])&&(this._storedCSS[s]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&n.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||n.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(n.push(function(t){this._trigger("remove",t,this._uiHash())}),n.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),n.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),s=this.containers.length-1;s>=0;s--)e||n.push(i("deactivate",this,this.containers[s])),this.containers[s].containerCache.over&&(n.push(i("out",this,this.containers[s])),this.containers[s].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(s=0;n.length>s;s++)n[s].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}})});
/* jshint ignore:end */

angular.module('qstrap.sortable', []).directive('qstrap.sortable', ['$timeout', '$log', function($timeout, $log) {

	"use strict";

	return {
		require: '?ngModel',
		link: function(scope, element, attrs, ngModel)
		{
			var savedNodes;

			function combineCallbacks(first, second)
			{
				if (second && (typeof second === 'function')) {
					return function(e, ui) {
						first(e, ui);
						second(e, ui);
					};
				}
				return first;
			}

			function hasSortingHelper(element, ui)
			{
				var helperOption = element.sortable('option', 'helper');
				return helperOption === 'clone' || (typeof helperOption === 'function' && ui.item.sortable.isCustomHelperUsed());
			}

			var opts = {};

			var callbacks = {
				receive: null,
				remove: null,
				start: null,
				stop: null,
				update: null
			};

			var wrappers = {
				helper: null
			};

			angular.extend(opts, scope.$eval(attrs['qstrap.sortable']));

			if (!angular.element.fn || !angular.element.fn.jquery)
			{
				$log.error('ui.sortable: jQuery should be included before AngularJS!');
				return;
			}

			if (ngModel)
			{
				// When we add or remove elements, we need the sortable to 'refresh'
				// so it can find the new/removed elements.
				scope.$watch(attrs.ngModel + '.length', function() {
					// Timeout to let ng-repeat modify the DOM
					$timeout(function() {
						// ensure that the jquery-ui-sortable widget instance
						// is still bound to the directive's element
						if (!!element.data('ui-sortable')) {
							element.sortable('refresh');
						}
					});
				});

				callbacks.start = function(e, ui)
				{
					// Save the starting position of dragged item
					ui.item.sortable = {
						index: ui.item.index(),
						cancel: function() {
							ui.item.sortable._isCanceled = true;
						},
						isCanceled: function() {
							return ui.item.sortable._isCanceled;
						},
						isCustomHelperUsed: function() {
							return !!ui.item.sortable._isCustomHelperUsed;
						},
						_isCanceled: false,
						_isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed
					};
				};

				callbacks.activate = function( /*e, ui*/ )
				{
					// We need to make a copy of the current element's contents so
					// we can restore it after sortable has messed it up.
					// This is inside activate (instead of start) in order to save
					// both lists when dragging between connected lists.
					savedNodes = element.contents();

					// If this list has a placeholder (the connected lists won't),
					// don't inlcude it in saved nodes.
					var placeholder = element.sortable('option', 'placeholder');

					// placeholder.element will be a function if the placeholder, has
					// been created (placeholder will be an object).  If it hasn't
					// been created, either placeholder will be false if no
					// placeholder class was given or placeholder.element will be
					// undefined if a class was given (placeholder will be a string)
					if (placeholder && placeholder.element && typeof placeholder.element === 'function')
					{
						var phElement = placeholder.element();
						// workaround for jquery ui 1.9.x,
						// not returning jquery collection
						phElement = angular.element(phElement);

						// exact match with the placeholder's class attribute to handle
						// the case that multiple connected sortables exist and
						// the placehoilder option equals the class of sortable items
						var excludes = element.find('[class="' + phElement.attr('class') + '"]');

						savedNodes = savedNodes.not(excludes);
					}
				};

				callbacks.update = function(e, ui)
				{
					// Save current drop position but only if this is not a second
					// update that happens when moving between lists because then
					// the value will be overwritten with the old value
					if (!ui.item.sortable.received)
					{
						ui.item.sortable.dropindex = ui.item.index();
						ui.item.sortable.droptarget = ui.item.parent();

						// Cancel the sort (let ng-repeat do the sort for us)
						// Don't cancel if this is the received list because it has
						// already been canceled in the other list, and trying to cancel
						// here will mess up the DOM.
						element.sortable('cancel');
					}

					// Put the nodes back exactly the way they started (this is very
					// important because ng-repeat uses comment elements to delineate
					// the start and stop of repeat sections and sortable doesn't
					// respect their order (even if we cancel, the order of the
					// comments are still messed up).
					if (hasSortingHelper(element, ui) && !ui.item.sortable.received)
					{
						// restore all the savedNodes except .ui-sortable-helper element
						// (which is placed last). That way it will be garbage collected.
						savedNodes = savedNodes.not(savedNodes.last());
					}
					savedNodes.appendTo(element);

					// If received is true (an item was dropped in from another list)
					// then we add the new item to this list otherwise wait until the
					// stop event where we will know if it was a sort or item was
					// moved here from another list
					if (ui.item.sortable.received && !ui.item.sortable.isCanceled())
					{
						scope.$apply(function() {
							var before = ngModel.$modelValue.slice(0, ui.item.sortable.dropindex);
							var after = ngModel.$modelValue.slice(ui.item.sortable.dropindex);
							ngModel.$setViewValue(before.concat([ui.item.sortable.moved]).concat(after));
						});
					}
				};

				callbacks.stop = function(e, ui)
				{
					// If the received flag hasn't be set on the item, this is a
					// normal sort, if dropindex is set, the item was moved, so move
					// the items in the list.
					if (!ui.item.sortable.received && ('dropindex' in ui.item.sortable) && !ui.item.sortable.isCanceled())
					{

						scope.$apply(function() {
							//instead of modifying the array in-place, use $setViewValue and let angular know about the change
							var before = ngModel.$modelValue.slice(0, ui.item.sortable.index);
							var after = ngModel.$modelValue.slice(ui.item.sortable.index+1);
							var newModelValue = before.concat(after);
							newModelValue.splice(ui.item.sortable.dropindex, 0, ngModel.$modelValue[ui.item.sortable.index]);
							ngModel.$setViewValue(newModelValue);
						});
					}
					else
					{
						// if the item was not moved, then restore the elements
						// so that the ngRepeat's comment are correct.
						if ((!('dropindex' in ui.item.sortable) || ui.item.sortable.isCanceled()) && !hasSortingHelper(element, ui))
						{
							savedNodes.appendTo(element);
						}
					}
				};

				callbacks.receive = function(e, ui)
				{
					// An item was dropped here from another list, set a flag on the
					// item.
					ui.item.sortable.received = true;
				};

				callbacks.remove = function(e, ui)
				{
					// Workaround for a problem observed in nested connected lists.
					// There should be an 'update' event before 'remove' when moving
					// elements. If the event did not fire, cancel sorting.
					if (!('dropindex' in ui.item.sortable))
					{
						element.sortable('cancel');
						ui.item.sortable.cancel();
					}

					// Remove the item from this list's model and copy data into item,
					// so the next list can retrive it
					if (!ui.item.sortable.isCanceled())
					{
						scope.$apply(function()
						{
							ui.item.sortable.moved = ngModel.$modelValue[ui.item.sortable.index];
							var before = ngModel.$modelValue.slice(0, ui.item.sortable.index);
							var after = ngModel.$modelValue.slice(ui.item.sortable.index+1);
							ngModel.$setViewValue(before.concat(after));
						});
					}
				};

				wrappers.helper = function(inner)
				{
					if (inner && typeof inner === 'function')
					{
						return function(e, item)
						{
							var innerResult = inner(e, item);
							item.sortable._isCustomHelperUsed = item !== innerResult;
							return innerResult;
						};
					}
					return inner;
				};

				scope.$watch(attrs['qstrap.sortable'], function(newVal /*, oldVal*/ )
				{
					// ensure that the jquery-ui-sortable widget instance
					// is still bound to the directive's element
					if (!!element.data('ui-sortable'))
					{
						angular.forEach(newVal, function(value, key)
						{
							if (callbacks[key])
							{
								if (key === 'stop')
								{
									// call apply after stop
									value = combineCallbacks(
										value,
										function() {
											scope.$apply();
										});
								}
								// wrap the callback
								value = combineCallbacks(callbacks[key], value);
							}
							else if (wrappers[key])
							{
								value = wrappers[key](value);
							}

							element.sortable('option', key, value);
						});
					}
				}, true);

				angular.forEach(callbacks, function(value, key)
				{
					opts[key] = combineCallbacks(value, opts[key]);
				});

			}
			else
			{
				$log.info('ui.sortable: ngModel not provided!', element);
			}

			// Create sortable
			element.sortable(opts);
		}
	};
}]);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.spin
 *
 * @restrict A
 * @element Any
 * @description
 * Directive that creates a spinner centered on its parent element. The following classes are added based on thier associated options:
 * spinner-show,
 * spinner-fade,
 * spinner-hide,
 * spinner-disabled.
 * These can be overridden for custom behavior in your css.
 *
 *
 * @param {string} spin-if Scope variable to watch. Displays spinner when true.
 * @param {string=} spin-size (sm, md, lg) Size of spinner. (Default sm)
 * @param {string=} spin-cover (show, hide, fade) Children of element will be shown/hidden/faded to 50% opacity while spinner is on. (Default fade)
 * @param {boolean=} spin-invert If true, spinner will be white. (Default is a black spinner)
 * @param {boolean=} spin-enable If true, interaction will be enabled during spin. (Default false)
 *
 * @example
   <example module="qstrap">
      <file name="spin.css">
        .spin-demo {
          width: 90px;
          height: 90px;
          float:left;
          position: relative;
          text-align: center;
          margin-right: 25px;
        }
        .black {
          color: #FFF;
          background-color: #000;
        }
        .demo-button {
          color: #777;
          background-color: #fefefe;
          border: 2px #dedede solid;
          border-radius: 6px;
          cursor: pointer;
          text-align: center;
          padding: 3px;
          width: 100px;
          height: 50px;
          float:left;
          position: relative;
          font-weight: bold;
          font-size: 13px;
          margin-right: 15px;
        }
        .demo-button:hover {
          border: 2px #bbb solid;
        }
        .clear {
          clear: both;
        }
      </file>
     <file name="spin.html">
       <div ng-controller="SpinDemoCtrl">
         <div>
          <h1>spin-size</h1>
            <div class="spin-demo" qstrap.spin spin-size="sm" spin-if="spinnerOn">Small*</div>
            <div class="spin-demo" qstrap.spin spin-size="md" spin-if="spinnerOn">Medium</div>
            <div class="spin-demo" qstrap.spin spin-size="lg" spin-if="spinnerOn">Large</div>
            <div class="clear"></div>
         </div>
         <div>
          <h1>spin-invert</h1>
            <div class="spin-demo" qstrap.spin spin-if="spinnerOn">Dark*</div>
            <div class="spin-demo black" qstrap.spin spin-invert="true" spin-if="spinnerOn">Inverted</div>
            <div class="clear"></div>
         </div>
         <div>
          <h1>spin-cover</h1>
            <div class="demo-button" qstrap.spin spin-cover="fade" spin-if="spinnerToggle[1]" ng-click="toggleSpinner(1)">
              <div>Click me!<br>cover=fade*</div>
            </div>
            <div class="demo-button" qstrap.spin spin-cover="show" spin-if="spinnerToggle[0]" ng-click="toggleSpinner(0)">
              <div>Click me!<br>cover=show</div>
            </div>
            <div class="demo-button" qstrap.spin spin-cover="hide" spin-if="spinnerToggle[2]" ng-click="toggleSpinner(2)">
              <div>Click me!<br>cover=hide</div>
            </div>
            <div class="clear"></div>
         </div>
         <div>
          <h1>spin-enable</h1>
            <div class="demo-button" qstrap.spin spin-if="spinnerOn" ng-click="incrementCount()">
              <div>Click me!<br>enable=false*</div>
            </div>
            <div class="demo-button" qstrap.spin spin-enable="true" spin-if="spinnerOn" ng-click="incrementCount()">
              <div>Click me!<br>enable=true</div>
            </div>
            <h3>Clicks: {{count}}</h3>
            <div class="clear"></div>
         </div>
         <h3>* = default</h3>
       </div>
     </file>
     <file name="spin.js">
       angular.module('qstrap.spin').controller('SpinDemoCtrl', function($scope, $timeout) {
         $scope.spinnerOn = true;
         $scope.spinnerToggle = [false, false, false];
         $scope.toggleSpinner = function(index){
          $scope.spinnerToggle[index] = !$scope.spinnerToggle[index];
          $timeout(function(){
            $scope.spinnerToggle[index] = !$scope.spinnerToggle[index];
          }, 1500);
         }
         $scope.count = 0;
         $scope.incrementCount = function(){
          $scope.count++;
         }
       });
     </file>
   </example>
 */
angular.module('qstrap.spin', []).directive('qstrap.spin', [
	'spinnerFactory',
	function(Spinner)
	{
		'use strict';

		return {
			scope:
			{
				spinIf: '=',
				spinSize: '@',
				spinInvert: '@',
        spinCover: '@',
				spinEnable: '@'
			},
			restrict: 'A',
			link: function($scope, element)
			{

				var opts = {};

				if ($scope.spinSize)
				{
					var sizes = {
						'sm':
						{
							length: 5,
							width: 2,
							radius: 4
						},
						'md':
						{
							length: 7,
							width: 2,
							radius: 6
						},
						'lg':
						{
							length: 10,
							width: 3,
							radius: 8
						}
					};
					opts = sizes[$scope.spinSize];
				}

				if ($scope.spinInvert == 'true')
				{
					opts.color = '#FFF';
				}

				var spinner = new Spinner(opts);
				$scope.$watch('spinIf', function(value)
				{
					if (value)
					{
						if ($scope.spinEnable != 'true')
						{
							element.addClass('spinner-disabled');
						}
						if ($scope.spinCover)
						{
              element.children().addClass('spinner-' + $scope.spinCover);
            }else{
							element.children().addClass('spinner-fade');
            }
						//Cover children then add spinner.
						spinner.spin(element[0]);
					}
					else
					{
						spinner.stop();
						//Remove spinner and un-cover siblings
            if ($scope.spinEnable != 'true')
            {
							element.removeClass('spinner-disabled');
						}
						if ($scope.spinCover)
						{
              element.children().removeClass('spinner-' + $scope.spinCover);
            }else{
							element.children().removeClass('spinner-fade');
            }
					}
				});
			}
		};
	}
]);

/* global angular, setTimeout, document, clearTimeout */
angular.module('qstrap.spin').factory('spinnerFactory', function()
{
	'use strict';
        var prefixes = ['webkit', 'Moz', 'ms', 'O']; /* Vendor prefixes */
        var animations = {}; /* Animation rules keyed by their name */
        var useCssAnimations; /* Whether to use CSS animations or setTimeout */

        /**
         * Utility function to create elements. If no tag name is given,
         * a DIV is created. Optionally properties can be passed.
         */
        function createEl(tag, prop) {
          var el = document.createElement(tag || 'div'),
            n;
          for (n in prop) {
            el[n] = prop[n];
          }
          return el;
        }

        /**
         * Appends children and returns the parent.
         */
        function ins(parent /* child1, child2, ...*/ ) {
          for (var i = 1, n = arguments.length; i < n; i++) {
            parent.appendChild(arguments[i]);
          }
          return parent;
        }

        /**
         * Insert a new stylesheet to hold the @keyframe or VML rules.
         */
        var sheet = (function() {
          var el = createEl('style', {
            type: 'text/css'
          });
          ins(document.getElementsByTagName('head')[0], el);
          return el.sheet || el.styleSheet;
        }());

        /**
         * Creates an opacity keyframe animation rule and returns its name.
         * Since most mobile Webkits have timing issues with animation-delay,
         * we create separate rules for each line/segment.
         */
        function addAnimation(alpha, trail, i, lines) {
          var name = ['opacity', trail, ~~ (alpha * 100), i, lines].join('-');
          var start = 0.01 + i / lines * 100;
          var z = Math.max(1 - (1 - alpha) / trail * (100 - start), alpha);
          var prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase();
          var pre = prefix && '-' + prefix + '-' || '';

          if (!animations[name]) {
            sheet.insertRule(
              '@' + pre + 'keyframes ' + name + '{' +
              '0%{opacity:' + z + '}' +
              start + '%{opacity:' + alpha + '}' +
              (start + 0.01) + '%{opacity:1}' +
              (start + trail) % 100 + '%{opacity:' + alpha + '}' +
              '100%{opacity:' + z + '}' +
              '}', sheet.cssRules.length);
            animations[name] = 1;
          }
          return name;
        }

        /**
         * Tries various vendor prefixes and returns the first supported property.
         */
        function vendor(el, prop) {
          var s = el.style,
            pp, i;

          prop = prop.charAt(0).toUpperCase() + prop.slice(1);
          for (i = 0; i < prefixes.length; i++) {
            pp = prefixes[i] + prop;
            if (s[pp] !== undefined) {
              return pp;
            }
          }
          if (s[prop] !== undefined) {
            return prop;
          }
        }

        /**
         * Sets multiple style properties at once.
         */
        function css(el, prop) {
          for (var n in prop) {
            el.style[vendor(el, n) || n] = prop[n];
          }
          return el;
        }

        /**
         * Fills in default values.
         */
        function merge(obj) {
          for (var i = 1; i < arguments.length; i++) {
            var def = arguments[i];
            for (var n in def) {
              if (obj[n] === undefined) {
                obj[n] = def[n];
              }
            }
          }
          return obj;
        }

        /**
         * Returns the line color from the given string or array.
         */
        function getColor(color, idx) {
          return typeof color == 'string' ? color : color[idx % color.length];
        }

        // Small defaults
        var defaults = {
          lines: 9, // The number of lines to draw
          length: 5, // The length of each line
          width: 2, // The line thickness
          radius: 4, // The radius of the inner circle
          rotate: 0, // Rotation offset
          corners: 0, // Roundness (0..1)
          color: '#000', // #rgb or #rrggbb
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1.5, // Rounds per second
          trail: 60, // Afterglow percentage
          opacity: 1 / 4, // Opacity of the lines
          fps: 20, // Frames per second when using setTimeout()
          zIndex: 1050, // Use a the same z-index as the modal so modals cover any existing spinners on the page
          className: 'spinner', // CSS class to assign to the element
          top: '50%', // center vertically
          left: '50%', // center horizontally
          position: 'absolute' // element position
        };

        /** The constructor */
        function Spinner(o) {
          this.opts = merge(o || {}, defaults);
        }

        merge(Spinner.prototype, {
          /**
           * Adds the spinner to the given target element. If this instance is already
           * spinning, it is automatically removed from its previous target by calling
           * stop() internally.
           */
          spin: function(target) {
            this.stop();

            var self = this;
            var o = self.opts;
            var el = self.el = css(createEl(0, {
              className: o.className
            }), {
              position: o.position,
              width: 0,
              zIndex: o.zIndex
            });

            css(el, {
              left: o.left,
              top: o.top
            });

            if (target) {
              target.insertBefore(el, target.firstChild || null);
            }

            el.setAttribute('role', 'progressbar');
            self.lines(el, self.opts);

            if (!useCssAnimations) {
              // No CSS animation support, use setTimeout() instead
              var i = 0;
              var start = (o.lines - 1) * (1 - o.direction) / 2;
              var alpha;
              var fps = o.fps;
              var f = fps / o.speed;
              var ostep = (1 - o.opacity) / (f * o.trail / 100);
              var astep = f / o.lines;

              (function anim() {
                i++;
                for (var j = 0; j < o.lines; j++) {
                  alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity);
                  self.opacity(el, j * o.direction + start, alpha);
                }
                self.timeout = self.el && setTimeout(anim, ~~ (1000 / fps));
              })();
            }
            return self;
          },

          /**
           * Stops and removes the Spinner.
           */
          stop: function() {
            var el = this.el;
            if (el) {
              clearTimeout(this.timeout);
              if (el.parentNode) {
                el.parentNode.removeChild(el);
              }
              this.el = undefined;
            }
            return this;
          },

          /**
           * Internal method that draws the individual lines. Will be overwritten
           * in VML fallback mode below.
           */
          lines: function(el, o) {
            var i = 0;
            var start = (o.lines - 1) * (1 - o.direction) / 2;
            var seg;

            function fill(color, shadow) {
              return css(createEl(), {
                position: 'absolute',
                width: (o.length + o.width) + 'px',
                height: o.width + 'px',
                background: color,
                boxShadow: shadow,
                transformOrigin: 'left',
                transform: 'rotate(' + ~~(360 / o.lines * i + o.rotate) + 'deg) translate(' + o.radius + 'px' + ',0)',
                borderRadius: (o.corners * o.width >> 1) + 'px'
              });
            }

            for (; i < o.lines; i++) {
              seg = css(createEl(), {
                position: 'absolute',
                top: 1 + ~(o.width / 2) + 'px',
                transform: '',
                opacity: o.opacity,
                animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
              });
              ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')));
            }
            return el;
          },

          /**
           * Internal method that adjusts the opacity of a single line.
           * Will be overwritten in VML fallback mode below.
           */
          opacity: function(el, i, val) {
            if (i < el.childNodes.length) {
              el.childNodes[i].style.opacity = val;
            }
          }
        });


        function initVML() {
          /* Utility function to create a VML tag */
          function vml(tag, attr) {
            return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr);
          }

          // No CSS transforms but VML support, add a CSS rule for VML elements:
          sheet.addRule('.spin-vml', 'behavior:url(#default#VML)');

          Spinner.prototype.lines = function(el, o) {
            var r = o.length + o.width;
            var s = 2 * r;

            function grp() {
              return css(
                vml('group', {
                  coordsize: s + ' ' + s,
                  coordorigin: -r + ' ' + -r
                }), {
                  width: s,
                  height: s
                }
              );
            }

            var margin = -(o.width + o.length) * 2 + 'px';
            var g = css(grp(), {
              position: 'absolute',
              top: margin,
              left: margin
            });
            var i;

            function seg(i, dx, filter) {
              ins(g,
                ins(css(grp(), {
                    rotation: 360 / o.lines * i + 'deg',
                    left: ~~dx
                  }),
                  ins(css(vml('roundrect', {
                      arcsize: o.corners
                    }), {
                      width: r,
                      height: o.width,
                      left: o.radius,
                      top: -o.width >> 1,
                      filter: filter
                    }),
                    vml('fill', {
                      color: getColor(o.color, i),
                      opacity: o.opacity
                    }),
                    vml('stroke', {
                      opacity: 0
                    }) // transparent stroke to fix color bleeding upon opacity change
                  )
                )
              );
            }

            for (i = 1; i <= o.lines; i++) {
              seg(i);
            }
            return ins(el, g);
          };

          Spinner.prototype.opacity = function(el, i, val) {
            var c = el.firstChild;
            if (c && i < c.childNodes.length) {
              c = c.childNodes[i];
              c = c && c.firstChild;
              c = c && c.firstChild;
              if (c) {
                c.opacity = val;
              }
            }
          };
        }

        var probe = css(createEl('group'), {
          behavior: 'url(#default#VML)'
        });

        if (!vendor(probe, 'transform') && probe.adj) {
          initVML();
        } else {
          useCssAnimations = vendor(probe, 'animation');
        }
        return Spinner;
});

/**
 * @ngdoc directive
 * @name qstrap:qstrap.spinner
 *
 * @restrict A
 * @element Any
 * @description
 * Directive that creates a number input with +/- buttons to increment/decreament a value
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} min Set a min value
 * @param {string=} max Set a max value
 * @param {string=} placeholder Set a placeholder
 * @param {string=} step Set the step size (defaults to 1)
 * @param {string=} simple Attribute to turn on the simple version
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The value is available as $value)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The value is available as $value)
 *
 * @example
   <example module="qstrap">
     <file name="spinner.html">
       <div ng-controller="SpinnerDemoCtrl">
         <div class="form-group">
          <h1>Default Spinner</h1>
            <span class='field-select' qstrap.spinner ng-model='defaultValue'></span>
            <div class="clear"></div>
         </div>
         <div class="form-group">
          <h1>Min/Max Spinner (2-4)</h1>
            <span class='field-select' qstrap.spinner ng-model='minMaxValue' min='2' max='4'></span>
            <div class="clear"></div>
         </div>
         <div class="form-group">
          <h1>Simple Spinner</h1>
            <span class='field-select' qstrap.spinner ng-model='simpleValue' simple='true'></span>
            <div class="clear"></div>
         </div>
         <div class="form-group">
          <h1>Simple Spinner (2-4)</h1>
            <span class='field-select' qstrap.spinner ng-model='simpleMinMaxValue' simple='true' min='2' max='4'></span>
            <div class="clear"></div>
         </div>
       </div>
     </file>
     <file name="spinner.js">
       angular.module('qstrap.spinner').controller('SpinnerDemoCtrl', function($scope, $timeout) {
         $scope.defaultValue = 3;
         $scope.minMaxValue = 3;
         $scope.simpleValue = 3;
         $scope.simpleMinMaxValue = 3;
       });
     </file>
   </example>
 */


angular.module('qstrap.spinner', []).directive('qstrap.spinner', ['$timeout', function($timeout)
{
	return {
		template: '' +
			'<span class="qspinner" ng-class="{simple:simple}">' +
				'<button class="btn" ng-disabled="val<=min" ng-class="{\'round-minus\':!simple}" ng-click="decrement()"></button>' +
				'<input class="form-control" type="number" ng-model="val" placeholder="{{placeholder}}" ng-blur="validate()" ng-style="{width: size}" ng-keypress="keyPressed($event.keyCode)">' +
				'<button class="btn" ng-disabled="val>=max" ng-class="{\'round-plus\':!simple}" ng-click="increment()"></button>' +
			'</span>',
		replace: true,
		scope: {
			onChange: '&',
			afterChange: '&',
			min: '@',
			max: '@',
			placeholder: '@',
			step: '@?'
		},
		require: 'ngModel',
		link: function($scope, el, attrs, ngModelCtrl)
		{

			ngModelCtrl.$render = function() {
				$scope.val = ngModelCtrl.$viewValue;
				$scope.validate(true);
			};

			angular.extend($scope, {
				simple: !!attrs.simple,
				decrement: function()
				{
					$scope.val -= +($scope.step || 1);
					$scope.validate();
				},
				increment: function()
				{
					$scope.val += +($scope.step || 1);
					$scope.validate();
				},
				validate: function(skipChange)
				{
					var prevVal = ngModelCtrl.$viewValue;
					$scope.val = Math.round($scope.val * 100) / 100;
					if (isNaN($scope.val))
					{
						$scope.val = prevVal;
						return;
					} else if ($scope.val > +$scope.max) {
						$scope.val = +$scope.max;
					} else if ($scope.val < +$scope.min) {
						$scope.val = +$scope.min;
					}

					ngModelCtrl.$setViewValue($scope.val);

					if (attrs.hasOwnProperty('onChange') && !skipChange)
					{
						$scope.onChange({$value: ngModelCtrl.$viewValue, $previous: prevVal});
					}

					if (attrs.hasOwnProperty('afterChange') && !skipChange)
					{
						$timeout(function() {
							$scope.afterChange({$value: ngModelCtrl.$viewValue, $previous: prevVal});
						});
					}
				},
				keyPressed: function(keyCode)
				{
					if (keyCode === 13) {
						$scope.validate();
					}
				}
			});

			$scope.size = 10 * (Math.max(
					('' + Math.abs(+$scope.max)).length,
					('' + Math.abs(+$scope.min)).length,
					('' + Math.abs(+$scope.step)).length) + 1);

		}
	};
}]);

(function (module, $)
{
	module.factory('qstrap.$switch', [
		'$filter',
		function ($filter) {
			'use strict';

			var defaults = {
				onText: $filter('qstrapTranslate')('ON'),
				offText: $filter('qstrapTranslate')('OFF'),
				className: '',
				size: ''
			};

			var QSwitch = function (input, options)
			{
				this._input = $(input);
				if (!this._input.is(':checkbox'))
					console.warn('QSwitch works best with checkbox inputs');

				this._options = $.extend({}, defaults, options);
				this.init();
			};

			QSwitch.prototype = {
				updateToggleClass:function(val)
				{
					this.dom.toggleClass('on', val);
					this.dom.toggleClass('off', !val);
				},
				init:function()
				{
					var self = this;
					this._input.after(this.build());
					this._input.hide();
					this.sizeText();
					this._input.on('update', function() {
						var val = self._input.is(':checked');
						self.updateToggleClass(val);
					});
				},
				build:function()
				{
					var val = this._input.is(':checked'),
						size = this._options.size ? ' btn-' + this._options.size : '';

					return (this.dom = $('<a>', {'class': 'q-switch ' + (val ? 'on' : 'off') + this._options.className}).append(
						$('<span>', {'class':'btn btn-primary active' + size}).append(
							this.onText = $('<span>').append(this._options.onText)
						),
						$('<span>', {'class':'btn btn-default active' + size}).append(
							this.offText = $('<span>').append(this._options.offText)
						),
						$('<b>', {'class':'btn ' + size})
					).click($.proxy(this.toggle, this)));
				},
				toggle:function()
				{
					var val = !this._input.is(':checked');
					this._input.prop('checked', val);
					this.updateToggleClass(val);
					if (this._options.onChange)
						this._options.onChange(val);
				},
				/*
				 * what was once a nice simple function now needs all of this overhead so that we can get the width of our text even if it isn't visible
				 */
				sizeText:function()
				{
					var props = { position: 'absolute', visibility: 'hidden', display: 'block' },
						hiddenParents = this.dom.parents().not(':visible'),
						orig = [];

					hiddenParents.each(function()
					{
						var o = {};
						for (var name in props)
						{
							o[name] = this.style[name];
							this.style[name] = props[name];
						}
						orig.push(o);
					});

					var w = {width: Math.max(this.onText.width(),this.offText.width()) + 'px'};

					hiddenParents.each(function(i)
					{
						var o = orig[i];
						for (var name in props)
						{
							this.style[name] = o[name];
						}
					});

					this.offText.css(w);
					this.onText.css(w);
				}
			};

			return QSwitch;
		}
	]);

	var old = $.fn.qswitch;
	var QSwitch = angular.injector(['ng', 'qstrap.switch', 'qstrap.translate']).get('qstrap.$switch');

	$.fn.qswitch = function (options)
	{
		return this.each(function()
		{
			var el = $(this);
			if (!el.data('q.switch'))
			{
				el.data('q.switch', new QSwitch(el, options));
			}
		});
	};

	$.fn.qswitch.Constructor = QSwitch;

	$.fn.qswitch.noConflict = function ()
	{
		$.fn.qswitch = old;
		return this;
	};

})(angular.module('qstrap.switch', []), jQuery);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.switch
 *
 * @restrict A
 * @element input
 * @description
 * Directive that creates an iOS-like toggle switch to replace the basic checkbox input.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} onText The text to display when the switch is in the on/true state.
 * @param {string=} offText The text to display when the switch is in the off/false state.
 * @param {expression=} onChange Angular expression to be executed before the value is set on the ngModel. (The switch value is available as $value)
 * @param {expression=} afterChange Angular expression to be executed after the value is set on the ngModel. (The switch value is available as $value)
 *
 * @example
   <example module="qstrap">
     <file name="switch.html">
       <div ng-controller="SwitchDemoCtrl">
         <input type='checkbox' qstrap.switch on-text="Yes" off-text="No" ng-model="val" after-change="alert($value)">
       </div>
     </file>
     <file name="switch.js">
       angular.module('qstrap.switch').controller('SwitchDemoCtrl', function($scope) {
         $scope.val = false;
         $scope.alert = function(value) { console.log('switched changed to: ' + value); }
       });
     </file>
   </example>
 */
angular.module('qstrap.switch', []).directive('qstrap.switch', [

	function()
	{
		'use strict';
		return {
			template: '<input type="checkbox">',
			restrict: 'A',
			replace: true,
			scope:
			{
				qval: '=ngModel',
				onText: '@',
				offText: '@',
				callback: '&onChange',
				afterChange: '&'
			},
			link: function($scope, element)
			{
				$scope.$watch('qval', function (newVal, oldVal) {
					if (newVal !== undefined) {
						element.prop('checked', newVal || null);
						element.trigger('update');
					}
				});
				element.prop('checked', $scope.qval || null);
				$scope.onChange = function(val)
				{
					$scope.qval = val;
					$scope.callback(
					{
						$value: val
					});
					$scope.$apply();
					if ($scope.afterChange)
					{
						$scope.afterChange(
						{
							$value: val
						});
					}
				};

				element.qswitch($scope);
			}
		};
	}
]);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.tabs
 *
 * @restrict A
 * @description
 * Directive that shows a set of tabs. When a tab is selected, the tab's template will be displayed
 *
 * @param {expression} tabs Angular expression that returns a tabs array. Each tab in the array is an object with a "title" and a either "template" attribute specifying a template url or a "content" attribute with static html.
 * @param {expression} onChange Angular expression that will be evaluated within the scope's context with $tab evaluating to the tab that was selected, before the digest cycle.
 * @param {expression} afterChange Angular expression that will be evaluated within the scope's context with $tab evaluating to the tab that was selected, after the digest cycle.
 * @param {string} tab.title A static html string that will be shown as the tab text
 * @param {string=} tab.template A template url that will be loaded as the tab's content. This can be cached manually with the $templateCache service.
 * @param {string=} tab.content Used in place of tab.template. It renders static html content, so it is boring. Use tab.template instead.
 * @param {number=} tab.selectedIndex The index which is selected by default.
 *
 * @example
   <example module="qstrap">
     <file name="tabs.html">
       <style>
         .qstrap-tabs .tab-content {
           padding: 16px;
         }
       </style>
       <div ng-controller="TabDemoController">
         <div qstrap.tabs tabs='tabs'></div>
         <div qstrap.tabs tabs='tabsTwo' selected-index='1'></div>
       </div>
     </file>
     <file name="tabs.js">
       angular.module('qstrap.tabs').controller('TabDemoController', function($scope, $templateCache)
       {
         $scope.tabs = [{
           title: 'My workflows',
           template: 'tabDemo.firstTab.html'
         },{
           title: 'Reporting & history',
           content: 'This tab is using the "content" property.'
         },{
           title: 'My app connections',
           template: 'tabDemo.thirdTab.html'
         }];

         $scope.tabsTwo = [{
           title: 'My workflows',
           template: 'tabDemo.firstTab.html'
         },{
           title: 'Default tab',
           content: 'This tab should be shown first!'
         },{
           title: 'Explore workflows',
           template: 'tabDemo.thirdTab.html'
         }];

         $scope.name = 'Ted Theodore Logan';

         $templateCache.put('tabDemo.firstTab.html', 'This tab is using the "template" property.');
         $templateCache.put('tabDemo.thirdTab.html', 'This is the D tab. It is sad.');
       });
     </file>
   </example>
 */
angular.module('qstrap.tabs', []).run([
	'$templateCache',
	function ($templateCache)
	{
		"use strict";
		$templateCache.put('$qstrap.tab-content', '<div ng-bind-html="tab.content"></div>');
	}
]).directive('qstrap.tabs', [
	'$parse',
	'$sce',
	'$timeout',
	function($parse, $sce, $timeout)
	{
		"use strict";
		return {
			restrict: 'A',
			scope: true,
			template: "" +
				"<div class='qstrap-tabs'>" +
					"<ul class='tab-list'>" +
			  			"<li ng-repeat='tab in tabs' ng-class='{active: tab.selected}' ng-style='{width: (100 / tabs.length) + \"%\"}'>" +
							"<a ng-click='select(tab)' ng-bind-html='tab.title'></a>" +
					  	"</li>" +
					"</ul>" +
					"<div class='tab-content'>" +
						"<div ng-repeat='tab in tabs' class='tab-pane' ng-class='{active: tab.selected }' ng-include='tab.template || \"$qstrap.tab-content\"'></div>" +
					"</div>" +
				"</div>",
			link: function($scope, $element, $attrs)
			{
				var tabs = $attrs.tabs ? $scope.$eval($attrs.tabs) : [];
				var selectedIndex = $attrs.selectedIndex ? $scope.$eval($attrs.selectedIndex) : 0;
				angular.forEach(tabs, function(tab)
				{
					tab.title = $sce.trustAsHtml(tab.title);
					if (tab.content)
						tab.content = $sce.trustAsHtml(tab.content);
				});

				var onChange = $attrs.onChange && $parse($attrs.onChange),
					afterChange = $attrs.afterChange && $parse($attrs.afterChange);

				function select(tab)
				{
					angular.forEach($scope.tabs, function(tab) {
						tab.selected = false;
					});
					tab.selected = true;
				}

				angular.extend($scope,
				{
					tabs: tabs,
					select: function(tab)
					{
						select(tab);

						if (onChange)
						{
							onChange($scope, {$tab: tab});
						}

						if (afterChange)
						{
							$timeout(function()
							{
								afterChange($scope, {$tab: tab});
							});
						}
					}
				});

				//select the first tab
				if ($scope.tabs.length)
				{
					select($scope.tabs[selectedIndex]);
				}
			}
		};
	}
]);

/**
 * @ngdoc directive
 * @name qstrap:qstrap.tooltip
 *
 * @restrict A
 * @description
 * Directive that creates a positioned tooltip next to the element.
 *
 * @param {string} position Position of the tooltip: (top, bottom, left, right)
 * @param {string} content Content of the tooltip.
 * @param {boolean} html is content HTML safe (true: will use content directly, fasle: will strip HTML from content)
 * @param {string} template Template URL of the tooltip. See below for the required html structure. This will overwrite the default template so you can add in your own directives, classes etc.
 * @param {string} tooltip-disabled Scope variable to watch. Disables the tooltip when truthy.
 * @param {number=} delay Optional scope variable to watch. Displays the tooltip after the delay (in milliseconds).
 * @example
	<example module="qstrap">
		<file name="tooltip.html">
			<style>
				.tooltips {
					margin-bottom: 40px;
				}
			</style>
			<div ng-controller="TooltipDemoController" class='tooltips'>
				<button class="btn btn-info" qstrap.tooltip position="left" content="{{content}}">Left</button>
				<button class="btn btn-info" qstrap.tooltip position="top" content="{{content}}">Top</button>
				<button class="btn btn-info" qstrap.tooltip position="bottom" content="{{content}}">Bottom</button>
				<button class="btn btn-info" qstrap.tooltip position="right" content="{{content}}">Right</button>

				<h1>Tooltip with HTML</h1>
				<p>
					By default qstrap will sanitize `content` by removing HTML. If you would like to
					display HTML set the html attribute to true.
				</p>
				<button class="btn btn-info" qstrap.tooltip html="true" content="{{contentHTML}}">With HTML</button>
				<button class="btn btn-info" qstrap.tooltip html="false" content="{{contentHTML}}">Strip HTML</button>

				<h1>Disable the Tooltip</h1>
				<button class="btn btn-info" qstrap.tooltip content="{{content}}" tooltip-disabled="disableTooltip" ng-click="disableTooltip = !disableTooltip">Toggle Tooltip</button>

				<h1>Tooltip on a Disabled Button</h1>
				<p>
					Because the disabled class disables pointer events, the tooltip should be placed on the button's container.
					The tooltip-disabled parameter can be used to disable the tooltip when the button is enabled.
				</p>
				<div qstrap.tooltip content="You do not have permission to perform this action" tooltip-disabled="enabled" style="display: inline-block;">
					<button class="btn btn-info" ng-class="{disabled: !enabled}">Disabled Button</button>
				</div>
				<button class="btn btn-info" ng-click="enabled = !enabled">Toggle Disabled Button</button>

				<h1>Tooltip with a Delay</h1>
				<button class="btn btn-info" qstrap.tooltip position="top" delay="1000" content="{{content}}">Delayed 1 sec</button>

				<h1>Tooltip with a template</h1>
				Templates should follow this structure:
				<pre class="prettyprint linenums" ng-set-text="tooltip.html"><ol class="linenums"><li class="L0"><span class="tag">&lt;div</span><span class="pln"> </span><span class="atn">class</span><span class="pun">=</span><span class="atv">"tooltip"</span><span class="tag">&gt;</span></li><li class="L1"><span class="pln">	</span><span class="tag">&lt;div</span><span class="pln"> </span><span class="atn">class</span><span class="pun">=</span><span class="atv">"tooltip-arrow"</span><span class="tag">&gt;&lt;/div&gt;</span></li><li class="L2"><span class="pln">	</span><span class="tag">&lt;div</span><span class="pln"> </span><span class="atn">class</span><span class="pun">=</span><span class="atv">"tooltip-inner"</span><span class="tag">&gt;</span></li><li class="L3"><span class="pln">		</span><span class="com">&lt;!-- place content here --&gt;</span></li><li class="L4"><span class="pln">	</span><span class="tag">&lt;/div&gt;</span></li><li class="L5"><span class="tag">&lt;/div&gt;</span></li></ol></pre>
				<button class="btn" qstrap.tooltip template="tooltip-demo.html">Template Tooltip</button>

				<h1>Tooltip with changing content</h1>
				<button class="btn" qstrap.tooltip content="Clicks: {{clickCount}}" ng-click="clickCount = clickCount + 1">Click Me!</button>

			</div>
		</file>
		<file name="tooltip.js">
			angular.module('qstrap.tooltip').controller('TooltipDemoController', [
				'$scope',
				'$templateCache',
				function($scope, $templateCache) {
					$scope.content = 'Hey this is content for the tooltip';
					$scope.contentHTML = '<h1>h1</h1> <b>bold</b> <u>underline</u>';
					$scope.clickCount = 0;
					$templateCache.put('tooltip-demo.html', '' +
						'<div class="tooltip">' +
							'<div class="tooltip-arrow"></div>' +
							'<div class="tooltip-inner">' +
								'Here is a templated tooltip!' +
							'</div>' +
						'</div>'
					);
				}
			]);
		</file>
	</example>
 */
(function(module) {
	'use strict';

	/*
	 * 	options = {
	 * 		anchor: [JQuery / DOM Node] // the element to anchor the tooltip to
	 *  	position: 'top' 			// top, right, bottom, left
	 *		scope: [Angular Scope]		// A child scope will be created from this object
	 *		content: [HTML] 			// HTML string that will be compiled as the tooltip's content
	 *		html: [boolean]				// in content HTML safe if true will use content directly, if false will stip HTML from content
	 *		template: [template.html] 	// URL to a template resource to load. Should follow bootstrap tooltip template
	 *		className: '' 				// any custom class name that will be added to the tooltip
	 * 	}
	 */
	module.factory('qstrap.$tooltip', [
		'$compile',
		'$document',
		'$http',
		'$q',
		'$timeout',
		'$templateCache',
		'qstrap.$position',
		function ($compile, $document, $http, $q, $timeout, $templateCache, $position) {

			var DEFAULT_TEMPLATE = 'qstrap-tooltip.tpl.html';
			$templateCache.put(DEFAULT_TEMPLATE, '' +
				'<div class="tooltip">' +
					'<div class="tooltip-arrow"></div>' +
					'<div class="tooltip-inner">{{content}}</div>' +
				'</div>'
			);

			function loadTemplate(templateUrl) {
				return $http.get(templateUrl || DEFAULT_TEMPLATE, {cache: $templateCache}).then(function (res) {
					return res.data;
				});
			}

			function setPosition(anchor, tooltip, position, adjustHeight)
			{
				position = position || 'top';
				tooltip.removeClass('top right bottom left').addClass(position);

				// reset arrow position
				var arrow = tooltip.find('.tooltip-arrow, .arrow');
				if (arrow[0] && arrow[0].style) {
					arrow[0].style['margin-top'] = null;
					arrow[0].style['margin-left'] = null;
				}

				var content = tooltip.find('.tooltip-inner, .popover-content');
				if (content.length && adjustHeight) {
					content.css("max-height", "none");
				}

				var POSITIONS = {
						top: 'top center',
						right: 'center right',
						bottom: 'bottom center',
						left: 'center left'
					},
					REFLECT_RULES = {
						top: 'top',
						right: 'left',
						bottom: 'top',
						left: 'left'
					},
					ADJUST_RULES = {
						top: 'left',
						right: 'top',
						bottom: 'left',
						left: 'top'
					};

				function onReflect(pos) {
					tooltip.removeClass(position).addClass(pos);
				}

				function onAdjustTop (diff) {
					arrow.css('margin-top', (parseInt(arrow.css('margin-top') || '0', 10) - diff) + 'px');
				}

				function onAdjustLeft (diff) {
					arrow.css('margin-left', (parseInt(arrow.css('margin-left'), 10) - diff) + 'px');
				}

				function onAdjustHeight (diff) {
					content.css('max-height', (content.height() - diff) + 'px');

					if (position === 'left' || position === 'right') {
						onAdjustTop(-diff / 2);
					}
				}

				$position({
					element: tooltip,
					anchor: anchor,
					position: POSITIONS[position],
					autoReflect: REFLECT_RULES[position],
					autoAdjust: ADJUST_RULES[position],
					adjustHeight: !!adjustHeight,
					onAdjustLeft: onAdjustLeft,
					onAdjustTop: onAdjustTop,
					onAdjustHeight: onAdjustHeight,
					onReflectLeft: onReflect,
					onReflectTop: onReflect
				});
			}

			function build(options) {
				return loadTemplate(options.template).then(function (templateHtml) {
					if(options.content || options.content === '') {
						var safeContent;
						// strip dangerous tokens from content
						if (!options.html) {
							var tmp = document.createElement('div');
							tmp.innerHTML = options.content;
							safeContent = tmp.textContent || tmp.innerText || "";
						} else {
							safeContent = options.content;
						}

						safeContent = safeContent.replace(/({{)|(}})/g, '');
						templateHtml = templateHtml.replace('{{content}}', safeContent);
					}
					var childScope = options.scope ? options.scope.$new() : $rootScope.$new();

					if (options.controller) {
						templateHtml = angular.element(templateHtml).attr('ng-controller', options.controller);
					}

					var tooltip = $compile(templateHtml)(childScope);

					if (options.className) {
						tooltip.addClass(options.className);
					}
					return tooltip;
				});
			}

			function Tooltip(options) {
				this.options = options;
				if (options.show) {
					this.show();
				}
				this._boundHide = $.proxy(this.hide, this);
				this._boundPosition = $.proxy(this.position, this);
			}
			Tooltip.prototype = {
				show: function () {
					// make sure the tooltip isn't on the page already
					this.hide();

					// make sure to remove the element if the anchor disappears
					if (this.options.anchor) {
						$(this.options.anchor).on('remove $destroy', this._boundHide);
					}

					var buildPromise = this.tooltip ? $q.when(this.tooltip) : this.build(),
						position = this._boundPosition,
						that = this;

					return buildPromise.then(function (tooltip) {
						// TODO add in show animations
						$($document[0].body).append(tooltip);

						// position immediately, then with watcher after angular digest to avoid scrollbar flicker
						position();

						that._stopWatchingHeight = tooltip.scope().$watch(function () {
							return tooltip.height();
						}, position);

						return tooltip;
					});
				},
				hide: function () {
					if (this.tooltip) {
						this.tooltip.detach();
					}
					// remove the listener on hide
					if (this.options.anchor) {
						$(this.options.anchor).off('remove $destroy', this._boundHide);
					}
					if (typeof this._stopWatchingHeight === 'function') {
						this._stopWatchingHeight();
					}
				},
				position: function () {
					setPosition(this.options.anchor, this.tooltip, this.options.position, this.options.adjustHeight);
				},
				// can be called multiple times. Each time, it will destroy the element, and it's scope, and recompile
				build: function () {
					this.destroy();

					var that = this;
					return build(this.options).then(function (tooltip) {
						//if it is attached
						that.tooltip = tooltip;
						return that.tooltip;
					});
				},
				updateContent: function(content) {
					if (this.options.content !== content) {
						this.options.content = content;

						var isAttached = this.tooltip && this.tooltip.parent().length;

						this.destroy();

						if (isAttached) {
							this.show();
						}
					}
				},
				destroy: function () {
					this.hide();
					delete this.tooltip;
				}
			};

			return function(options) {
				return new Tooltip(options);
			};
		}
	]);

	module.directive('qstrap.tooltip', [
		'$timeout',
		'qstrap.$tooltip',
		function($timeout, $tooltip)
		{
			return {
				restrict: 'A',
				scope: {
					content: '@?',
					position: '@?',
					html: '=',
					tooltipDisabled: '=',
					delay: '='
				},
				link: function ($scope, element, attr) {
					var options = {
						html: $scope.html,
						content: $scope.content,
						position: $scope.position,
						template: attr.template,
						anchor: element,
						scope: $scope.$parent,
						className: attr.className
					};

					var tooltip = $tooltip(options);

					function showDelayed(disable) {
						return $timeout(function () {
							if (!disable) {
								tooltip.show();
							}
						}, $scope.delay || 0);
					}

					var delayTimeout, mouseIsOver;
					element.on('mouseenter touchstart', function () {
						mouseIsOver = true;
						delayTimeout = showDelayed($scope.tooltipDisabled);
					});

					element.on('mouseleave touchend', function () {
						mouseIsOver = false;
						$timeout.cancel(delayTimeout);
						tooltip.hide();
					});

					var watchers = [
						//the tooltip disabled property
						$scope.$watch('tooltipDisabled', function(newValue, oldValue) {
							if (oldValue !== newValue) {
								if (newValue) {
									$timeout.cancel(delayTimeout);
									tooltip.hide();
								} else if (!newValue && mouseIsOver) {
									delayTimeout = showDelayed(newValue);
								}
							}
						}),
						// position and templates
						$scope.$watch(function () { return attr.position + '' + attr.template; }, function () {
							options.position = attr.position || options.position;
							options.template = attr.template || options.template;
							tooltip.build();
						}),
						//content
						$scope.$watch(function () { return attr.content; }, function () {
							tooltip.updateContent(attr.content);
						})
					];

					element.on('$destroy', function() {
						if ($scope) {
							for(var i = watchers.length; i--;) {
								watchers[i]();
							}
							watchers = null;
							$scope.$destroy();
							$scope = null;
							tooltip.destroy();
						}
					});
				}
			};
		}
	]);
})(angular.module('qstrap.tooltip', ['qstrap.position']));

/**
 * @ngdoc directive
 * @name qstrap:qstrap.weekday
 *
 * @restrict A
 * @description
 * Directive that creates a weekday picker as a button group
 *
 * @param {object} ngModel Scope variable that represents the selected weekdays. Keys are three letter weekday abbrevation, and the correpsonding boolean value indicates if a weekday is selected by default.
 * @param {boolean=} startWithMon Boolean value indicating to start the week with Monday. Defaulted to FALSE, which starts week with Sunday.
 * @param {expression=} onChange Callback when the selected weekdays are set on the ngModel. (The weekday value is available as $value)
 *
 * @example
   <example module="qstrap">
	 <file name="weekday.html">
		<h3>Monday as start of the week</h3>
		<div ng-controller="WeekdayDemoCtrl1">
			<div qstrap.weekday start-with-mon="startWithMon" ng-model="selectedWeekdays" on-change="alert($value)" style="margin-top: 10px;"></div>
		</div>
		<h3>Sunday as start of the week</h3>
		<div ng-controller="WeekdayDemoCtrl2" style="margin-top: 20px;">
			<div qstrap.weekday start-with-mon="startWithMon" ng-model="selectedWeekdays" on-change="alert($value)" style="margin-top: 10px;"></div>
		</div>

	 </file>
	 <file name="weekday.js">
				angular.module('qstrap.weekday').controller('WeekdayDemoCtrl1', [
					'$scope',
					function($scope) {
						$scope.selectedWeekdays = {
							'sun': true,
							'mon': true,
							'fri': true
						};
						$scope.startWithMon = true;
						$scope.alert = function(value) {
							console.log('Weekdays selected: ' + JSON.stringify(value));
						}
					}
				]);

				angular.module('qstrap.weekday').controller('WeekdayDemoCtrl2', [
					'$scope',
					'$timeout',
					function($scope, $timeout) {
						$scope.selectedWeekdays = {
							'mon': true,
							'wed': true
						};
						$scope.alert = function(value) {
							console.log('Weekdays selected: ' + JSON.stringify(value));
						}
					}
				]);
	 </file>
   </example>
 */

(function (module) {
	'use strict';
	module.directive('qstrap.weekday',
		['$parse',
			'qstrap._weekday',
			function($parse, _weekday)
			{
				return {
					template: '' +
						'<div class="qweekday-wrapper">' +
							'<div ng-repeat="weekday in weekdays" class="btn qweekday" ng-class="{\'qweekday-selected\': weekday.isSelected }" ng-click="toggleWeekday(weekday)">{{::weekday.label}}</div>' +
						'</div>',
					scope: {
						onChange: '&?',
						startWithMon: '<?',
						selectedWeekdays:'=ngModel' // should we validate that this is an array of numbers ?
					},
					require: 'ngModel',
					link: function($scope, el, $attrs, ngModelCtrl)
					{
						$scope.selectedWeekdays = typeof($scope.selectedWeekdays) === 'object' ? $scope.selectedWeekdays : {};
						$scope.startWithMon = !!$scope.startWithMon;

						angular.extend($scope, {
							toggleWeekday: function (weekday) {
								weekday.isSelected = !weekday.isSelected;

								$scope.selectedWeekdays[weekday.id] = weekday.isSelected;

								if ($scope.onChange) {
									$scope.onChange({
										$value: $scope.selectedWeekdays
									});
								}
							}
						});

						var watcher = $scope.$watchCollection('selectedWeekdays', function (obj) {
							for (var index = 0; index < $scope.weekdays.length; index++) {
								$scope.weekdays[index].isSelected = !!obj[$scope.weekdays[index].id];
							}
						});

						$scope.weekdays = _weekday.getWeekdays($scope.startWithMon, $scope.selectedWeekdays);
					}
				};
			}
	]).factory('qstrap._weekday', [
		'$filter',
		function ($filter) {
			var _service = {};
			var WEEKDAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
			var WEEKDAY_LABELS = {
				'sun': 'SUN_ABBR',
				'mon': 'MON_ABBR',
				'tue': 'TUE_ABBR',
				'wed': 'WED_ABBR',
				'thu': 'THU_ABBR',
				'fri': 'FRI_ABBR',
				'sat': 'SAT_ABBR'
			};

			_service.getWeekdays = function (startWithMon, selectedWeekdays) {

				var weekdays = [];
				for (var index = 0; index < WEEKDAYS.length; index++) {
					weekdays[index] = {
						id: WEEKDAYS[index],
						label: $filter('qstrapTranslate')(WEEKDAY_LABELS[WEEKDAYS[index]]),
						isSelected: !!selectedWeekdays[WEEKDAYS[index]]
					};
				}

				if (startWithMon) {
					weekdays.push(weekdays.shift());
				}

				return weekdays;
			};

			return _service;
		}]);
})(angular.module('qstrap.weekday', ['qstrap.translate']));
return {}
})(jQuery);